(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This helper contains analytics origins used by the server. For
 * example: shelved_book_origin.rb
 */

var ShelvedBookOrigin = exports.ShelvedBookOrigin = {
  BROWSE_SPOTLIGHT: "browse_spotlight",
  RECS_WIDGET: "recs_widget"
};

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*eslint-disable camelcase*/
var TRACKED_CLASSES = exports.TRACKED_CLASSES = {
  // If you change the click_type here, please make sure to also change dfp_entry.rb
  //
  // The classes listed here are all classes tracked, other than the "more"
  // class found in mobile.

  // Book Ads
  book_image: {
    dfp: true,
    pmet: { click_type: "book_image" }
  },
  book_title: {
    dfp: true,
    pmet: { click_type: "book_title" }
  },
  author_link: {
    dfp: true,
    pmet: { click_type: "author_name" }
  },
  full_content_link: {
    dfp: true,
    pmet: { click_type: "body_click" }
  },
  user_profile: {
    dfp: true,
    pmet: { click_type: "social" }
  },
  want_to_read_button: {
    dfp: true,
    pmet: { click_type: "wtr_button" }
  },

  // Custom Ads
  sponsored_update_body_image: {
    dfp: true,
    pmet: { click_type: "image" }
  },
  cta_link: {
    dfp: true,
    pmet: { click_type: "cta_click" }
  },
  sponsored_label: {
    dfp: true,
    pmet: { click_type: "sponsored" }
  },

  // Other click tracking
  newsfeed_caret_not_interested: {
    dfp: false,
    pmet: { click_type: "not_interested" }
  },
  newsfeed_caret_help: {
    dfp: false,
    pmet: { click_type: "why" }
  },
  newsfeed_caret: {
    dfp: false,
    pmet: { click_type: "caret" }
  },

  // Desktop-Only
  user_rating_star: {
    dfp: true,
    pmet: { click_type: "rating" }
  },
  preview_book: {
    dfp: true,
    pmet: { click_type: "preview" }
  },
  sponsored_update_body_title_link: {
    dfp: true,
    pmet: { click_type: "sponsored_title" }
  }
};

var TRACKED_CLASSES_AUDIBLE = exports.TRACKED_CLASSES_AUDIBLE = {
  AEP_Desktop_Browse_Image: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_Image" }
  },
  AEP_Desktop_Browse_Title: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_Title" }
  },
  AEP_Desktop_Browse_ExploreButton: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_ExploreButton" }
  },
  AEP_Desktop_Browse_SponsoredBy: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_SponsoredBy" }
  },
  AEP_Desktop_Video_ExternalLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Video_ExternalLink",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookImage: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookImage",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookTitle: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookTitle",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_AuthorLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_AuthorLink",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_WantToRead",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_Stars: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_Stars",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookDescription: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookDescription",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookExternalLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookExternalLink",
      no_redirect: true }
  },
  AEP_Desktop_Carousel_BookImage: {
    pmet: { pmet_click_tid: "AEP_Desktop_Carousel_BookImage",
      no_redirect: true }
  },
  AEP_Desktop_Carousel_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Desktop_Carousel_WantToRead",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_BookImage: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_BookImage",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_WantToRead",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_BookTitle: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_BookTitle",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_Author: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_Author",
      no_redirect: true }
  }

};

var TRACKED_CLASSES_PREMIUM_CAMPAIGN = exports.TRACKED_CLASSES_PREMIUM_CAMPAIGN = {
  fcm_blog_title: {
    dfp: true,
    pmet: { click_type: "fcm_blog_title" }
  },
  fcm_blog_image: {
    dfp: true,
    pmet: { click_type: "fcm_blog_image" }
  },
  fcm_blog_button: {
    dfp: true,
    pmet: { click_type: "fcm_blog_button" }
  },
  fcm_book_author: {
    dfp: true,
    pmet: { click_type: "fcm_book_author" }
  },
  fcm_book_image: {
    dfp: true,
    pmet: { click_type: "fcm_book_image" }
  },
  fcm_book_title: {
    dfp: true,
    pmet: { click_type: "fcm_book_title" }
  },
  fcm_book_button: {
    dfp: true,
    pmet: { click_type: "fcm_book_button" }
  },
  fcm_book_description: {
    dfp: true,
    pmet: { click_type: "fcm_book_description" }
  },
  fcm_giveaway_author: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_author" }
  },
  fcm_giveaway_button: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_button" }
  },
  fcm_giveaway_image: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_image" }
  },
  fcm_giveaway_title: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_title" }
  },
  fcm_list_button: {
    dfp: true,
    pmet: { click_type: "fcm_list_button" }
  },
  fcm_list_books: {
    dfp: true,
    pmet: { click_type: "fcm_list_books" }
  },
  fcm_list_title: {
    dfp: true,
    pmet: { click_type: "fcm_list_title" }
  },
  fcm_genre_title: {
    dfp: true,
    pmet: { click_type: "fcm_genre_title" }
  },
  fcm_genre_image: {
    dfp: true,
    pmet: { click_type: "fcm_genre_image" }
  },
  fcm_genre_button: {
    dfp: true,
    pmet: { click_type: "fcm_genre_button" }
  }
};
/*eslint-enable*/

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchApstagBids = exports.requestCreative = undefined;
exports.requestCreativeForAdSlot = requestCreativeForAdSlot;
exports.defineSlot = defineSlot;
exports.enableServices = enableServices;
exports.dimensionsExplode = dimensionsExplode;
exports.validateA9Sizes = validateA9Sizes;
exports.getA9Sizes = getA9Sizes;
exports.slotToHash = slotToHash;
exports.lazyLoadOnView = lazyLoadOnView;
exports.lazyLoadInit = lazyLoadInit;
exports.adSlotsDefined = adSlotsDefined;

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_actions = require("../../react_actions/google_ads_actions");

var _google_ads_actions2 = _interopRequireDefault(_google_ads_actions);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

// Lazy load expand controls when we start loading ads before they become viewable
// The default from lazysizes is 370 which is too sensitive for our ads metrics
var LAZY_LOAD_EXPAND = 200;

var A9_SIZES = ["300x250", "728x90", "970x90", "320x50", "970x250", "160x600"];

// googletag helper methods
var allGptSlots = function allGptSlots() {
  return window.googletag.pubads().getSlots();
};
var getIdFromGptSlot = function getIdFromGptSlot(slot) {
  return slot.getSlotElementId();
};
var refreshSlots = function refreshSlots(slots) {
  return window.googletag.pubads().refresh(slots);
};

/*
 * This method defines the behavior after DFP indicates that a slot has finished
 * rendering. Here we track impressions. If the slot is a native ad, we will call
 * `attachServedNativeAdAttributesAndTracking` to insert the native creative.
 */
var attachCallbacksAfterSlotRender = function attachCallbacksAfterSlotRender(adId, params) {
  window.googletag.pubads().addEventListener("slotRenderEnded", function (event) {
    if (event.slot.getSlotId().getDomId() === adId) {
      if (event.isEmpty) {
        _google_ads_actions2.default.removeAdSlot(adId);
        _google_ads_actions2.default.trackImpression({ slotId: adId, impressionCode: _google_ads_store.ImpressionCode.empty });
      } else {
        var iframe = $j(params.googleHookSelector).find("iframe[id^=\"google_ads_iframe_\"]");
        var creative = iframe.contents().find(params.creativeSelector);
        var adUnit = event.slot.getAdUnitPath().split("/", 3)[2];

        /** Ad element to track in CSA */
        var impressionElement = document.getElementById("" + adId);

        if (params.isNativeAd) {
          var sponsoredId = creative.data("id");
          var clickUrl = creative.data("url");

          if (sponsoredId && clickUrl) {
            _google_ads_actions2.default.attachServedNativeAdAttributesAndTracking({
              slotId: adId,
              campaignId: event.campaignId,
              lineItemId: event.lineItemId,
              creative: creative,
              sponsoredId: sponsoredId,
              impressionCode: _google_ads_store.ImpressionCode.success,
              dfpUrl: creative.data("url"),
              adUnit: adUnit,
              impressionElement: impressionElement
            });
          } else {
            _google_ads_actions2.default.trackImpression({ slotId: adId, impressionCode: _google_ads_store.ImpressionCode.empty });
          }
        } else {
          _google_ads_actions2.default.attachServedBannerAdAttributesAndTracking({ slotId: adId,
            campaignId: event.campaignId,
            lineItemId: event.lineItemId,
            creative: creative,
            impressionCode: _google_ads_store.ImpressionCode.success,
            delayImpressionTracking: params.delayImpressionTracking,
            impressionElement: impressionElement
          });
        }
        if (params.dimensions === "160x600") {
          $j(".mainContentContainer").addClass("adSkinEnabled");
        }
      }
    }
  });
};

/**
* This method is responsible for attaching an event listener to the ad slot and
* for calling `display` on it. If the ad is lazy loaded, it will additionally
* define and refresh the slot.
*
* @param adId (required) id used by google to find the ad on the page
* @param params (required) contains information about the ad slot
        googleHookSelector (required) used to find the iframe within ad div
        creativeSelector (required) used to find the creatixve ID in the iframe
        dimensions (required) used to add styling to ad units
        isNativeAd (required) check if ad unit is native and look for sponsored update
        deviceType (optional) only used for poll requests to track device type
        delayImpressionTracking (optional) delay impression tracking
              until ad is viewed in navbar
*/
var requestCreative = exports.requestCreative = function requestCreative(adId) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var googletag = window.googletag;

  attachCallbacksAfterSlotRender(adId, params);
  _google_ads_actions2.default.hasAttachedDfpCallbackForSlot(adId);

  if (params.lazyLoadedNewsfeedAd) {
    // For lazy loaded newsfeed ads, manually define the slot and refresh it
    // after calling googletag.display. We do this here to ensure that
    // the above listener is defined first.
    var ad = params.lazyLoadedNewsfeedAd;
    var slot = window.googletag.defineSlot("/4215/" + ad.name, ad.dimensions, adId);
    if (!slot) return;
    slot.addService(window.googletag.pubads());
    googletag.display(adId);
    refreshSlots([slot]);
  } else if (params.isLazyLoaded) {
    var creativeSize = dimensionsExplode(params.dimensions);
    var slot = googletag.defineSlot(params.path, creativeSize, adId);
    if (!slot) return;

    // Override forceSafeFrame for native ads
    if (params.isNativeAd) {
      slot.setConfig({
        safeFrame: {
          forceSafeFrame: false
        }
      });
    }

    slot.addService(googletag.pubads());
    var slotHash = [{
      slotID: adId, slotName: params.path, sizes: [creativeSize]
    }];
    // A9 only allows the following ad slot sizes
    // 300x250, 728x90, 970x90 and 320x50
    var a9Sizes = getA9Sizes(params.dimensions);
    var a9Hash = _lodash2.default.isEmpty(a9Sizes) ? [] : [slotToHash(params.path, adId, a9Sizes)];
    fetchApstagBids(slotHash, a9Hash);
  } else {
    googletag.cmd.push(function () {
      googletag.display(adId);
    });
  }
};

/**
 * Request Creative callback for ad slot
 * and mark ad as requested
 *
 */
function requestCreativeForAdSlot(adId) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  _google_ads_actions2.default.requestCreativeForSlot(adId, params);
}

/**
 * Define Ad Slot for ad units defined in dfp ads resources.
 * All ad units are defined when the store is initialized for
 * roadblock ads
 *
 * @param adId (required) add Id to the slot for googletags callback
 * @param slotPath (required) define path for ad unit
 * (i.e. /4215/goodr.book.show.300x250)
 * @param dimension (required) slot size (e.g. "300x250"). For multi-size ads,
 * this should be an array of slot sizes (e.g. ["970x66", "970x90", "970x250"])
 */
function defineSlot(adId, slotPath, dimension, adSizeMapping) {
  var isNativeAd = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];

  if (window.googletag && window.googletag.cmd) {
    window.googletag.cmd.push(function () {
      var googletag = window.googletag;
      // If this is a multiple-sized ad slot, pass DFP an array of the eligible
      // slot sizes
      var creativeSize = dimensionsExplode(dimension);
      var slot = undefined;

      if (adSizeMapping) {
        var _ret = (function () {
          var mapping = googletag.sizeMapping();
          _lodash2.default.map(adSizeMapping, function (pair) {
            var pairingArray = _lodash2.default.map(pair, function (val) {
              var splitStr = val.split("x");
              return splitStr[0] ? [parseInt(splitStr[0]), parseInt(splitStr[1])] : [];
            });
            mapping = mapping.addSize(pairingArray[0], pairingArray[1]);
          });
          slot = googletag.defineSlot(slotPath, creativeSize, adId);
          if (!slot) return {
              v: undefined
            };
          slot.defineSizeMapping(mapping.build()).setCollapseEmptyDiv(true);
        })();

        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
      } else {
        slot = googletag.defineSlot(slotPath, creativeSize, adId);
        if (!slot) return;
      }

      // Override forceSafeFrame for native ads
      if (isNativeAd) {
        slot.setConfig({
          safeFrame: {
            forceSafeFrame: false
          }
        });
      }

      slot.addService(googletag.pubads());
    });
  }
}

function enableServices() {
  if (window.googletag && window.googletag.cmd) {
    window.googletag.cmd.push(function () {
      var googletag = window.googletag;
      googletag.enableServices();
    });
  }
}

function dimensionsExplode(dimensions) {
  var dimensionsArray = undefined;
  if (Array.isArray(dimensions)) {
    dimensionsArray = _lodash2.default.map(dimensions, function (val) {
      var splitStr = val.split("x");
      return [parseInt(splitStr[0]), parseInt(splitStr[1])];
    });
  } else {
    var splitStr = dimensions.split("x");
    dimensionsArray = [parseInt(splitStr[0]), parseInt(splitStr[1])];
  }
  return dimensionsArray;
}

// A9 only allows the following ad slot sizes
// 300x250, 728x90, 970x90 and 320x50
function validateA9Sizes(val) {
  if (A9_SIZES.includes(val)) {
    return true;
  } else {
    return false;
  }
}

// Dimensions is either an array of sizes for the ad
// slot or one size represented as a string.
function getA9Sizes(dimensions) {
  var dimensionsArray = [];
  if (Array.isArray(dimensions)) {
    var validA9Dimensions = _lodash2.default.filter(dimensions, function (val) {
      return validateA9Sizes(val);
    });
    dimensionsArray = _lodash2.default.map(validA9Dimensions, function (val) {
      var splitStr = val.split("x");
      return [parseInt(splitStr[0]), parseInt(splitStr[1])];
    });
  } else {
    if (validateA9Sizes(dimensions)) {
      var splitStr = dimensions.split("x");
      dimensionsArray = [[parseInt(splitStr[0]), parseInt(splitStr[1])]];
    }
  }
  return dimensionsArray;
}

// This function converts an ad object (from the Google Ads Store data)
// into a hash compatible with the apstag library.
function slotToHash(ad, adId) {
  var a9Sizes = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  // Prepare slot data for apstag

  var dimensions = Array.isArray(ad.dimensions) ? ad.dimensions : [ad.dimensions];
  var dimensionsMapped = _lodash2.default.isEmpty(a9Sizes) ? _lodash2.default.map(dimensions, function (val) {
    var splitStr = val.split("x");
    return [parseInt(splitStr[0]), parseInt(splitStr[1])];
  }) : a9Sizes;
  return {
    slotID: adId,
    slotName: ad.path,
    sizes: dimensionsMapped
  };
}

// This function takes an array of slot hashes (outputs from slotToHash) and
// submits them to apstag, which returns bids on those slots from A9. These bids
// are added to the targeting values of the slots, and a
// googletag.pubads().refresh() request is made for all slots passed in.
//
// NOTE: ADS WILL NOT DISPLAY PROPERLY UNTIL THIS FUNCTION IS CALLED FOR THE
// SLOTS TO BE DISPLAYED!
var fetchApstagBids = exports.fetchApstagBids = function fetchApstagBids(gptSlots, apsSlots) {
  var googletag = window.googletag;
  if (googletag && googletag.cmd) {
    googletag.cmd.push(function () {
      var apstag = window.apstag;
      if (Array.isArray(gptSlots) && gptSlots.length) {
        // If apstag isn't loaded or no aps slots, refresh directly without A9 bids
        if (!apstag || _lodash2.default.isEmpty(apsSlots)) {
          googletag.cmd.push(function () {
            return checkCallbacksAndRefresh(gptSlots);
          });
        } else {
          apstag.fetchBids({
            slots: apsSlots
          }, function () {
            googletag.cmd.push(function () {
              return checkCallbacksAndRefresh(gptSlots);
            });
          });
        }
      }
    });
  }
};

var checkCallbacksAndRefresh = function checkCallbacksAndRefresh(apsSlots) {
  var apstag = window.apstag;
  var apsSlotIds = apsSlots.map(function (apsSlot) {
    return apsSlot.slotID;
  });
  var gptSlots = allGptSlots().filter(function (gptSlot) {
    return apsSlotIds.includes(getIdFromGptSlot(gptSlot));
  });
  new Promise(function (resolve, reject) {
    return _google_ads_actions2.default.checkCallbacksAttached(resolve, reject, apsSlotIds);
  }).then(function () {
    if (apstag) {
      apstag.setDisplayBids();
    }
    refreshSlots(gptSlots);
  }).catch(function () {
    return null;
  });
};

// This is here because jQuery can't be stubbed directly in tests.
function lazyLoadOnView(callback) {
  $j(document).on("lazybeforeunveil", callback);
}

// Set Lazyload params on google ad store initialization
function lazyLoadInit() {
  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = LAZY_LOAD_EXPAND;
}

function adSlotsDefined() {
  var googletag = window.googletag;
  return typeof googletag === "function" && googletag.pubads().getSlots().length > 0;
}

},{"../../react_actions/google_ads_actions":34,"../../react_stores/google_ads_store":264,"lodash":"lodash"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ERROR_MESSAGE = undefined;
exports.httpRequest = httpRequest;
exports.httpPost = httpPost;
exports.httpDelete = httpDelete;
exports.httpGet = httpGet;

var _default_auth_failure_handler = require("./default_auth_failure_handler");

var _lodash = require("lodash");

/**
 * Make an ajax request for the provided url. The returned promise
 * may never be fulfilled and will instead redirect the browser
 * to an authentication page if the URL requires that the user is
 * signed in and they are currently not signed in.
 *
 * If you want the user to be successfully returned to your
 * page, look into setting session[:jumpto] in your controller
 * action. :return_url and other mechanisms do not work generically.
 *
 * TODO-GR-44007: replace jQuery as underlying library
 *
 * @param url - Required. String URL for the desired resource
 * @param options
 *        options.method = "GET" (default), "POST", "DELETE"
 *        all other options are passed along unchanged to jQuery.ajax
 *        see https://api.jquery.com/jQuery.ajax/ for API. For example, pass
 *        {contentType: "json"} to have response parsed as JSON and returned
 *        as an Object. Pass a `data` key with your request arguments.
 * @return jQuery.Promise
 *         will resolve with the same arguments as the done/success callback
 *         or reject with the same arguments as the fail callback
 */
function httpRequest(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  options = (0, _lodash.merge)({}, options, { type: options.method });
  options = (0, _lodash.omit)(options, "method");

  var deferred = $j.Deferred();
  var jQueryPromise = $j.ajax(url, options);

  jQueryPromise.done(deferred.resolve);

  jQueryPromise.fail(function (jqXHR, textStatus, errorThrown) {
    if ((0, _default_auth_failure_handler.redirectOnAuthFailure)(jqXHR)) {
      return; // never fulfill or reject because we just want the redirect to go through
    } else {
        deferred.reject(jqXHR, textStatus, errorThrown);
      }
  });

  return deferred.promise();
}

/**
 * convenience method for httpRequest with the desired
 * method of POST. see doc for httpRequest for complete
 * details.
 *
 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpPost(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "POST" }));
}

/**
 * convenience method for httpRequest with the desired
 * method of DELETE. see doc for httpRequest for complete
 * details.

 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpDelete(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "DELETE" }));
}

/**
 * convenience method for httpRequest with the desired
 * method of GET. see doc for httpRequest for complete
 * details.
 *
 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpGet(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "GET" }));
}

var DEFAULT_ERROR_MESSAGE = exports.DEFAULT_ERROR_MESSAGE = "Something went wrong with your request. Please\n  try again later.";

},{"./default_auth_failure_handler":5,"lodash":"lodash"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectOnAuthFailure = redirectOnAuthFailure;

var _env_utils = require("../env_utils");

/**
 * If we receive a 403, redirect.
 *
 * Port of the Flight mixin app/assets/javascripts/components/mixins/auth_redirect.js
 *
 * @param jqXHR
 * @returns {boolean} true if it was a 403 and will be redirected. false otherwise.
 *                    if true, it's best not to try to execute any more code since it
 *                    may not have time to run before window.unload
 */
function redirectOnAuthFailure(jqXHR) {
  if (jqXHR && jqXHR.status === 403) {
    var data = jqXHR.responseJSON;
    if (data.redirect) {
      (0, _env_utils.setLocationUrl)(data.redirect);
      return true;
    }
  }
  return false;
}

},{"../env_utils":12}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOK_ORIGINS = exports.BOOK_ORIGINS = {
  CURRENTLY_READING_WIDGET: "currently-reading-widget",
  UPDATE_READING_PROGRESS: "hp_status_editor"
};

},{}],7:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeTrackAnimationStyle = exports.computeTrackLeftOffset = exports.computeTrackStyle = exports.getReactObjectByType = exports.getStoreObjects = exports.previousTransitionMessage = exports.nextTransitionMessage = exports.objectTypeToComponentMap = undefined;

var _audiobook_slide = require("../../react_components/carousel/slides/audiobook_slide");

var _audiobook_slide2 = _interopRequireDefault(_audiobook_slide);

var _audiobook_tooltip = require("../../react_components/carousel/slides/audiobook_tooltip");

var _audiobook_tooltip2 = _interopRequireDefault(_audiobook_tooltip);

var _audiobook_mobile_slide = require("../../react_components/carousel/slides/audiobook_mobile_slide");

var _audiobook_mobile_slide2 = _interopRequireDefault(_audiobook_mobile_slide);

var _marketing_slide = require("../../react_components/carousel/slides/marketing_slide");

var _marketing_slide2 = _interopRequireDefault(_marketing_slide);

var _sample_slide = require("../../react_components/carousel/slides/sample_slide");

var _sample_slide2 = _interopRequireDefault(_sample_slide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var objectTypeToComponentMap = exports.objectTypeToComponentMap = {
  audiobookSlide: _audiobook_slide2.default,
  audiobookTooltip: _audiobook_tooltip2.default,
  audiobookMobileSlide: _audiobook_mobile_slide2.default,
  marketingSlide: _marketing_slide2.default,
  sample: _sample_slide2.default
};

var nextTransitionMessage = exports.nextTransitionMessage = "next";
var previousTransitionMessage = exports.previousTransitionMessage = "prev";

var getStoreObjects = exports.getStoreObjects = function getStoreObjects(props) {
  var slideArray = [];
  var tooltipArray = [];
  var slideType = props.slideType;
  var slides = props.slides;
  var tooltipType = props.tooltipType;
  var tooltips = props.tooltips;
  var ReactSlideComponentType = getReactObjectByType(slideType);
  if (ReactSlideComponentType) {
    slides.forEach(function (entry) {
      var slideObj = React.createElement(ReactSlideComponentType, entry);
      slideArray.push(slideObj);
    });
  } else {
    slides.forEach(function () {
      var slideObj = _jsx("div", {}, void 0, "Sorry. Could not resolve the carouselSlideType property to a valid React Component. Please review the property value");
      slideArray.push(slideObj);
    });
  }
  if (tooltipType) {
    (function () {
      var ReactTooltipComponentType = getReactObjectByType(tooltipType);
      if (ReactTooltipComponentType) {
        tooltips.forEach(function (entry) {
          var tooltipObj = React.createElement(ReactTooltipComponentType, entry);
          tooltipArray.push(tooltipObj);
        });
      }
    })();
  }
  var returnObj = { slides: slideArray };
  if (tooltipArray.length > 0) {
    returnObj.tooltips = tooltipArray;
  }
  return returnObj;
};

var getReactObjectByType = exports.getReactObjectByType = function getReactObjectByType(type) {
  return objectTypeToComponentMap[type];
};

var computeTrackStyle = exports.computeTrackStyle = function computeTrackStyle(spec) {
  var trackLeft = computeTrackLeftOffset(spec);

  var trackWidth = undefined;
  if (spec.carouselWrapAround) {
    trackWidth = spec.carouselSlidesToShow * spec.slideContainerWidth + 2 * spec.carouselSlidesToScroll * spec.slideContainerWidth;
  } else {
    var numberOfSlidesToLoad = 0;
    var slideIndex = undefined;
    if (spec.animating) {
      slideIndex = spec.currentSlide;
    } else {
      slideIndex = spec.hasOwnProperty("targetSlide") ? spec.targetSlide : spec.currentSlide;
    }
    numberOfSlidesToLoad += slideIndex + spec.carouselSlidesToShow;
    if (slideIndex + spec.carouselSlidesToShow + spec.carouselSlidesToScroll < spec.slideCount) {
      numberOfSlidesToLoad += spec.carouselSlidesToScroll;
    } else {
      numberOfSlidesToLoad += spec.slideCount - slideIndex - spec.carouselSlidesToShow;
    }
    trackWidth = numberOfSlidesToLoad * spec.slideContainerWidth;
  }

  var style = {
    opacity: 1,
    width: trackWidth,
    WebkitTransform: "translate3d(" + trackLeft + "px, 0px, 0px)",
    transform: "translate3d(" + trackLeft + "px, 0px, 0px)",
    transition: "",
    WebkitTransition: "",
    msTransform: "translateX(" + trackLeft + "px)"
  };

  // Fallback for IE8 - found this snippet online about a potential issue with IE8. have to test this.
  if (!window.addEventListener && window.attachEvent) {
    style.marginLeft = trackLeft + "px";
  }

  return style;
};

var computeTrackLeftOffset = exports.computeTrackLeftOffset = function computeTrackLeftOffset(spec) {
  var trackLeftOffset = undefined;
  var targetSlide = spec.hasOwnProperty("targetSlide") ? spec.targetSlide : spec.currentSlide;
  if (spec.carouselWrapAround) {
    trackLeftOffset = spec.slideContainerWidth * spec.carouselSlidesToScroll * -1;
    if (spec.animating) {
      if (targetSlide > spec.currentSlide) {
        trackLeftOffset -= spec.slideContainerWidth * spec.carouselSlidesToScroll;
      } else if (targetSlide < spec.currentSlide) {
        trackLeftOffset += spec.slideContainerWidth * spec.carouselSlidesToScroll;
      }
    }
  } else {
    trackLeftOffset = targetSlide * spec.slideContainerWidth * -1;
  }
  return trackLeftOffset;
};

var computeTrackAnimationStyle = exports.computeTrackAnimationStyle = function computeTrackAnimationStyle(spec) {
  var style = computeTrackStyle(spec);
  style.WebkitTransition = "-webkit-transform " + spec.carouselSlidingSpeed + "ms ease";
  style.transition = "transform " + spec.carouselSlidingSpeed + "ms ease";
  return style;
};

},{"../../react_components/carousel/slides/audiobook_mobile_slide":87,"../../react_components/carousel/slides/audiobook_slide":88,"../../react_components/carousel/slides/audiobook_tooltip":89,"../../react_components/carousel/slides/marketing_slide":90,"../../react_components/carousel/slides/sample_slide":91}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VARIANTS = exports.VARIANTS = {
  DEFAULT: "default",
  DARK_BG: "darkBg"
};

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleDataTracking = handleDataTracking;

var _data_tracking_actions = require("../../react_actions/data_tracking/data_tracking_actions");

var _data_tracking_actions2 = _interopRequireDefault(_data_tracking_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTrackingEnabled = function isTrackingEnabled(sourceElement) {
  return sourceElement.getAttribute("data-tracking-enabletracking") === "true";
};

/**
 * This function is a JavaScript DOM event listener implementation to handle any type of
 * user interaction on a DOM Element. The listener is attached by
 * react_mixins/tracking_data_attributes_mixin.js mixin for components with
 * `trackingOptions.enableTracking` prop set to true. The listener will trigger a react action when
 * it first encounters data-tracking-enabletracking="true" data attribute within the source element.
 *
 * @param event Object - JavaScript event object
 */
function handleDataTracking(event) {
  var source = event.target;
  var trackingRootNode = event.currentTarget;

  var dataTrackingEnabled = false;

  if (source === trackingRootNode) {
    dataTrackingEnabled = isTrackingEnabled(source);
  } else {
    //when clicked on one of the child elements of trackingRootNode element.
    while (trackingRootNode.contains(source)) {
      dataTrackingEnabled = isTrackingEnabled(source);
      if (dataTrackingEnabled) {
        break;
      }
      source = source.parentNode;
    }
  }

  if (dataTrackingEnabled) {
    _data_tracking_actions2.default.trackClickEvent(event, source);
  }
}

},{"../../react_actions/data_tracking/data_tracking_actions":32}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromNow = fromNow;
exports.getFormattedDate = getFormattedDate;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Refer to moment docs for default duration.humanize thresholds
// http://momentjs.com/docs/*/customization/relative-time-threshold/
/**
 * A util library to support custom date functions.
 */
_moment2.default.relativeTimeThreshold("s", 60);
_moment2.default.relativeTimeThreshold("m", 60);
_moment2.default.relativeTimeThreshold("h", 24);
_moment2.default.relativeTimeThreshold("d", 25);
_moment2.default.relativeTimeThreshold("M", 10);

_moment2.default.locale("en-abbreviated", { // Define custom relative time formats
  relativeTime: {
    future: "in %s",
    past: "%s",
    s: "Just now",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});
_moment2.default.locale("en"); // Reset to default

/**
 * Returns relative time
 * Refer to http://momentjs.com/docs/ for more on Relativetime settings
 *
 * @param pastTime Date - A JavaScript date
 * @param currentTime moment - (Optional) if passed calculates the relative from
 * that moment. Default is moment() which is now
 * @param mockPastTime moment - (Optional) only used as di for tests
 *
 * @returns String - relative time from now in the below format
 *
 * Just Now = under a minute ago
 * 1m = 1 minute, for use in 1-59 minutes
 * 1h = 1 hour, for use in 1-23 hours
 * 1d = 1 day, for use in 1-6 days
 * 1w = 1 week, for use in anything under a month
 * 15 Mar = day and month, for use or anything older than a month
 * 15 Mar 12 = anything in previous year
 */
function fromNow(pastTime) {
  var currentTime = arguments.length <= 1 || arguments[1] === undefined ? (0, _moment2.default)() : arguments[1];
  var mockPastTime = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  currentTime.locale("en-abbreviated");
  if (mockPastTime !== null) {
    pastTime = mockPastTime;
  } else {
    pastTime = (0, _moment2.default)(pastTime).locale("en-abbreviated");
  }

  var pastDays = currentTime.diff(pastTime, "days");
  var pastMonths = currentTime.diff(pastTime, "months");
  var pastDaysPrecise = currentTime.diff(pastTime, "days", true);
  var relativeWeekThreshold = 6.5; // 6.5 days is considered a week

  if (_lodash2.default.inRange(pastMonths, 1, 13)) {
    // under a year
    return currentTime.subtract(pastDays, "days").format("DD MMM");
  } else if (pastMonths > 12) {
    // over a year
    return currentTime.subtract(pastDays, "days").format("DD MMM YY");
  } else if (_lodash2.default.inRange(pastDays, 7, 28)) {
    // under a month
    return Math.ceil(pastDays / 7) + "w";
  } else if (pastDaysPrecise >= relativeWeekThreshold && pastDaysPrecise <= 28) {
    // same as above but handles a special case where > 6.5 days should be "1w" instead of "7d"
    return Math.round(pastDaysPrecise / relativeWeekThreshold) + "w";
  } else {
    // under a week uses moment relative threshold configuration above
    return pastTime.fromNow();
  }
}

/**
 * Returns a formatted date
 * Refer to http://momentjs.com/docs/#/parsing/string/ for details on parsing
 *
 * @param date String
 * @param format String - deisred output format, defaults to YYYY-MM-DD
 * @return String - date string in the specified format
 */
function getFormattedDate(date) {
  var format = arguments.length <= 1 || arguments[1] === undefined ? "YYYY-MM-DD" : arguments[1];

  if (date) {
    var parsedDate = (0, _moment2.default)(date);
    return parsedDate.format(format);
  }
  return "";
}

},{"lodash":"lodash","moment":"moment"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIconClassnames = exports.getExclusiveShelfType = exports.SHELF_TYPES = exports.DEFAULT_SHELVES = undefined;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SHELVES = exports.DEFAULT_SHELVES = {
  READ: {
    name: "read",
    displayName: "Read"
  },
  CURRENTLY_READING: {
    name: "currently-reading",
    displayName: "Currently Reading"
  },
  WANT_TO_READ: {
    name: "to-read",
    displayName: "Want to Read"
  },
  DID_NOT_FINISH: {
    name: "did-not-finish",
    displayName: "Did Not Finish"
  }
};

var SHELF_TYPES = exports.SHELF_TYPES = {
  DEFAULT: "defaultShelves",
  CUSTOM_EXCLUSIVE: "customExclusiveShelves",
  NONEXCLUSIVE: "nonExclusiveShelves"
};

var getExclusiveShelfType = exports.getExclusiveShelfType = function getExclusiveShelfType(shelfName) {
  if (shelfName === DEFAULT_SHELVES.READ.name || shelfName === DEFAULT_SHELVES.CURRENTLY_READING.name || shelfName === DEFAULT_SHELVES.WANT_TO_READ.name || shelfName === DEFAULT_SHELVES.DID_NOT_FINISH.name) {
    return SHELF_TYPES.DEFAULT;
  } else {
    return SHELF_TYPES.CUSTOM_EXCLUSIVE;
  }
};

// returns check icon style that matches exclusive shelf
var checkIconClassnames = exports.checkIconClassnames = function checkIconClassnames(shelfName) {
  return (0, _classnames2.default)({
    "wantToReadButton__checkIcon--toRead": shelfName === DEFAULT_SHELVES.WANT_TO_READ.name,
    "wantToReadButton__checkIcon--currentlyReading": shelfName === DEFAULT_SHELVES.CURRENTLY_READING.name,
    "wantToReadButton__checkIcon--read": shelfName === DEFAULT_SHELVES.READ.name,
    "wantToReadButton__checkIcon--didNotFinish": shelfName === DEFAULT_SHELVES.DID_NOT_FINISH.name,
    "wantToReadButton__checkIcon--other": shelfName && getExclusiveShelfType(shelfName) === SHELF_TYPES.CUSTOM_EXCLUSIVE
  });
};

},{"classnames":"classnames"}],12:[function(require,module,exports){
"use strict";

/**
 * Environment specific utility module to support shared code. Its using commonJS style exports instead
 * of ES6 exports as its used in gulpfile.js which is not ES6 yet.
 */
module.exports = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  TEST: "test",

  /**
   * Returns true if DOM is available for rendering.
   * @return {boolean}
   */
  hasDom: function hasDom() {
    return !!window.document;
  },

  /**
   * Returns true if there is no DOM available for rendering.
   * @return {boolean}
   */
  domUnavailable: function domUnavailable() {
    return !this.hasDom();
  },
  isDevelopment: function isDevelopment() {
    return "production" === this.DEVELOPMENT;
  },
  getCurrentPath: function getCurrentPath() {
    if (window && window.location) {
      return window.encodeURIComponent(window.location.pathname + window.location.search);
    }
  },

  /**
   * Sets window location href to the given url. Why a separate method? To easily test it as its
   * not trivial to mock object attributes in unit testing.
   *
   * @param url String - new location url
   */
  setLocationUrl: function setLocationUrl(url) {
    if (window) {
      window.location.href = url;
    }
  },
  getLocationUrl: function getLocationUrl() {
    if (window && window.location) {
      return window.location.href;
    }
  },

  // Another window.location accessor, to make stubbing in tests easier.
  getLocationPathname: function getLocationPathname() {
    if (window && window.location) {
      return window.location.pathname;
    }
  },
  getUserAgent: function getUserAgent() {
    if (window && window.navigator) {
      return window.navigator.userAgent;
    }
    return "";
  }
};

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

exports.default = {

  /*
    Reports an error.
    Always logs the error and message to the console.
    It used to send to bugsnag but no longer.
     params
      - error: the error with relevant stack trace.
      - message: friendly title for searching
   */

  notifyException: function notifyException(error, message) {
    if (error) {
      if (window.console && (0, _lodash.isFunction)(window.console.error)) {
        window.console.error(message, error.stack); //eslint-disable-line no-console
      }
    } else if (window.console && (0, _lodash.isFunction)(window.console.warn)) {
        window.console.warn("Attempted to notifyException without providing error,\n                           message: " + message);
      }
  },

  /**
   * Notify a user of an error. Currently just uses the browser's alert dialog
   * but may eventually use a custom, stylized dialog.
   *
   * @param message (required) text to show the user
   */
  notifyUser: function notifyUser(message) {
    if (window && (0, _lodash.isFunction)(window.alert)) {
      window.alert(message);
    }
  }
};

},{"lodash":"lodash"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEYCODES = {
  enter: 13,
  escape: 27,
  space: 32,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40
};

exports.default = {
  isEnter: function isEnter(keyCode) {
    return keyCode === KEYCODES.enter;
  },
  isEscape: function isEscape(keyCode) {
    return keyCode === KEYCODES.escape;
  },
  isSpace: function isSpace(keyCode) {
    return keyCode === KEYCODES.space;
  },
  isArrowLeft: function isArrowLeft(keyCode) {
    return keyCode === KEYCODES.leftArrow;
  },
  isArrowUp: function isArrowUp(keyCode) {
    return keyCode === KEYCODES.upArrow;
  },
  isArrowRight: function isArrowRight(keyCode) {
    return keyCode === KEYCODES.rightArrow;
  },
  isArrowDown: function isArrowDown(keyCode) {
    return keyCode === KEYCODES.downArrow;
  },
  isDropdownOpenerKey: function isDropdownOpenerKey(keyCode) {
    return this.isEnter(keyCode) || this.isSpace(keyCode) || this.isArrowDown(keyCode);
  },
  isDefaultOpenerKey: function isDefaultOpenerKey(keyCode) {
    return this.isEnter(keyCode) || this.isSpace(keyCode);
  },
  isDefaultCloserKey: function isDefaultCloserKey(keyCode) {
    return this.isEscape(keyCode);
  },

  KEYCODES: KEYCODES
};

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _gr_error_reporting = require("./gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var previouslyRequestedTimestamps = undefined;

var reset = function reset() {
  previouslyRequestedTimestamps = [];
};

reset();

var getDuplicateUpdateIds = function getDuplicateUpdateIds(incomingUpdates, updatesAlreadyLoaded) {
  var incomingIds = (0, _lodash.map)(incomingUpdates, "id");
  var existingIds = (0, _lodash.map)(updatesAlreadyLoaded, "id");
  return (0, _lodash.intersection)(incomingIds, existingIds);
};

exports.default = {

  /**
   * Fetches newsfeed updates for the current user. Due to some circuit breakers
   * built into this, it may not actually make an HTTP request.
   * 
   * @param timestamp - a Number representing a unix timestamp; all updates returned
   *                    should be earlier than this time
   * @param options (optional)
   *        requestParams - an object of additional params to be sent with the request
   *                        e.g. { param1: 3, param2: true }
   *        updatesAlreadyLoaded - newsfeed updates already loaded. Their "id" attributes are
   *                          checked against updates returned by the response and if there
   *                          are duplicates the returned promise is rejected because
   *                          something is wrong with the server output.
   *                          Their structure should be identical to the one used by
   *                          NewsfeedUpdateStore.
   * @returns {jQuery.Deferred Promise} will resolve with the new updates
   *                                    or reject if there is a problem
   */

  loadNewsfeedUpdatesOlderThan: function loadNewsfeedUpdatesOlderThan(timestamp) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var deferred = $j.Deferred();
    if ((0, _lodash.includes)(previouslyRequestedTimestamps, timestamp)) {
      var error = new Error("NewsfeedApiClient.loadNewsfeedUpdatesOlderThan called more than once with " + timestamp);
      _gr_error_reporting2.default.notifyException(error, "NewsfeedApiClient attempted duplicate requests");
      deferred.reject();
      return deferred.promise();
    }

    previouslyRequestedTimestamps.push(timestamp);

    var maxUpdatedAt = undefined;
    if (timestamp) {
      maxUpdatedAt = timestamp - 1;
    }

    var updatesAlreadyLoadedCount = options.updatesAlreadyLoaded ? options.updatesAlreadyLoaded.length : 0;
    var requestData = (0, _lodash.merge)({ max_updated_at: maxUpdatedAt, updates_already_loaded_count: updatesAlreadyLoadedCount }, options.requestParams);

    var request = $j.post("/home/load_more_updates", requestData);

    request.done(function (response) {
      var duplicates = getDuplicateUpdateIds(response.updates.newsfeedUpdates, options.updatesAlreadyLoaded);
      if ((0, _lodash.isEmpty)(duplicates)) {
        deferred.resolve(response);
      } else {
        var error = new Error("Request for " + JSON.stringify(requestData) + " received duplicate updates: " + JSON.stringify(duplicates));
        _gr_error_reporting2.default.notifyException(error, "NewsfeedApiClient received duplicate updates");
        deferred.reject();
      }
    }).fail(deferred.reject);

    return deferred.promise();
  },

  reset: reset
};

},{"./gr_error_reporting":13,"lodash":"lodash"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumberWithDelimiter = formatNumberWithDelimiter;
exports.formatPercentage = formatPercentage;
exports.fractionWithPercentage = fractionWithPercentage;
/**
 * A util library to support number formatting functions.
 */

// Format a number with grouped thousands using a delimiter
// Similar to `number_with_delimiter` in Rails:
// http://apidock.com/rails/ActionView/Helpers/NumberHelper/number_with_delimiter
function formatNumberWithDelimiter(number) {
  var delimiter = arguments.length <= 1 || arguments[1] === undefined ? "," : arguments[1];

  return number.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1" + delimiter);
}

function formatPercentage(numerator, denominator) {
  if (numerator === null || denominator === null) {
    return null;
  } else if (denominator === 0) {
    return null;
  } else {
    return (numerator / denominator * 100).toFixed() + "%";
  }
}

/**
 * Formats a fraction with percent. Usually used for reading progress
 * or reading challenge progress.
 *
 * @param value aka the numerator
 * @param max aka the denominator
 * @returns {string} e.g. "10/100 (10%)"
 */
function fractionWithPercentage(value, max) {
  var percentage = formatPercentage(value, max);

  if (percentage) {
    return value + "/" + max + " (" + percentage + ")";
  } else {
    return null;
  }
}

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  Reusable functions for dealing with React refs.
 */

/*
  Use this function as a value of a ref callback
  if all you want to do is focus on that element on mount.

  e.g.

  <div ref={focusOnMount} />
 */
var focusOnMount = exports.focusOnMount = function focusOnMount(element) {
  if (element) {
    element.focus();
  }
};

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PositionTypes = undefined;
exports.hasProgress = hasProgress;
exports.truncateBookTitle = truncateBookTitle;
exports.isValidUpdate = isValidUpdate;
exports.isValidProgressAmount = isValidProgressAmount;
exports.invalidProgressMessage = invalidProgressMessage;
exports.isDisplayableAsPercent = isDisplayableAsPercent;
exports.currentPositionLabel = currentPositionLabel;

var _number_formatting_utils = require("./number_formatting_utils");

var _lodash = require("lodash");

var PositionTypes = exports.PositionTypes = {
  Page: "page",
  Percent: "percent"
};

function hasProgress(readingSession) {
  return readingSession.currentPosition !== 0;
}

function truncateBookTitle(title) {
  var maxLength = arguments.length <= 1 || arguments[1] === undefined ? 80 : arguments[1];

  return (0, _lodash.trunc)(title, {
    omission: "…",
    length: maxLength
  });
}

function isValidUpdate(session) {
  return session.body.length > 0 || session.currentPosition.toString().length > 0;
}

var isValidPageProgress = function isValidPageProgress(session) {
  return parseInt(session.currentPosition) >= 0;
};

var isValidPercentProgress = function isValidPercentProgress(session) {
  return parseInt(session.currentPosition) >= 0 && parseInt(session.currentPosition) <= 100;
};

function isValidProgressAmount(session) {
  if (session.positionType === PositionTypes.Page) {
    return isValidPageProgress(session);
  } else if (session.positionType === PositionTypes.Percent) {
    return isValidPercentProgress(session);
  }
  return false;
}

function invalidProgressMessage(session) {
  if (session.positionType === PositionTypes.Page) {
    return "Please enter a page number that is positive.";
  } else if (session.positionType === PositionTypes.Percent) {
    return "Please enter a percentage between 0 and 100.";
  }
  return "Invalid input";
}

/**
 * Returns true if the supplied ReadingSession-shaped data
 * can be displayed as a percent, meaning it either _is_
 * based directly on percent or has a page number out of a
 * known total number of pages. Some books don't have a numPages
 * attribute.
 *
 * There is a related function, user_status_helper#isDisplayableAsPercent
 * for the equivalent for UserStatus-shaped data.
 *
 * @param readingSession
 * @returns {boolean}
 */
function isDisplayableAsPercent(readingSession) {

  // Note: finalPosition can refer to either 100 (when percent)
  // or the book's page count
  return readingSession.positionType === PositionTypes.Percent || readingSession.positionType === PositionTypes.Page && readingSession.finalPosition;
}

function currentPositionLabel(readingSession) {
  if (readingSession.positionType === PositionTypes.Page) {
    if (isDisplayableAsPercent(readingSession)) {
      return (0, _number_formatting_utils.fractionWithPercentage)(readingSession.currentPosition, readingSession.finalPosition);
    } else {
      return "On page " + readingSession.currentPosition;
    }
  } else {
    return readingSession.currentPosition + "%";
  }
}

},{"./number_formatting_utils":16,"lodash":"lodash"}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ICON_SIZES = exports.ICON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

var ICON_SHAPES = exports.ICON_SHAPES = {
  CIRCLE: "circular",
  ROUND_SQUARE: "roundSquare",
  RECTANGULAR: "rectangular"
};

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImages = getImages;
/**
 * gr_image_registry.js.erb stores Rails-generated image paths in window.
 * This module serves as an interface to those image paths; JavaScript code under app/gulp
 * should import this module rather than try to access `window` directly.
 *
 * refer to:
 * /rails-root/app/assets/javascripts/shared_all_formats/gr_image_registry.js.erb
 * @returns {*}
 */

function getImages() {
  // window.GrImageRegistry is not available to server side rendering and throws
  // JS errors when accessing images from the object. Returning an empty object to avoid those
  // server side errors.
  return window.GrImageRegistry || {};
}

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acknowledgeEvent = acknowledgeEvent;
/**
 * Acknowledge event for Touch Not Ready (TNR) metrics
 * If an event is acknowledged, the TNR count should not be incremented
 * The custom ACK count for the element should be incremented
 * See custom_touch_not_ready.js
 * The native browser event must be accessed from React's SyntheticEvent wrapper
 *
 * References:
 * https://w.amazon.com/bin/view/Latency/Projects/TouchNotReady/DeveloperDocs
 * https://reactjs.org/docs/events.html
 */

function acknowledgeEvent(event) {
  // Only acknowledge if native event available and TNR library loaded
  if (event && event.nativeEvent && event.nativeEvent.acknowledge) {
    event.nativeEvent.acknowledge(event.currentTarget);
  }
}

},{}],22:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This module is a JS version of ruby's #to_sentence method, which converts an
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             array to a comma-separated sentence where the last element is joined by a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             connector word.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  toSentence: function toSentence(items) {
    var lastWordConnector = arguments.length <= 1 || arguments[1] === undefined ? "and" : arguments[1];

    var sentence = [];
    var numItems = items.length;
    switch (numItems) {
      case 0:
        return "";
      case 1:
        sentence.push(items[0]);
        break;
      case 2:
        sentence.push(items[0]);
        sentence.push(" " + lastWordConnector + " ");
        sentence.push(items[1]);
        break;
      default:
        _lodash2.default.each(items.slice(0, -1), function (item) {
          sentence.push(item);
          sentence.push(", ");
        });
        sentence.push(lastWordConnector + " ");
        sentence.push(items[numItems - 1]); // last item
        break;
    }
    return _jsx("span", {}, void 0, sentence);
  },
  sentenceJoin: function sentenceJoin(items) {
    var separator = arguments.length <= 1 || arguments[1] === undefined ? ", " : arguments[1];

    var sentence = [];
    _lodash2.default.each(items.slice(0, -1), function (item) {
      sentence.push(item);
      sentence.push(separator);
    });
    sentence.push(items[items.length - 1]);
    return _jsx("span", {}, void 0, sentence);
  }
};

},{"lodash":"lodash"}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDisplayableAsPercent = isDisplayableAsPercent;
/**
 * Returns true if the supplied UserStatus-shaped data
 * can be displayed as a percent, meaning it either _is_
 * based directly on percent or has a page number out of a
 * known total number of pages. Some books don't have a numPages
 * attribute.
 *
 * This is duplicative of reading_session_helper#isDisplayableAsPercent.
 *
 * @param userStatus
 * @returns {boolean}
 */
function isDisplayableAsPercent(userStatus) {
  return !!userStatus.maxProgressValue;
}

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["loadMoreFollowedAuthors"]);

},{"reflux":"reflux"}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["hideBanner", "optAuthorIntoQA"]);

},{"reflux":"reflux"}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["follow", "unFollow"]);

},{"reflux":"reflux"}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return _reflux2.default.createActions([
  // selects a specific result based on mouse movement
  "selectSpecificResult",
  // selects the next active result index based on arrow key input
  "selectNextResult",
  // selects the previous active result index based on arrow key input
  "selectPreviousResult",
  // queries the search controller for search results based on user input
  "search",
  // hides searching spinner and shows the results
  "searchResultsFound",
  // either shows/hides the results based on the input
  "setShowResultsContainer"]);
};

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"reflux":"reflux"}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getACopyClickedHandler = exports.getACopyClosed = exports.getACopyLoadedSuccess = exports.GET_A_COPY_ACTIONS = undefined;

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var GET_A_COPY_ACTIONS = exports.GET_A_COPY_ACTIONS = {
  LOADED_SUCCESS: "GET_A_COPY_LOADED_SUCCESS",
  INTERSTITIAL_CLOSED: "GET_A_COPY_INTERSTITIAL_CLOSED"
};

var getACopyLoadedSuccess = exports.getACopyLoadedSuccess = function getACopyLoadedSuccess(data) {
  return {
    type: GET_A_COPY_ACTIONS.LOADED_SUCCESS,
    data: data
  };
};

var getACopyClosed = exports.getACopyClosed = function getACopyClosed() {
  return {
    type: GET_A_COPY_ACTIONS.INTERSTITIAL_CLOSED
  };
};

var getACopyClickedHandler = exports.getACopyClickedHandler = function getACopyClickedHandler(getACopyDataUrl) {
  return function (dispatch) {
    (0, _ajax_helper.httpGet)(getACopyDataUrl).done(function (data) {
      dispatch(getACopyLoadedSuccess(data));
    });
  };
};

},{"../../modules/ajax/ajax_helper":4}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["hideTooltip", "setSlides", "setWidths", "showTooltip", "slidingCompletion"]);

},{"reflux":"reflux"}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([]);

},{"reflux":"reflux"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  addNewComment: {},
  commentEntered: { sync: true },
  deleteComment: {},
  showCommentsForPage: {},
  showSeeMoreLoadingSpinner: {},
  textareaFocused: {},
  textareaFocusRequested: {},
  textareaUnfocused: {}
});

},{"reflux":"reflux"}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
// expect event object with additional trackingOptions object
"trackClickEvent"]);

},{"reflux":"reflux"}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["openCreationDialog", "closeCreationDialog", "save"]);

},{"reflux":"reflux"}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
// accepts a single string arg that is the contents of the message
"requestCreativeForSlot", "displayCreativeForSlot", "removeAdSlot", "trackImpression", "attachServedNativeAdAttributesAndTracking", "attachServedBannerAdAttributesAndTracking", "hasAttachedDfpCallbackForSlot", "checkCallbacksAttached"]);

},{"reflux":"reflux"}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["like", "unLike"]);

},{"reflux":"reflux"}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["openModal", "closeModal"]);

},{"reflux":"reflux"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  loadMoreUpdates: {},
  newsfeedItemsLoaded: { sync: true },
  updateNativeAdSlot: {},
  userNotInterested: {},
  undoUserNotInterested: {},
  hideStory: {},
  previewBook: {},
  setUpdatesFeedPreferences: {}
});

},{"reflux":"reflux"}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["bookNumChanged", "startChallenge"]);

},{"reflux":"reflux"}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["updateProgress", "closeUpdateProgressForm", "openUpdateProgressForm", "refreshReadingSessions", "shelveBookSuccess", "loadAllReadingSessions"]);

},{"reflux":"reflux"}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["requestNextRec"]);

},{"reflux":"reflux"}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  addShelvings: {},
  bookShelved: {},
  bookUnshelved: {},
  shelveBook: {},
  toggleNonExclusiveShelving: {},
  rateBook: { children: ["newBook", "failed"] },
  unshelveBook: {}
});

},{"reflux":"reflux"}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["userAgentGainsTouch", "userAgentLosesTouch"]);

},{"reflux":"reflux"}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["userNotInterested", "undoUserNotInterested", "isFlashMessageForBook", "closeFlashMessage", "addBookIDToState"]);

},{"reflux":"reflux"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["addNonExclusiveShelf", "removeNonExclusiveShelf"]);

},{"reflux":"reflux"}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["openAddShelfTextbox", "closeAddShelfTextbox", "updateShelfNameFilter", "updateShelves"]);

},{"reflux":"reflux"}],46:[function(require,module,exports){
"use strict";

require("./_polyfills");

var _dom_ready_initializers = require("./_dom_ready_initializers");

var _dom_ready_initializers2 = _interopRequireDefault(_dom_ready_initializers);

var _public_actions = require("./_public_actions");

var _public_actions2 = _interopRequireDefault(_public_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ReactActions = _public_actions2.default;

// initialize any routines that are required to execute on DOM Ready
_dom_ready_initializers2.default.initializeModernizrTouchCheck();

},{"./_dom_ready_initializers":47,"./_polyfills":48,"./_public_actions":49}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  /**
   * Initializes modernizr touch check on DOM Ready
   */
  initializeModernizrTouchCheck: function initializeModernizrTouchCheck() {
    document.addEventListener("DOMContentLoaded", function () {
      if (Modernizr && Modernizr.touchevents) {
        window.ReactActions.UserAgentCapabilitiesActions.userAgentGainsTouch();
      } else {
        window.ReactActions.UserAgentCapabilitiesActions.userAgentLosesTouch();
      }
    });
  }
};

},{}],48:[function(require,module,exports){
"use strict";

var _objectAssign = require("object-assign");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("../react_isomorphic/shims/Array.prototype.find");

window.Object.assign = _objectAssign2.default;

},{"../react_isomorphic/shims/Array.prototype.find":245,"object-assign":"object-assign"}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user_agent_capabilities_actions = require("../react_actions/user_agent_capabilities_actions");

var _user_agent_capabilities_actions2 = _interopRequireDefault(_user_agent_capabilities_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  UserAgentCapabilitiesActions: _user_agent_capabilities_actions2.default
};

},{"../react_actions/user_agent_capabilities_actions":42}],50:[function(require,module,exports){
"use strict";

require("./_common");

var _global = require("../react_isomorphic/global");

var _author_bundle = require("../react_isomorphic/author_bundle");

var _home = require("../react_isomorphic/home");

var _lodash = require("lodash");

window.ReactComponents = (0, _lodash.merge)(window.ReactComponents, _global.GlobalComponents, _author_bundle.AuthorComponents, _home.HomeComponents);
window.ReactStores = (0, _lodash.merge)(window.ReactStores, _global.GlobalStores, _author_bundle.AuthorStores, _home.HomeStores);

},{"../react_isomorphic/author_bundle":242,"../react_isomorphic/global":243,"../react_isomorphic/home":244,"./_common":46,"lodash":"lodash"}],51:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _book = require("../../book");

var _book2 = _interopRequireDefault(_book);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _want_to_read_button = require("../../want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SponsoredBook",

  propTypes: {
    widgetTitle: _react2.default.PropTypes.string,
    showAudibleCommand: _react2.default.PropTypes.bool,
    sponsoredBookExternalLinkUrl: _react2.default.PropTypes.string,
    sponsoredBookExternalLinkText: _react2.default.PropTypes.string,
    bookAci: _react2.default.PropTypes.string,
    requestOriginUrl: _react2.default.PropTypes.string,
    randomRequestParam: _react2.default.PropTypes.string,
    audiobookHost: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      trackingOptions: {
        enableTracking: true
      }
    };
  },
  renderTitle: function renderTitle() {
    if (this.props.widgetTitle) {
      return _jsx("h3", {}, void 0, this.props.widgetTitle);
    }
    return null;
  },
  renderExternalLink: function renderExternalLink() {
    if (this.props.sponsoredBookExternalLinkUrl) {
      var externalLink = _jsx("form", {
        target: "_blank",
        rel: "noopener noreferrer"
      }, void 0, _jsx("button", {
        formAction: this.props.sponsoredBookExternalLinkUrl,
        className: "gr-button"
      }, void 0, this.props.sponsoredBookExternalLinkText));
      return _jsx("div", {
        className: "gr-sponsoredBook-ControlContainer"
      }, void 0, _jsx(_click_tracking_wrapper2.default, {
        children: externalLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookExternalLink
      }));
    }
    return null;
  },
  render: function render() {
    var wantToReadProps = {
      bookId: this.props.bookId,
      bookTitle: this.props.title,
      uniqueId: (0, _lodash.random)(10000).toString(),
      showStars: true,
      showMenu: true
    };
    var classnames = (0, _classnames2.default)(["gr-sponsoredWidget", "gr-sponsoredBook"]);
    var props = (0, _lodash.omit)(this.props, "trackingOptions");

    return _jsx("div", {
      className: classnames
    }, void 0, this.renderTitle(), _react2.default.createElement(
      _book2.default,
      _extends({ size: "large" }, props, { bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookImage,
        bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookTitle,
        authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_AuthorLink }),
      _react2.default.createElement(_want_to_read_button2.default, _extends({}, wantToReadProps, { trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_WantToRead, starsTrackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_Stars })),
      _jsx(_book_description2.default, {
        bookDescription: this.props.description,
        className: "gr-book__description u-marginTopXSmall",
        bookDescriptionTargetingData: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookDescription
      }),
      _jsx("div", {}, void 0, this.renderExternalLink())
    ));
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../book":73,"../../book_description":75,"../../click_tracking_wrapper":93,"../../gr_component_factory":108,"../../want_to_read/want_to_read_button":238,"classnames":"classnames","lodash":"lodash","react":"react"}],52:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "YoutubeVideo",

  propTypes: {
    widgetTitle: _react2.default.PropTypes.string,
    width: _react2.default.PropTypes.number,
    height: _react2.default.PropTypes.number,
    videoId: _react2.default.PropTypes.string,
    videoTitle: _react2.default.PropTypes.string,
    videoDescription: _react2.default.PropTypes.string,
    videoExternalLinkUrl: _react2.default.PropTypes.string,
    videoExternalLinkText: _react2.default.PropTypes.string,
    autoplay: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      width: 300,
      height: 200,
      autoplay: false,
      trackingOptions: {
        enableTracking: true
      }
    };
  },
  renderTitle: function renderTitle() {
    if (this.props.widgetTitle) {
      return _jsx("h3", {}, void 0, this.props.widgetTitle);
    }
    return null;
  },
  renderVideoTitle: function renderVideoTitle() {
    if (this.props.videoTitle) {
      return _jsx("div", {
        className: "gr-youtubeVideo__title"
      }, void 0, this.props.videoTitle);
    }
    return null;
  },
  renderVideoDescription: function renderVideoDescription() {
    if (this.props.videoDescription) {
      return _jsx("div", {
        className: "gr-youtubeVideo__description"
      }, void 0, this.props.videoDescription);
    }
    return null;
  },
  renderExternalLink: function renderExternalLink() {
    if (this.props.videoExternalLinkUrl) {
      var externalLink = _jsx("form", {
        target: "_blank",
        rel: "noopener noreferrer"
      }, void 0, _jsx("button", {
        formAction: this.props.videoExternalLinkUrl,
        className: "gr-button"
      }, void 0, this.props.videoExternalLinkText));
      return _jsx(_click_tracking_wrapper2.default, {
        children: externalLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Video_ExternalLink
      });
    }
    return null;
  },
  render: function render() {
    var classnames = (0, _classnames2.default)(["gr-sponsoredWidget"]);
    var source = "//www.youtube.com/embed/" + this.props.videoId + "?autoplay=";
    var autoplay = this.props.autoplay ? "1" : "0";
    source += autoplay;
    var playerStyle = { width: this.props.width, display: "inline-block" };
    return _jsx("div", {
      className: classnames
    }, void 0, this.renderTitle(), _jsx("div", {
      style: playerStyle
    }, void 0, _jsx("iframe", {
      width: this.props.width,
      height: this.props.height,
      src: source,
      frameBorder: 0,
      allowFullScreen: true
    })), _jsx("div", {
      className: "gr-youtubeVideo__additionalContent"
    }, void 0, this.renderVideoTitle(), this.renderVideoDescription(), this.renderExternalLink()));
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":93,"../../gr_component_factory":108,"classnames":"classnames","react":"react"}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _google_ad_helper = require("../../modules/ads/google_ad_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var BLOCK_CLASS_NAME = "googleBannerAd";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleBannerAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.ads[this.props.adId];
  })],

  propTypes: {
    adId: _react2.default.PropTypes.string.isRequired,
    className: _react2.default.PropTypes.string,
    delayImpressionTracking: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      delayImpressionTracking: false
    };
  },
  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    var adId = this.props.adId;
    if (this.getStoreState()) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        delayImpressionTracking: this.props.delayImpressionTracking,
        isLazyLoaded: this.getStoreState().isLazyLoaded,
        path: this.getStoreState().path
      };
      if (this.getStoreState().isLazyLoaded) {
        (0, _google_ad_helper.lazyLoadOnView)((function (event) {
          if (event.target.id === this.adId) {
            (0, _google_ad_helper.requestCreativeForAdSlot)(this.adId, this.params);
          }
        }).bind({ adId: adId, params: params }));
      } else {
        (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
      }
    }
  },
  getWidthFromDimensions: function getWidthFromDimensions(dimensionsStr) {
    return parseInt(dimensionsStr.split("x")[0]);
  },
  getBannerAdSizingStyle: function getBannerAdSizingStyle(dimensions) {
    var _this = this;

    var width = undefined;
    if (Array.isArray(dimensions)) {
      var _Math;

      // Per DFP recommendations regarding multi-size ads, we should set the
      // width to the widest creative to avoid ads being cropped.
      width = (_Math = Math).max.apply(_Math, _toConsumableArray(dimensions.map(function (x) {
        return _this.getWidthFromDimensions(x);
      })));
    } else {
      width = this.getWidthFromDimensions(dimensions);
    }
    return { width: width, height: "auto" };
  },
  render: function render() {
    if (this.getStoreState()) {
      var classes = (0, _classnames2.default)(this.props.className, BLOCK_CLASS_NAME, {
        lazyload: this.getStoreState().isLazyLoaded
      });
      return _react2.default.createElement("div", { className: classes,
        id: this.props.adId,
        style: this.getBannerAdSizingStyle(this.getStoreState().dimensions),
        ref: "googleHook" });
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/google_ad_helper":3,"../../react_stores/google_ads_store":264,"../gr_component_factory":108,"classnames":"classnames","react":"react","reflux":"reflux"}],54:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // Google ad store connection to native ads
// This component calls request native ad which pull the native ad id from the iframe
// and requests the native ad from ajax_native_ad in dfp_controller

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _google_ads_store = require("../../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _native_ad_body = require("./native_ad_body");

var _native_ad_body2 = _interopRequireDefault(_native_ad_body);

var _google_ad_helper = require("../../../modules/ads/google_ad_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleNativeAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: React.PropTypes.string.isRequired,
    trackingOptions: React.PropTypes.shape({
      enableTracking: React.PropTypes.bool,
      adId: React.PropTypes.string
    }).isRequired,
    className: React.PropTypes.string,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool,
    isMobile: React.PropTypes.bool,
    isNewsfeed: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isMobile: false,
      isNewsfeed: true,
      signedIn: true
    };
  },
  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    if (this.getStoreState() && !this.getStoreState().creative) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        lazyLoadedNewsfeedAd: this.getStoreState().lazyLoadedNewsfeedAd,
        path: this.getStoreState().path,
        isLazyLoaded: this.getStoreState().isLazyLoaded
      };
      if (this.getStoreState().lazyLoadedNewsfeedAd || this.getStoreState().isLazyLoaded) {
        (0, _google_ad_helper.lazyLoadOnView)((function (event) {
          if (event.target.id === this.adId) {
            (0, _google_ad_helper.requestCreativeForAdSlot)(this.adId, this.params);
          }
        }).bind({ adId: this.props.adId, params: params }));
      } else {
        (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
      }
    }
  },
  render: function render() {
    if (this.getStoreState()) {
      // IMPORTANT: We must keep the googleHook div visible in order to preserve
      //            viewable impressions!
      var googleHookClasses = (0, _classnames2.default)("googleNativeAd__googleHook", this.getStoreState().className, "lazyload");
      var nativeAdClasses = (0, _classnames2.default)("googleNativeAd", this.props.className);
      var nativeAdBody = this.getStoreState().creative ? _jsx(_native_ad_body2.default, {
        creative: this.getStoreState().creative,
        adId: this.props.adId,
        deviceType: this.getStoreState().deviceType,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        isMobile: this.props.isMobile,
        isNewsfeed: this.props.isNewsfeed
      }) : null;
      return _jsx("div", {
        className: nativeAdClasses
      }, void 0, React.createElement(
        "div",
        { className: googleHookClasses, id: this.props.adId, ref: "googleHook" },
        nativeAdBody
      ));
    } else {
      return null;
    }
  }
});

},{"../../../modules/ads/google_ad_helper":3,"../../../react_stores/google_ads_store":264,"../../gr_component_factory":108,"./native_ad_body":56,"classnames":"classnames","reflux":"reflux"}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ads_store = require("../../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _google_native_ad = require("./google_native_ad");

var _google_native_ad2 = _interopRequireDefault(_google_native_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: _react2.default.PropTypes.string.isRequired,
    trackingOptions: _react2.default.PropTypes.shape({
      enableTracking: _react2.default.PropTypes.bool,
      adId: _react2.default.PropTypes.string
    }).isRequired,
    className: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool,
    allowBehavioralTargeting: _react2.default.PropTypes.bool,
    isMobile: _react2.default.PropTypes.bool,
    isNewsfeed: _react2.default.PropTypes.bool
  },

  getAdsStoreState: function getAdsStoreState() {
    return this.state.googleAdsStore;
  },
  getDefaultProps: function getDefaultProps() {
    return {
      signedIn: true,
      isMobile: false,
      isNewsfeed: true
    };
  },
  render: function render() {
    if (!this.getAdsStoreState()) {
      return null;
    }
    return _react2.default.createElement(_google_native_ad2.default, this.props);
  }
}); // Entry point for native ads

},{"../../../react_stores/google_ads_store":264,"../../gr_component_factory":108,"./google_native_ad":54,"react":"react","reflux":"reflux"}],56:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_not_interested_store = require("../../../react_stores/user_not_interested_store");

var _user_not_interested_store2 = _interopRequireDefault(_user_not_interested_store);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _native_book_ad = require("./native_book_ad");

var _native_book_ad2 = _interopRequireDefault(_native_book_ad);

var _native_flex_ad = require("./native_flex_ad");

var _native_flex_ad2 = _interopRequireDefault(_native_flex_ad);

var _user_not_interested_message = require("./user_not_interested_message");

var _user_not_interested_message2 = _interopRequireDefault(_user_not_interested_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeAdBody",

  mixins: [_reflux2.default.connect(_user_not_interested_store2.default, "userNotInterestedStore")],

  propTypes: {
    adId: React.PropTypes.string,
    creative: React.PropTypes.object.isRequired,
    adDeviceType: React.PropTypes.string,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool,
    isMobile: React.PropTypes.bool,
    isNewsfeed: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isNewsfeed: true,
      isMobile: false,
      signedIn: true
    };
  },
  getUserNotInterestedStoreState: function getUserNotInterestedStoreState() {
    return this.state.userNotInterestedStore;
  },
  render: function render() {
    if (this.props.creative && this.props.creative.book) {
      var bookId = this.props.creative.book.bookId;
      if (this.getUserNotInterestedStoreState()[bookId]) {
        if (this.getUserNotInterestedStoreState()[bookId].isClosed) {
          return null;
        } else if (this.getUserNotInterestedStoreState()[bookId].isFlashMessage) {
          return _jsx(_user_not_interested_message2.default, {
            id: this.props.adId,
            isNewsfeed: this.props.isNewsfeed,
            className: this.props.className,
            creative: this.props.creative
          });
        }
      } else {
        _user_not_interested_actions2.default.addBookIDToState(bookId);
      }
    }
    if (this.props.creative && this.props.creative.book) {
      return _jsx(_native_book_ad2.default, {
        isNewsfeed: this.props.isNewsfeed,
        isMobile: this.props.isMobile,
        creative: this.props.creative,
        adDeviceType: this.props.adDeviceType,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        id: this.props.adId
      });
    } else {
      return _jsx(_native_flex_ad2.default, {
        id: this.props.adId,
        creative: this.props.creative,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        isNewsfeed: this.props.isNewsfeed,
        isMobile: this.props.isMobile
      });
    }
  }
});

},{"../../../react_actions/user_not_interested_actions":43,"../../../react_stores/user_not_interested_store":274,"../../gr_component_factory":108,"./native_book_ad":59,"./native_flex_ad":61,"./user_not_interested_message":63,"reflux":"reflux"}],57:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeAdCaret = undefined;

var _react = require("react");

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _dropdown = require("../../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeAdCaret = exports.NativeAdCaret = (function (_Component) {
  _inherits(NativeAdCaret, _Component);

  function NativeAdCaret(props) {
    _classCallCheck(this, NativeAdCaret);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeAdCaret).call(this, props));
  }

  _createClass(NativeAdCaret, [{
    key: "renderNotInterested",
    value: function renderNotInterested() {
      var _this2 = this;

      if (this.props.book && this.props.signedIn) {
        var notInterButtonAction = function notInterButtonAction() {
          return _user_not_interested_actions2.default.userNotInterested(_this2.props.book.bookId);
        };
        var notInterButton = _jsx("button", {
          className: "gr-buttonAsLink nativeAdCaretMenu__button",
          onClick: notInterButtonAction
        }, void 0, "I’m not interested in this book");
        return _jsx(_click_tracking_wrapper2.default, {
          children: notInterButton,
          trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret_not_interested
        });
      } else {
        return null;
      }
    }
  }, {
    key: "caretList",
    value: function caretList() {
      var whyAmISeeingThisLink = _jsx("a", {
        className: "nativeAdCaretMenu__link",
        href: this.props.helpLink
      }, void 0, "Why am I seeing this?");
      return _jsx("div", {
        className: "nativeAdCaretMenu"
      }, void 0, this.renderNotInterested(), (0, _lodash.map)(this.props.additionalLinks, function (link) {
        return _jsx("div", {
          className: "nativeAdCaretMenu__button"
        }, link, "link");
      }), _jsx(_click_tracking_wrapper2.default, {
        children: whyAmISeeingThisLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret_help
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: "nativeAdCaret"
      }, void 0, _jsx(_dropdown2.default, {
        trigger: _jsx("div", {
          className: "nativeAdCaret nativeAdCaret__image",
          "aria-label": "Sponsored item options"
        }),
        triggerEventType: _dropdown2.default.TriggerEventTypes.CLICK,
        bemModifiers: "caret",
        children: this.caretList()
      }));
    }
  }]);

  return NativeAdCaret;
})(_react.Component);

NativeAdCaret.propTypes = {
  book: _gr_prop_types2.default.book(),
  helpLink: _react.PropTypes.string,
  updateId: _react.PropTypes.string,
  additionalLinks: _react.PropTypes.arrayOf(_react.PropTypes.elements),
  signedIn: _react.PropTypes.bool
};

NativeAdCaret.defaultProps = {
  trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret,
  signedIn: true
};

exports.default = NativeAdCaret;

},{"../../../modules/ads/click_tracking_helper":2,"../../../react_actions/user_not_interested_actions":43,"../../click_tracking_wrapper":93,"../../dropdown":104,"../../shared/gr_prop_types":221,"lodash":"lodash","react":"react"}],58:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeAdSponsoredLabel = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeAdSponsoredLabel = exports.NativeAdSponsoredLabel = (function (_Component) {
  _inherits(NativeAdSponsoredLabel, _Component);

  function NativeAdSponsoredLabel(props) {
    _classCallCheck(this, NativeAdSponsoredLabel);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeAdSponsoredLabel).call(this, props));
  }

  _createClass(NativeAdSponsoredLabel, [{
    key: "render",
    value: function render() {
      var sponsoredLabel = this.props.sponsoredBy ? "Sponsored by " : "Sponsored";
      var sponsoredFooter = _jsx("div", {
        className: "nativeAd__sponsoredLabel"
      }, void 0, _jsx("span", {
        className: "googleNativeAd__sponsoredBadgeIcon"
      }), _jsx("span", {
        className: "googleNativeAd__sponsoredLabel"
      }, void 0, sponsoredLabel), _jsx("a", {
        target: "_blank",
        href: this.props.sponsoredUrl,
        className: "gr-hyperlink"
      }, void 0, this.props.sponsoredBy));
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_label,
        children: sponsoredFooter
      });
    }
  }]);

  return NativeAdSponsoredLabel;
})(_react.Component);

NativeAdSponsoredLabel.propTypes = {
  sponsoredBy: _react2.default.PropTypes.string,
  sponsoredUrl: _react2.default.PropTypes.string
};

exports.default = NativeAdSponsoredLabel;

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":93,"react":"react"}],59:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeBookAd = undefined;

var _react = require("react");

var _native_book_ad_header = require("./native_book_ad_header");

var _native_book_ad_header2 = _interopRequireDefault(_native_book_ad_header);

var _book = require("../../book");

var _book2 = _interopRequireDefault(_book);

var _book_with_wtr_button = require("../../book_with_wtr_button");

var _book_with_wtr_button2 = _interopRequireDefault(_book_with_wtr_button);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _shape_icon = require("../../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _native_ad_caret = require("./native_ad_caret");

var _native_ad_caret2 = _interopRequireDefault(_native_ad_caret);

var _native_ad_sponsored_label = require("./native_ad_sponsored_label");

var _native_ad_sponsored_label2 = _interopRequireDefault(_native_ad_sponsored_label);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeBookAd = exports.NativeBookAd = (function (_Component) {
  _inherits(NativeBookAd, _Component);

  function NativeBookAd(props) {
    _classCallCheck(this, NativeBookAd);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeBookAd).call(this, props));
  }

  _createClass(NativeBookAd, [{
    key: "isDesktopNewsfeed",
    value: function isDesktopNewsfeed() {
      return this.props.isNewsfeed && !this.props.isMobile;
    }
  }, {
    key: "isMobileNewsfeed",
    value: function isMobileNewsfeed() {
      return this.props.isNewsfeed && this.props.isMobile;
    }
  }, {
    key: "renderBookDescription",
    value: function renderBookDescription() {
      var previewBook = !this.props.isMobile ? _jsx(_preview_book2.default, {
        book: this.props.creative.book
      }) : null;
      if (this.props.creative.customText) {
        return _jsx("div", {
          className: "gr-book__description u-marginTopXSmall"
        }, void 0, React.createElement(_expandable_html2.default, this.props.creative.customText), _jsx("div", {
          className: "u-paddingTopSmall"
        }, void 0, previewBook));
      } else {
        return _jsx("div", {}, void 0, _jsx(_book_description2.default, {
          className: "u-marginTopXSmall",
          bookDescription: this.props.creative.book.description
        }), _jsx("div", {
          className: "u-paddingTopSmall"
        }, void 0, previewBook));
      }
    }
  }, {
    key: "renderLearnMoreButton",
    value: function renderLearnMoreButton() {
      var bookLink = _jsx("a", {
        href: this.props.creative.book.bookUrl,
        rel: "noopener noreferrer",
        className: "gr-button u-marginTopMedium"
      }, void 0, "Learn More");
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.cta_link,
        children: bookLink
      });
    }
  }, {
    key: "renderBook",
    value: function renderBook() {
      var bodyContainerClassnames = (0, _classnames2.default)({
        "gr-newsfeedItem__body": this.isDesktopNewsfeed(),
        bookAdBody: !this.isDesktopNewsfeed()
      });
      var book = this.props.creative.book;
      if (this.props.signedIn) {
        return _jsx(_book_with_wtr_button2.default, {
          body: this.renderBookDescription(),
          book: book,
          responsiveWtrButton: this.props.isMobile,
          bookClassName: bodyContainerClassnames
        });
      } else {
        return React.createElement(
          _book2.default,
          _extends({}, book, {
            className: bodyContainerClassnames,
            size: _book.VALID_BOOK_SIZES.LARGE }),
          this.props.isMobile ? _jsx(_community_rating2.default, {
            rating: parseFloat(book.avgRating),
            displayAvgRatingText: false,
            ratingsCount: book.ratingsCount,
            size: _community_rating2.default.ICON_SIZES.MEDIUM
          }) : null,
          this.renderBookDescription(),
          this.renderLearnMoreButton()
        );
      }
    }
  }, {
    key: "renderCaret",
    value: function renderCaret() {
      return _jsx("div", {
        className: "googleNativeAd__caret"
      }, void 0, _jsx(_native_ad_caret2.default, {
        book: this.props.creative.book,
        helpLink: this.props.creative.helpLink,
        updateId: this.props.id,
        signedIn: this.props.signedIn
      }));
    }
  }, {
    key: "renderIconBody",
    value: function renderIconBody() {
      if (this.props.creative.firstFriend) {
        return _jsx(_user_icon2.default, {
          user: this.props.creative.firstFriend,
          size: _shape_icon_values.ICON_SIZES.MEDIUM
        });
      } else {
        return _jsx(_shape_icon2.default, {
          imageUrl: this.props.creative.defaultIcon,
          size: _shape_icon_values.ICON_SIZES.MEDIUM,
          imageAlt: "Sponsored Newsfeed Item Icon",
          border: true
        });
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return _jsx("div", {
        className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
      }, void 0, this.renderIconBody());
    }
  }, {
    key: "render",
    value: function render() {
      var sponsoredLine = _jsx(_native_ad_sponsored_label2.default, {
        sponsoredBy: this.props.creative.sponsoredBy,
        sponsoredUrl: this.props.creative.sponsoredUrl
      });

      var bodyClasses = (0, _classnames2.default)("gr-mediaBox", {
        "feedItem feedItem--ad": this.isMobileNewsfeed(),
        "gr-newsfeedItem gr-mediaBox": this.isDesktopNewsfeed(),
        "googleNativeAd__item ": !this.isDesktopNewsfeed()
      });
      var bookClasses = (0, _classnames2.default)({
        nativeAd__newsfeedBody: this.isDesktopNewsfeed()
      });
      return React.createElement(
        "div",
        { className: bodyClasses, ref: "nativeAd" },
        this.isDesktopNewsfeed() && this.renderIcon(),
        _jsx("div", {
          className: "u-marginBottomSmall"
        }, void 0, this.renderCaret(), _jsx("div", {
          className: "nativeAd__headerText"
        }, void 0, _jsx(_native_book_ad_header2.default, {
          creative: this.props.creative,
          signedIn: this.props.signedIn,
          allowBehavioralTargeting: this.props.allowBehavioralTargeting
        })), this.props.creative.isSponsored ? sponsoredLine : null, _jsx("div", {
          className: bookClasses
        }, void 0, this.renderBook()))
      );
    }
  }]);

  return NativeBookAd;
})(_react.Component);

NativeBookAd.propTypes = {
  isNewsfeed: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool,
  creative: _react.PropTypes.shape().isRequired,
  adDeviceType: _react.PropTypes.string,
  signedIn: _react.PropTypes.bool,
  allowBehavioralTargeting: React.PropTypes.bool,
  id: _react.PropTypes.string
};

exports.default = NativeBookAd;

},{"../../../modules/ads/click_tracking_helper":2,"../../../modules/shape_icon_values":19,"../../book":73,"../../book_description":75,"../../book_with_wtr_button":76,"../../click_tracking_wrapper":93,"../../community_rating":99,"../../preview_book/preview_book":200,"../../shape_icon":219,"../../user/user_icon":230,"../../user_content/expandable_html":232,"./native_ad_caret":57,"./native_ad_sponsored_label":58,"./native_book_ad_header":60,"classnames":"classnames","react":"react"}],60:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeBookAdHeader",

  propTypes: {
    creative: _gr_prop_types2.default.creative().isRequired,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool
  },

  // Setting default to true for signed in homepage newsfeed
  getDefaultProps: function getDefaultProps() {
    return {
      signedIn: true
    };
  },
  renderLink: function renderLink(text, url) {
    return _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: url
    }, void 0, text);
  },
  renderFriendHeader: function renderFriendHeader() {
    var firstFriend = _lodash2.default.head(this.props.creative.topFriends);
    return _jsx("span", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, _jsx(_user_profile_link2.default, {
      user: firstFriend
    }), this.renderHeaderText(), " ", this.props.creative.friendActionText);
  },
  renderHeaderText: function renderHeaderText() {
    if (this.props.creative.numAdditionalFriends === 1) {
      return _jsx("span", {}, void 0, " and ", _jsx(_user_profile_link2.default, {
        user: this.props.creative.topFriends[1]
      }));
    } else if (this.props.creative.numAdditionalFriends > 1) {
      return _jsx("span", {}, void 0, " and ", this.renderLink(this.props.creative.numAdditionalFriends + " other friends", this.props.creative.book.bookUrl + "#friendReviews"));
    } else {
      return null;
    }
  },
  renderSimilarBook: function renderSimilarBook() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText gr-newsfeedItem__headerText--truncateWithEllipsis"
    }, void 0, "This is similar to ", this.renderLink(this.props.creative.similarBook.title, this.props.creative.similarBook.bookUrl));
  },
  renderGenres: function renderGenres() {
    var topGenre = _lodash2.default.head(this.props.creative.genres);
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "This book has been shelved by members as ", this.renderLink(topGenre.genre, topGenre.url), this.props.creative.genres.length > 1 ? _jsx("span", {}, void 0, " and ", this.renderLink(this.props.creative.genres[1].genre, this.props.creative.genres[1].url)) : null);
  },
  renderDefault: function renderDefault() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "Based on your reading preferences, you might enjoy");
  },
  renderSignedOutText: function renderSignedOutText() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "Recommended");
  },
  renderContextualHeader: function renderContextualHeader() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, this.props.creative.headerText);
  },
  render: function render() {
    if (this.props.creative.headerText) {
      return this.renderContextualHeader();
    } else if (!this.props.allowBehavioralTargeting) {
      return this.renderSignedOutText();
    } else if (!this.props.signedIn) {
      return this.renderSignedOutText();
    } else if (this.props.creative.topFriends) {
      return this.renderFriendHeader();
    } else if (this.props.creative.similarBook) {
      return this.renderSimilarBook();
    } else if (this.props.creative.genres) {
      return this.renderGenres();
    } else {
      return this.renderDefault();
    }
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_profile_link":231,"lodash":"lodash"}],61:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeFlexAd = undefined;

var _react = require("react");

var _native_flex_ad_body = require("./native_flex_ad_body");

var _native_flex_ad_body2 = _interopRequireDefault(_native_flex_ad_body);

var _shape_icon = require("../../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _native_ad_caret = require("./native_ad_caret");

var _native_ad_caret2 = _interopRequireDefault(_native_ad_caret);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _native_ad_sponsored_label = require("./native_ad_sponsored_label");

var _native_ad_sponsored_label2 = _interopRequireDefault(_native_ad_sponsored_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeFlexAd = exports.NativeFlexAd = (function (_Component) {
  _inherits(NativeFlexAd, _Component);

  function NativeFlexAd(props) {
    _classCallCheck(this, NativeFlexAd);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeFlexAd).call(this, props));
  }

  _createClass(NativeFlexAd, [{
    key: "getHeaderText",
    value: function getHeaderText() {
      return {
        __html: this.props.creative.headerText
      };
    }
  }, {
    key: "renderCaret",
    value: function renderCaret() {
      return _jsx("div", {
        className: "googleNativeAd__caret"
      }, void 0, _jsx(_native_ad_caret2.default, {
        helpLink: this.props.creative.helpLink,
        updateId: this.props.id,
        signedIn: this.props.signedIn
      }));
    }
  }, {
    key: "isDesktopNewsfeed",
    value: function isDesktopNewsfeed() {
      return this.props.isNewsfeed && !this.props.isMobile;
    }
  }, {
    key: "isMobileNewsfeed",
    value: function isMobileNewsfeed() {
      return this.props.isNewsfeed && this.props.isMobile;
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return _jsx("div", {
        className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
      }, void 0, _jsx(_shape_icon2.default, {
        imageUrl: this.props.creative.defaultIcon,
        size: _shape_icon_values.ICON_SIZES.MEDIUM,
        imageAlt: "Sponsored Item Icon",
        border: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var bodyClassNames = (0, _classnames2.default)({
        "gr-newsfeedItem__body nativeAd__newsfeedBody": this.isDesktopNewsfeed()
      });
      var sponsoredLine = _jsx(_native_ad_sponsored_label2.default, {
        sponsoredBy: this.props.creative.sponsoredBy,
        sponsoredUrl: this.props.creative.sponsoredUrl
      });

      var bodyClasses = (0, _classnames2.default)("gr-mediaBox", {
        "gr-newsfeedItem gr-mediaBox": this.isDesktopNewsfeed(),
        "googleNativeAd__item ": !this.isDesktopNewsfeed(),
        "feedItem feedItem--ad": this.isMobileNewsfeed()
      });
      return React.createElement(
        "div",
        { className: bodyClasses, ref: "nativeAd" },
        this.isDesktopNewsfeed() && this.renderIcon(),
        _jsx("div", {
          className: "u-marginBottomSmall"
        }, void 0, this.renderCaret(), _jsx("div", {
          className: "nativeAd__headerText"
        }, void 0, _jsx("div", {
          className: "gr-newsfeedItem__headerText",
          dangerouslySetInnerHTML: this.getHeaderText()
        })), this.props.creative.isSponsored ? sponsoredLine : null, _jsx(_native_flex_ad_body2.default, {
          creative: this.props.creative,
          bodyClassNames: bodyClassNames
        }))
      );
    }
  }]);

  return NativeFlexAd;
})(_react.Component);

NativeFlexAd.propTypes = {
  id: _react.PropTypes.string,
  creative: _react.PropTypes.shape().isRequired,
  signedIn: _react.PropTypes.bool,
  isNewsfeed: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool
};

exports.default = NativeFlexAd;

},{"../../../modules/shape_icon_values":19,"../../shape_icon":219,"./native_ad_caret":57,"./native_ad_sponsored_label":58,"./native_flex_ad_body":62,"classnames":"classnames","react":"react"}],62:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeFlexAdBody",

  propTypes: {
    creative: _gr_prop_types2.default.creative().isRequired,
    bodyClassNames: _react2.default.PropTypes.string
  },

  renderImage: function renderImage() {
    var bodyImageClasses = (0, _classnames2.default)("gr-mediaBox__media", this.withBemModifiers("flexAdBody__image"));
    var bodyImage = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.updateUrl,
      className: "flexAdBody__imageLink"
    }, void 0, _jsx("img", {
      alt: this.props.creative.title,
      className: bodyImageClasses,
      src: this.props.creative.image
    }));
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_update_body_image,
      children: bodyImage
    });
  },
  renderExploreButton: function renderExploreButton() {
    var micrositeLink = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.callToActionUrl,
      className: "gr-button u-marginTopMedium gr-microsite-link"
    }, void 0, this.props.creative.callToActionText);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.cta_link,
      children: micrositeLink
    });
  },
  render: function render() {
    var bodyClasses = (0, _classnames2.default)(this.props.bodyClassNames, "gr-mediaBox", "flexAdBody");
    var bodyTitleLinkClasses = (0, _classnames2.default)("flexAdBody__titleLink", "gr-hyperlink", "gr-hyperlink--naked");
    var titleLink = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.updateUrl,
      className: bodyTitleLinkClasses
    }, void 0, this.props.creative.title);
    return _jsx("div", {
      className: bodyClasses
    }, void 0, this.renderImage(), _jsx("div", {
      className: "gr-mediaBox__desc"
    }, void 0, _jsx("div", {
      className: "flexAdBody__title"
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_update_body_title_link,
      children: titleLink
    })), _jsx("div", {
      className: "flexAdBody__description"
    }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.creative.description)), this.renderExploreButton()));
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":93,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"classnames":"classnames","react":"react"}],63:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserNotInterestedMessage = undefined;

var _react = require("react");

var _close_button = require("../../close_button");

var _close_button2 = _interopRequireDefault(_close_button);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserNotInterestedMessage = exports.UserNotInterestedMessage = (function (_Component) {
  _inherits(UserNotInterestedMessage, _Component);

  function UserNotInterestedMessage(props) {
    _classCallCheck(this, UserNotInterestedMessage);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserNotInterestedMessage).call(this, props));
  }

  _createClass(UserNotInterestedMessage, [{
    key: "renderUndoButton",
    value: function renderUndoButton(book) {
      var _this2 = this;

      return _jsx("button", {
        className: "gr-buttonAsLink",
        onClick: function onClick() {
          _user_not_interested_actions2.default.undoUserNotInterested(book.bookId, _this2.props.id);
        }
      }, void 0, "Undo");
    }
  }, {
    key: "render",
    value: function render() {
      var book = this.props.creative.book;
      if (this.props.isNewsfeed) {
        var userNotInterestedMessage = _jsx("span", {
          className: "gr-newsfeedItem__flashMessage--body"
        }, void 0, "Thanks! We won't recommend", " ", _jsx("a", {
          href: book.bookUrl
        }, void 0, book.title), " ", "again!", " ", this.renderUndoButton(book));
        return _jsx("div", {
          className: "gr-newsfeedItem gr-newsfeedItem__flashMessage",
          role: "alert"
        }, void 0, _jsx("div", {
          className: "gr-newsfeedItem__close"
        }, void 0, _jsx(_close_button2.default, {
          action: function action() {
            _user_not_interested_actions2.default.closeFlashMessage(book.bookId);
          }
        })), userNotInterestedMessage);
      } else {
        var userNotInterestedMessage = _jsx("span", {
          className: "userNotInterested__message"
        }, void 0, "Thanks! We won't recommend", " ", _jsx("a", {
          href: book.bookUrl
        }, void 0, book.title), " ", "again!", " ", this.renderUndoButton(book));
        var userNotInterestedClassname = (0, _classnames2.default)(this.props.className, "userNotInterested");
        return _jsx("div", {
          className: userNotInterestedClassname,
          role: "alert"
        }, void 0, _jsx("div", {
          className: "userNotInterested__close"
        }, void 0, _jsx(_close_button2.default, {
          action: function action() {
            _user_not_interested_actions2.default.closeFlashMessage(book.bookId);
          }
        })), userNotInterestedMessage);
      }
    }
  }]);

  return UserNotInterestedMessage;
})(_react.Component);

UserNotInterestedMessage.propTypes = {
  id: _react.PropTypes.string,
  isNewsfeed: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  creative: _react.PropTypes.shape()
};

exports.default = UserNotInterestedMessage;

},{"../../../react_actions/user_not_interested_actions":43,"../../close_button":94,"classnames":"classnames","react":"react"}],64:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _start_answering_button = require("./start_answering_button");

var _start_answering_button2 = _interopRequireDefault(_start_answering_button);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _ask_the_author_banner_store = require("../../../react_stores/ask_the_author_banner_store");

var _ask_the_author_banner_store2 = _interopRequireDefault(_ask_the_author_banner_store);

var _ask_the_author_banner_actions = require("../../../react_actions/ask_the_author_banner_actions");

var _ask_the_author_banner_actions2 = _interopRequireDefault(_ask_the_author_banner_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AskTheAuthorInvitationBanner",
  mixins: [_reflux2.default.connect(_ask_the_author_banner_store2.default, "askTheAuthorBannerStore")],

  propTypes: function propTypes() {
    _gr_prop_types2.default.user().isRequired;
    React.PropTypes.number.isRequired;
  },
  render: function render() {
    var state = this.state.askTheAuthorBannerStore;
    if (state.isBannerShown) {
      return _jsx("div", {
        className: "askTheAuthorBanner"
      }, void 0, _jsx("div", {
        className: "askTheAuthorBanner__icon"
      }, void 0, _jsx("div", {
        className: "gr-mediaBox__media"
      }, void 0, _jsx(_user_icon2.default, {
        user: this.props.authorUser,
        size: _shape_icon_values.ICON_SIZES.MEDIUM
      }))), _jsx("div", {
        className: "askTheAuthorBanner__title"
      }, void 0, "Hey ", this.props.authorUser.informalName, "! Engage with your readers. Activate Ask the Author to answer their questions."), _jsx("div", {
        className: "askTheAuthorBanner__button"
      }, void 0, _jsx(_start_answering_button2.default, {
        authorID: this.props.authorID
      }), _jsx("button", {
        className: "gr-buttonAsLink askTheAuthorBanner__link",
        onClick: _ask_the_author_banner_actions2.default.hideBanner
      }, void 0, "Skip For Now")));
    } else {
      return null;
    }
  }
});

},{"../../../modules/shape_icon_values":19,"../../../react_actions/ask_the_author_banner_actions":25,"../../../react_stores/ask_the_author_banner_store":254,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_icon":230,"./start_answering_button":69,"reflux":"reflux"}],65:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Renders a widget containing author name, questions answered
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            most recent book, picture, Ask button if they are currently enabled
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            for Ask The Author, and their most recently answered question.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _spoiler = require("../../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

var _flag_for_abuse_link = require("../../flagged_resources/flag_for_abuse_link");

var _flag_for_abuse_link2 = _interopRequireDefault(_flag_for_abuse_link);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _likes_and_comments_footer = require("../../like/likes_and_comments_footer");

var _likes_and_comments_footer2 = _interopRequireDefault(_likes_and_comments_footer);

var _spoiler_warning = require("./shared/spoiler_warning");

var _spoiler_warning2 = _interopRequireDefault(_spoiler_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AskTheAuthorCommunityQuestionAnswerContainer",

  propTypes: {
    authorUser: _gr_prop_types2.default.user().isRequired,
    currentUser: _gr_prop_types2.default.user().isRequired,
    authorTagline: _react2.default.PropTypes.string.isRequired,
    ATAenabled: _react2.default.PropTypes.bool.isRequired,
    questionURL: _react2.default.PropTypes.string.isRequired,
    answerURL: _react2.default.PropTypes.string.isRequired,
    answersCountText: _react2.default.PropTypes.string,
    communityQuestionText: _react2.default.PropTypes.string.isRequired,
    communityAnswerText: _react2.default.PropTypes.shape(_gr_prop_types2.default.truncatedHtml()),
    questionSpoiler: _react2.default.PropTypes.bool.isRequired,
    answerSpoiler: _react2.default.PropTypes.bool.isRequired,
    flagForAbuseUrl: _react2.default.PropTypes.string.isRequired,
    like: _gr_prop_types2.default.like().isRequired,
    comment: _gr_prop_types2.default.comment().isRequired
  },
  renderAuthorIconAndAskButton: function renderAuthorIconAndAskButton() {
    return _jsx("div", {
      className: "askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__iconColumnWidth"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media gr-mediaFlexbox__media--alignSelfCenter"
    }, void 0, _jsx(_user_icon2.default, {
      user: this.props.authorUser,
      size: _shape_icon_values.ICON_SIZES.LARGE
    })), this.props.ATAenabled ? _jsx("a", {
      href: this.props.questionURL,
      className: "gr-button askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__button askTheAuthorFeaturedListItemContainer__button",
      "aria-label": "Ask {this.props.authorUser.name} a question"
    }, void 0, "Ask ") : null);
  },
  renderAuthorAnswer: function renderAuthorAnswer() {
    return _jsx("div", {
      className: "askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__answerText"
    }, void 0, _jsx("span", {
      className: "askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__authorAnswer"
    }, void 0, this.props.authorUser.viewableName, ": "), " ", this.props.answerSpoiler ? _jsx(_spoiler2.default, {
      html: this.props.communityAnswerText.fullContentText,
      spoilerWarning: _jsx(_spoiler_warning2.default, {
        spoilerType: "answer"
      })
    }) : _jsx(_expandable_html2.default, {
      html: this.props.communityAnswerText.fullContentText,
      truncatedHtml: this.props.communityAnswerText.html
    }));
  },
  renderAuthorQuestion: function renderAuthorQuestion() {
    return _jsx("div", {
      className: "u-marginTopSmall askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__questionText"
    }, void 0, this.props.questionSpoiler ? _jsx(_spoiler2.default, {
      html: this.props.communityQuestionText,
      spoilerWarning: _jsx(_spoiler_warning2.default, {
        spoilerType: "question"
      })
    }) : this.props.communityQuestionText);
  },
  renderFlagForAbuseUrl: function renderFlagForAbuseUrl() {
    return _jsx("div", {
      className: "gr-comment gr-comment__rightSideInformation"
    }, void 0, _jsx(_flag_for_abuse_link2.default, {
      flagForAbuseUrl: this.props.flagForAbuseUrl
    }));
  },
  renderLikesAndCommentsFooter: function renderLikesAndCommentsFooter() {
    return _jsx("div", {
      className: "u-marginTopXSmall u-marginBottomSmall"
    }, void 0, _jsx(_likes_and_comments_footer2.default, {
      currentUser: this.props.currentUser,
      resourceKey: this.props.like.key,
      resourceLabel: this.props.like.label,
      isLikeable: this.props.like.isLikeable,
      showAsLink: true,
      comment: this.props.comment
    }));
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-mediaFlexbox"
    }, void 0, this.renderAuthorIconAndAskButton(), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("a", {
      href: this.props.authorUser.profileUrl,
      className: "gr-hyperlink gr-hyperlink--bold askTheAuthorFeaturedListItemContainer__title"
    }, void 0, this.props.authorUser.viewableName, " "), _jsx("div", {
      className: "askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__answersCount"
    }, void 0, _jsx("a", {
      href: this.props.answerURL,
      className: "gr-hyperlink"
    }, void 0, this.props.answersCountText, " ")), _jsx("div", {}, void 0, _jsx("small", {}, void 0, this.props.authorTagline)), this.renderAuthorQuestion(), this.renderAuthorAnswer(), this.renderFlagForAbuseUrl(), this.renderLikesAndCommentsFooter()));
  }
});

},{"../../../modules/shape_icon_values":19,"../../flagged_resources/flag_for_abuse_link":106,"../../gr_component_factory":108,"../../like/likes_and_comments_footer":120,"../../shared/gr_prop_types":221,"../../user/user_icon":230,"../../user_content/expandable_html":232,"../../user_content/spoiler":234,"./shared/spoiler_warning":68,"react":"react"}],66:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Displays a widget with Author name, photo, most recent book, Ask button (if they are enabled for
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Ask The Author), and number of answers they've given.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            If an author is not enabled for ATA, the tag and Ask button are both hidden.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AskTheAuthorFeaturedAuthorContainer",

  propTypes: {
    authorUser: _gr_prop_types2.default.author().isRequired,
    authorTagline: _react2.default.PropTypes.string.isRequired,
    ATAenabled: _react2.default.PropTypes.bool.isRequired,
    questionURL: _react2.default.PropTypes.string.isRequired,
    answerURL: _react2.default.PropTypes.string.isRequired,
    answersCount: _react2.default.PropTypes.string
  },

  render: function render() {
    return _jsx("div", {
      className: "gr-mediaFlexbox"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media gr-mediaFlexbox__media--verticallyCentered"
    }, void 0, _jsx(_user_icon2.default, {
      user: { viewableName: this.props.authorUser.name,
        profileImage: this.props.authorUser.profileImage,
        profileUrl: this.props.authorUser.profileUrl },
      size: _shape_icon_values.ICON_SIZES.LARGE
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "askTheAuthorFeaturedListItemContainer__title"
    }, void 0, _jsx("a", {
      href: this.props.authorUser.profileUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, this.props.authorUser.name, " ")), _jsx("div", {}, void 0, _jsx("small", {}, void 0, this.props.authorTagline)), this.props.ATAenabled ? _jsx("div", {
      className: "askTheAuthorFeaturedListItemContainer__button"
    }, void 0, _jsx("a", {
      href: this.props.questionURL,
      className: "gr-button",
      "aria-label": "Ask {this.props.authorUser.name} a question"
    }, void 0, "Ask ")) : null, this.props.answersCount ? _jsx("div", {
      className: "u-inlineBlock"
    }, void 0, _jsx("a", {
      href: this.props.answerURL,
      className: "gr-hyperlink"
    }, void 0, this.props.answersCount)) : null));
  }
});

},{"../../../modules/shape_icon_values":19,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_icon":230,"react":"react"}],67:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Renders the list of authors the current user follows.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Each followed author's widget is rendered individually in
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            AskTheAuthorCommunityQuestionAnswerContainer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Loads three authors at a time, displays a "Load more authors you follow"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            link conditionally if there are more authors in the store
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            that have not been displayed
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _community_question_answer_container = require("./community_question_answer_container");

var _community_question_answer_container2 = _interopRequireDefault(_community_question_answer_container);

var _ask_the_author_followed_authors_store = require("../../../react_stores/ask_the_author_followed_authors_store");

var _ask_the_author_followed_authors_store2 = _interopRequireDefault(_ask_the_author_followed_authors_store);

var _followed_authors_actions = require("../../../react_actions/ask_the_author/followed_authors_actions");

var _followed_authors_actions2 = _interopRequireDefault(_followed_authors_actions);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  mixins: [_reflux2.default.connect(_ask_the_author_followed_authors_store2.default, "askTheAuthorFollowedAuthorsStore")],
  displayName: "AskTheAuthorFollowedAuthorsContainer",

  propTypes: {
    currentUser: _gr_prop_types2.default.user().isRequired
  },

  loadMoreFollowedAuthors: function loadMoreFollowedAuthors() {
    _followed_authors_actions2.default.loadMoreFollowedAuthors();
  },

  // if we have no more authors to show, do not display bottom border
  getContainerClassName: function getContainerClassName(currentAuthor, lastAuthor, showLink) {
    if (showLink < 1 && lastAuthor === JSON.stringify(currentAuthor)) {
      return "u-marginTopSmall u-marginBottomSmall";
    }
    return "u-marginTopSmall u-marginBottomSmall u-bottomGrayBorder";
  },
  render: function render() {
    var _this = this;

    var state = this.state.askTheAuthorFollowedAuthorsStore;
    var numOfAuthorsToDisplay = state.authors ? state.authors.length : 0;
    var lastAuthor = numOfAuthorsToDisplay > 0 ? JSON.stringify(state.authors[numOfAuthorsToDisplay - 1]) : null;
    var totalNumOfAuthors = state.total;
    var showLink = totalNumOfAuthors - numOfAuthorsToDisplay;
    var classNameLine = undefined,
        commentData = undefined,
        likeData = undefined;
    var currentUser = this.props.currentUser;
    return _jsx("div", {
      className: "communityContainer"
    }, void 0, state.authors.map(function (auth) {
      classNameLine = _this.getContainerClassName(auth, lastAuthor, showLink);
      commentData = (0, _lodash.get)(auth, "social.comment");
      likeData = (0, _lodash.get)(auth, "social.like");
      return _jsx("div", {}, auth.profileUrl, _jsx("div", {
        className: classNameLine
      }, void 0, _jsx(_community_question_answer_container2.default, {
        authorUser: {
          viewableName: auth.name,
          profileUrl: auth.profileUrl,
          profileImage: auth.profileImage
        },
        currentUser: currentUser,
        authorTagline: auth.authorTagline,
        questionURL: auth.questionURL,
        answerURL: auth.answerURL,
        answersCountText: auth.answersCountText,
        ATAenabled: auth.ATAenabled,
        communityQuestionText: auth.recentQuestionText,
        communityAnswerText: {
          html: auth.recentAnswerTruncatedHtml.html,
          fullContentText: auth.recentAnswerTruncatedHtml.answerText,
          truncated: auth.recentAnswerTruncatedHtml.truncated
        },
        questionSpoiler: auth.recentQuestionSpoiler,
        answerSpoiler: auth.recentAnswerSpoiler,
        flagForAbuseUrl: auth.flagForAbuseUrl,
        like: {
          key: likeData.key,
          label: likeData.label,
          isLikeable: likeData.isLikeable
        },
        comment: {
          canComment: commentData.canComment,
          commentable: commentData.commentable,
          subjectKey: commentData.subjectKey,
          subject: {
            type: commentData.subject.type,
            id: commentData.subject.id
          },
          subjectUrl: commentData.subjectUrl
        }
      })));
    }), showLink > 0 ? _jsx("button", {
      className: "gr-buttonAsLink askTheAuthorCommunityQuestionAnswerContainer__followLink",
      onClick: this.loadMoreFollowedAuthors
    }, void 0, " More Authors You Follow… ") : null);
  }
});

},{"../../../react_actions/ask_the_author/followed_authors_actions":24,"../../../react_stores/ask_the_author_followed_authors_store":255,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"./community_question_answer_container":65,"lodash":"lodash","reflux":"reflux"}],68:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SpoilerWarning",

  propTypes: {
    spoilerType: React.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("span", {
      className: "authorAnswerNewsfeedItem__spoilerWarning"
    }, void 0, "This ", this.props.spoilerType, " contains spoilers…");
  }
});

},{"../../../gr_component_factory":108}],69:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _ask_the_author_banner_actions = require("../../../react_actions/ask_the_author_banner_actions");

var _ask_the_author_banner_actions2 = _interopRequireDefault(_ask_the_author_banner_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "StartAnsweringButton",

  propTypes: {
    authorID: React.PropTypes.number.isRequired
  },

  render: function render() {
    var _this = this;

    return _jsx("button", {
      className: "gr-button gr-button--dark gr-button--medium askTheAuthorBanner__startAnswering",
      onClick: function onClick() {
        _ask_the_author_banner_actions2.default.optAuthorIntoQA(_this.props.authorID);
      }
    }, void 0, "Start Answering Questions");
  }
});

},{"../../../react_actions/ask_the_author_banner_actions":25,"../../gr_component_factory":108}],70:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTHOR_BADGE_SIZES = {
  SMALL: "small",
  LARGE: "large"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorBadge",

  statics: {
    AUTHOR_BADGE_SIZES: AUTHOR_BADGE_SIZES
  },

  propTypes: {
    size: React.PropTypes.oneOf([AUTHOR_BADGE_SIZES.SMALL, AUTHOR_BADGE_SIZES.LARGE]),
    isGoodreadsAuthor: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: AUTHOR_BADGE_SIZES.SMALL
    };
  },
  getClasses: function getClasses() {
    return (0, _classnames2.default)("gr-icon", {
      "gr-icon--authorBadge": this.props.size === AUTHOR_BADGE_SIZES.SMALL,
      "gr-icon--authorBadgeLarge": this.props.size === AUTHOR_BADGE_SIZES.LARGE
    });
  },
  renderBadge: function renderBadge() {
    return _jsx("span", {
      className: this.getClasses(),
      title: "Goodreads Author"
    });
  },
  render: function render() {
    return this.props.isGoodreadsAuthor ? this.renderBadge() : null;
  }
});

},{"../gr_component_factory":108,"classnames":"classnames","react":"react"}],71:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _author_follow_actions = require("../../react_actions/author_follow_actions");

var _author_follow_actions2 = _interopRequireDefault(_author_follow_actions);

var _author_follow_store = require("../../react_stores/author_follow_store");

var _author_follow_store2 = _interopRequireDefault(_author_follow_store);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorFollowButton",

  mixins: [_reflux2.default.connectFilter(_author_follow_store2.default, "authorFollowStore", function (follows) {
    return follows[this.props.authorId];
  })],

  propTypes: {
    authorId: _react2.default.PropTypes.number.isRequired,
    className: _react2.default.PropTypes.string
  },

  handleButtonClicked: function handleButtonClicked() {
    if (this.state.authorFollowStore.isFollowing) {
      _author_follow_actions2.default.unFollow(this.props.authorId);
    } else {
      _author_follow_actions2.default.follow(this.props.authorId);
      // After a follow attempt "Unfollow" should not appear until
      // mouse leaves and re-enters button
      this.setState({ isHovering: false });
    }
  },
  getButtonText: function getButtonText() {
    if (this.state.authorFollowStore.isFollowing) {
      if (this.state.isHovering) {
        return "Unfollow";
      } else {
        return "Following";
      }
    } else {
      return "Follow author";
    }
  },
  render: function render() {
    var _this = this;

    var cx = (0, _classnames2.default)("gr-button", this.props.className);
    return _jsx("button", {
      className: cx,
      onClick: this.handleButtonClicked,
      onMouseEnter: function onMouseEnter() {
        _this.setState({ isHovering: true });
      },
      onMouseLeave: function onMouseLeave() {
        _this.setState({ isHovering: false });
      },
      disabled: this.state.authorFollowStore.buttonEnabled ? false : "disabled"
    }, void 0, this.getButtonText());
  }
});

},{"../../react_actions/author_follow_actions":26,"../../react_stores/author_follow_store":256,"../gr_component_factory":108,"classnames":"classnames","react":"react","reflux":"reflux"}],72:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _author_follow_store = require("../../react_stores/author_follow_store");

var _author_follow_store2 = _interopRequireDefault(_author_follow_store);

var _number_formatting_utils = require("../../modules/number_formatting_utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorFollowCount",

  mixins: [_reflux2.default.connectFilter(_author_follow_store2.default, "authorFollowStore", function (follows) {
    return follows[this.props.authorId];
  })],

  propTypes: {
    authorId: _react2.default.PropTypes.number.isRequired,
    className: _react2.default.PropTypes.string
  },

  render: function render() {
    var count = this.state.authorFollowStore.followingCount;

    return _jsx("div", {
      className: this.props.className
    }, void 0, (0, _number_formatting_utils.formatNumberWithDelimiter)(count) + " " + (count === 1 ? "follower" : "followers"));
  }
});

},{"../../modules/number_formatting_utils":16,"../../react_stores/author_follow_store":256,"../gr_component_factory":108,"react":"react","reflux":"reflux"}],73:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_BOOK_SIZES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _author_badge = require("./author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALID_BOOK_SIZES = exports.VALID_BOOK_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Book",

  propTypes: {
    imageUrl: _react2.default.PropTypes.string.isRequired,
    bookUrl: _react2.default.PropTypes.string.isRequired,
    bookCoverUrl: _react2.default.PropTypes.string, // if book cover should link somewhere besides book page
    title: _react2.default.PropTypes.string.isRequired,
    size: _react2.default.PropTypes.oneOf(_lodash2.default.values(VALID_BOOK_SIZES)),
    titleSize: _react2.default.PropTypes.oneOf(_lodash2.default.values(VALID_BOOK_SIZES)),
    author: _gr_prop_types2.default.author(),
    mediaBoxModifier: _react2.default.PropTypes.string,
    className: _react2.default.PropTypes.string,
    sponsored: _react2.default.PropTypes.bool,
    bookImageTrackingData: _react2.default.PropTypes.object,
    bookTitleTrackingData: _react2.default.PropTypes.object,
    authorLinkTrackingData: _react2.default.PropTypes.object,
    label: _react2.default.PropTypes.element
  },
  getDefaultProps: function getDefaultProps() {
    return {
      size: VALID_BOOK_SIZES.MEDIUM,
      bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES.book_image,
      bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES.book_title,
      authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES.author_link
    };
  },
  render: function render() {
    var bookClasses = (0, _classnames2.default)("gr-mediaBox", "gr-book--" + this.props.size, this.withBemModifiers("gr-book"), this.props.className);
    var bookImageClasses = (0, _classnames2.default)("gr-mediaBox__media", this.withBemModifiers("gr-book__image"), { "gr-book__image--large": this.props.size === VALID_BOOK_SIZES.LARGE });
    var titleSize = this.props.titleSize == null ? this.props.size : this.props.titleSize;
    var bookTitleLinkClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__titleLink"), { "gr-book__titleLink--large": titleSize === VALID_BOOK_SIZES.LARGE }, "gr-hyperlink gr-hyperlink--naked");
    var bookTitleClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__title"));
    var mediaBoxClasses = this.withBemModifiers("gr-mediaBox__desc", this.props.mediaBoxModifier);
    var bookImage = _jsx("img", {
      alt: this.props.title,
      className: bookImageClasses,
      src: this.props.imageUrl
    });
    var bookLink = _jsx("a", {
      href: this.props.bookUrl,
      className: bookTitleLinkClasses
    }, void 0, this.props.title);
    return _jsx("div", {
      className: bookClasses
    }, void 0, _jsx("a", {
      href: this.props.bookCoverUrl || this.props.bookUrl
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      children: bookImage,
      trackingOptions: this.props.bookImageTrackingData
    })), _jsx("div", {
      className: mediaBoxClasses
    }, void 0, this.props.label, _jsx("div", {
      className: bookTitleClasses
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      children: bookLink,
      trackingOptions: this.props.bookTitleTrackingData
    })), this.renderAuthorLink(), _jsx("div", {
      className: "gr-book__additionalContent"
    }, void 0, this.props.children)));
  },
  renderAuthorLink: function renderAuthorLink() {
    var authorSize = this.props.titleSize == null ? this.props.size : this.props.titleSize;
    var bookAuthorClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__author"), { "gr-book__author--large": authorSize === VALID_BOOK_SIZES.LARGE });

    if (this.props.author) {
      var authorLink = _jsx("a", {
        href: this.props.author.profileUrl,
        className: "gr-book__authorLink gr-hyperlink gr-hyperlink--naked"
      }, void 0, this.props.author.name);

      return _jsx("div", {
        className: bookAuthorClasses
      }, void 0, "by ", _jsx(_click_tracking_wrapper2.default, {
        children: authorLink,
        trackingOptions: this.props.authorLinkTrackingData
      }), _react2.default.createElement(_author_badge2.default, this.props.author));
    } else {
      return _jsx("div", {
        className: bookAuthorClasses
      }, void 0, "by deleted author");
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./author/author_badge":70,"./click_tracking_wrapper":93,"./gr_component_factory":108,"./shared/gr_prop_types":221,"classnames":"classnames","lodash":"lodash","react":"react"}],74:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CTA_TEXT_SIGNED_OUT = exports.CTA_TEXT_SIGNED_IN = undefined;

var _react = require("react");

var _shape_icon_values = require("../../modules/shape_icon_values");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _user_rating = require("../user_rating");

var _user_rating2 = _interopRequireDefault(_user_rating);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _write_a_review_button = require("../review/write_a_review_button");

var _write_a_review_button2 = _interopRequireDefault(_write_a_review_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               title: Review Cta
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This component displays the review Cta to the user to prompt them to leave a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               review or rating on a book. 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookId`: Book ID
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `user`: Current user
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `destinationPath`: The destination Url on clicking on the write a review button or rating widget
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookTitle`: Title of the book
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `actionType`: The Clickstream metric for the write a review button click
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `ratingClickstreamRef`: The ref tag for the Clickstream rating action context
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var CTA_TEXT_SIGNED_IN = exports.CTA_TEXT_SIGNED_IN = " start your review of ";
var CTA_TEXT_SIGNED_OUT = exports.CTA_TEXT_SIGNED_OUT = "Start your review of ";

var ReviewCta = (function (_Component) {
  _inherits(ReviewCta, _Component);

  function ReviewCta(props) {
    _classCallCheck(this, ReviewCta);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ReviewCta).call(this, props));
  }

  _createClass(ReviewCta, [{
    key: "goToDestination",
    value: function goToDestination() {
      window.location.assign(this.props.destinationPath);
    }
  }, {
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: "reviewCta"
      }, void 0, _jsx("div", {
        className: "reviewCta__left"
      }, void 0, _jsx(_user_icon2.default, {
        user: this.props.user,
        shape: _shape_icon_values.ICON_SHAPES.RECTANGULAR
      })), _jsx("div", {
        className: "reviewCta__right"
      }, void 0, _jsx("div", {
        className: "u-marginLeftXSmall reviewCta__label"
      }, void 0, _jsx(_user_profile_link2.default, {
        className: "reviewCta__userProfileLink",
        user: this.props.user
      }), this.props.user.viewableName ? CTA_TEXT_SIGNED_IN : CTA_TEXT_SIGNED_OUT, this.props.bookTitle), _jsx("div", {
        className: "reviewCta__controls"
      }, void 0, _jsx(_user_rating2.default, {
        bookId: this.props.bookId,
        starSize: _user_rating.STAR_SIZES.MEDIUM,
        handleClick: this.goToDestination.bind(this),
        displayLabel: false,
        clickstreamRef: this.props.ratingClickstreamRef
      }), _jsx(_write_a_review_button2.default, {
        destinationPath: this.props.destinationPath,
        actionType: this.props.actionType,
        bookId: this.props.bookId,
        className: "reviewCta__writeButton"
      }))));
    }
  }]);

  return ReviewCta;
})(_react.Component);

exports.default = ReviewCta;

ReviewCta.propTypes = {
  bookId: _react.PropTypes.string.isRequired,
  user: _react.PropTypes.object.isRequired,
  destinationPath: _react.PropTypes.string.isRequired,
  bookTitle: _react.PropTypes.string.isRequired,
  actionType: _react.PropTypes.string,
  ratingClickstreamRef: _react.PropTypes.string
};

},{"../../modules/shape_icon_values":19,"../modal":126,"../modal_trigger":127,"../review/write_a_review_button":213,"../user/user_icon":230,"../user/user_profile_link":231,"../user_rating":236,"react":"react"}],75:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("./user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookDescription",

  propTypes: {
    bookDescription: _gr_prop_types2.default.bookDescription().isRequired,
    className: React.PropTypes.string,
    bookDescriptionTargetingData: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bookDescription: {
        html: "",
        truncated: false,
        fullContentUrl: ""
      }
    };
  },
  render: function render() {
    var cx = (0, _classnames2.default)(this.props.className, "gr-book__description");
    var description = this.props.bookDescription;
    return _jsx("div", {
      className: cx
    }, void 0, description.html ? React.createElement(_truncated_html2.default, _extends({}, description, {
      fullContentText: "Continue reading",
      bookDescriptionTargetingData: this.props.bookDescriptionTargetingData })) : null, this.props.children);
  }
});

},{"./gr_component_factory":108,"./shared/gr_prop_types":221,"./user_content/truncated_html":235,"classnames":"classnames"}],76:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _book = require("./book");

var _book2 = _interopRequireDefault(_book);

var _want_to_read_button = require("./want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _lodash = require("lodash");

var _community_rating = require("./community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookWithWTRButton",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    body: React.PropTypes.element,
    bookSize: React.PropTypes.oneOf((0, _lodash.values)(_book.VALID_BOOK_SIZES)),
    bookClassName: React.PropTypes.string,
    responsiveWtrButton: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bookSize: _book.VALID_BOOK_SIZES.LARGE,
      responsiveWtrButton: false
    };
  },
  renderBookBody: function renderBookBody() {
    return this.props.body ? this.props.body : null;
  },
  renderCommunityRating: function renderCommunityRating() {
    var book = this.props.book;
    return _jsx(_community_rating2.default, {
      rating: parseFloat(book.avgRating),
      displayAvg: false,
      displayAvgRatingText: false,
      ratingsCount: book.ratingsCount,
      size: _community_rating2.default.ICON_SIZES.MEDIUM
    });
  },
  renderWtrButton: function renderWtrButton() {
    return _jsx(_want_to_read_button2.default, {
      bookTitle: this.props.book.title,
      uniqueId: (0, _lodash.random)(1000000).toString(),
      bookId: this.props.book.bookId,
      withModalShelvingMenu: this.props.responsiveWtrButton,
      showStars: !this.props.responsiveWtrButton,
      readOnlyStars: this.props.readOnlyStars
    });
  },
  render: function render() {
    return React.createElement(
      _book2.default,
      _extends({ className: this.props.bookClassName }, this.props.book, { size: this.props.bookSize }),
      this.props.responsiveWtrButton && this.renderCommunityRating(),
      this.renderWtrButton(),
      this.renderBookBody()
    );
  }
});

},{"./book":73,"./community_rating":99,"./gr_component_factory":108,"./shared/gr_prop_types":221,"./want_to_read/want_to_read_button":238,"lodash":"lodash"}],77:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetACopyButton = undefined;

var _react = require("react");

var _reactRedux = require("react-redux");

var _get_a_copy_store = require("../../react_stores/buy_buttons/get_a_copy_store");

var _get_a_copy_store2 = _interopRequireDefault(_get_a_copy_store);

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetACopyButton = exports.GetACopyButton = function GetACopyButton(_ref) {
  var getACopyDataUrl = _ref.getACopyDataUrl;
  var getACopyClickedHandler = _ref.getACopyClickedHandler;
  return _jsx("div", {}, void 0, _jsx("button", {
    className: "gr-button gr-button--fullWidth u-paddingTopTiny u-paddingBottomTiny u-defaultType",
    onClick: function onClick() {
      return getACopyClickedHandler(getACopyDataUrl);
    }
  }, void 0, "Get a copy"));
};

GetACopyButton.propTypes = {
  getACopyDataUrl: _react.PropTypes.string.isRequired,
  getACopyClickedHandler: _react.PropTypes.func.isRequired
};

var stateToProps = function stateToProps() {
  return {};
};
var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    getACopyClickedHandler: function getACopyClickedHandler(dataUrl) {
      return dispatch((0, _get_a_copy_actions.getACopyClickedHandler)(dataUrl));
    }
  };
};

var ConnectedButton = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(GetACopyButton);

var ButtonWithProviderRoot = function ButtonWithProviderRoot(props) {
  return _jsx(_reactRedux.Provider, {
    store: _get_a_copy_store2.default
  }, void 0, React.createElement(ConnectedButton, props));
};

exports.default = ButtonWithProviderRoot;

},{"../../react_actions/buy_buttons/get_a_copy_actions":28,"../../react_stores/buy_buttons/get_a_copy_store":259,"react":"react","react-redux":"react-redux"}],78:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _book = require("../book");

var _book2 = _interopRequireDefault(_book);

var _community_rating = require("../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _glide_button = require("./glide_button");

var _glide_button2 = _interopRequireDefault(_glide_button);

var _get_a_copy_link = require("./get_a_copy_link");

var _get_a_copy_link2 = _interopRequireDefault(_get_a_copy_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetACopyInterstitial = function GetACopyInterstitial(_ref) {
  var book = _ref.book;
  var bookLinks = _ref.bookLinks;
  var glideButton = _ref.glideButton;
  var onCloseHandler = _ref.onCloseHandler;
  return _jsx(_modal2.default, {
    id: "GetACopyInterstitial",
    onCloseHandler: onCloseHandler,
    showByDefault: true,
    centered: true,
    bemModifiers: "small"
  }, void 0, _jsx("h3", {
    className: "gr-h3 gr-h3--noTopMargin"
  }, void 0, "Get a Copy"), React.createElement(
    _book2.default,
    _extends({}, book, {
      className: "u-paddingBottomSmall u-bottomGrayBorder u-marginBottomSmall",
      size: "large" }),
    _jsx(_community_rating2.default, {
      rating: parseFloat(book.avgRating),
      displayAvg: true,
      displayAvgRatingText: false,
      size: "medium"
    })
  ), _jsx("div", {
    className: "u-textAlignCenter"
  }, void 0, _jsx("p", {
    className: "gr-metaText gr-metaText--upper u-fontSizeDefault"
  }, void 0, "Available At:"), glideButton ? React.createElement(_glide_button2.default, _extends({}, glideButton, { bookId: book.bookId })) : null, bookLinks.map(function (link) {
    return React.createElement(_get_a_copy_link2.default, _extends({ key: link.name }, link));
  }), _jsx("p", {
    className: "u-fontSizeDefault"
  }, void 0, _jsx("a", {
    href: book.moreStoresUrl
  }, void 0, "More store options"))));
};

GetACopyInterstitial.propTypes = {
  book: _react.PropTypes.shape(_book2.default.propTypes).isRequired,
  bookLinks: _react.PropTypes.array.isRequired,
  glideButton: _react.PropTypes.object,
  onCloseHandler: _react.PropTypes.func
};

exports.default = GetACopyInterstitial;

},{"../book":73,"../community_rating":99,"../modal":126,"./get_a_copy_link":80,"./glide_button":81,"react":"react"}],79:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalInterstitial = undefined;

var _reactRedux = require("react-redux");

var _get_a_copy_store = require("../../react_stores/buy_buttons/get_a_copy_store");

var _get_a_copy_store2 = _interopRequireDefault(_get_a_copy_store);

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

var _get_a_copy_interstitial = require("./get_a_copy_interstitial");

var _get_a_copy_interstitial2 = _interopRequireDefault(_get_a_copy_interstitial);

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConditionalInterstitial = exports.ConditionalInterstitial = function ConditionalInterstitial(_ref) {
  var interstitial = _ref.interstitial;
  var onClose = _ref.onClose;
  return interstitial ? React.createElement(_get_a_copy_interstitial2.default, _extends({}, interstitial, {
    onCloseHandler: onClose })) : _jsx("noscript", {});
};

ConditionalInterstitial.propTypes = {
  interstitial: _react.PropTypes.shape({
    book: _react.PropTypes.object,
    bookLinks: _react.PropTypes.array,
    glideButton: _react.PropTypes.object
  }),
  onClose: _react.PropTypes.func
};

var stateToProps = function stateToProps(state) {
  return {
    interstitial: state.activeGetACopyInterstitial
  };
};

var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch((0, _get_a_copy_actions.getACopyClosed)());
    }
  };
};

var ConnectedInterstitial = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(ConditionalInterstitial);

var GetACopyInterstitialWrapper = function GetACopyInterstitialWrapper() {
  return _jsx(_reactRedux.Provider, {
    store: _get_a_copy_store2.default
  }, void 0, _jsx(ConnectedInterstitial, {}));
};

exports.default = GetACopyInterstitialWrapper;

},{"../../react_actions/buy_buttons/get_a_copy_actions":28,"../../react_stores/buy_buttons/get_a_copy_store":259,"./get_a_copy_interstitial":78,"react":"react","react-redux":"react-redux"}],80:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var GetACopyLink = function GetACopyLink(_ref) {
  var name = _ref.name;
  var url = _ref.url;
  return _jsx("div", {
    className: "u-marginBottomTiny"
  }, void 0, _jsx("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gr-button gr-button--fullWidth"
  }, void 0, name));
};

GetACopyLink.propTypes = {
  name: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired
};

exports.default = GetACopyLink;

},{"react":"react"}],81:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _get_a_copy_link = require("./get_a_copy_link");

var _get_a_copy_link2 = _interopRequireDefault(_get_a_copy_link);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlideButton = function GlideButton(_ref) {
  var price = _ref.price;
  var url = _ref.url;
  var bookId = _ref.bookId;

  function handleClick() {
    (0, _ajax_helper.httpPost)("/track/track_clickstream", {
      data: {
        hit_type: "actionOnly",
        action_type: "bb_click-amazon"
      }
    });
  }
  return _jsx("div", {
    onClick: handleClick
  }, void 0, _jsx(_get_a_copy_link2.default, {
    name: "Kindle Store " + price,
    url: url
  }));
};

GlideButton.propTypes = {
  price: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired,
  bookId: _react.PropTypes.string.isRequired
};

exports.default = GlideButton;

},{"../../modules/ajax/ajax_helper":4,"./get_a_copy_link":80,"react":"react"}],82:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*doc
                                                                                                                                                                                                                                                                   ---
                                                                                                                                                                                                                                                                   title: Carousel
                                                                                                                                                                                                                                                                   name: carousel
                                                                                                                                                                                                                                                                   category: React
                                                                                                                                                                                                                                                                   ---
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                   A carousel component that will render a set of slide objects in a given sequence. This carousel is designed to accommodate
                                                                                                                                                                                                                                                                   any slide type. It will be the user responsibility to develop the react component to templatize the slide object and feed
                                                                                                                                                                                                                                                                   the necessary data by defining the slides in the CarouselStore. The carousel component will be responsible for
                                                                                                                                                                                                                                                                   orchestrating all the interactions with the user and to construct the framework where the slide objects will be rendered.
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                   Required properties:
                                                                                                                                                                                                                                                                   * `carouselId` (string): Unique string identifier of carousel.
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                   Optional properties:
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                   * `carouselWrapAround` (bool|false): wrap around carousel scrolling.
                                                                                                                                                                                                                                                                   * `carouselInitialSlideIndex` (number|0): slide index where to start when first rendering the carousel.
                                                                                                                                                                                                                                                                   * `carouselReverseScroll` (bool|false): inverting the scrolling direction of the arrows.
                                                                                                                                                                                                                                                                   * `carouselSlidesToShow` (number|1): number of slides to display at any given time.
                                                                                                                                                                                                                                                                   * `carouselSlidesToScroll` (number|1): number of slides to scroll when clicking the arrows.
                                                                                                                                                                                                                                                                   * `carouselSlidingSpeed` (number|500): sliding speed in milliseconds
                                                                                                                                                                                                                                                                   * `carouselStyle` (object|{}): custom styling object to be used to render the outer carousel component.
                                                                                                                                                                                                                                                                   * `carouselTitle` (object|null): title to be displayed at the top of the component - object having type, class and text properties to be rendered with React.createElement
                                                                                                                                                                                                                                                                   * `arrowSmTopOffset` (number|0): offset to specify vertical position of small arrows.
                                                                                                                                                                                                                                                                   * `includeSequenceIndicators` (bool|false): display sequence indicator circles.
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                   */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectAssign = require("object-assign");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _ReactTransitionEvents = require("react/lib/ReactTransitionEvents");

var _ReactTransitionEvents2 = _interopRequireDefault(_ReactTransitionEvents);

var _lodash = require("lodash");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _next_arrow = require("./next_arrow");

var _next_arrow2 = _interopRequireDefault(_next_arrow);

var _previous_arrow = require("./previous_arrow");

var _previous_arrow2 = _interopRequireDefault(_previous_arrow);

var _sequence_indicators = require("../sequence_indicators");

var _sequence_indicators2 = _interopRequireDefault(_sequence_indicators);

var _slide_track = require("./slide_track");

var _slide_track2 = _interopRequireDefault(_slide_track);

var _tooltip_track = require("./tooltip_track");

var _tooltip_track2 = _interopRequireDefault(_tooltip_track);

var _carousel_default_props = require("./defaults/carousel_default_props");

var _carousel_default_props2 = _interopRequireDefault(_carousel_default_props);

var _carousel_event_handlers = require("../../react_mixins/carousel/carousel_event_handlers");

var _carousel_event_handlers2 = _interopRequireDefault(_carousel_event_handlers);

var _carousel_helper = require("../../modules/carousel/carousel_helper");

var _carousel_store = require("../../react_stores/carousel_store");

var _carousel_store2 = _interopRequireDefault(_carousel_store);

var _carousel_actions = require("../../react_actions/carousel_actions");

var _carousel_actions2 = _interopRequireDefault(_carousel_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_WIDTHS_THROTTLE_WAIT = 10;

exports.default = _gr_component_factory2.default.createClass({

  displayName: "Carousel",
  mixins: [_carousel_event_handlers2.default, _reflux2.default.connectFilter(_carousel_store2.default, "carouselStore", function (carouselState) {
    return carouselState.carousels[this.props.carouselId];
  })],

  propTypes: {
    carouselId: _react2.default.PropTypes.string.isRequired,
    carouselTitle: _react2.default.PropTypes.object,
    carouselWrapAround: _react2.default.PropTypes.bool,
    carouselInitialSlideIndex: _react2.default.PropTypes.number,
    carouselReverseScroll: _react2.default.PropTypes.bool,
    carouselSlidesToShow: _react2.default.PropTypes.number,
    carouselSlidesToScroll: _react2.default.PropTypes.number,
    carouselSlidingSpeed: _react2.default.PropTypes.number,
    carouselStyle: _react2.default.PropTypes.object,
    arrowSmTopOffset: _react2.default.PropTypes.number,
    includeSequenceIndicators: _react2.default.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {};
  },

  // This awkward merging is because this was built when Reflux supported setting
  // store state into the top-level state object which is obviously a bad idea
  // because then you can't easily trace where the state is coming from.
  // ...like all the state in this component
  // And the test coverage wasn't sufficient to see what breaks
  getState: function getState() {
    return Object.assign({}, this.state, this.state.carouselStore);
  },
  getDefaultProps: function getDefaultProps() {
    return _carousel_default_props2.default;
  },
  componentDidMount: function componentDidMount() {
    _carousel_actions2.default.setSlides(this.props.carouselId);
    this.setWidths();
    window.addEventListener("resize", (0, _lodash.throttle)(this.setWidths, SET_WIDTHS_THROTTLE_WAIT));
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener("resize", (0, _lodash.throttle)(this.setWidths, SET_WIDTHS_THROTTLE_WAIT));
  },
  setWidths: function setWidths() {
    var listWidth = this.getWidth(_reactDom2.default.findDOMNode(this.refs.list));
    var slideContainerWidth = Math.round(listWidth / this.props.carouselSlidesToShow);
    var trackVisibleWidth = slideContainerWidth * this.props.carouselSlidesToShow;
    var widthStateSpecs = {
      listWidth: listWidth,
      slideContainerWidth: slideContainerWidth,
      trackVisibleWidth: trackVisibleWidth,
      currentSlide: this.getState().currentSlide || this.props.carouselInitialSlideIndex,
      carouselSlidesToShow: this.props.carouselSlidesToShow,
      carouselSlidesToScroll: this.props.carouselSlidesToScroll,
      carouselWrapAround: this.props.carouselWrapAround
    };
    widthStateSpecs.trackStyle = (0, _carousel_helper.computeTrackStyle)(widthStateSpecs);
    _carousel_actions2.default.setWidths(this.props.carouselId, widthStateSpecs);
  },
  getWidth: function getWidth(elem) {
    return elem.getBoundingClientRect().width || elem.offsetWidth;
  },
  slideHandler: function slideHandler(targetSlide) {
    var _this = this;

    var adjustedTargetSlide = undefined;
    var removalCallback = undefined,
        addCallback = undefined;

    if (targetSlide < 0) {
      if (this.props.carouselWrapAround) {
        adjustedTargetSlide = this.getState().slideCount + targetSlide;
      } else {
        adjustedTargetSlide = 0;
      }
    } else if (targetSlide >= this.getState().slideCount) {
      if (this.props.carouselWrapAround) {
        adjustedTargetSlide = targetSlide - this.getState().slideCount;
      } else {
        adjustedTargetSlide = this.getState().slideCount - this.props.carouselSlidesToShow;
      }
    } else {
      adjustedTargetSlide = targetSlide;
    }

    var nextStateChanges = {
      currentSlide: adjustedTargetSlide,
      trackStyle: (0, _carousel_helper.computeTrackStyle)((0, _objectAssign2.default)({ targetSlide: adjustedTargetSlide }, this.props, this.getState())),
      swipeLeft: null
    };
    var fullNextState = {
      carouselStore: Object.assign({}, this.getState(), nextStateChanges)
    };

    removalCallback = function () {
      _this.setState(fullNextState);
      _ReactTransitionEvents2.default.removeEndEventListener(_reactDom2.default.findDOMNode(_this.refs.track), removalCallback);
      _carousel_actions2.default.slidingCompletion(_this.props.carouselId, nextStateChanges.currentSlide);
    };

    addCallback = function () {
      _ReactTransitionEvents2.default.addEndEventListener(_reactDom2.default.findDOMNode(_this.refs.track), removalCallback);
    };

    var animationTrackStyle = {
      trackStyle: (0, _carousel_helper.computeTrackAnimationStyle)((0, _objectAssign2.default)({ targetSlide: this.props.carouselWrapAround ? targetSlide : adjustedTargetSlide, animating: true }, this.props, this.getState()))
    };
    var fullAnimationTrackStyle = {
      carouselStore: Object.assign({}, this.getState(), animationTrackStyle)
    };

    this.setState(fullAnimationTrackStyle, addCallback);
  },
  renderTitle: function renderTitle() {
    if (this.props.carouselTitle) {
      var title = _react2.default.createElement(this.props.carouselTitle.type || "div", { className: this.props.carouselTitle.class }, this.props.carouselTitle.text);
      return title;
    }
  },
  renderTooltipTrack: function renderTooltipTrack() {
    if (this.getState().tooltips) {
      var tooltipProps = {
        trackCurrentSlide: this.getState().currentSlide,
        trackWrapAround: this.props.carouselWrapAround,
        trackSlidesCount: this.getState().slideCount,
        trackSlidesToScroll: this.props.carouselSlidesToScroll,
        trackSlidesToShow: this.props.carouselSlidesToShow,
        trackSlideContainerWidth: this.getState().slideContainerWidth,
        trackStyle: {
          width: this.getState().listWidth
        },
        trackSlideWidth: this.getState().slideContainerWidth,
        trackTooltips: this.getState().tooltips,
        displayTooltipAtIndex: this.getState().displayTooltipAtIndex
      };

      return _react2.default.createElement(_tooltip_track2.default, _extends({ ref: "tooltips" }, tooltipProps));
    }
  },
  renderSequenceIndicators: function renderSequenceIndicators() {
    if (this.props.includeSequenceIndicators) {
      return _jsx("div", {
        className: "gr-carousel__slideSequenceIndicatorsContainer"
      }, void 0, _jsx(_sequence_indicators2.default, {
        count: this.getState().slideCount || 0,
        selectedIndex: this.getState().currentSlide || 0
      }));
    }
  },
  render: function render() {
    var trackProps = {
      carouselId: this.props.carouselId,
      trackCurrentSlide: this.getState().currentSlide,
      trackWrapAround: this.props.carouselWrapAround,
      trackSlidesCount: this.getState().slideCount,
      trackSlidesToScroll: this.props.carouselSlidesToScroll,
      trackSlidesToShow: this.props.carouselSlidesToShow,
      trackSlideContainerWidth: this.getState().slideContainerWidth,
      trackStyle: this.getState().trackStyle,
      trackSlides: this.getState().slides
    };

    var arrowProps = {
      carouselId: this.props.carouselId,
      carouselWrapAround: this.props.carouselWrapAround,
      currentSlide: this.getState().currentSlide,
      slideCount: this.getState().slideCount,
      carouselSlidesToShow: this.props.carouselSlidesToShow,
      carouselSlidesToScroll: this.props.carouselSlidesToScroll,
      clickHandler: this.changeSlide,
      carouselReverseScroll: this.props.carouselReverseScroll,
      trackRef: this.refs.track,
      smTopOffset: this.props.arrowSmTopOffset
    };

    return _jsx("div", {
      className: "gr-carousel",
      style: this.props.carouselStyle
    }, void 0, this.renderTitle(), _jsx("div", {
      className: "gr-carousel__slider"
    }, void 0, _react2.default.createElement(
      "div",
      {
        ref: "list",
        className: "gr-carousel__list",
        onMouseDown: this.swipeStart,
        onMouseUp: this.swipeEnd,
        onTouchStart: this.swipeStart,
        onTouchEnd: this.swipeEnd },
      _react2.default.createElement(_slide_track2.default, _extends({ ref: "track" }, trackProps))
    ), this.renderTooltipTrack(), _react2.default.createElement(_previous_arrow2.default, arrowProps), _react2.default.createElement(_next_arrow2.default, arrowProps), this.renderSequenceIndicators()));
  }
});

},{"../../modules/carousel/carousel_helper":7,"../../react_actions/carousel_actions":29,"../../react_mixins/carousel/carousel_event_handlers":247,"../../react_stores/carousel_store":260,"../gr_component_factory":108,"../sequence_indicators":218,"./defaults/carousel_default_props":83,"./next_arrow":84,"./previous_arrow":85,"./slide_track":86,"./tooltip_track":92,"lodash":"lodash","object-assign":"object-assign","react":"react","react-dom":"react-dom","react/lib/ReactTransitionEvents":280,"reflux":"reflux"}],83:[function(require,module,exports){
"use strict";

var defaultProps = {

  carouselWrapAround: true,
  carouselInitialSlideIndex: 0,
  carouselReverseScroll: false,
  carouselSlides: [],
  carouselSlidesToShow: 1,
  carouselSlidesToScroll: 1,
  carouselSlidingSpeed: 500,
  carouselTitle: null,

  arrowSmTopOffset: 0,

  includeSequenceIndicators: false
};
module.exports = defaultProps;

},{}],84:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _carousel_helper = require("../../modules/carousel/carousel_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({

  displayName: "NextArrow",

  propTypes: {
    carouselId: _react2.default.PropTypes.string.isRequired,
    currentSlide: _react2.default.PropTypes.number,
    slideCount: _react2.default.PropTypes.number,
    carouselSlidesToShow: _react2.default.PropTypes.number,
    carouselWrapAround: _react2.default.PropTypes.bool,
    clickHandler: _react2.default.PropTypes.func,
    carouselReverseScroll: _react2.default.PropTypes.bool,
    smTopOffset: _react2.default.PropTypes.number,
    trackRef: _react2.default.PropTypes.object
  },

  clickHandler: function clickHandler(options, e) {
    e.preventDefault();
    this.props.clickHandler(options, e);
  },
  render: function render() {
    var message = this.props.carouselReverseScroll ? _carousel_helper.prevTransitionMessage : _carousel_helper.nextTransitionMessage;
    var nextHandler = this.clickHandler.bind(this, { message: message });
    var nextClasses = ["gr-carousel__arrow", "gr-carousel__arrow--next"];

    if (this.props.carouselReverseScroll) {
      if (!this.props.carouselWrapAround && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.carouselSlidesToShow)) {
        nextClasses.push("gr-carousel__arrow--disabled");
        nextHandler = null;
      }
    } else {
      if (!this.props.carouselWrapAround) {
        if (this.props.currentSlide >= this.props.slideCount - this.props.carouselSlidesToShow) {
          nextClasses.push("gr-carousel__arrow--disabled");nextHandler = null;
        }
        if (this.props.slideCount <= this.props.carouselSlidesToShow) {
          nextClasses.push("gr-carousel__arrow--disabled");nextHandler = null;
        }
      }
    }
    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { top: this.props.smTopOffset + "px" },
      onClick: nextHandler
    };
    return _jsx("div", {}, void 0, _react2.default.createElement("button", _extends({ "aria-label": "Next", type: "button" }, nextArrowProps)));
  }
});

},{"../../modules/carousel/carousel_helper":7,"../gr_component_factory":108,"classnames":"classnames","react":"react"}],85:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _carousel_helper = require("../../modules/carousel/carousel_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({

  displayName: "PreviousArrow",

  propTypes: {
    carouselId: _react2.default.PropTypes.string.isRequired,
    currentSlide: _react2.default.PropTypes.number,
    slideCount: _react2.default.PropTypes.number,
    carouselSlidesToShow: _react2.default.PropTypes.number,
    carouselWrapAround: _react2.default.PropTypes.bool,
    clickHandler: _react2.default.PropTypes.func,
    carouselReverseScroll: _react2.default.PropTypes.bool,
    smTopOffset: _react2.default.PropTypes.number,
    trackRef: _react2.default.PropTypes.object
  },

  clickHandler: function clickHandler(options, e) {
    e.preventDefault();
    this.props.clickHandler(options, e);
  },
  render: function render() {
    var message = this.props.carouselReverseScroll ? _carousel_helper.nextTransitionMessage : _carousel_helper.prevTransitionMessage;
    var prevHandler = this.clickHandler.bind(this, { message: message });
    var prevClasses = ["gr-carousel__arrow", "gr-carousel__arrow--prev"];

    if (this.props.carouselReverseScroll) {
      if (!this.props.carouselWrapAround) {
        if (this.props.currentSlide >= this.props.slideCount - this.props.carouselSlidesToShow) {
          prevClasses.push("gr-carousel__arrow--disabled");
          prevHandler = null;
        }
        if (this.props.slideCount <= this.props.carouselSlidesToShow) {
          prevClasses.push("gr-carousel__arrow--disabled");
          prevHandler = null;
        }
      }
    } else {
      if (!this.props.carouselWrapAround && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.carouselSlidesToShow)) {
        prevClasses.push("gr-carousel__arrow--disabled");
        prevHandler = null;
      }
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { top: this.props.smTopOffset + "px" },
      onClick: prevHandler
    };
    return _jsx("div", {}, void 0, _react2.default.createElement("button", _extends({ "aria-label": "Previous", type: "button" }, prevArrowProps)));
  }
});

},{"../../modules/carousel/carousel_helper":7,"../gr_component_factory":108,"classnames":"classnames","react":"react"}],86:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _objectAssign = require("object-assign");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSlideClasses = function getSlideClasses(spec) {

  var slideCloned = undefined,
      index = undefined;

  index = spec.slideIndex;
  slideCloned = index < 0 || index >= spec.trackSlidesCount;
  return (0, _classnames2.default)({
    "gr-carousel__slide": true,
    "carousel-cloned": slideCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  style.width = spec.trackSlideContainerWidth;
  return style;
};

// Determines if aria-hidden should be set to hide
// slide from screen readers (for off-screen slides)
var shouldHideSlideFromAria = function shouldHideSlideFromAria(slideIndex, currentSlideIndex, slidesToShow) {
  var slidesFromFirstShownSlide = slideIndex - currentSlideIndex;
  return slidesFromFirstShownSlide < 0 || slidesFromFirstShownSlide >= slidesToShow;
};

var renderSlides = function renderSlides(spec) {

  if (spec.trackCurrentSlide == null || !spec.trackSlides) {
    return null;
  }
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  _react2.default.Children.forEach(spec.trackSlides, function (elem, index) {
    var childElement = _react2.default.cloneElement(elem, (0, _objectAssign2.default)({
      carouselId: spec.carouselId,
      currentSlide: spec.trackCurrentSlide,
      slideIndex: index,
      slidesToShow: spec.trackSlidesToShow,
      sidesToScroll: spec.trackSlidesToScroll,
      slideCount: spec.trackSlidesCount,
      slideWidth: spec.trackSlideContainerWidth }, elem.props));

    var trackElement = _jsx("div", {}, void 0, childElement);
    var slideStyle = getSlideStyle((0, _objectAssign2.default)({ slideIndex: index }, spec));
    var slideClasses = getSlideClasses((0, _objectAssign2.default)({ slideIndex: index }, spec));

    if (spec.trackCurrentSlide - spec.trackSlidesToScroll <= index && index < spec.trackCurrentSlide + spec.trackSlidesToShow + spec.trackSlidesToScroll) {

      slides.push(_react2.default.cloneElement(trackElement, {
        "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
        key: "original" + index,
        "data-index": index,
        className: slideClasses,
        style: (0, _objectAssign2.default)({}, elem.props.style || {}, slideStyle)
      }));
    }

    if (spec.trackWrapAround) {
      if (spec.trackCurrentSlide - spec.trackSlidesToScroll < 0 && index >= spec.trackSlidesCount + spec.trackCurrentSlide - spec.trackSlidesToScroll) {
        var key = -(spec.trackSlidesCount - index);
        preCloneSlides.push(_react2.default.cloneElement(trackElement, {
          "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
          key: "cloned" + key,
          "data-index": key,
          className: slideClasses,
          style: (0, _objectAssign2.default)({}, elem.props.style || {}, slideStyle)
        }));
      } else if (spec.trackCurrentSlide + spec.trackSlidesToShow >= spec.trackSlidesCount && index < spec.trackCurrentSlide + spec.trackSlidesToShow - spec.trackSlidesCount) {
        var key = index + spec.trackSlidesCount;
        postCloneSlides.push(_react2.default.cloneElement(trackElement, {
          "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
          key: "cloned" + key,
          "data-index": key,
          className: slideClasses,
          style: (0, _objectAssign2.default)({}, elem.props.style || {}, slideStyle)
        }));
      } else if (spec.trackCurrentSlide + (spec.trackSlidesToShow + spec.trackSlidesToScroll) > spec.trackSlidesCount && index < spec.trackCurrentSlide + (spec.trackSlidesToShow + spec.trackSlidesToScroll) - spec.trackSlidesCount) {
        var key = index + spec.trackSlidesCount;
        postCloneSlides.push(_react2.default.cloneElement(trackElement, {
          "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
          key: "cloned" + key,
          "data-index": key,
          className: slideClasses,
          style: (0, _objectAssign2.default)({}, elem.props.style || {}, slideStyle)
        }));
      }
    }
  });

  return preCloneSlides.concat(slides, postCloneSlides);
};

exports.default = _gr_component_factory2.default.createClass({

  displayName: "SlideTrack",

  propTypes: {
    carouselId: _react2.default.PropTypes.string,
    trackCurrentSlide: _react2.default.PropTypes.number,
    trackWrapAround: _react2.default.PropTypes.bool,
    trackSlides: _react2.default.PropTypes.array,
    trackSlidesCount: _react2.default.PropTypes.number,
    trackSlidesToScroll: _react2.default.PropTypes.number,
    trackSlidesToShow: _react2.default.PropTypes.number,
    trackSlideContainerWidth: _react2.default.PropTypes.number,
    trackStyle: _react2.default.PropTypes.object
  },

  render: function render() {
    var slides = renderSlides(this.props);
    return _jsx("div", {
      className: (0, _classnames2.default)("gr-carousel__track"),
      style: this.props.trackStyle
    }, void 0, slides);
  }
});

},{"../gr_component_factory":108,"classnames":"classnames","object-assign":"object-assign","react":"react"}],87:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _want_to_read_button = require("../../want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({

  displayName: "AudiobookMobileSlide",

  propTypes: {
    bookId: _react2.default.PropTypes.string,
    title: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    bookUrl: _react2.default.PropTypes.string,
    author: _react2.default.PropTypes.object,
    description: _react2.default.PropTypes.object,
    avgRating: _react2.default.PropTypes.number,

    //properties passed to the children describing the behavior of
    //the parent
    carouselId: _react2.default.PropTypes.string,
    currentSlide: _react2.default.PropTypes.number,
    slideIndex: _react2.default.PropTypes.number,
    slidesToShow: _react2.default.PropTypes.number,
    sidesToScroll: _react2.default.PropTypes.number,
    slideCount: _react2.default.PropTypes.number,
    slideWidth: _react2.default.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      trackingOptions: {
        enableTracking: true
      }
    };
  },
  renderImage: function renderImage() {
    var image = _jsx("div", {
      className: "gr-carousel-audiobookMobileBookCover"
    }, void 0, _jsx("a", {
      className: "gr-carousel-audiobookMobileImgContainer",
      href: this.props.bookUrl
    }, void 0, _jsx("img", {
      src: this.props.imageUrl
    })));
    return _jsx(_click_tracking_wrapper2.default, {
      children: image,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_BookImage
    });
  },
  renderTitle: function renderTitle() {
    var bookName = this.props.title;
    if (bookName.length > 45) {
      bookName = bookName.substring(0, 43) + "...";
    }
    var bookTitle = _jsx("div", {
      className: "gr-carousel-bookTitleMobile"
    }, void 0, _jsx("a", {
      href: this.props.bookUrl
    }, void 0, bookName));
    return _jsx(_click_tracking_wrapper2.default, {
      children: bookTitle,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_BookTitle
    });
  },
  renderAuthor: function renderAuthor() {
    var author = _jsx("div", {
      className: "gr-carousel-bookAuthorMobile"
    }, void 0, _jsx("a", {
      href: this.props.author.profileUrl
    }, void 0, "by ", this.props.author.name));
    return _jsx(_click_tracking_wrapper2.default, {
      children: author,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_Author
    });
  },
  render: function render() {

    var wantToReadProps = {
      bookId: this.props.bookId.toString(),
      bookTitle: this.props.title,
      uniqueId: (0, _lodash.random)(1000000).toString(),
      showStars: false,
      showMenu: false,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_WantToRead
    };

    return _jsx("div", {
      className: "gr-carousel-audiobookMobileSlide"
    }, void 0, this.renderImage(), _jsx("div", {
      className: "gr-carousel-audiobookMobileBookDetails"
    }, void 0, this.renderTitle(), this.renderAuthor(), _jsx("div", {
      className: "gr-carousel-wantToRead-SpacingLeftMobile"
    }, void 0, _react2.default.createElement(_want_to_read_button2.default, wantToReadProps))));
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":93,"../../gr_component_factory":108,"../../want_to_read/want_to_read_button":238,"lodash":"lodash","react":"react"}],88:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _want_to_read_button = require("../../want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _carousel_actions = require("../../../react_actions/carousel_actions");

var _carousel_actions2 = _interopRequireDefault(_carousel_actions);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({

  displayName: "AudiobookSlide",

  propTypes: {
    bookId: _react2.default.PropTypes.string,
    title: _react2.default.PropTypes.string,
    bookAci: _react2.default.PropTypes.string,
    requestOriginUrl: _react2.default.PropTypes.string,
    randomRequestParam: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    audiobookHost: _react2.default.PropTypes.string,
    bookUrl: _react2.default.PropTypes.string,
    author: _react2.default.PropTypes.object,
    description: _react2.default.PropTypes.object,
    avgRating: _react2.default.PropTypes.number,

    //properties passed to the children describing the behavior of
    //the parent
    carouselId: _react2.default.PropTypes.string,
    currentSlide: _react2.default.PropTypes.number,
    slideIndex: _react2.default.PropTypes.number,
    slidesToShow: _react2.default.PropTypes.number,
    sidesToScroll: _react2.default.PropTypes.number,
    slideCount: _react2.default.PropTypes.number,
    slideWidth: _react2.default.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      trackingOptions: {
        enableTracking: true
      }
    };
  },
  showTooltip: function showTooltip() {
    _carousel_actions2.default.showTooltip(this.props.carouselId, this.props.slideIndex);
  },
  hideTooltip: function hideTooltip() {
    _carousel_actions2.default.hideTooltip(this.props.carouselId);
  },
  renderImage: function renderImage() {
    var image = _jsx("a", {
      className: "img-container",
      href: this.props.bookUrl
    }, void 0, _jsx("img", {
      src: this.props.imageUrl
    }));
    return _jsx(_click_tracking_wrapper2.default, {
      children: image,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Carousel_BookImage
    });
  },
  render: function render() {

    var wantToReadProps = {
      bookId: this.props.bookId.toString(),
      bookTitle: this.props.title,
      uniqueId: (0, _lodash.random)(1000000).toString(),
      showStars: false,
      showMenu: false,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Carousel_WantToRead
    };

    return _jsx("div", {
      className: "gr-carousel-audiobookSlide",
      onMouseEnter: this.showTooltip,
      onMouseLeave: this.hideTooltip
    }, void 0, this.renderImage(), _jsx("div", {
      className: "gr-carousel-wantToRead-SpacingLeft"
    }, void 0, _react2.default.createElement(_want_to_read_button2.default, wantToReadProps)));
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../../react_actions/carousel_actions":29,"../../click_tracking_wrapper":93,"../../gr_component_factory":108,"../../want_to_read/want_to_read_button":238,"lodash":"lodash","react":"react"}],89:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _want_to_read_button = require("../../want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AudiobookTooltip",
  propTypes: {
    bookId: _react2.default.PropTypes.string,
    title: _react2.default.PropTypes.string,
    bookAci: _react2.default.PropTypes.string,
    requestOriginUrl: _react2.default.PropTypes.string,
    randomRequestParam: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    audiobookHost: _react2.default.PropTypes.string,
    bookUrl: _react2.default.PropTypes.string,
    author: _react2.default.PropTypes.object,
    description: _react2.default.PropTypes.object,
    avgRating: _react2.default.PropTypes.number,

    //properties passed to the children describing the behavior of
    //the parent
    currentSlide: _react2.default.PropTypes.number,
    tooltipIndex: _react2.default.PropTypes.number,
    slidesToShow: _react2.default.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      trackingOptions: {
        enableTracking: true
      }
    };
  },
  render: function render() {

    var wantToReadProps = {
      bookId: this.props.bookId.toString(),
      bookTitle: this.props.title,
      uniqueId: (0, _lodash.random)(1000000).toString(),
      showStars: true,
      showMenu: true,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Carousel_WantToRead
    };

    return _react2.default.createElement(
      "div",
      { ref: "toolTip", className: "gr-carousel-tooltipAudioBook" },
      _jsx("h2", {}, void 0, _jsx("a", {
        className: "gr-carousel-tooltipAudioBook-bookTitle",
        href: this.props.bookUrl
      }, void 0, this.props.title)),
      "by ",
      _jsx("a", {
        className: "gr-carousel-tooltipAudioBook-authorName",
        href: this.props.author.profileUrl
      }, void 0, this.props.author.name),
      this.props.author.isGoodreadsAuthor ? "*" : null,
      _jsx(_community_rating2.default, {
        rating: parseFloat(this.props.avgRating),
        displayAvg: true
      }),
      _jsx(_book_description2.default, {
        bookDescription: this.props.description
      }),
      _jsx("div", {
        className: "gr-carousel-wantToRead-SpacingLeft"
      }, void 0, _react2.default.createElement(_want_to_read_button2.default, wantToReadProps))
    );
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../book_description":75,"../../community_rating":99,"../../gr_component_factory":108,"../../want_to_read/want_to_read_button":238,"lodash":"lodash","react":"react"}],90:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Slide variant for the Carousel component.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This slide type contains a heading and marketing text.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var MarketingSlide = function MarketingSlide(props) {
  return _jsx("div", {
    className: "gr-col-12 gr-col-md-9 marketingSlide"
  }, void 0, _jsx("div", {
    className: "marketingSlide__contents"
  }, void 0, _jsx("h3", {
    className: "gr-h3 marketingSlide__heading"
  }, void 0, props.heading), _jsx("div", {
    className: "marketingSlide__text"
  }, void 0, props.text)));
};

MarketingSlide.propTypes = {
  heading: _react.PropTypes.string,
  text: _react.PropTypes.string.isRequired
};

exports.default = MarketingSlide;

},{"react":"react"}],91:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({

  displayName: "SampleSlide",

  propTypes: {
    text: _react2.default.PropTypes.string
  },

  render: function render() {
    return _jsx("div", {}, void 0, this.props.text);
  }
});

},{"../../gr_component_factory":108,"react":"react"}],92:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _objectAssign = require("object-assign");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderTooltips = function renderTooltips(spec) {
  if (spec.trackCurrentSlide === null || !spec.trackTooltips) {
    return null;
  }
  var slides = [];
  var postCloneSlides = [];

  _react2.default.Children.forEach(spec.trackTooltips, function (elem, index) {
    var childElement = _react2.default.cloneElement(elem, (0, _objectAssign2.default)({
      currentSlide: spec.trackCurrentSlide,
      slideIndex: index }, elem.props));

    var trackElement = _jsx("div", {}, void 0, childElement);
    //let slideStyle = getSlideStyle(assign({slideIndex: index}, spec));
    //let slideClasses = getSlideClasses(assign({slideIndex: index}, spec));
    var offset = index - spec.trackCurrentSlide + 1;
    if (offset < 0) {
      offset += spec.trackTooltips.length;
    }
    var style = {
      left: spec.trackSlideWidth * offset,
      position: "relative"
    };
    var classname = "";
    if (index === spec.displayTooltipAtIndex) {
      classname = "gr-carousel-tooltipAudioBook__visible";
    } else {
      classname = "gr-carousel-tooltipAudioBook__hidden";
    }
    if (index < spec.trackCurrentSlide + spec.trackSlidesToShow && index >= spec.trackCurrentSlide) {

      slides.push(_react2.default.cloneElement(trackElement, {
        key: "original" + index,
        "data-index": index,
        className: (0, _classnames2.default)(classname),
        style: (0, _objectAssign2.default)(style, elem.props.style || {})
      }));
    }

    if (spec.trackWrapAround) {
      if (spec.trackCurrentSlide + spec.trackSlidesToShow >= spec.trackSlidesCount && index < spec.trackCurrentSlide + spec.trackSlidesToShow - spec.trackSlidesCount) {
        var key = index + spec.trackSlidesCount;
        postCloneSlides.push(_react2.default.cloneElement(trackElement, {
          key: "cloned" + key,
          "data-index": key,
          className: (0, _classnames2.default)(classname),
          style: (0, _objectAssign2.default)(style, elem.props.style || {})
        }));
      }
    }
  });

  return [].concat(slides, postCloneSlides);
};

exports.default = _gr_component_factory2.default.createClass({

  displayName: "TooltipTrack",

  propTypes: {
    trackCurrentSlide: _react2.default.PropTypes.number,
    trackWrapAround: _react2.default.PropTypes.bool,
    trackTooltips: _react2.default.PropTypes.array,
    trackSlidesCount: _react2.default.PropTypes.number,
    trackSlidesToScroll: _react2.default.PropTypes.number,
    trackSlidesToShow: _react2.default.PropTypes.number,
    trackSlideContainerWidth: _react2.default.PropTypes.number,
    trackStyle: _react2.default.PropTypes.object,
    displayTooltipAtIndex: _react2.default.PropTypes.number,
    trackSlideWidth: _react2.default.PropTypes.number
  },

  render: function render() {
    var slides = renderTooltips(this.props);
    return _jsx("div", {
      className: (0, _classnames2.default)("tooltip-track"),
      style: this.props.trackStyle
    }, void 0, slides);
  }
});

},{"../gr_component_factory":108,"classnames":"classnames","object-assign":"object-assign","react":"react"}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*doc
---
title: Click Tracking Wrapper
name: click_tracking_wrapper
category: React
---

Wrappers an object in order to attach click tracking options to component

See also [tracking_data_attributes_mixin].

You can pass in children such as links or buttons that will report to dfp and pmet.

```rails_example
<%= react_component 'ReactComponents.StyleGuideExampleComponentWrapper',
                        componentName: 'ReactComponents.ClickTrackingWrapper',
                        propsToEval: {
                          children: "React.createElement('a', {href: '#'}, 'Random author name');"
                        },
                        trackingOptions: {
                          dfp: true,
                          pmet: {
                            click_type: "author_name"
                          }
                        }
                    %>
```
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "ClickTrackingWrapper",

  propTypes: {
    trackingOptions: _react2.default.PropTypes.shape({
      dfp: _react2.default.PropTypes.bool,
      pmet: _react2.default.PropTypes.object.isRequired
    }).isRequired,
    children: _react2.default.PropTypes.element.isRequired
  },

  render: function render() {
    return this.props.children;
  }
});

},{"./gr_component_factory":108,"react":"react"}],94:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _image_registry = require("../modules/shared/image_registry");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _close_button_values = require("../modules/close_button_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CloseButton",

  propTypes: {
    action: _react2.default.PropTypes.func.isRequired,
    variant: _react2.default.PropTypes.oneOf([_close_button_values.VARIANTS.DEFAULT, _close_button_values.VARIANTS.DARK_BG])
  },

  getDefaultProps: function getDefaultProps() {
    return { variant: _close_button_values.VARIANTS.DEFAULT };
  },
  render: function render() {
    var cx = (0, _classnames2.default)("gr-iconButton", this.props.className);
    var buttonImage = undefined;
    if (this.props.variant === _close_button_values.VARIANTS.DARK_BG) {
      buttonImage = (0, _image_registry.getImages)().closeIcons.darkBackground;
    } else {
      buttonImage = (0, _image_registry.getImages)().closeIcon;
    }
    return _jsx("button", {
      type: "button",
      className: cx,
      onClick: this.props.action
    }, void 0, _jsx("img", {
      alt: "Dismiss",
      src: buttonImage
    }));
  }
});

},{"../modules/close_button_values":8,"../modules/shared/image_registry":20,"./gr_component_factory":108,"classnames":"classnames","react":"react"}],95:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _expandable_html = require("../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _hidden_html = require("../user_content/hidden_html");

var _hidden_html2 = _interopRequireDefault(_hidden_html);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _right_side_information = require("./right_side_information");

var _right_side_information2 = _interopRequireDefault(_right_side_information);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 Comment displays a single comment from a user.
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "Comment",

  propTypes: {
    body: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml()),
    createdAt: _gr_prop_types2.default.date.isRequired,
    authorUser: _gr_prop_types2.default.user().isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: _gr_prop_types2.default.commentSubject(),
    deletableByCurrentUser: _react2.default.PropTypes.bool.isRequired,
    blockedByCurrentUser: _react2.default.PropTypes.bool,
    showTimestamp: _react2.default.PropTypes.bool,
    uri: _react2.default.PropTypes.string.isRequired,
    flagForAbuseUrl: _react2.default.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      blockedByCurrentUser: false
    };
  },
  getInitialState: function getInitialState() {
    return { showCommentDeletingSpinner: false };
  },
  renderBody: function renderBody() {
    if (this.props.blockedByCurrentUser) {
      var unhideText = "unhide comment";
      return _jsx(_hidden_html2.default, {
        unhideText: unhideText
      }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.body));
    } else {
      return _react2.default.createElement(_expandable_html2.default, this.props.body);
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-comment gr-mediaBox"
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media"
    }, void 0, _jsx(_user_icon2.default, {
      user: this.props.authorUser
    })), _jsx("div", {
      className: "gr-mediaBox__desc\n                              gr-mediaBox__desc--clearfixOverflow"
    }, void 0, _react2.default.createElement(_right_side_information2.default, this.props), _jsx(_user_profile_link2.default, {
      user: this.props.authorUser
    }), this.props.blockedByCurrentUser ? _jsx("strong", {}, void 0, " (blocked)") : null, _jsx("div", {
      className: "gr-comment__body"
    }, void 0, this.renderBody())));
  }
});

},{"../gr_component_factory":108,"../shared/gr_prop_types":221,"../user/user_icon":230,"../user/user_profile_link":231,"../user_content/expandable_html":232,"../user_content/hidden_html":233,"./right_side_information":98,"react":"react"}],96:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _comment_actions = require("../../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _comments_store = require("../../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommentForm",

  propTypes: {
    authorUser: _gr_prop_types2.default.user().isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: _react2.default.PropTypes.shape({
      type: _react2.default.PropTypes.string,
      id: _react2.default.PropTypes.number,
      uri: _react2.default.PropTypes.string }),
    placeholder: _react2.default.PropTypes.string
  },

  mixins: [(0, _gr_reflux.connectToLazyStore)(_comments_store2.default, "subjectKey")],

  getDefaultProps: function getDefaultProps() {
    return {
      placeholder: "Write a comment…"
    };
  },
  addNewComment: function addNewComment(event) {
    if (!this.isCommentEmpty()) {
      _comment_actions2.default.addNewComment({
        subjectKey: this.props.subjectKey,
        subject: this.props.subject,
        body: this.state.unsavedComment,
        authorUser: this.props.authorUser
      });
    }
    event.preventDefault();
  },
  isCommentEmpty: function isCommentEmpty() {
    return _lodash2.default.isEmpty(_lodash2.default.trim(this.state.unsavedComment));
  },
  onTextChange: function onTextChange(event) {
    _comment_actions2.default.commentEntered(this.props.subjectKey, event.target.value);
  },
  onFocus: function onFocus() {
    _comment_actions2.default.textareaFocused(this.props.subjectKey);
  },
  onBlur: function onBlur() {
    _comment_actions2.default.textareaUnfocused(this.props.subjectKey);
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.state.textareaFocusRequested === true) {
      this.refs.commentBodyTextarea.focus();
    }
  },
  render: function render() {
    var commentFormClassName = (0, _classnames2.default)(this.withBemModifiers("gr-commentForm"), "gr-mediaBox");
    return _jsx("div", {
      className: commentFormClassName
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media u-noLineHeight"
    }, void 0, _jsx(_user_icon2.default, {
      user: this.props.authorUser
    })), _jsx("form", {
      className: "gr-mediaBox__desc",
      method: "post",
      action: "/comment"
    }, void 0, _jsx("input", {
      type: "hidden",
      name: "id",
      value: this.props.subject.id
    }), _jsx("input", {
      type: "hidden",
      name: "type",
      value: this.props.subject.type
    }), _react2.default.createElement("textarea", { className: "gr-textarea gr-commentForm__textarea",
      name: "comment[body_usertext]",
      disabled: this.state.saveInProgress,
      onChange: this.onTextChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      rows: this.state.textareaRows,
      value: this.state.unsavedComment,
      ref: "commentBodyTextarea",
      placeholder: this.props.placeholder,
      "aria-label": this.props.placeholder }), this.state.showCommentButton ? _jsx("button", {
      className: "gr-commentForm__submitButton gr-button gr-button--small",
      disabled: this.state.saveInProgress || this.isCommentEmpty(),
      onClick: this.addNewComment,
      type: "submit"
    }, void 0, "Comment") : null));
  }
});

},{"../../react_actions/comment_actions":31,"../../react_mixins/gr_reflux":250,"../../react_stores/comments_store":262,"../gr_component_factory":108,"../shared/gr_prop_types":221,"../user/user_icon":230,"classnames":"classnames","lodash":"lodash","react":"react"}],97:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _comment = require("./comment");

var _comment2 = _interopRequireDefault(_comment);

var _pagination_links = require("../pagination_links");

var _pagination_links2 = _interopRequireDefault(_pagination_links);

var _comments_store = require("../../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _comment_actions = require("../../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MAX_COMMENTS = 3;
var FIRST_PAGE = 1;

/*
 Comments displays a list of comments.
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "Comments",

  propTypes: {
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: _gr_prop_types2.default.commentSubject(),
    subjectUrl: _react2.default.PropTypes.string,
    showTimestamp: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { showTimestamp: true };
  },

  mixins: [(0, _gr_reflux.connectToLazyStore)(_comments_store2.default, "subjectKey")],

  seeMoreCommentsText: function seeMoreCommentsText() {
    if (this.state.numComments == 1) {
      return "See 1 comment";
    } else {
      return "See all " + this.state.numComments + " comments";
    }
  },
  showCommentsForPage: function showCommentsForPage(page) {
    _comment_actions2.default.showCommentsForPage({
      subjectKey: this.props.subjectKey,
      subject: this.props.subject,
      page: page
    });
  },
  showMoreClicked: function showMoreClicked(event) {
    _comment_actions2.default.showSeeMoreLoadingSpinner(this.props.subjectKey);
    this.showCommentsForPage(FIRST_PAGE);
    event.preventDefault();
  },
  renderSeeMoreComments: function renderSeeMoreComments() {
    var numComments = this.state.numComments;
    if (numComments > DEFAULT_MAX_COMMENTS || numComments > this.state.comments.length) {
      return _jsx("div", {
        className: "gr-comments__seeAllLinkBox"
      }, void 0, this.state.showSeeMoreLoadingSpinner ? _jsx("span", {}, void 0, _jsx("span", {
        className: "gr-hyperlink gr-hyperlink--bold"
      }, void 0, this.seeMoreCommentsText()), _jsx("span", {
        id: "showMoreSpinner",
        className: "u-marginLeftTiny"
      }, void 0, _jsx(_spinner2.default, {}))) : _jsx("a", {
        href: this.props.subjectUrl,
        className: "gr-hyperlink gr-hyperlink--bold",
        onClick: this.showMoreClicked
      }, void 0, this.seeMoreCommentsText()));
    } else {
      return null;
    }
  },
  renderComments: function renderComments() {
    var _this = this;

    var comments = this.state.showPagination ? this.state.comments : _lodash2.default.takeRight(this.state.comments, DEFAULT_MAX_COMMENTS);
    return _lodash2.default.map(comments, function (comment) {
      return _react2.default.createElement(_comment2.default, _extends({ key: comment.uri,
        subjectKey: _this.props.subjectKey,
        subject: _this.props.subject,
        showTimestamp: _this.props.showTimestamp
      }, comment));
    });
  },
  render: function render() {
    var commentsClassName = (0, _classnames2.default)(this.withBemModifiers("gr-comments"), "gr-box", "gr-box--hiddenOverflow", "u-defaultType");
    if (this.state.numComments > 0) {
      return _jsx("div", {
        className: commentsClassName
      }, void 0, this.state.showPagination ? null : this.renderSeeMoreComments(), this.renderComments(), this.state.showPagination ? _jsx("div", {
        className: "u-topGrayBorder"
      }, void 0, _jsx(_pagination_links2.default, {
        subjectKey: this.props.subjectKey,
        totalSize: this.state.numComments,
        currentPageNumber: this.state.currentPage,
        perPage: 10,
        changePageAction: this.showCommentsForPage,
        className: "gr-paginationLinks__links"
      })) : null);
    } else {
      return null;
    }
  }
});

},{"../../react_actions/comment_actions":31,"../../react_mixins/gr_reflux":250,"../../react_stores/comments_store":262,"../gr_component_factory":108,"../pagination_links":198,"../shared/gr_prop_types":221,"../spinner":226,"./comment":95,"classnames":"classnames","lodash":"lodash","react":"react"}],98:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _flag_for_abuse_link = require("../flagged_resources/flag_for_abuse_link");

var _flag_for_abuse_link2 = _interopRequireDefault(_flag_for_abuse_link);

var _relative_time = require("../time/relative_time");

var _relative_time2 = _interopRequireDefault(_relative_time);

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _comment_actions = require("../../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommentRightSideInformation",
  mixins: [_reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],
  propTypes: {
    showTimestamp: _react2.default.PropTypes.bool,
    deletableByCurrentUser: _react2.default.PropTypes.bool.isRequired,
    subject: _gr_prop_types2.default.commentSubject().isRequired,
    uri: _react2.default.PropTypes.string.isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    createdAt: _gr_prop_types2.default.date.isRequired,
    flagForAbuseUrl: _react2.default.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { showTimestamp: true };
  },
  getInitialState: function getInitialState() {
    return { showCommentDeletingSpinner: false };
  },
  deleteComment: function deleteComment() {
    var commentData = { subject: this.props.subject,
      subjectKey: this.props.subjectKey };
    if (window.confirm("Are you sure you want to delete this comment?")) {
      this.setState({ showCommentDeletingSpinner: true });
      _comment_actions2.default.deleteComment(this.props.subjectKey, this.props.uri, commentData);
    }
  },
  getDeleteLink: function getDeleteLink() {
    if (this.props.deletableByCurrentUser) {
      if (this.state.showCommentDeletingSpinner) {
        return _react2.default.createElement(_spinner2.default, { ref: "spinner" });
      } else {
        return _react2.default.createElement(
          "a",
          { className: "gr-comment__deleteLink gr-hyperlink--naked gr-hyperlink",
            ref: "deleteLink",
            href: "",
            onClick: this.deleteComment,
            "aria-label": "Delete comment" },
          "Delete"
        );
      }
    }
  },
  getFlag: function getFlag() {
    var fullFlagUrl = this.props.flagForAbuseUrl + "&return_url=" + encodeURIComponent(_env_utils2.default.getLocationUrl());
    return _jsx(_flag_for_abuse_link2.default, {
      flagForAbuseUrl: fullFlagUrl
    });
  },
  getTimestamp: function getTimestamp() {
    if (this.props.showTimestamp) {
      return _jsx("small", {
        className: "gr-comment__timestamp"
      }, void 0, _jsx(_relative_time2.default, {
        time: this.props.createdAt
      }));
    }
  },
  getRightSideElements: function getRightSideElements() {
    return [this.getTimestamp(), this.getDeleteLink(), this.getFlag()];
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-comment__rightSideInformation"
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: this.getRightSideElements()
    }));
  }
});

},{"../../modules/env_utils":12,"../../react_actions/comment_actions":31,"../../react_stores/user_agent_capabilities_store":273,"../dot_separated_elements":102,"../flagged_resources/flag_for_abuse_link":106,"../gr_component_factory":108,"../shared/gr_prop_types":221,"../spinner":226,"../time/relative_time":228,"react":"react","reflux":"reflux"}],99:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This component renders a line of basic book details/stats.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The component always includes an average star rating,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             and optionally includes avg rating text, ratings count,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             text reviews count, publication date, and editions count.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _dot_separated_elements = require("./dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
var MAX_RATING = 5;
exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityRating",

  statics: {
    ICON_SIZES: ICON_SIZES
  },
  propTypes: {
    rating: _react2.default.PropTypes.number.isRequired,
    size: _react2.default.PropTypes.oneOf([ICON_SIZES.SMALL, ICON_SIZES.MEDIUM, ICON_SIZES.LARGE]),
    displayAvg: _react2.default.PropTypes.bool,
    displayAvgRatingText: _react2.default.PropTypes.bool,
    ratingsCount: _react2.default.PropTypes.number,
    textReviewsCount: _react2.default.PropTypes.number,
    publication: _react2.default.PropTypes.shape({
      toBePublished: _react2.default.PropTypes.bool,
      date: _react2.default.PropTypes.string
    }),
    editions: _react2.default.PropTypes.shape({
      countString: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    }),
    className: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      displayAvg: false,
      size: ICON_SIZES.SMALL
    };
  },
  wrapperClasses: function wrapperClasses() {
    return (0, _classnames2.default)("communityRating__starsWrapper", {
      "communityRating__starsWrapper--small": this.props.size === ICON_SIZES.SMALL,
      "communityRating__starsWrapper--medium": this.props.size === ICON_SIZES.MEDIUM,
      "communityRating__starsWrapper--large": this.props.size === ICON_SIZES.LARGE
    });
  },
  starClasses: function starClasses() {
    return (0, _classnames2.default)("communityRating__stars", {
      "communityRating__stars--small": this.props.size === ICON_SIZES.SMALL,
      "communityRating__stars--medium": this.props.size === ICON_SIZES.MEDIUM,
      "communityRating__stars--large": this.props.size === ICON_SIZES.LARGE
    });
  },

  // Emulate behavior in application_helper.rb, adjusted for SVG sizing
  getRoundedRating: function getRoundedRating(rating) {
    var flooredRating = Math.floor(rating);
    if (rating === flooredRating) {
      return rating;
    }
    if (rating - flooredRating < 0.5) {
      return flooredRating + 0.45;
    } else {
      return flooredRating + 0.6;
    }
  },
  renderRating: function renderRating() {
    var roundedRating = this.getRoundedRating(this.props.rating);
    var starsStyle = {
      width: roundedRating / MAX_RATING * 100 + "%"
    };
    var ratingStarsLabel = "Rated " + this.props.rating.toFixed(2) + " of " + MAX_RATING;

    var displayAvgRatingText = this.props.displayAvgRatingText === null ? this.props.displayAvg : this.props.displayAvgRatingText;

    return _jsx("span", {}, void 0, _jsx("div", {
      className: this.wrapperClasses()
    }, void 0, _jsx("div", {
      className: this.starClasses(),
      style: starsStyle,
      "aria-label": ratingStarsLabel
    })), this.props.displayAvg ? _jsx("span", {
      className: "gr-metaText"
    }, void 0, this.props.rating.toFixed(2), displayAvgRatingText ? " avg. rating" : "") : null);
  },
  renderRatingsCount: function renderRatingsCount() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, this.props.ratingsCount.toLocaleString(), " Ratings");
  },
  renderTextReviewsCount: function renderTextReviewsCount() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, this.props.textReviewsCount.toLocaleString(), " Reviews");
  },
  renderPublicationDate: function renderPublicationDate() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, (this.props.publication.toBePublished ? "expected publication" : "published") + " " + this.props.publication.date);
  },
  renderEditionsCount: function renderEditionsCount() {
    return _jsx("span", {
      className: "gr-metaText"
    }, void 0, _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--naked u-inlineBlock",
      href: this.props.editions.url
    }, void 0, this.props.editions.countString));
  },
  render: function render() {
    var ratingClassName = (0, _classnames2.default)("communityRating", this.props.className);
    var ratingStarsLabel = "Rated " + this.props.rating.toFixed(2) + " of " + MAX_RATING;

    var elements = [this.renderRating()];

    if (this.props.ratingsCount) {
      elements.push(this.renderRatingsCount());
    }

    if (this.props.textReviewsCount) {
      elements.push(this.renderTextReviewsCount());
    }

    if (this.props.publication && this.props.publication.date) {
      elements.push(this.renderPublicationDate());
    }

    if (this.props.editions && this.props.editions.countString) {
      elements.push(this.renderEditionsCount());
    }

    return _jsx("div", {
      className: ratingClassName,
      "aria-label": ratingStarsLabel
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: elements
    }));
  }
});

},{"./dot_separated_elements":102,"./gr_component_factory":108,"classnames":"classnames","react":"react"}],100:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /* react-onclickoutside is a deprecated package that should not be used for new
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              code. Instead of having an outside click close a module, there should be an
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              explicit close affordances in the spec. */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _react = require("react");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _book_search = require("../search/book_search");

var _book_search2 = _interopRequireDefault(_book_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AddBookSearch",

  mixins: [_reactOnclickoutside2.default],

  propTypes: {
    onChooseResult: _react.PropTypes.func.isRequired,
    search: _react.PropTypes.shape({
      searchPath: _react.PropTypes.string.isRequired,
      autocompleteUrl: _react.PropTypes.string.isRequired
    }).isRequired,
    onDismiss: _react.PropTypes.func
  },

  handleClickOutside: function handleClickOutside() {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  },
  render: function render() {
    var search = this.props.search;
    // Note: The BookSearch component is also called by nav_search, which has a different onChooseResult action.
    //       These should probably be separated into two separate components, with some shared styles and UI logic.
    return _jsx(_book_search2.default, {
      bemModifiers: this.props.bemModifiers,
      searchPath: search.searchPath,
      autocompleteUrl: search.autocompleteUrl,
      onChooseResult: this.props.onChooseResult,
      closeAfterResultChosen: true
    });
  }
});

},{"../gr_component_factory":108,"../search/book_search":214,"react":"react","react-onclickoutside":"react-onclickoutside"}],101:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Currently Reading
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: currently_reading
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Displays all the books on a user's currently reading shelf. Attaches update
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           reading progress components to each book. If no books are passed in, displays a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           book search instead.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component is used on the home page.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

//COMPONENTS

// ACTIONS

// STORE

// CONSTANTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _react = require("react");

var _reading_session_helper = require("../../modules/reading_session_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reactAddonsCssTransitionGroup = require("react-addons-css-transition-group");

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _image_registry = require("../../modules/shared/image_registry");

var _add_book_search = require("./add_book_search");

var _add_book_search2 = _interopRequireDefault(_add_book_search);

var _book = require("../book");

var _book2 = _interopRequireDefault(_book);

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _general_status_update_button = require("../home_page/general_status_update_button");

var _general_status_update_button2 = _interopRequireDefault(_general_status_update_button);

var _reading_notes_link = require("../reading_notes/reading_notes_link");

var _reading_notes_link2 = _interopRequireDefault(_reading_notes_link);

var _reading_progress_bar = require("../reading_sessions/reading_progress_bar");

var _reading_progress_bar2 = _interopRequireDefault(_reading_progress_bar);

var _update_reading_progress = require("../update_reading_progress");

var _update_reading_progress2 = _interopRequireDefault(_update_reading_progress);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _reading_session_actions = require("../../react_actions/reading_session_actions");

var _reading_session_actions2 = _interopRequireDefault(_reading_session_actions);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _reading_session_store = require("../../react_stores/reading_session_store");

var _reading_session_store2 = _interopRequireDefault(_reading_session_store);

var _default_shelves = require("../../modules/default_shelves");

var _book_origins = require("../../modules/book_origins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkClassNames = "gr-hyperlink";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CurrentlyReading",

  mixins: [_reflux2.default.connect(_reading_session_store2.default, "readingSessionStore")],

  propTypes: {
    search: _react.PropTypes.shape({
      searchPath: _react.PropTypes.string.isRequired,
      autocompleteUrl: _react.PropTypes.string.isRequired
    }).isRequired,
    recommendationUrl: _react.PropTypes.string.isRequired,
    askYourFriendsUrl: _react.PropTypes.string.isRequired,
    viewAllCurrentlyReadingUrl: _react.PropTypes.string.isRequired,
    MAX_BODY_LENGTH: _react.PropTypes.number.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      showSearchForm: false
    };
  },
  renderGeneralUpdateButton: function renderGeneralUpdateButton() {
    return _jsx(_general_status_update_button2.default, {
      characterLimit: this.props.MAX_BODY_LENGTH
    });
  },
  renderDiscoveryLinks: function renderDiscoveryLinks() {
    var links = [_jsx("a", {
      href: this.props.recommendationUrl,
      className: linkClassNames
    }, void 0, "Recommendations"), this.renderGeneralUpdateButton()];
    return _jsx("div", {
      className: "currentlyReadingShelf__discoveryLinks"
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: links
    }));
  },
  shelveAsCurrentlyReading: function shelveAsCurrentlyReading(book) {
    this.setState({ loading: true });
    _shelvings_actions2.default.shelveBook(book.bookId, _default_shelves.DEFAULT_SHELVES.CURRENTLY_READING, _book_origins.BOOK_ORIGINS.CURRENTLY_READING_WIDGET);
  },
  showSearchForm: function showSearchForm() {
    this.setState({ showSearchForm: true });
  },
  renderSparseState: function renderSparseState() {
    var shelfClassNames = (0, _classnames2.default)("gr-mediaFlexbox", "gr-mediaFlexbox--alignItemsCenter", { "currentlyReadingShelf__empty--loading": this.state.loading });
    return _jsx("div", {}, void 0, _jsx("div", {
      className: shelfClassNames
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media",
      alt: "",
      src: (0, _image_registry.getImages)().currentlyReadingSparseStateIcon
    }), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, "What are you reading?")));
  },
  renderProgressBar: function renderProgressBar(session) {
    if ((0, _reading_session_helper.hasProgress)(session)) {
      return _jsx("a", {
        className: "currentlyReadingShelf__progressBar\n                           gr-hyperlink\n                           gr-hyperlink--naked",
        href: session.userStatusUrl
      }, void 0, React.createElement(_reading_progress_bar2.default, session));
    } else {
      return null;
    }
  },
  renderUpdateButton: function renderUpdateButton(session, book, storeState) {
    if (session.hideUpdateButton === true) {
      return null;
    } else {
      return _jsx("div", {
        "aria-live": "polite"
      }, void 0, storeState.sessionBeingUpdatedId === session.sessionId ? _jsx(_update_reading_progress2.default, {
        existingReadingSession: session,
        book: book,
        MAX_BODY_LENGTH: this.props.MAX_BODY_LENGTH
      }) : _jsx("button", {
        className: "gr-button gr-button--quiet u-marginTopTiny gr-button--small",
        onClick: function onClick() {
          _reading_session_actions2.default.openUpdateProgressForm(session.sessionId);
        }
      }, void 0, "Update progress"));
    }
  },
  renderBooks: function renderBooks() {
    var _this = this;

    var storeState = this.state.readingSessionStore;
    if (this.hasReadingSessions()) {
      return _jsx(_reactAddonsCssTransitionGroup2.default, {
        transitionName: "currentlyReadingShelf__item",
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 300
      }, void 0, (0, _lodash.map)(storeState.readingSessions, function (session) {
        var book = (0, _lodash.merge)({}, session.book, {
          title: (0, _reading_session_helper.truncateBookTitle)(session.book.title, 40)
        });
        return React.createElement(
          _book2.default,
          _extends({}, book, {
            className: "u-marginBottomSmall",
            key: book.bookId,
            mediaBoxModifier: "clearfixOverflow" }),
          _this.renderReadingNotesLink(session.readingNotesCountText, session.readingNotesUrl, session.hasSharedContent),
          _this.renderProgressBar(session),
          _this.renderUpdateButton(session, book, storeState)
        );
      }));
    } else {
      return this.renderSparseState();
    }
  },
  renderReadingNotesLink: function renderReadingNotesLink(countText, linkUrl, hasSharedContent) {
    if ((0, _lodash.isEmpty)(countText) || (0, _lodash.isEmpty)(linkUrl)) {
      return null;
    } else {
      return _jsx(_reading_notes_link2.default, {
        className: "u-paddingTopTiny",
        countTextClassName: "u-fontSizeSmall",
        hasSharedContent: hasSharedContent,
        readingNotesCountText: countText,
        readingNotesUrl: linkUrl
      });
    }
  },
  onAddBookSearchDismiss: function onAddBookSearchDismiss() {
    this.setState({ showSearchForm: false });
  },
  renderBookSearch: function renderBookSearch() {
    if (!this.hasReadingSessions() || this.state.showSearchForm) {
      return _jsx(_add_book_search2.default, {
        bemModifiers: "currentlyReading",
        search: this.props.search,
        onDismiss: this.onAddBookSearchDismiss,
        onChooseResult: this.shelveAsCurrentlyReading
      });
    } else {
      return null;
    }
  },
  loadAll: function loadAll() {
    _reading_session_actions2.default.loadAllReadingSessions();
  },
  hasMoreSessions: function hasMoreSessions() {
    var storeState = this.state.readingSessionStore;
    return storeState.readingSessions.length !== storeState.allReadingSessionsCount;
  },
  viewMoreLink: function viewMoreLink() {
    var storeState = this.state.readingSessionStore;
    if (storeState.loadMoreInProgress) {
      return _jsx(_spinner2.default, {});
    } else if (this.hasMoreSessions()) {
      return _jsx("button", {
        className: "gr-buttonAsLink",
        onClick: this.loadAll
      }, void 0, "See more");
    } else {
      return _jsx("a", {
        href: this.props.viewAllCurrentlyReadingUrl
      }, void 0, "View all books");
    }
  },
  renderFooterLinks: function renderFooterLinks() {
    var links = [this.viewMoreLink(),
    // Firefox will persist the 'disabled' state of buttons upon refresh. A
    // workaround is to use an input with 'autocomplete=off' instead of a
    // button. See https://bugzilla.mozilla.org/show_bug.cgi?id=654072
    _jsx("input", {
      className: "gr-buttonAsLink currentlyReadingShelf__addBook",
      value: "Add a book",
      onClick: this.showSearchForm,
      type: "button",
      disabled: this.state.showSearchForm,
      autoComplete: "off"
    }), this.renderGeneralUpdateButton()];
    return _jsx(_dot_separated_elements2.default, {
      elements: links
    });
  },
  renderFooter: function renderFooter() {
    if (this.hasReadingSessions()) {
      return this.renderFooterLinks();
    } else {
      return this.renderDiscoveryLinks();
    }
  },
  hasReadingSessions: function hasReadingSessions() {
    return !(0, _lodash.isEmpty)(this.state.readingSessionStore.readingSessions);
  },
  render: function render() {
    return _jsx("div", {}, void 0, _jsx("section", {
      className: "currentlyReadingShelf"
    }, void 0, _jsx("h3", {
      className: "gr-h3 gr-h3--noTopMargin"
    }, void 0, "Currently Reading"), this.renderBooks()), _jsx("footer", {}, void 0, _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, this.renderBookSearch()), this.renderFooter()));
  }
});

},{"../../modules/book_origins":6,"../../modules/default_shelves":11,"../../modules/reading_session_helper":18,"../../modules/shared/image_registry":20,"../../react_actions/reading_session_actions":39,"../../react_actions/shelvings_actions":41,"../../react_stores/reading_session_store":269,"../book":73,"../dot_separated_elements":102,"../gr_component_factory":108,"../home_page/general_status_update_button":113,"../reading_notes/reading_notes_link":211,"../reading_sessions/reading_progress_bar":212,"../spinner":226,"../update_reading_progress":229,"./add_book_search":100,"classnames":"classnames","lodash":"lodash","react":"react","react-addons-css-transition-group":"react-addons-css-transition-group","reflux":"reflux"}],102:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "DotSeparatedElements",

  propTypes: {
    elements: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string])).isRequired,
    separator: _react2.default.PropTypes.element
  },

  getDefaultProps: function getDefaultProps() {
    return {
      separator: _jsx("span", {}, void 0, " · ")
    };
  },
  joinElementsWithSeparator: function joinElementsWithSeparator() {
    var _this = this;

    var elements = (0, _lodash.compact)(this.props.elements);
    return (0, _lodash.transform)(elements, function (result, element, index) {
      result.push(element);
      if (index + 1 !== elements.length) {
        result.push(_this.props.separator);
      }
    });
  },
  render: function render() {
    return _jsx("span", {
      className: this.props.className
    }, void 0, (0, _lodash.map)(this.joinElementsWithSeparator(), function (element, index) {
      return _jsx("span", {}, index, element);
    }));
  }
});

},{"./gr_component_factory":108,"lodash":"lodash","react":"react"}],103:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Drop Down List
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: drop_down_list
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This is a basic menu list component that will take in arbitrary component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           children and display them in a list view. If the number of children is > the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           passed in maxListItems prop, the children will be appropriately truncated, and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           a "More" link will appear that will link to a passed in moreURL prop.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           OPTIONAL - moreLinkURL - url for the "More" link to redirect to. Does not display
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    the "More" link if no URL is passed in.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      moreLinkText - display text for the link. Defaults to "More"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "DropDownList",

  propTypes: {
    showMoreLink: _react2.default.PropTypes.bool,
    moreLinkURL: _react2.default.PropTypes.string,
    moreLinkText: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { showMoreLink: false,
      moreLinkURL: null,
      moreLinkText: "…More" };
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.props.children, this.props.showMoreLink && this.props.moreLinkURL !== null ? _jsx("a", {
      className: "dropDownList__listItem--moreLink",
      href: this.props.moreLinkURL
    }, void 0, this.props.moreLinkText) : null);
  }
});

},{"./gr_component_factory":108,"react":"react"}],104:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Dropdown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: dropdown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           A dropdown component. Includes a trigger and content area.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           NOTE: We tried to make Dropdown a single reusable component for anything with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           dropdown-style interaction. Unfortunately, because of special styling and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           interaction cases (e.g., navbar menus, "want to read" button),
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           it ended up a giant pile of special cases and logic forks. It's now an unwieldy mess.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           REQUIRED - trigger: element that will trigger the dropdown to open
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      triggerEventType: the event that will open the dropdown (e.g. click, hover)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Note: On touch devices the component will render as if you
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        had specified triggerEventType of "click"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           OPTIONAL - tooltipText: text to render as a `title` attribute on the trigger
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   element
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.Dropdown',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   trigger: 'Browse ▾',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   triggerEventType: 'hover',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   children: 'Link item one' } %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

/* react-onclickoutside is a deprecated package that should not be used for new
   code. Instead of having an outside click close a module, there should be an
   explicit close affordances in the spec. */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _hover_intent = require("../react_mixins/hover_intent");

var _hover_intent2 = _interopRequireDefault(_hover_intent);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _keys = require("../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _user_agent_capabilities_store = require("../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _touch_not_ready_helper = require("../modules/shared/touch_not_ready_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TriggerEventTypes = {
  HOVER: "hover",
  CLICK: "click"
};

var alignments = {
  LEFT: "left",
  RIGHT: "right"
};

var mouseOverDelay = 100;
var mouseOutDelay = mouseOverDelay;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Dropdown",

  mixins: [_hover_intent2.default, _reactOnclickoutside2.default, _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    alignment: _react2.default.PropTypes.oneOf(_lodash2.default.values(alignments)),
    fallbackUrl: _react2.default.PropTypes.string,
    onShowCallback: _react2.default.PropTypes.func,
    tooltipText: _react2.default.PropTypes.string,
    trigger: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]).isRequired,
    triggerEventType: _react2.default.PropTypes.oneOf(_lodash2.default.values(TriggerEventTypes))
  },

  statics: {
    TriggerEventTypes: TriggerEventTypes
  },

  getTriggerEventType: function getTriggerEventType() {
    if (this.state.userAgentCapabilities.touch) {
      return TriggerEventTypes.CLICK;
    }
    return this.props.triggerEventType;
  },
  getInitialState: function getInitialState() {
    return {
      dropdownOpen: false
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      triggerEventType: TriggerEventTypes.CLICK,
      alignment: alignments.LEFT
    };
  },
  hide: function hide() {
    this.setState({ dropdownOpen: false });
  },
  show: function show() {
    this.setState({ dropdownOpen: true });
    if (this.props.onShowCallback) {
      this.props.onShowCallback();
    }
  },
  toggle: function toggle(ev) {
    if (this.props.children) {
      ev.preventDefault();
    }
    this.state.dropdownOpen ? this.hide() : this.show();
  },
  openList: function openList(ev) {
    if (_keys2.default.isDropdownOpenerKey(ev.keyCode)) {
      ev.preventDefault();
      if (_keys2.default.isArrowDown(ev.keyCode)) {
        this.show();
      } else {
        this.toggle(ev);
      }
    } else if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      ev.preventDefault();
      this.hide();
    }
  },
  handleClickOutside: function handleClickOutside() {
    // On touch devices that display dropdown components, touch gestures such as
    // panning and zooming trigger this event listener. We disabled hiding in
    // this listener for touch devices because hiding the dropdown on touch
    // gestures is disruptive.
    if (!this.state.userAgentCapabilities.touch) {
      this.hide();
    }
  },
  handleMouseEnter: function handleMouseEnter() {
    this.onEnterIntent(this.show, mouseOverDelay);
  },
  handleMouseLeave: function handleMouseLeave() {
    this.onLeaveIntent(this.hide, mouseOutDelay);
  },
  handleTriggerClick: function handleTriggerClick(event) {
    (0, _touch_not_ready_helper.acknowledgeEvent)(event);
    // After hovering to open the dropdown, don't close on click
    if (this.state.dropdownOpen && this.props.triggerEventType === TriggerEventTypes.HOVER && this.state.userAgentCapabilities.touch !== true) {
      event.preventDefault();
      return;
    } else {
      this.toggle(event);
    }
  },
  triggerClasses: function triggerClasses() {
    return (0, _classnames2.default)(this.withBemModifiers(["dropdown__trigger"]), { "dropdown__trigger--buttonReset": _lodash2.default.isUndefined(this.props.fallbackUrl) }, { "dropdown__trigger--triggerEventTypeHover": this.props.triggerEventType === TriggerEventTypes.HOVER }, { "dropdown__trigger--personalNav": this.props.isInPersonalNav === "true" }, { "dropdown__trigger--personalNavActive": this.props.isInPersonalNav === "true" && this.state.dropdownOpen });
  },
  renderTriggerButton: function renderTriggerButton() {
    return _jsx("button", {
      className: this.triggerClasses(),
      "aria-haspopup": "true",
      "aria-expanded": this.state.dropdownOpen,
      onClick: this.handleTriggerClick,
      onKeyDown: this.openList,
      title: this.props.tooltipText,
      "data-ux-click": this.props.isInPersonalNav === "true"
    }, void 0, this.props.trigger);
  },
  renderTriggerLink: function renderTriggerLink() {
    return _jsx("a", {
      className: this.triggerClasses(),
      href: this.props.fallbackUrl,
      onClick: this.handleTriggerClick,
      onKeyDown: this.openList,
      role: "button",
      "aria-haspopup": "true",
      "aria-expanded": this.state.dropdownOpen,
      title: this.props.tooltipText,
      "data-ux-click": this.props.isInPersonalNav === "true"
    }, void 0, this.props.trigger);
  },
  render: function render() {
    var dropdownClasses = (0, _classnames2.default)(this.withBemModifiers("dropdown"));
    var dropdownShowOption = this.props.bemModifiers === "authorModule" || this.props.bemModifiers === "friendFollowModuleMobile" ? { "dropdown__menu--showMobile": this.state.dropdownOpen } : { "dropdown__menu--show": this.state.dropdownOpen };
    var dropdownContentsClasses = (0, _classnames2.default)(this.withBemModifiers("dropdown__menu"), "gr-box gr-box--withShadowLarge", dropdownShowOption);
    var trigger = _lodash2.default.isUndefined(this.props.fallbackUrl) ? this.renderTriggerButton() : this.renderTriggerLink();
    var dropdownContents = _jsx("div", {
      className: dropdownContentsClasses,
      role: "menu"
    }, void 0, this.props.children);

    switch (this.getTriggerEventType()) {
      case TriggerEventTypes.HOVER:
        return _jsx("div", {
          className: dropdownClasses,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, void 0, trigger, dropdownContents);
      case TriggerEventTypes.CLICK:
        return _jsx("div", {
          className: dropdownClasses
        }, void 0, trigger, dropdownContents);
    }
  }
});

},{"../modules/keys":14,"../modules/shared/touch_not_ready_helper":21,"../react_mixins/hover_intent":251,"../react_stores/user_agent_capabilities_store":273,"./gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],105:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: "error_message.js",

  propTypes: {
    componentName: _react2.default.PropTypes.string.isRequired
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-errorMessage"
    }, void 0, "There was an issue rendering ", this.props.componentName);
  }
});

},{"react":"react"}],106:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FlagForAbuseLink",
  propTypes: {
    flagForAbuseUrl: _react2.default.PropTypes.string.isRequired,
    resourceType: _react2.default.PropTypes.string
  },

  render: function render() {
    var flagClasses = (0, _classnames2.default)("gr-metaText", "gr-hyperlink--naked", "gr-hyperlink", "gr-flag");
    var flagTitle = "Flag this " + (this.props.resourceType || "comment") + " as inappropriate.";
    return _jsx("a", {
      href: this.props.flagForAbuseUrl,
      className: flagClasses,
      title: flagTitle
    }, void 0, "Flag");
  }
});

},{"../gr_component_factory":108,"classnames":"classnames","react":"react"}],107:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _reactTextareaAutosize = require("react-textarea-autosize");

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _keys = require("../../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 A form that displays with z-index: $z-index-long-text-popup-form that has a header, a single large
 textarea with a live character count, and save and cancel buttons.

 Also contains optional social links, which currently consists of a Facebook toggle.
 Enable these by passing a showSocialLinks=true prop (false by default).
 */
exports.default = _gr_component_factory2.default.createClass({
  displayName: "LongTextPopupForm",
  propTypes: {
    characterLimit: _react.PropTypes.number.isRequired,
    text: _react.PropTypes.string,
    onCancel: _react.PropTypes.func.isRequired,
    onSubmit: _react.PropTypes.func.isRequired,
    onTextChange: _react.PropTypes.func.isRequired,
    submitButtonLabel: _react.PropTypes.string,
    header: _react.PropTypes.element.isRequired,

    // Set to true while waiting for the server to respond with success or failure
    saveInProgress: _react.PropTypes.bool,

    // include { required: true } inside textareaProps to validate the presence of text
    // all other props are passed along unchanged to TextareaAutosize
    textareaProps: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      submitButtonLabel: "Save",
      submitButtonDisabled: false,
      submissionInProgress: false,
      text: ""
    };
  },
  submit: function submit() {
    this.props.onSubmit(this.props.text);
  },
  cancel: function cancel() {
    this.props.onCancel();
  },
  handleClickOutside: function handleClickOutside() {
    this.cancel();
  },
  remainingCharacterCount: function remainingCharacterCount() {
    return this.props.characterLimit - this.props.text.length;
  },
  tooManyCharacters: function tooManyCharacters() {
    return this.remainingCharacterCount() < 0;
  },
  tooFewCharacters: function tooFewCharacters() {
    if (this.props.textareaProps && this.props.textareaProps.required) {
      return (0, _lodash.isEmpty)(this.props.text);
    }
    return false;
  },
  isValid: function isValid() {
    return !this.tooManyCharacters() && !this.tooFewCharacters();
  },
  saveInProgress: function saveInProgress() {
    return this.props.saveInProgress;
  },
  isSubmitButtonDisabled: function isSubmitButtonDisabled() {
    return !this.isValid() || this.saveInProgress();
  },
  updateTextChanged: function updateTextChanged(value) {
    if (this.props.onTextChange) {
      this.props.onTextChange(value);
    }
    this.setState({ text: value,
      remainingCharacterCount: this.props.characterLimit - value.length });
  },
  hideOnEscape: function hideOnEscape(ev) {
    if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      this.cancel();
    }
  },
  submitButtonLabel: function submitButtonLabel() {
    if (this.saveInProgress()) {
      return "Saving...";
    } else {
      return this.props.submitButtonLabel;
    }
  },
  renderFooter: function renderFooter() {
    var charCountClasses = (0, _classnames2.default)("longTextPopupForm__remainingCharacterCount", { "longTextPopupForm__remainingCharacterCount--tooHigh": this.tooManyCharacters() });
    return _jsx("div", {
      className: "longTextPopupForm__footer"
    }, void 0, _jsx("span", {
      className: charCountClasses
    }, void 0, this.remainingCharacterCount(), " characters left"), _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.cancel
    }, void 0, "Cancel"), _jsx("button", {
      className: "gr-button longTextPopupForm__submitButton",
      onClick: this.submit,
      disabled: this.isSubmitButtonDisabled()
    }, void 0, this.submitButtonLabel()));
  },
  render: function render() {
    var _this = this;

    return _jsx("div", {
      className: "longTextPopupForm",
      onKeyDown: this.hideOnEscape
    }, void 0, _jsx("div", {
      className: "longTextPopupForm__header u-beigeBackground"
    }, void 0, this.props.header), React.createElement(_reactTextareaAutosize2.default, _extends({ className: "gr-textarea longTextPopupForm__textInput",
      onChange: function onChange(ev) {
        _this.props.onTextChange(ev.target.value);
      },
      value: this.props.text
    }, this.props.textareaProps)), this.renderFooter());
  }
});

},{"../../modules/keys":14,"../gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react","react-textarea-autosize":278}],108:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bem_modifiers = require("../react_mixins/bem_modifiers");

var _bem_modifiers2 = _interopRequireDefault(_bem_modifiers);

var _deploy_service = require("../react_mixins/deploy_service");

var _deploy_service2 = _interopRequireDefault(_deploy_service);

var _reactAddonsPureRenderMixin = require("react-addons-pure-render-mixin");

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _tracking_data_attributes_mixin = require("../react_mixins/tracking_data_attributes_mixin");

var _tracking_data_attributes_mixin2 = _interopRequireDefault(_tracking_data_attributes_mixin);

var _error_message = require("./error_message");

var _error_message2 = _interopRequireDefault(_error_message);

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _gr_error_reporting = require("../modules/gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MIXINS = [_reactAddonsPureRenderMixin2.default, _bem_modifiers2.default, _deploy_service2.default, _tracking_data_attributes_mixin2.default];

/**
 * A factory that creates React class
 *
 * Params:
 * spec: object - React component definition. The definition expects `render`
 * function and `displayName` attribute. If not an error will be thrown.
 * options: {
 *   showErrorMessage: boolean - if true, shows an error message
 * }
 */

var DEFAULT_OPTIONS = {
  showErrorMessage: "production" === _env_utils2.default.DEVELOPMENT
};

var wrapRenderFunction = function wrapRenderFunction(spec, options) {
  var originalRender = spec.render;
  options = (0, _lodash.merge)({}, DEFAULT_OPTIONS, options);
  spec.render = function () {
    try {
      return originalRender.apply(this, arguments);
    } catch (error) {
      _gr_error_reporting2.default.notifyException(error, "Failed to render " + spec.displayName);
      if (options.showErrorMessage) {
        return _jsx(_error_message2.default, {
          componentName: spec.displayName
        });
      } else {
        return null;
      }
    }
  };
};

// throw an error if a valid component name. The component name is useful for debugging.
var validateComponentNameRequired = function validateComponentNameRequired(componentName) {
  if ((0, _lodash.isEmpty)(componentName)) {
    throw new Error("GrError: Missing component name. Please " + "make sure `displayName` attribute is defined while creating a React class " + "using GrComponentFactory.createClass.");
  }
};

var addMixins = function addMixins(spec) {
  var mixins = spec.mixins || [];
  spec.mixins = mixins.concat(DEFAULT_MIXINS);
};

var getComponentSpec = function getComponentSpec(spec, options) {
  addMixins(spec);
  // If we are in a test environment (TEST var set in gulpfile), do not catch
  // rendering errors in components
  if ("production" !== _env_utils2.default.TEST) {
    wrapRenderFunction(spec, options);
  }
  return spec;
};

exports.default = {
  createClass: function createClass(spec) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    validateComponentNameRequired(spec.displayName);
    return _react2.default.createClass(getComponentSpec(spec, options));
  }
};

},{"../modules/env_utils":12,"../modules/gr_error_reporting":13,"../react_mixins/bem_modifiers":246,"../react_mixins/deploy_service":248,"../react_mixins/tracking_data_attributes_mixin":252,"./error_message":105,"lodash":"lodash","react":"react","react-addons-pure-render-mixin":"react-addons-pure-render-mixin"}],109:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GroupIcon",

  propTypes: {
    group: _react2.default.PropTypes.shape({
      name: _react2.default.PropTypes.string.isRequired,
      iconUrl: _react2.default.PropTypes.string.isRequired,
      url: _react2.default.PropTypes.string.isRequired
    }).isRequired,
    includeLink: _react2.default.PropTypes.bool,
    size: _react2.default.PropTypes.oneOf([_shape_icon_values.ICON_SIZES.SMALL, _shape_icon_values.ICON_SIZES.MEDIUM, _shape_icon_values.ICON_SIZES.LARGE])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      includeLink: false,
      size: _shape_icon_values.ICON_SIZES.SMALL
    };
  },
  render: function render() {
    var group = this.props.group;
    return _jsx(_shape_icon2.default, {
      imageUrl: group.iconUrl,
      imageAlt: group.name,
      linkUrl: group.url,
      shape: _shape_icon_values.ICON_SHAPES.ROUND_SQUARE,
      size: this.props.size,
      includeLink: this.props.includeLink
    });
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":108,"../shape_icon":219,"react":"react"}],110:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _to_sentence = require("../../modules/to_sentence");

var _to_sentence2 = _interopRequireDefault(_to_sentence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ChoiceWidget",
  mixins: [_to_sentence2.default],
  propTypes: {
    badgeUrl: _react2.default.PropTypes.string.isRequired,
    choiceAwardsUrl: _react2.default.PropTypes.string.isRequired,
    flourishUrl: _react2.default.PropTypes.string.isRequired,
    friendsWhoVoted: _react2.default.PropTypes.array,
    numOtherFriends: _react2.default.PropTypes.number,
    numVotesCast: _react2.default.PropTypes.string.isRequired,
    winnersAnnounced: _react2.default.PropTypes.bool.isRequired,
    choiceYear: _react2.default.PropTypes.number.isRequired
  },

  renderTitle: function renderTitle() {
    return _jsx("div", {
      className: "choiceWidget__title"
    }, void 0, _jsx("span", {
      className: "choiceWidget__titleWhite u-displayBlock"
    }, void 0, this.props.winnersAnnounced ? "Announcing" : "Decide", " Readers' "), _jsx("span", {
      className: "choiceWidget__titleWhite u-displayBlock"
    }, void 0, "Favorite Books of ", this.props.choiceYear));
  },
  renderNumVotesCast: function renderNumVotesCast() {
    return _jsx("div", {
      className: "choiceWidget__votesCast"
    }, void 0, this.props.numVotesCast, " Votes Cast");
  },
  renderFriendLink: function renderFriendLink(friend) {
    return _jsx("a", {
      className: "choiceWidget__votesCast",
      href: friend.url
    }, void 0, friend.name);
  },
  renderOtherFriendsText: function renderOtherFriendsText() {
    return _jsx("span", {}, void 0, this.props.numOtherFriends, " other", this.props.numOtherFriends == 1 ? " friend" : " friends");
  },
  renderFriendsWhoVoted: function renderFriendsWhoVoted() {
    var _this = this;

    if (!this.props.friendsWhoVoted) {
      return null;
    }
    var friendLinks = (0, _lodash.map)(this.props.friendsWhoVoted, function (friend) {
      return _this.renderFriendLink(friend);
    });
    if (this.props.numOtherFriends > 0) {
      friendLinks.push(this.renderOtherFriendsText());
    }
    return _jsx("div", {
      className: "choiceWidget__votesCast"
    }, void 0, this.toSentence(friendLinks), this.props.friendsWhoVoted.length == 1 ? " has " : " have ", "voted.");
  },
  renderButtonText: function renderButtonText() {
    return this.props.winnersAnnounced ? "See the Winners" : "Cast Your Vote";
  },
  renderBadge: function renderBadge() {
    return _jsx("a", {
      href: this.props.choiceAwardsUrl
    }, void 0, _jsx("img", {
      className: "",
      src: this.props.badgeUrl,
      alt: "Goodreads Choice Awards"
    }));
  },
  render: function render() {
    return _jsx("div", {
      className: "choiceWidget"
    }, void 0, _jsx("h3", {
      className: "gr-h3 gr-h3--noTopMargin"
    }, void 0, "Goodreads Choice Awards"), _jsx("div", {
      className: "choiceWidget__photoAndTextContainer"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media"
    }, void 0, this.renderBadge()), _jsx("div", {
      className: "choiceWidget__titleAndButtonContainer"
    }, void 0, _jsx("div", {}, void 0, this.renderTitle()), _jsx("a", {
      className: "gr-button gr-button--fullWidth choiceWidget__seeWinnersButton gr-button--choice",
      href: this.props.choiceAwardsUrl
    }, void 0, this.renderButtonText()), _jsx("div", {
      className: "gr-mediaFlexbox u-marginBottomXSmall"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__desc u-marginRightTiny"
    }, void 0, this.renderNumVotesCast(), this.renderFriendsWhoVoted())))));
  }
});

},{"../../modules/to_sentence":22,"../gr_component_factory":108,"lodash":"lodash","react":"react"}],111:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "EditorialBlogThumbnail",
  propTypes: {
    likesCountText: _react2.default.PropTypes.string,
    commentsCountText: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    blogPostUrl: _react2.default.PropTypes.string.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    header: _react2.default.PropTypes.string.isRequired
  },

  renderBlogLink: function renderBlogLink(text) {
    return _jsx("span", {
      className: "gr-metaText"
    }, void 0, text);
  },
  renderImage: function renderImage() {
    if (this.props.imageUrl) {
      return _jsx("a", {
        href: this.props.blogPostUrl
      }, void 0, _jsx("img", {
        className: "gr-editorialBlogPost__image",
        src: this.props.imageUrl,
        alt: "" + this.props.title
      }));
    } else {
      return null;
    }
  },
  renderLikesAndComments: function renderLikesAndComments() {
    var likesLink = this.renderBlogLink(this.props.likesCountText);
    var commentsLink = this.renderBlogLink(this.props.commentsCountText);
    if (this.props.likesCountText && this.props.commentsCountText) {
      return _jsx(_dot_separated_elements2.default, {
        elements: [likesLink, commentsLink]
      });
    } else if (this.props.likesCountText) {
      return likesLink;
    } else if (this.props.commentsCountText) {
      return commentsLink;
    } else {
      return null;
    }
  },
  render: function render() {
    return _jsx("section", {
      className: "gr-editorialBlogPost"
    }, void 0, _jsx("article", {}, void 0, _jsx("h3", {}, void 0, this.props.header), _jsx("a", {
      href: this.props.blogPostUrl,
      className: "gr-editorialBlogPost__title"
    }, void 0, this.props.title), this.renderImage(), _jsx("div", {
      className: "gr-editorialBlogPost__likesAndComments"
    }, void 0, this.renderLikesAndComments())));
  }
});

},{"../dot_separated_elements":102,"../gr_component_factory":108,"react":"react"}],112:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component implements the "footer" (side rail) links for the signed in
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           desktop home page. It essentially duplicates _footer_responsive.html.haml,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           which is (going to be) used everywhere else. I (clinew) decided it was not
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           worth the time and effort to engineer a single component, with a single set of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           markup, that could be used in both places, because the styling is so different.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _image_registry = require("../../modules/shared/image_registry");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Footer",

  propTypes: {
    aboutUrl: _react2.default.PropTypes.string.isRequired,
    adPreferencesUrl: _react2.default.PropTypes.string.isRequired,
    androidDownloadUrl: _react2.default.PropTypes.string.isRequired,
    authorsUrl: _react2.default.PropTypes.string.isRequired,
    authorsBlogUrl: _react2.default.PropTypes.string.isRequired,
    yourAdsPrivacyChoicesUrl: _react2.default.PropTypes.string.isRequired,
    facebookUrl: _react2.default.PropTypes.string.isRequired,
    instagramUrl: _react2.default.PropTypes.string.isRequired,
    interestBasedAdsUrl: _react2.default.PropTypes.string.isRequired,
    iOSDownloadUrl: _react2.default.PropTypes.string.isRequired,
    jobsUrl: _react2.default.PropTypes.string.isRequired,
    linkedInUrl: _react2.default.PropTypes.string.isRequired,
    advertiseUrl: _react2.default.PropTypes.string.isRequired,
    termsUrl: _react2.default.PropTypes.string.isRequired,
    twitterUrl: _react2.default.PropTypes.string.isRequired,
    privacyUrl: _react2.default.PropTypes.string.isRequired,
    helpUrl: _react2.default.PropTypes.string.isRequired,
    mobileSiteUrl: _react2.default.PropTypes.string.isRequired,
    // TODO: https://issues.amazon.com/issues/CaR-9319: Clean up after fully launching CCBA pref page
    showCCBAPageLink: _react2.default.PropTypes.bool.isRequired
  },

  render: function render() {
    var siteLinkClasses = (0, _classnames2.default)("gr-hyperlink", "gr-hyperlink--black");
    return _jsx("footer", {}, void 0, _jsx("div", {
      className: "gr-footer__siteLinks"
    }, void 0, _jsx("div", {
      className: "gr-footer__firstLinkColumn"
    }, void 0, _jsx("h3", {
      className: "gr-h3"
    }, void 0, "Company"), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.aboutUrl
    }, void 0, "About us")), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.jobsUrl
    }, void 0, "Careers")), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.termsUrl
    }, void 0, "Terms")), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.privacyUrl
    }, void 0, "Privacy")), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.interestBasedAdsUrl
    }, void 0, "Interest Based Ads")), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.adPreferencesUrl
    }, void 0, "Ad Preferences")), this.props.showCCBAPageLink && _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.yourAdsPrivacyChoicesUrl,
      style: { whiteSpace: 'nowrap' }
    }, void 0, "Your Ads Privacy Choices", _jsx("img", {
      alt: "",
      src: (0, _image_registry.getImages)().siteFooter.ccbaIcon,
      style: { marginLeft: '4px' }
    }))), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.helpUrl
    }, void 0, "Help"))), _jsx("div", {
      className: "gr-footer__secondLinkColumn"
    }, void 0, _jsx("h3", {
      className: "gr-h3"
    }, void 0, "Work with us"), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.authorsUrl
    }, void 0, "Authors")), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.advertiseUrl
    }, void 0, "Advertise")), _jsx("div", {}, void 0, _jsx("a", {
      className: siteLinkClasses,
      href: this.props.authorsBlogUrl
    }, void 0, "Authors & ads blog")))), _jsx("h3", {
      className: "gr-h3"
    }, void 0, "Connect"), _jsx("a", {
      className: "gr-footer__socialLink",
      href: this.props.facebookUrl
    }, void 0, _jsx("img", {
      alt: "Goodreads on Facebook",
      src: (0, _image_registry.getImages)().siteFooter.facebookIcon
    })), _jsx("a", {
      className: "gr-footer__socialLink",
      href: this.props.twitterUrl
    }, void 0, _jsx("img", {
      alt: "Goodreads on Twitter",
      src: (0, _image_registry.getImages)().siteFooter.twitterIcon
    })), _jsx("a", {
      className: "gr-footer__socialLink",
      href: this.props.instagramUrl
    }, void 0, _jsx("img", {
      alt: "Goodreads on Instagram",
      src: (0, _image_registry.getImages)().siteFooter.instagramIcon
    })), _jsx("a", {
      className: "gr-footer__socialLink",
      href: this.props.linkedInUrl
    }, void 0, _jsx("img", {
      alt: "Goodreads on LinkedIn",
      src: (0, _image_registry.getImages)().siteFooter.linkedInIcon
    })), _jsx("div", {
      className: "gr-footer__appLinks"
    }, void 0, _jsx("a", {
      className: "gr-footer__iOSLink",
      href: this.props.iOSDownloadUrl
    }, void 0, _jsx("img", {
      alt: "Download app for iOS",
      src: (0, _image_registry.getImages)().goodreadsApps.iOSDownloadBadge
    })), _jsx("a", {
      href: this.props.androidDownloadUrl
    }, void 0, _jsx("img", {
      alt: "Download app for Android",
      src: (0, _image_registry.getImages)().goodreadsApps.androidDownloadBadgeDesktopHome,
      srcSet: (0, _image_registry.getImages)().goodreadsApps.androidDownloadBadgeDesktopHome2x + " 2x"
    })), _jsx("p", {}, void 0, _jsx("a", {
      className: "gr-hyperlink\n                          gr-hyperlink--black\n                          gr-footer__layoutLink\n                          gr-footer__layoutLink--mobile",
      rel: "nofollow",
      href: this.props.mobileSiteUrl
    }, void 0, "Mobile Version")), _jsx("p", {}, void 0, _jsx("small", {}, void 0, "© ", new Date().getFullYear(), " Goodreads LLC")), _jsx("img", {
      alt: "An Amazon Company",
      src: (0, _image_registry.getImages)().siteFooter.amazonCompanyLogoIcon,
      style: { height: '1em', width: 'auto', display: 'block' }
    })));
  }
});

},{"../../modules/shared/image_registry":20,"../gr_component_factory":108,"classnames":"classnames","react":"react"}],113:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _reflux = require("reflux");

var _react_ref_helpers = require("../../modules/react_ref_helpers");

var _long_text_popup_form = require("../forms/long_text_popup_form");

var _long_text_popup_form2 = _interopRequireDefault(_long_text_popup_form);

var _general_status_update_actions = require("../../react_actions/general_status_update_actions");

var _general_status_update_actions2 = _interopRequireDefault(_general_status_update_actions);

var _general_status_update_store = require("../../react_stores/general_status_update_store");

var _general_status_update_store2 = _interopRequireDefault(_general_status_update_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promptText = "Share your book thoughts with friends...";
var textareaHtmlId = "generalStatusUpdateFormTextarea";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GeneralStatusUpdateButton",

  mixins: [(0, _reflux.connect)(_general_status_update_store2.default, "generalStatusUpdate")],

  propTypes: {
    characterLimit: _react.PropTypes.number.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      updateText: ""
    };
  },
  isFormOpen: function isFormOpen() {
    return this.state.generalStatusUpdate.creationInProgress;
  },
  syncUpdateText: function syncUpdateText(text) {
    this.setState({ updateText: text });
  },
  renderForm: function renderForm() {
    if (this.isFormOpen()) {
      return _jsx(_long_text_popup_form2.default, {
        characterLimit: this.props.characterLimit,
        text: this.state.updateText,
        onCancel: _general_status_update_actions2.default.closeCreationDialog,
        onSubmit: _general_status_update_actions2.default.save,
        onTextChange: this.syncUpdateText,
        header: _jsx("label", {
          htmlFor: textareaHtmlId
        }, void 0, promptText),
        saveInProgress: this.state.generalStatusUpdate.saveInProgress,
        textareaProps: {
          id: textareaHtmlId,
          ref: _react_ref_helpers.focusOnMount,
          required: true
        }
      });
    }
  },
  render: function render() {
    return _jsx("span", {
      "aria-live": "polite"
    }, void 0, _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: _general_status_update_actions2.default.openCreationDialog,
      disabled: this.isFormOpen()
    }, void 0, "General update"), this.renderForm());
  }
});

},{"../../modules/react_ref_helpers":17,"../../react_actions/general_status_update_actions":33,"../../react_stores/general_status_update_store":263,"../forms/long_text_popup_form":107,"../gr_component_factory":108,"react":"react","reflux":"reflux"}],114:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_ratings_store = require("../../react_stores/user_ratings_store");

var _user_ratings_store2 = _interopRequireDefault(_user_ratings_store);

var _progress_bar = require("../progress_bar");

var _progress_bar2 = _interopRequireDefault(_progress_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ImproveRecommendations",
  mixins: [_reflux2.default.connectFilter(_user_ratings_store2.default, "ratingsCount", function (storeData) {
    return storeData.ratingsCount;
  })],
  propTypes: {
    maxRecsCount: _react2.default.PropTypes.number,
    rateBooksUrl: _react2.default.PropTypes.string
  },

  renderPercent: function renderPercent() {
    return Math.round(this.state.ratingsCount / this.props.maxRecsCount * 100) + "%";
  },
  renderCopy: function renderCopy() {
    if (this.state.ratingsCount < this.props.maxRecsCount) {
      return _jsx("div", {
        className: "u-marginBottomXSmall"
      }, void 0, "Rating at least ", this.props.maxRecsCount, " books improves your recommendations. You have rated ", this.state.ratingsCount, ".");
    } else {
      return _jsx("div", {
        className: "u-marginBottomXSmall"
      }, void 0, "You have rated at least ", this.props.maxRecsCount, " books! Your recommendations are being recalculated.");
    }
  },
  render: function render() {
    return _jsx("section", {
      className: "gr-homePageRailContainer\n                               u-paddingBottomMedium"
    }, void 0, _jsx("h3", {}, void 0, "Improve Recommendations"), this.renderCopy(), _jsx(_progress_bar2.default, {
      value: this.state.ratingsCount,
      max: this.props.maxRecsCount,
      width: "80%"
    }), _jsx("div", {
      className: "gr-metaText u-marginTopTiny"
    }, void 0, this.state.ratingsCount + "/" + this.props.maxRecsCount + " (" + this.renderPercent() + ")"), _jsx("a", {
      href: this.props.rateBooksUrl,
      className: "u-displayBlock u-marginTopXSmall"
    }, void 0, "Rate more books"));
  }
});

},{"../../react_stores/user_ratings_store":275,"../gr_component_factory":108,"../progress_bar":204,"react":"react","reflux":"reflux"}],115:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Displays a user’s book recommendations. This component is used on the home page.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           We have eight different recommendation algorithms for this widget. We first
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           randomly choose one of six algorithms which are based on the user's shelvings.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Those correspond with the following algorithm ids:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           0: recs are based on the genre of a book the user is currently reading
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           1: recs are based on books similar to a book the user is currently reading
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           2: recs are based on the genre of a book the user recently read
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           3: recs are based on books similar to a book the user recently read
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           4: recs are based on the genre of a book the user shelved
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           5: recs are based on books similar a book the user shelved
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           If we cannot generate sufficient recs from those algorithms above, we have
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           generic 'fallback' algorithms. They come in two types:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           fav_genres_recs: recs are based on one of the user's favorite genres
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           shelf_recs: recs are based on one of the user's shelves
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FALLBACK_RECS = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _reactAddonsCssTransitionGroup = require("react-addons-css-transition-group");

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _lodash = require("lodash");

var _origins = require("../../analytics/origins");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _book_description = require("../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _book = require("../book");

var _book2 = _interopRequireDefault(_book);

var _community_rating = require("../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _want_to_read_button = require("../want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _recommendations_store = require("../../react_stores/recommendations_store");

var _recommendations_store2 = _interopRequireDefault(_recommendations_store);

var _recommendations_actions = require("../../react_actions/recommendations_actions");

var _recommendations_actions2 = _interopRequireDefault(_recommendations_actions);

var _reading_session_helper = require("../../modules/reading_session_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REC_ALGORITHM_IDS = {
  CURRENTLY_READING: [0, 1],
  RECENTLY_READ: [2, 3],
  SHELVED: [4, 5],
  GENRES: [0, 2, 4]
};

var FALLBACK_RECS = exports.FALLBACK_RECS = {
  FAV_GENRE_RECS: "fav_genres_recs",
  SHELF_RECS: "shelf_recs"
};

var transitionTimeout = 300;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Recommendations",

  mixins: [_reflux2.default.connect(_recommendations_store2.default, "recommendationsStore")],

  boldLink: function boldLink(linkUrl, linkText) {
    return _jsx("a", {
      href: linkUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, linkText);
  },
  renderJustificationText: function renderJustificationText() {
    var state = this.state.recommendationsStore;
    return _jsx("div", {
      className: "recommendationsWidget__justificationText"
    }, void 0, state.fallbackRecsType ? this.renderGenericRationaleText() : this.renderShelvingRationaleText());
  },
  renderGenericRationaleText: function renderGenericRationaleText() {
    var state = this.state.recommendationsStore;
    if (state.fallbackRecsType === FALLBACK_RECS.FAV_GENRE_RECS) {
      return _jsx("span", {}, void 0, "A few recommendations for you in", state.genre.url ? _jsx("span", {}, void 0, " ", this.boldLink(state.genre.url, state.genre.name)) : _jsx("span", {}, void 0, " ", state.genre.name));
    } else {
      return _jsx("span", {}, void 0, "Based on your ", this.boldLink(state.recShelf.url, state.recShelf.name + " shelf"), " a few recommendations:");
    }
  },
  getShelvingDescription: function getShelvingDescription() {
    var state = this.state.recommendationsStore;
    if ((0, _lodash.includes)(REC_ALGORITHM_IDS.CURRENTLY_READING, state.algorithmId)) {
      return "Because you are currently reading ";
    } else if ((0, _lodash.includes)(REC_ALGORITHM_IDS.RECENTLY_READ, state.algorithmId)) {
      if (state.recBook.currentUserRating < 3) {
        return "Because you read ";
      } else {
        return "Because you enjoyed ";
      }
    } else {
      return "Because you shelved ";
    }
  },
  renderShelvingRationaleText: function renderShelvingRationaleText() {
    var state = this.state.recommendationsStore;
    var shelvingDescription = this.getShelvingDescription();
    var bookLink = this.boldLink(state.recBook.url, (0, _reading_session_helper.truncateBookTitle)(state.recBook.title));

    return _jsx("span", {}, void 0, shelvingDescription, bookLink, ":");
  },
  renderBookDisplay: function renderBookDisplay(book) {
    return _jsx("div", {
      className: "recommendationsWidget__rec u-marginTopXSmall"
    }, book.bookId, _jsx("div", {
      className: "recommendationsWidget__bookWrapper"
    }, void 0, React.createElement(
      _book2.default,
      book,
      _jsx(_community_rating2.default, {
        rating: parseFloat(book.avgRating),
        displayAvg: true
      }),
      _jsx("div", {
        className: "u-marginTopXSmall"
      }, void 0, _jsx(_want_to_read_button2.default, {
        bookTitle: book.title,
        uniqueId: (0, _lodash.random)(1000000).toString(),
        bookId: book.bookId,
        origin: _origins.ShelvedBookOrigin.RECS_WIDGET,
        showMenu: false
      }))
    )), this.renderBookDescription(book), this.renderCaret());
  },
  renderBookDescription: function renderBookDescription(book) {
    if (!(0, _lodash.isUndefined)(book.description)) {
      return _jsx(_book_description2.default, {
        bookDescription: book.description
      });
    } else {
      return null;
    }
  },
  renderCaret: function renderCaret() {
    return _jsx("button", {
      className: "gr-button\n                         gr-button--caretRight\n                         recommendationsWidget__caret",
      "aria-label": "Next Recommendation",
      onClick: _recommendations_actions2.default.requestNextRec
    });
  },
  renderRecommendationsLink: function renderRecommendationsLink() {
    var state = this.state.recommendationsStore;
    if (!state.fallbackRecsType) {
      return _jsx("a", {
        className: "recommendationsWidget__viewAll",
        href: state.recBook.similarBooksUrl
      }, void 0, "View all books similar to ", (0, _reading_session_helper.truncateBookTitle)(state.recBook.title));
    } else if (state.fallbackRecsType === FALLBACK_RECS.FAV_GENRE_RECS && state.genre.similarBooksUrl) {
      return _jsx("a", {
        className: "recommendationsWidget__viewAll",
        href: state.genre.similarBooksUrl
      }, void 0, "View similar books in this genre");
    } else {
      return _jsx("a", {
        className: "recommendationsWidget__viewAll",
        href: "/recommendations"
      }, void 0, "View all recommendations");
    }
  },
  render: function render() {
    var state = this.state.recommendationsStore;
    var activeRecommendation = state.recommendations[state.activeRecommendationId];
    return _jsx("div", {
      className: "recommendationsWidget"
    }, void 0, _jsx("h3", {
      className: "gr-h3 gr-h3--noTopMargin"
    }, void 0, "Recommendations"), this.renderJustificationText(), _jsx(_reactAddonsCssTransitionGroup2.default, {
      transitionName: "recommendationsWidget__rec",
      transitionEnterTimeout: transitionTimeout,
      transitionLeaveTimeout: transitionTimeout
    }, void 0, this.renderBookDisplay(activeRecommendation.book)), _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, " ", this.renderRecommendationsLink(), " "));
  }
});

},{"../../analytics/origins":1,"../../modules/reading_session_helper":18,"../../react_actions/recommendations_actions":40,"../../react_stores/recommendations_store":270,"../book":73,"../book_description":75,"../community_rating":99,"../gr_component_factory":108,"../want_to_read/want_to_read_button":238,"lodash":"lodash","react-addons-css-transition-group":"react-addons-css-transition-group","reflux":"reflux"}],116:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _like_actions = require("../../react_actions/like_actions");

var _like_actions2 = _interopRequireDefault(_like_actions);

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeButton",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_like_store2.default, "resourceKey")],

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired,
    resourceLabel: _react2.default.PropTypes.string.isRequired,
    showAsLink: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { showAsLink: true };
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.likeFocused && !this.state.showLoadingSpinner) {
      this.refs.likeButton.focus();
      this.likeFocused = false;
    }
  },
  buttonClicked: function buttonClicked() {
    if (this.state.isLiked) {
      _like_actions2.default.unLike(this.props.resourceKey);
    } else {
      _like_actions2.default.like(this.props.resourceKey);
    }
  },
  render: function render() {
    var _this = this;

    var linkText = this.state.isLiked ? "Unlike" : "Like";
    var buttonClasses = (0, _classnames2.default)({ "gr-buttonAsLink": this.props.showAsLink }, { "gr-button gr-button--small": !this.props.showAsLink });
    return _jsx("span", {
      "aria-live": "polite"
    }, void 0, this.state.showLoadingSpinner ? _jsx(_spinner2.default, {}) : _react2.default.createElement(
      "button",
      { "aria-label": linkText + " " + this.props.resourceLabel,
        ref: "likeButton",
        className: buttonClasses,
        onClick: this.buttonClicked,
        onFocus: function onFocus() {
          _this.likeFocused = true;
        } },
      linkText
    ));
  }
});

},{"../../react_actions/like_actions":35,"../../react_mixins/gr_reflux":250,"../../react_stores/like_store":265,"../gr_component_factory":108,"../spinner":226,"classnames":"classnames","react":"react"}],117:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _gr_reflux = require("../../react_mixins/gr_reflux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeCount",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_like_store2.default, "resourceKey")],

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired
  },

  getPluralLike: function getPluralLike(likeCount) {
    if (likeCount === 1) {
      return "like";
    } else {
      return "likes";
    }
  },
  render: function render() {
    if (this.state.likeCount > 0) {
      return _jsx("span", {}, void 0, _jsx("a", {
        className: "gr-hyperlink--quiet",
        href: this.state.likersListUrl
      }, void 0, this.state.likeCount, " ", this.getPluralLike(this.state.likeCount)), " · ");
    } else {
      return null;
    }
  }
});

},{"../../react_mixins/gr_reflux":250,"../../react_stores/like_store":265,"../gr_component_factory":108,"react":"react"}],118:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeInformation",

  mixins: [_reflux2.default.connectFilter(_like_store2.default, "likeStore", function (likes) {
    return likes[this.props.resourceKey];
  })],

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired
  },

  getNameLink: function getNameLink() {
    var likedBy = this.state.likeStore.likedBy;
    var likedByUser = !_lodash2.default.isUndefined(likedBy.friends) ? likedBy.friends[0] : likedBy.others[0];

    return _jsx("a", {
      href: likedByUser.profile_url,
      className: "gr-hyperlink gr-hyperlink--bold likeInformation__name"
    }, void 0, likedByUser.name);
  },
  getPluralPerson: function getPluralPerson(count) {
    if (count > 1) {
      return "people";
    }
    return "person";
  },
  getYouLikeMessage: function getYouLikeMessage() {
    return _jsx("span", {
      className: "likeInformation__name"
    }, void 0, "You");
  },
  getYouAndAnotherPersonLikeMessage: function getYouAndAnotherPersonLikeMessage() {
    return _jsx("span", {}, void 0, this.getYouLikeMessage(), " and ", this.getNameLink());
  },
  getYouAndManyPeopleLikeMessage: function getYouAndManyPeopleLikeMessage() {
    var likeState = this.state.likeStore;
    var count = likeState.likeCount - 2;
    return _jsx("span", {}, void 0, this.getYouLikeMessage(), ", ", this.getNameLink(), ",", " and ", _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: likeState.likersListUrl
    }, void 0, count, " other ", this.getPluralPerson(count)));
  },
  getSomeoneLikeMessage: function getSomeoneLikeMessage() {
    return _jsx("span", {}, void 0, this.getNameLink());
  },
  getManyPeopleLikeMessage: function getManyPeopleLikeMessage() {
    var likeState = this.state.likeStore;
    var count = likeState.likeCount - 1;
    return _jsx("span", {}, void 0, this.getNameLink(), " and ", _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: likeState.likersListUrl
    }, void 0, count, " other ", this.getPluralPerson(count)));
  },
  getLikeMessage: function getLikeMessage() {
    var likeState = this.state.likeStore;
    if (likeState.isLiked) {
      switch (likeState.likeCount) {
        case 1:
          return this.getYouLikeMessage();
        case 2:
          return this.getYouAndAnotherPersonLikeMessage();
        default:
          return this.getYouAndManyPeopleLikeMessage();
      }
    } else {
      switch (likeState.likeCount) {
        case 1:
          return this.getSomeoneLikeMessage();
        default:
          return this.getManyPeopleLikeMessage();
      }
    }
  },
  render: function render() {
    var likeState = this.state.likeStore;
    if (!likeState.isLiked) {
      if (_lodash2.default.isEmpty(likeState.likedBy)) {
        return null;
      }
    }
    return _jsx("div", {
      className: "likeInformation u-defaultType"
    }, void 0, this.getLikeMessage(), " liked this");
  }
});

},{"../../react_stores/like_store":265,"../gr_component_factory":108,"lodash":"lodash","react":"react","reflux":"reflux"}],119:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _like_count = require("./like_count");

var _like_count2 = _interopRequireDefault(_like_count);

var _like_button = require("./like_button");

var _like_button2 = _interopRequireDefault(_like_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeSimpleFooter",

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired,
    resourceLabel: _react2.default.PropTypes.string.isRequired,
    isLikeable: _react2.default.PropTypes.bool.isRequired,
    showAsLink: _react2.default.PropTypes.bool
  },

  render: function render() {
    return _jsx("span", {}, void 0, _jsx(_like_count2.default, {
      resourceKey: this.props.resourceKey
    }), this.props.isLikeable ? _jsx(_like_button2.default, {
      resourceKey: this.props.resourceKey,
      resourceLabel: this.props.resourceLabel,
      showAsLink: this.props.showAsLink
    }) : null);
  }
});

},{"../gr_component_factory":108,"./like_button":116,"./like_count":117,"react":"react"}],120:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Renders a footer that contains the like count, the like/unlike action button,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            and a comment button that displays the comment form and/or list of comments
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            when clicked
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _like_simple_footer = require("./like_simple_footer");

var _like_simple_footer2 = _interopRequireDefault(_like_simple_footer);

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _comments = require("../comment/comments");

var _comments2 = _interopRequireDefault(_comments);

var _comment_form = require("../comment/comment_form");

var _comment_form2 = _interopRequireDefault(_comment_form);

var _comments_store = require("../../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _gr_reflux = require("../../react_mixins/gr_reflux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikesAndCommentsFooter",
  mixins: [(0, _gr_reflux.connectToLazyStore)(_comments_store2.default, "comment.subjectKey")],
  propTypes: {
    currentUser: _gr_prop_types2.default.user().isRequired,
    resourceKey: _react2.default.PropTypes.string.isRequired,
    resourceLabel: _react2.default.PropTypes.string.isRequired,
    isLikeable: _react2.default.PropTypes.bool.isRequired,
    showAsLink: _react2.default.PropTypes.bool,
    comment: _gr_prop_types2.default.comment().isRequired
  },
  getInitialState: function getInitialState() {
    return {
      showCommentForm: false,
      showCommentList: false
    };
  },
  getSimpleFooter: function getSimpleFooter() {
    return _jsx(_like_simple_footer2.default, {
      resourceKey: this.props.resourceKey,
      resourceLabel: this.props.resourceLabel,
      showAsLink: this.props.showAsLink,
      isLikeable: this.props.isLikeable
    });
  },
  isCommentListShown: function isCommentListShown() {
    return this.state.showCommentList;
  },
  isCommentFormShown: function isCommentFormShown() {
    return this.state.showCommentForm;
  },
  toggleCommentFormDisplayStatus: function toggleCommentFormDisplayStatus() {
    this.setState({ showCommentList: !this.isCommentListShown() });
    if (this.props.comment.canComment) {
      this.setState({ showCommentForm: !this.isCommentFormShown() });
    }
  },

  //
  // Creates array of footer elements
  //
  getFooterElements: function getFooterElements() {
    var elements = [];
    var buttonText = this.state.numComments > 1 ? "Comments" : "Comment";
    elements.push(this.getSimpleFooter());
    //
    // We want to show the comments button...
    // 1. If the resource is commentable AND there are comments associated with it
    // 2. OR the user themself can comment on the resource
    //
    var commentsToShow = this.props.comment.commentable && this.state.numComments > 0;
    if (commentsToShow || this.props.comment.canComment) {
      //
      //update button text to reflect number of comments
      //
      if (this.state.numComments > 0) {
        buttonText = this.state.numComments + " " + buttonText;
      }
      elements.push(_jsx("button", {
        className: "gr-buttonAsLink",
        onClick: this.toggleCommentFormDisplayStatus
      }, void 0, buttonText));
    }
    return elements;
  },
  render: function render() {
    return _jsx("div", {}, void 0, _jsx("div", {}, void 0, _jsx(_dot_separated_elements2.default, {
      elements: this.getFooterElements()
    })), this.state.showCommentList ? _jsx(_comments2.default, {
      subjectKey: this.props.comment.subjectKey,
      subjectUrl: this.props.comment.subjectUrl,
      subject: this.props.comment.subject,
      bemModifiers: "whiteBackgroundNormalWidth"
    }) : null, this.state.showCommentForm ? _jsx(_comment_form2.default, {
      subjectKey: this.props.comment.subjectKey,
      subject: this.props.comment.subject,
      authorUser: this.props.currentUser,
      bemModifiers: "whiteBackground"
    }) : null);
  }
});

},{"../../react_mixins/gr_reflux":250,"../../react_stores/comments_store":262,"../comment/comment_form":96,"../comment/comments":97,"../dot_separated_elements":102,"../gr_component_factory":108,"../shared/gr_prop_types":221,"./like_simple_footer":119,"react":"react"}],121:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIUM_DEVICE_BREAKPOINT = 768;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AmazonLoginButton",

  getInitialState: function getInitialState() {
    return {
      popup: false
    };
  },

  propTypes: {
    amazonSignInUrl: _react2.default.PropTypes.string.isRequired,
    enabled: _react2.default.PropTypes.bool,
    fullWidth: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enabled: false,
      fullWidth: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.setState({
      popup: window.innerWidth > MEDIUM_DEVICE_BREAKPOINT });
  },
  // or smaller
  handleButtonPress: function handleButtonPress() {
    if (this.state.popup) {
      window.open(this.props.amazonSignInUrl, "", "width=900,height=540");
    } else {
      window.location.assign(this.props.amazonSignInUrl);
    }
  },
  render: function render() {
    if (this.props.enabled) {
      return _jsx("button", {
        className: "gr-button gr-button--amazon gr-button--auth " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
        onClick: this.handleButtonPress
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter gr-mediaFlexbox--justifyHorizontalContentCenter"
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox__media gr-button--amazon__icon"
      }), _jsx("div", {
        className: "gr-mediaFlexbox__desc"
      }, void 0, "Continue with Amazon")));
    }
    return null;
  }
});

},{"../gr_component_factory":108,"react":"react"}],122:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIUM_DEVICE_BREAKPOINT = 768;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FacebookLoginButton",

  getInitialState: function getInitialState() {
    return {
      popup: false
    };
  },

  propTypes: {
    enabled: _react2.default.PropTypes.bool,
    facebookRedirectUrl: _react2.default.PropTypes.string.isRequired,
    facebookSignInUrl: _react2.default.PropTypes.string.isRequired,
    fullWidth: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enabled: false,
      fullWidth: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.setState({
      popup: window.innerWidth > MEDIUM_DEVICE_BREAKPOINT });
  },
  // or smaller
  handleButtonPress: function handleButtonPress() {
    if (this.state.popup && typeof $grfb !== "undefined") {
      $grfb.login({
        redirect: this.props.facebookRedirectUrl
      });
    } else {
      window.location.assign(this.props.facebookSignInUrl);
    }
  },
  render: function render() {
    if (this.props.enabled && typeof $grfb !== "undefined") {
      return _jsx("button", {
        className: "gr-button gr-button--facebook gr-button--auth " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
        onClick: this.handleButtonPress
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter gr-mediaFlexbox--justifyHorizontalContentCenter"
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox__media gr-button--facebook__icon"
      }), _jsx("div", {
        className: "gr-mediaFlexbox__desc"
      }, void 0, "Continue with Facebook")));
    }
    return null;
  }
});

},{"../gr_component_factory":108,"react":"react"}],123:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Renders a Modal inviting the user to sign up or sign in. Aimed at signed out
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           visitors, with server-side business logic checking whether or not it should be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           displayed, so calls an AJAX endpoint in componentDidMount.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _amazon_login_button = require("../../login/amazon_login_button");

var _amazon_login_button2 = _interopRequireDefault(_amazon_login_button);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facebook_login_button = require("../../login/facebook_login_button");

var _facebook_login_button2 = _interopRequireDefault(_facebook_login_button);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../../modal");

var _modal2 = _interopRequireDefault(_modal);

var _register_button = require("../../login/register_button");

var _register_button2 = _interopRequireDefault(_register_button);

var _service_terms_and_privacy = require("../../login/service_terms_and_privacy");

var _service_terms_and_privacy2 = _interopRequireDefault(_service_terms_and_privacy);

var _ajax_helper = require("../../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LoginInterstitial",

  propTypes: {
    allowAmazonSignIn: React.PropTypes.bool,
    allowFacebookSignIn: React.PropTypes.bool,
    overrideSignedOutPageCount: React.PropTypes.bool.isRequired,
    path: React.PropTypes.shape({
      termsUrl: React.PropTypes.string.isRequired,
      privacyUrl: React.PropTypes.string.isRequired
    }).isRequired
  },

  componentDidMount: function componentDidMount() {
    var _this = this;

    (0, _ajax_helper.httpGet)("/sign_in_prompt", {
      data: {
        countOverride: this.props.overrideSignedOutPageCount
      } }).done(function (promptValues, responseStatus) {
      if (responseStatus === "success") {
        _this.setState({
          signInUrl: promptValues.signInUrl,
          signUpUrl: promptValues.signUpUrl,
          thirdPartyRedirectUrl: promptValues.thirdPartyRedirectUrl,
          amazonSignInUrl: promptValues.amazonSignInUrl,
          deviceType: promptValues.deviceType,
          facebookSignInUrl: promptValues.facebookSignInUrl,
          isShown: promptValues.showPrompt === true && promptValues.isDelayed === false
        });
        if (promptValues.showPrompt === true && promptValues.isDelayed === true) {
          _this.timer = setTimeout(function () {
            _this.setState({ isShown: true });
          }, 20000);
        }
      } else if (responseStatus === "nocontent") {
        // HTTP 204 means "no prompt"
        _this.setState({ isShown: false });
      }
    }).fail(function () {
      // If call returns other failure, don't show.
      _this.setState({ isShown: false });
    });
  },
  getDefaultProps: function getDefaultProps() {
    return {
      allowAmazonSignIn: false,
      allowFacebookSignIn: false
    };
  },
  getInitialState: function getInitialState() {
    return { isShown: false };
  },
  isResponsive: function isResponsive() {
    // Design decision to show the responsive variant of the pop-up on mobile
    // devices. I think we want to make that the only variant, eventually.
    return this.state.deviceType === "mobile";
  },
  onCloseHandler: function onCloseHandler() {
    (0, _ajax_helper.httpPost)("/track/track_click", {
      data: { feature: "LoginInterstitial:dismiss" }
    });
    if (this.state.deviceType) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: { feature: "LoginInterstitial:" + this.state.deviceType + ":" + ":dismiss" }
      });
    }
  },
  showPopUpBook: function showPopUpBook() {
    return this.state.deviceType === "desktop";
  },
  renderAmazonLoginButton: function renderAmazonLoginButton() {
    if (this.state.amazonSignInUrl) {
      return _jsx("div", {
        className: "loginModal__button"
      }, void 0, _jsx(_amazon_login_button2.default, {
        enabled: this.props.allowAmazonSignIn,
        amazonSignInUrl: this.state.amazonSignInUrl,
        fullWidth: true
      }));
    }
  },
  renderFacebookLoginButton: function renderFacebookLoginButton() {
    if (this.state.facebookSignInUrl) {
      return _jsx("div", {
        className: "loginModal__button"
      }, void 0, _jsx(_facebook_login_button2.default, {
        enabled: this.props.allowFacebookSignIn,
        facebookRedirectUrl: this.state.thirdPartyRedirectUrl,
        facebookSignInUrl: this.state.facebookSignInUrl,
        fullWidth: true
      }));
    }
  },
  renderContent: function renderContent() {
    var containerClasses = (0, _classnames2.default)("loginModal", { "loginModal--responsive": this.isResponsive() });
    var modalContent = _jsx("div", {
      className: containerClasses
    }, void 0, this.showPopUpBook() ? "" : _jsx("div", {
      className: "loginModal__icon",
      alt: "Goodreads"
    }), _jsx("div", {
      className: "loginModal__header"
    }, void 0, _jsx("h3", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, "Discover & read more")), this.showPopUpBook() ? _jsx("div", {
      className: "loginModal__popUpBook"
    }) : "", _jsx("div", {
      className: "loginModal__body"
    }, void 0, _jsx("span", {
      className: "u-defaultType"
    }, void 0, "Sign up to get better recommendations with a free account."), _jsx("div", {
      className: "loginModal__cta"
    }, void 0, this.renderAmazonLoginButton(), _jsx("div", {
      className: "loginModal__button"
    }, void 0, _jsx(_register_button2.default, {
      fullWidth: true,
      signUpUrl: this.state.signUpUrl
    })), _jsx("span", {
      className: "u-defaultType"
    }, void 0, "Already a member?  ", _jsx("a", {
      href: this.state.signInUrl,
      rel: "nofollow"
    }, void 0, "Sign in"))), _jsx(_service_terms_and_privacy2.default, {
      termsUrl: this.props.path.termsUrl,
      privacyUrl: this.props.path.privacyUrl
    })));
    return modalContent;
  },
  render: function render() {
    if (this.state.isShown) {
      var modal = _jsx(_modal2.default, {
        id: "LoginInterstitial",
        centered: true,
        onCloseHandler: this.onCloseHandler,
        responsive: this.isResponsive(),
        showByDefault: true
      }, void 0, this.renderContent());
      return modal;
    } else {
      return null;
    }
  }
});

},{"../../../modules/ajax/ajax_helper":4,"../../gr_component_factory":108,"../../login/amazon_login_button":121,"../../login/facebook_login_button":122,"../../login/register_button":124,"../../login/service_terms_and_privacy":125,"../../modal":126,"classnames":"classnames"}],124:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RegisterButton",

  propTypes: {
    fullWidth: _react2.default.PropTypes.bool,
    signUpUrl: _react2.default.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      fullWidth: false
    };
  },
  render: function render() {
    var registerButton = _jsx("a", {
      className: "gr-button gr-button--large " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
      href: this.props.signUpUrl
    }, void 0, "Sign up with email");
    return registerButton;
  }
});

},{"../gr_component_factory":108,"react":"react"}],125:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ServiceTermsAndPrivacy",

  propTypes: {
    privacyUrl: _react2.default.PropTypes.string.isRequired,
    termsUrl: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    var serviceTermsAndPrivacy = _jsx("small", {}, void 0, "By clicking “Sign up” I agree to the Goodreads ", _jsx("a", {
      href: this.props.termsUrl,
      rel: "nofollow",
      target: "_blank"
    }, void 0, "Terms of Service"), " and confirm that I am at least 13 years old.  Read our ", _jsx("a", {
      href: this.props.privacyUrl,
      rel: "nofollow",
      target: "_blank"
    }, void 0, "Privacy Policy"));
    return serviceTermsAndPrivacy;
  }
});

},{"../gr_component_factory":108,"react":"react"}],126:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Modal dialog: halt/block other page content, display new content, and force
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             the user to interact with or dismiss that content before doing anything else.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Display options, controlled by props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Default: "Lightbox" style modal window overlaying page
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Centered (centered: true): Center modal window within screen (?). May be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          combined with Responsive variant. If
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          you're trying to center your contents within the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          modal area, use your content's markup and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          styling; Modal is not responsible for
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          styling its contents.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Drawer (asDrawer: true): Display as "drawer" sliding in from side of screen.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Does not make sense combined with Centered or
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Responsive.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Responsive (responsive: true): Same as Default, but display like drawer at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              smaller screen sizes. Mutually exclusive with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              Drawer mode.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _modal_store = require("../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _close_button = require("./close_button");

var _close_button2 = _interopRequireDefault(_close_button);

var _keys = require("../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require("lodash");

var _close_button_values = require("../modules/close_button_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Modal",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore")],

  propTypes: {
    asDrawer: _react2.default.PropTypes.bool,
    id: _react2.default.PropTypes.string.isRequired,
    centered: _react2.default.PropTypes.bool,
    showByDefault: _react2.default.PropTypes.bool,

    // This callback is run after the modal is hidden so it currently cannot
    // prevent closure. If you need such functionality, you need to
    // add another specific prop.
    onCloseHandler: _react2.default.PropTypes.func,

    // Provides a pair of Confirm/Cancel buttons that'll fire this callback
    // after user clicks Confirm. Both buttons close the Modal on click.
    onConfirmHandler: _react2.default.PropTypes.func,
    lockBodyScroll: _react2.default.PropTypes.bool,

    responsive: _react2.default.PropTypes.bool
  },

  getCloseButtonVariant: function getCloseButtonVariant() {
    if (this.props.asDrawer) {
      return _close_button_values.VARIANTS.DARK_BG;
    } else {
      return _close_button_values.VARIANTS.DEFAULT;
    }
  },
  getDefaultProps: function getDefaultProps() {
    return {
      asDrawer: false,
      centered: false,
      showByDefault: false,
      lockBodyScroll: true,
      responsive: false
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.showByDefault) {
      _modal_actions2.default.openModal(this.props.id);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.updateBodyScrollability();
  },

  // prevent body from scrolling when modal is open
  updateBodyScrollability: function updateBodyScrollability() {
    if (this.props.lockBodyScroll && this.isActive()) {
      document.body.classList.add("modalOpened");
    } else if (!this.state.modalStore.currentActiveModal) {
      document.body.classList.remove("modalOpened");
    }
  },
  hide: function hide() {
    _modal_actions2.default.closeModal();
    if (this.props.onCloseHandler && (0, _lodash.isFunction)(this.props.onCloseHandler)) {
      this.props.onCloseHandler();
    }
  },
  isActive: function isActive() {
    return this.state.modalStore.currentActiveModal === this.props.id;
  },
  hideOnOverlayClick: function hideOnOverlayClick(ev) {
    if (ev.target.className.indexOf("modal--overlay") > -1) {
      this.hide();
    }
  },
  hideOnEscape: function hideOnEscape(ev) {
    if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      this.hide();
    }
  },
  handleConfirm: function handleConfirm() {
    if (this.props.onConfirmHandler) {
      this.props.onConfirmHandler();
    }
    this.hide();
  },
  renderConfirmButtons: function renderConfirmButtons() {
    // Confirm/Cancel
    return _jsx("div", {
      className: "modal__confirmButtonsContainer"
    }, void 0, _jsx("button", {
      className: "gr-button gr-button--large gr-button--dark u-marginRightMedium",
      "data-testid": "confirm",
      onClick: this.handleConfirm,
      type: "button"
    }, void 0, "Confirm"), _jsx("button", {
      className: "gr-button gr-button--large",
      "data-testid": "cancel",
      onClick: this.hide,
      type: "button"
    }, void 0, "Cancel"));
  },
  render: function render() {
    var modalClass = (0, _classnames2.default)("modal", "modal--overlay", { "modal--show": this.isActive() && !this.props.centered,
      "modal--centered": this.isActive() && this.props.centered,
      "modal--drawer": this.props.asDrawer && !this.props.responsive,
      "modal--responsive": this.props.responsive });
    return _react2.default.createElement(
      "div",
      { className: modalClass, ref: "modalContent", tabIndex: "0",
        onClick: this.hideOnOverlayClick, onKeyDown: this.hideOnEscape },
      this.renderContents()
    );
  },
  renderContents: function renderContents() {
    if (this.props.asDrawer) {
      // In "drawer" mode, close button appears in overlay area, not content area
      return _jsx("div", {}, void 0, _jsx("div", {
        className: "modal__close"
      }, void 0, _jsx(_close_button2.default, {
        action: this.hide,
        variant: this.getCloseButtonVariant()
      })), _jsx("div", {
        className: this.withBemModifiers("modal__content")
      }, void 0, this.props.children));
    } else {
      return _jsx("div", {
        className: this.withBemModifiers("modal__content")
      }, void 0, _jsx("div", {
        className: "modal__close"
      }, void 0, _jsx(_close_button2.default, {
        action: this.hide,
        variant: this.getCloseButtonVariant()
      })), this.props.children, this.props.onConfirmHandler && this.renderConfirmButtons());
    }
  }
});

},{"../modules/close_button_values":8,"../modules/keys":14,"../react_actions/modal_actions":36,"../react_stores/modal_store":266,"./close_button":94,"./gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react","reflux":"reflux"}],127:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _modal_store = require("../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ModalTrigger",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore")],

  propTypes: {
    id: _react2.default.PropTypes.string.isRequired,
    clickHandler: _react2.default.PropTypes.func
  },

  isActive: function isActive() {
    return this.state.modalStore.currentActiveModal === this.props.id;
  },
  openModal: function openModal() {
    if (this.props.clickHandler) {
      this.props.clickHandler();
    }
    _modal_actions2.default.openModal(this.props.id);
  },
  render: function render() {
    return _jsx("a", {
      className: this.withBemModifiers("modalTrigger"),
      onClick: this.openModal,
      role: "button",
      "aria-expanded": this.isActive(),
      "aria-haspopup": true
    }, void 0, this.props.children);
  }
});

},{"../react_actions/modal_actions":36,"../react_stores/modal_store":266,"./gr_component_factory":108,"react":"react","reflux":"reflux"}],128:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorBlogPostNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.authorBlogPostNewsfeedResource()
  },

  renderBody: function renderBody() {
    return _jsx("div", {
      className: "gr-newsfeedItem__authorBlog"
    }, void 0, _jsx("a", {
      className: "gr-newsfeedItem__resourceNameLink",
      href: this.props.resource.url
    }, void 0, this.props.resource.title), React.createElement(_truncated_html2.default, _extends({}, this.props.resource.body, {
      fullContentText: "Read post" })));
  },
  render: function render() {
    return React.createElement(_social_update2.default, _extends({
      header: _jsx("span", {}, void 0, "wrote a new blog post"),
      body: this.renderBody()
    }, this.props, {
      resource: this.props.resource
    }));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/truncated_html":235,"../social_update":188}],129:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _author_follow_button = require("../../author/author_follow_button");

var _author_follow_button2 = _interopRequireDefault(_author_follow_button);

var _author_follow_count = require("../../author/author_follow_count");

var _author_follow_count2 = _interopRequireDefault(_author_follow_count);

var _author_badge = require("../../author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorFollowDetails",

  propTypes: {
    user: _gr_prop_types2.default.user(),
    author: _gr_prop_types2.default.author().isRequired,
    userAuthorFollowingsUrl: _react2.default.PropTypes.string
  },

  renderAuthorName: function renderAuthorName() {
    var author = this.props.author;
    return _jsx("div", {
      className: "gr-newsfeedItem__authorFollowTitle"
    }, void 0, _jsx("a", {
      href: author.profileUrl,
      className: "gr-newsfeedItem__resourceNameLink"
    }, void 0, author.name), _react2.default.createElement(_author_badge2.default, author));
  },
  render: function render() {
    var authorId = this.props.author.id;

    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, this.renderAuthorName(), _jsx(_author_follow_count2.default, {
      authorId: authorId,
      className: "gr-newsfeedItem__ratingDetailsText u-defaultType"
    }), _jsx(_author_follow_button2.default, {
      authorId: authorId,
      className: "u-marginTopMedium"
    }));
  }
});

},{"../../author/author_badge":70,"../../author/author_follow_button":71,"../../author/author_follow_count":72,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"react":"react"}],130:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _author_follow_details = require("./author_follow_details");

var _author_follow_details2 = _interopRequireDefault(_author_follow_details);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorFollowNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.authorFollowNewsfeedResource()
  },

  // Return a subset of the author props for SocialUpdateBody
  // This mirrors the structure of user in gr_prop_types
  getSocialUpdateBodyUser: function getSocialUpdateBodyUser() {
    return {
      viewableName: this.props.resource.author.name,
      profileImage: this.props.resource.author.profileImage,
      profileUrl: this.props.resource.author.profileUrl
    };
  },

  // A link to a list of all authors the newsfeed story's user is following
  renderUserAuthorFollowingsLink: function renderUserAuthorFollowingsLink() {
    return _jsx("a", {
      href: this.props.resource.userAuthorFollowingsUrl
    }, void 0, "See all authors ", this.props.resource.user.viewableName, " is following");
  },
  renderBody: function renderBody() {
    var icon = _jsx(_user_icon2.default, {
      user: this.getSocialUpdateBodyUser(),
      size: _shape_icon_values.ICON_SIZES.LARGE
    });
    return _jsx(_social_update_body2.default, {
      customIcon: icon
    }, void 0, React.createElement(_author_follow_details2.default, this.props.resource));
  },
  render: function render() {
    return React.createElement(_social_update2.default, _extends({
      header: _jsx("span", {}, void 0, "is now following:"),
      body: this.renderBody(),
      additionalFooterLinks: [this.renderUserAuthorFollowingsLink()]
    }, this.props));
  }
});

},{"../../../modules/shape_icon_values":19,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_icon":230,"../social_update":188,"../social_update_body":189,"./author_follow_details":129}],131:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _nonsocial_update = require("../nonsocial_update");

var _nonsocial_update2 = _interopRequireDefault(_nonsocial_update);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorQaSettingNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.authorQaSettingNewsfeedResource()
  },

  renderHeader: function renderHeader() {
    var author = this.props.resource.author;
    return _jsx("span", {}, void 0, _jsx("a", {
      href: author.profileUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, author.name), " started an Ask the Author Session");
  },
  renderBody: function renderBody() {
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "gr-newsfeedItem__qaMessage"
    }, void 0, this.props.resource.message ? "“" + this.props.resource.message + "”" : "Join the conversation!"), _jsx("a", {
      href: this.props.resource.url,
      className: "gr-button u-marginBottomMedium u-marginTopSmall"
    }, void 0, "Ask a Question"));
  },
  render: function render() {
    return _jsx(_nonsocial_update2.default, {
      header: this.renderHeader(),
      body: this.renderBody(),
      updateIconUrl: this.props.resource.author.profileImage
    });
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../nonsocial_update":165}],132:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _nonsocial_update = require("../nonsocial_update");

var _nonsocial_update2 = _interopRequireDefault(_nonsocial_update);

var _book_with_wtr_button = require("../../book_with_wtr_button");

var _book_with_wtr_button2 = _interopRequireDefault(_book_with_wtr_button);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TrendingGenreNewsfeedItem",

  propTypes: {
    updateTitle: _react2.default.PropTypes.string.isRequired,
    updateIconUrl: _react2.default.PropTypes.string.isRequired,
    updateSubjects: _react2.default.PropTypes.shape({
      book: _gr_prop_types2.default.book().isRequired,
      genre: _react2.default.PropTypes.shape({
        name: _react2.default.PropTypes.string.isRequired,
        genreUrl: _react2.default.PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  },

  renderHeader: function renderHeader() {
    var updateSubjects = this.props.updateSubjects;
    return _jsx("span", {}, void 0, _jsx("span", {}, void 0, this.props.updateTitle, ", "), _jsx("a", {
      href: updateSubjects.genre.genreUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, updateSubjects.genre.name));
  },
  renderBodyDetails: function renderBodyDetails() {
    return _jsx("div", {}, void 0, _jsx(_book_description2.default, {
      className: "u-marginTopXSmall",
      bookDescription: this.props.updateSubjects.book.description
    }));
  },
  renderBody: function renderBody() {
    return _jsx(_book_with_wtr_button2.default, {
      book: this.props.updateSubjects.book,
      body: this.renderBodyDetails()
    });
  },
  renderFooter: function renderFooter() {
    return _jsx("div", {
      className: "gr-newsfeedItem__footerActions"
    }, void 0, _jsx(_preview_book2.default, {
      book: this.props.updateSubjects.book
    }));
  },
  render: function render() {
    return _react2.default.createElement(_nonsocial_update2.default, _extends({
      header: this.renderHeader(),
      body: this.renderBody(),
      footer: this.renderFooter()
    }, this.props));
  }
});

},{"../../book_description":75,"../../book_with_wtr_button":76,"../../gr_component_factory":108,"../../preview_book/preview_book":200,"../../shared/gr_prop_types":221,"../nonsocial_update":165,"react":"react"}],133:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reading_challenge_newsfeed_item = require("./reading_challenge_newsfeed_item");

var _reading_challenge_newsfeed_item2 = _interopRequireDefault(_reading_challenge_newsfeed_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHALLENGE_TYPES = {
  READING_CHALLENGE: "y"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ChallengeNewsfeedItem",
  propTypes: {
    resource: _react2.default.PropTypes.shape({
      challenge: _react2.default.PropTypes.shape({
        type: _react2.default.PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    urcDeprecateViewChallengeLink: _react2.default.PropTypes.bool
  },

  render: function render() {
    if (this.props.resource.challenge.type === CHALLENGE_TYPES.READING_CHALLENGE) {
      return _react2.default.createElement(_reading_challenge_newsfeed_item2.default, this.props);
    } else {
      return null;
    }
  }
});

},{"../../gr_component_factory":108,"./reading_challenge_newsfeed_item":136,"react":"react"}],134:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _book_cover_row = require("../shared/book_cover_row");

var _book_cover_row2 = _interopRequireDefault(_book_cover_row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingChallengeCompleteDetails",
  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    goalNum: _react2.default.PropTypes.number.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    numRead: _react2.default.PropTypes.number.isRequired,
    challenge: _react2.default.PropTypes.shape({
      title: _react2.default.PropTypes.string.isRequired
    }),
    books: _react2.default.PropTypes.arrayOf(_gr_prop_types2.default.book()).isRequired,
    urcDeprecateViewChallengeLink: _react2.default.PropTypes.bool
  },

  renderBookNumText: function renderBookNumText() {
    return this.props.goalNum + " " + (this.props.goalNum === 1 ? "book" : "books");
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, "Congratulate ", this.props.user.viewableName, "!", _jsx("div", {
      className: "readingChallengeNewsfeedItem__challengeDescription"
    }, void 0, this.props.user.viewableName, " has completed the goal of reading ", "", this.renderBookNumText(), " for the ", this.props.challenge.title, "!", _jsx(_book_cover_row2.default, {
      numBooksRead: this.props.numRead,
      url: this.props.url,
      books: this.props.books
    }), !this.props.urcDeprecateViewChallengeLink && _jsx("a", {
      href: this.props.url,
      id: "viewChallengeLink",
      className: "u-displayBlock"
    }, void 0, "View Challenge")));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../shared/book_cover_row":183,"react":"react"}],135:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _progress_bar = require("../../progress_bar");

var _progress_bar2 = _interopRequireDefault(_progress_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROGRESS_BAR_WIDTH = 200;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingChallengeJoinDetails",
  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    goalNum: _react2.default.PropTypes.number.isRequired,
    numRead: _react2.default.PropTypes.number.isRequired,
    challenge: _react2.default.PropTypes.shape({
      title: _react2.default.PropTypes.string.isRequired
    })
  },

  renderBookNumText: function renderBookNumText() {
    return this.props.goalNum + " " + (this.props.goalNum === 1 ? "book" : "books");
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, "Cheer ", this.props.user.viewableName, "!", _jsx("div", {
      className: "readingChallengeNewsfeedItem__challengeDescription"
    }, void 0, this.props.user.viewableName, " has set a goal of reading ", "", this.renderBookNumText(), " for the ", this.props.challenge.title, "!"), _jsx(_progress_bar2.default, {
      value: this.props.numRead,
      max: this.props.goalNum,
      width: PROGRESS_BAR_WIDTH,
      progressText: Math.floor(this.props.numRead / this.props.goalNum * 100) + "%"
    }), _jsx("small", {}, void 0, this.props.numRead, " of ", this.props.goalNum, " books read"));
  }
});

},{"../../gr_component_factory":108,"../../progress_bar":204,"../../shared/gr_prop_types":221,"react":"react"}],136:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _reading_challenge_badge = require("../../reading_challenge/reading_challenge_badge");

var _reading_challenge_badge2 = _interopRequireDefault(_reading_challenge_badge);

var _reading_challenge_join_details = require("./reading_challenge_join_details");

var _reading_challenge_join_details2 = _interopRequireDefault(_reading_challenge_join_details);

var _reading_challenge_complete_details = require("./reading_challenge_complete_details");

var _reading_challenge_complete_details2 = _interopRequireDefault(_reading_challenge_complete_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingChallengeNewsfeedItem",
  propTypes: {
    resource: _react2.default.PropTypes.shape({
      user: _gr_prop_types2.default.user().isRequired,
      url: _react2.default.PropTypes.string.isRequired,
      goalNum: _react2.default.PropTypes.number.isRequired,
      numRead: _react2.default.PropTypes.number.isRequired,
      challenge: _gr_prop_types2.default.readingChallenge(),
      books: _react2.default.PropTypes.arrayOf(_gr_prop_types2.default.book())
    }),
    urcDeprecateViewChallengeLink: _react2.default.PropTypes.bool
  },

  getSocialUpdateBody: function getSocialUpdateBody() {
    var challengeIcon = _jsx(_reading_challenge_badge2.default, {
      challenge: this.props.resource.challenge
    });

    return _jsx(_social_update_body2.default, {
      customIcon: challengeIcon
    }, void 0, this.props.resource.challenge.isFinished ? _react2.default.createElement(_reading_challenge_complete_details2.default, _extends({ ref: "challengeCompleteDetails" }, this.props.resource, {
      urcDeprecateViewChallengeLink: this.props.urcDeprecateViewChallengeLink })) : _react2.default.createElement(_reading_challenge_join_details2.default, _extends({ ref: "challengeJoinDetails" }, this.props.resource)));
  },
  renderHeaderText: function renderHeaderText() {
    var challenge = this.props.resource.challenge;
    var text = this.props.resource.challenge.isFinished ? "has completed the " : "has joined the ";
    return _jsx("span", {}, void 0, text, _jsx("a", {
      className: "gr-hyperlink--bold",
      href: challenge.url
    }, void 0, challenge.title));
  },
  render: function render() {
    return _react2.default.createElement(_social_update2.default, _extends({
      header: this.renderHeaderText(),
      body: this.getSocialUpdateBody()
    }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../reading_challenge/reading_challenge_badge":209,"../../shared/gr_prop_types":221,"../social_update":188,"../social_update_body":189,"./reading_challenge_complete_details":134,"./reading_challenge_join_details":135,"react":"react"}],137:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _newsfeed_helper = require("./newsfeed_helper");

var newsfeedHelper = _interopRequireWildcard(_newsfeed_helper);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childNewsfeedItemProps = {
  isChildNewsfeedItem: true
};
exports.default = _gr_component_factory2.default.createClass({
  displayName: "ChildNewsfeedItem",

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    update: _react2.default.PropTypes.object.isRequired,
    headerText: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    if (newsfeedHelper.isNewsfeedTypeSupported(this.props.update.resourceType)) {
      return _jsx("article", {
        className: "gr-childNewsfeedItem u-defaultType"
      }, void 0, _jsx("header", {
        className: "gr-childNewsfeedItem__header"
      }, void 0, _jsx("span", {
        className: "gr-childNewsfeedItem__headerTitle"
      }, void 0, _jsx(_user_profile_link2.default, {
        user: this.props.user
      }), " ", this.props.headerText)), newsfeedHelper.renderNewsfeedItem(this.props.update, _extends({}, childNewsfeedItemProps, { readOnlyStars: this.props.readOnlyStars })));
    } else {
      return null;
    }
  }
});

},{"../gr_component_factory":108,"../shared/gr_prop_types":221,"../user/user_profile_link":231,"./newsfeed_helper":163,"react":"react"}],138:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _child_newsfeed_item = require("../child_newsfeed_item");

var _child_newsfeed_item2 = _interopRequireDefault(_child_newsfeed_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommentNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.object.isRequired,
    update: _react2.default.PropTypes.object.isRequired
  },

  headerText: function headerText() {
    var resourceTypeDisplayName = this.props.update.resource.typeDisplayName;
    if (!resourceTypeDisplayName) {
      resourceTypeDisplayName = "update";
    }

    return "commented on an " + resourceTypeDisplayName;
  },
  render: function render() {
    return _jsx(_child_newsfeed_item2.default, {
      update: this.props.update,
      user: this.props.resource.user,
      headerText: this.headerText()
    });
  }
});

},{"../../gr_component_factory":108,"../child_newsfeed_item":137,"react":"react"}],139:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _community_answer_details = require("../community_answer_details");

var _community_answer_details2 = _interopRequireDefault(_community_answer_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorAnswerNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape(_gr_prop_types2.default.communityAnswer())
  },

  renderAuthorQALink: function renderAuthorQALink() {
    return _jsx("a", {
      href: this.props.resource.communityQuestion.authorQuestionsUrl
    }, void 0, "View all Author Q&A");
  },
  render: function render() {
    var body = _react2.default.createElement(_community_answer_details2.default, this.props.resource);

    return _react2.default.createElement(_social_update2.default, _extends({}, this.props, {
      header: _jsx("span", {}, void 0, "answered a question"),
      body: body,
      additionalFooterLinks: [this.renderAuthorQALink()]
    }));
  }
});

},{"../../../gr_component_factory":108,"../../../shared/gr_prop_types":221,"../../social_update":188,"../community_answer_details":140,"react":"react"}],140:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _spoiler = require("../../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityAnswerDetails",

  propTypes: _gr_prop_types2.default.communityAnswer(),

  renderAnswerSpoilerWarning: function renderAnswerSpoilerWarning() {
    return _jsx("span", {
      className: "communityQANewsfeedItem__spoilerWarning"
    }, void 0, "This answer contains spoilers…");
  },
  renderQuestionSpoilerWarning: function renderQuestionSpoilerWarning() {
    return _jsx("span", {
      className: "communityQANewsfeedItem__spoilerWarning"
    }, void 0, "This question contains spoilers…");
  },
  renderAnswerText: function renderAnswerText() {
    var answerText = React.createElement(_truncated_html2.default, this.props.answerText);
    return _jsx("div", {
      className: "communityQANewsfeedItem__answerText"
    }, void 0, this.props.isSpoiler ? _jsx(_spoiler2.default, {
      spoilerWarning: this.renderAnswerSpoilerWarning()
    }, void 0, answerText) : answerText);
  },
  renderQuestionText: function renderQuestionText() {
    var communityQuestion = this.props.communityQuestion;
    return _jsx("div", {
      className: "communityQANewsfeedItem__questionText"
    }, void 0, communityQuestion.isSpoiler ? _jsx(_spoiler2.default, {
      html: communityQuestion.questionText,
      spoilerWarning: this.renderQuestionSpoilerWarning()
    }) : communityQuestion.questionText);
  },
  renderQuestion: function renderQuestion() {
    return _jsx("div", {
      className: "communityQANewsfeedItem__question"
    }, void 0, _jsx(_user_profile_link2.default, {
      user: this.props.communityQuestion.user
    }), " asked:", this.renderQuestionText());
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderAnswerText(), this.renderQuestion());
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_profile_link":231,"../../user_content/spoiler":234,"../../user_content/truncated_html":235}],141:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _author_answer_newsfeed_item = require("./author_answer/author_answer_newsfeed_item");

var _author_answer_newsfeed_item2 = _interopRequireDefault(_author_answer_newsfeed_item);

var _reader_answer_newsfeed_item = require("./reader_answer/reader_answer_newsfeed_item");

var _reader_answer_newsfeed_item2 = _interopRequireDefault(_reader_answer_newsfeed_item);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  CommunityQuestions are used for both the Reader Q&A and Ask the Author products.
  The object's `category` attribute denotes whether it is a reader or author
  question. These constant values are originally defined in community_question.rb,
  see file for further explanation.
*/
var CommunityQuestionCategories = {
  AUTHOR_CATEGORY: 1,
  READER_CATEGORY: 2
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityAnswerNewsfeedItem",

  statics: {
    CommunityQuestionCategories: CommunityQuestionCategories
  },

  propTypes: {
    resource: _react2.default.PropTypes.shape(_gr_prop_types2.default.communityAnswer())
  },

  render: function render() {
    switch (this.props.resource.communityQuestion.category) {
      case CommunityQuestionCategories.AUTHOR_CATEGORY:
        return _react2.default.createElement(_author_answer_newsfeed_item2.default, this.props);
      case CommunityQuestionCategories.READER_CATEGORY:
        return _react2.default.createElement(_reader_answer_newsfeed_item2.default, this.props);
      default:
        throw new Error("Unexpected category passed to CommunityAnswer. " + ("Received " + this.props.resource.communityQuestion.category + ". ") + ("Expected one of " + _lodash2.default.values(CommunityQuestionCategories)));
    }
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"./author_answer/author_answer_newsfeed_item":139,"./reader_answer/reader_answer_newsfeed_item":142,"lodash":"lodash","react":"react"}],142:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _community_answer_details = require("../community_answer_details");

var _community_answer_details2 = _interopRequireDefault(_community_answer_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReaderAnswerNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape(_gr_prop_types2.default.communityAnswer())
  },

  renderHeader: function renderHeader() {
    var book = this.props.resource.communityQuestion.book;
    return _jsx("span", {}, void 0, "answered a question about ", _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: book.bookUrl
    }, void 0, book.title));
  },
  render: function render() {
    var body = _react2.default.createElement(_community_answer_details2.default, this.props.resource);

    return _react2.default.createElement(_social_update2.default, _extends({}, this.props, {
      header: this.renderHeader(),
      body: body
    }));
  }
});

},{"../../../gr_component_factory":108,"../../../shared/gr_prop_types":221,"../../social_update":188,"../community_answer_details":140,"react":"react"}],143:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reader_question_newsfeed_item = require("./reader_question/reader_question_newsfeed_item");

var _reader_question_newsfeed_item2 = _interopRequireDefault(_reader_question_newsfeed_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * As of now, we only show updates for asking Reader questions. If in the future
 * we want to show updates for asking Author questions too, this component can
 * be expanded to accommodate the other type of question.
 *
 * See community_answer_newsfeed_item.js.jsx for question category considerations
 *
 */
exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityQuestionNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape(_gr_prop_types2.default.communityQuestion())
  },

  render: function render() {
    return _react2.default.createElement(_reader_question_newsfeed_item2.default, this.props);
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"./reader_question/reader_question_newsfeed_item":145,"react":"react"}],144:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _spoiler = require("../../../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReaderQuestionDetails",

  propTypes: _gr_prop_types2.default.communityQuestion(),

  renderQuestionSpoilerWarning: function renderQuestionSpoilerWarning() {
    return _jsx("span", {
      className: "communityQANewsfeedItem__spoilerWarning"
    }, void 0, "This question contains spoilers…");
  },
  renderQuestionText: function renderQuestionText() {
    if (this.props.isSpoiler) {
      return _jsx(_spoiler2.default, {
        spoilerWarning: this.renderQuestionSpoilerWarning()
      }, void 0, this.props.questionText);
    } else {
      return this.props.questionText;
    }
  },
  renderAnswerButton: function renderAnswerButton() {
    return _jsx("a", {
      className: "gr-button u-marginTopMedium u-marginBottomMedium",
      href: this.props.questionUrl
    }, void 0, "Answer this question");
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, _jsx("div", {
      className: "u-defaultType"
    }, void 0, this.renderQuestionText()), this.renderAnswerButton());
  }
});

},{"../../../gr_component_factory":108,"../../../shared/gr_prop_types":221,"../../../user_content/spoiler":234}],145:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _reader_question_details = require("./reader_question_details");

var _reader_question_details2 = _interopRequireDefault(_reader_question_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReaderQuestionNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape(_gr_prop_types2.default.communityQuestion())
  },

  renderHeader: function renderHeader() {
    var book = this.props.resource.book;
    return _jsx("span", {}, void 0, "asked a question about ", _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: book.bookUrl
    }, void 0, book.title));
  },
  render: function render() {
    var body = _react2.default.createElement(_reader_question_details2.default, this.props.resource);
    return _react2.default.createElement(_social_update2.default, _extends({
      header: this.renderHeader(),
      body: body
    }, this.props));
  }
});

},{"../../../gr_component_factory":108,"../../../shared/gr_prop_types":221,"../../social_update":188,"./reader_question_details":144,"react":"react"}],146:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _blog_newsfeed_item_body = require("./blog_newsfeed_item_body");

var _blog_newsfeed_item_body2 = _interopRequireDefault(_blog_newsfeed_item_body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BlogNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.blogNewsfeedResource()
  },

  renderCard: function renderCard() {
    return _jsx("div", {}, void 0, _jsx(_blog_newsfeed_item_body2.default, {
      resource: this.props.resource
    }));
  },
  render: function render() {
    return React.createElement(_social_update2.default, _extends({
      body: this.renderCard()
    }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../social_update":188,"./blog_newsfeed_item_body":147}],147:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BlogNewsfeedItemBody",

  propTypes: {
    resource: _gr_prop_types2.default.blogNewsfeedResource()
  },

  renderImage: function renderImage() {
    if (this.props.resource.imageUrl) {
      return _jsx("a", {
        href: this.props.resource.resourceUrl
      }, void 0, _jsx("img", {
        className: "editorialCard__image",
        src: this.props.resource.imageUrl,
        alt: this.props.resource.title
      }));
    } else {
      return null;
    }
  },
  body: function body() {
    return { __html: this.props.resource.body.html };
  },
  render: function render() {
    return _jsx("div", {
      className: "editorialCard"
    }, void 0, this.renderImage(), _jsx("div", {
      className: "editorialCard__title"
    }, void 0, _jsx("a", {
      href: this.props.resource.resourceUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, this.props.resource.title)), _jsx("div", {
      className: "editorialCard__body",
      dangerouslySetInnerHTML: this.body()
    }));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221}],148:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _ajax_helper = require("../../../modules/ajax/ajax_helper");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _nonsocial_update = require("../nonsocial_update");

var _nonsocial_update2 = _interopRequireDefault(_nonsocial_update);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _newsfeed_item_header_timestamp = require("../newsfeed_item_header_timestamp");

var _newsfeed_item_header_timestamp2 = _interopRequireDefault(_newsfeed_item_header_timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CustomNewsfeedItem",

  propTypes: {
    resource: _react.PropTypes.shape({
      updateIconUrl: _react.PropTypes.string.isRequired,
      headline: _react.PropTypes.string.isRequired,
      headlineUrl: _react.PropTypes.string,
      title: _react.PropTypes.string,
      titleUrl: _react.PropTypes.string,
      description: _react.PropTypes.shape(_gr_prop_types2.default.expandableHtml()),
      imageUrl: _react.PropTypes.string,
      cta: _react.PropTypes.string,
      ctaUrl: _react.PropTypes.string
    }).isRequired
  },

  renderLinkOrText: function renderLinkOrText(key) {
    var _this = this;

    var section = this.props.resource[key];
    var url = this.props.resource[key + "Url"];
    return url ? _jsx("a", {
      href: url,
      onClick: function onClick() {
        return _this.handleClick(key);
      },
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, section) : _jsx("span", {}, void 0, section);
  },
  renderHeader: function renderHeader() {
    return _jsx("div", {}, void 0, this.renderLinkOrText("headline"), _jsx(_newsfeed_item_header_timestamp2.default, {
      time: this.props.updatedAt
    }));
  },
  handleClick: function handleClick(key) {
    (0, _ajax_helper.httpPost)("/track/track_click", {
      data: { feature: "CustomNewsfeedDesktop_" + key }
    });
    return true;
  },
  renderBody: function renderBody() {
    var _this2 = this;

    var resource = this.props.resource;
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "customNewsfeedCard"
    }, void 0, resource.title && _jsx("div", {
      className: "customNewsfeedCard__title"
    }, void 0, this.renderLinkOrText("title")), resource.imageUrl && _jsx("div", {}, void 0, _jsx("img", {
      className: "customNewsfeedCard__image",
      src: resource.imageUrl,
      alt: resource.headline
    })), resource.description && _jsx("div", {}, void 0, React.createElement(_expandable_html2.default, this.props.resource.description))), resource.cta && _jsx("div", {
      className: "customNewsfeedCtaLink"
    }, void 0, _jsx("a", {
      onClick: function onClick() {
        return _this2.handleClick("cta");
      },
      href: resource.ctaUrl
    }, void 0, resource.cta)));
  },
  render: function render() {
    return _jsx("div", {}, void 0, _jsx(_nonsocial_update2.default, {
      updateIconUrl: this.props.resource.updateIconUrl,
      header: this.renderHeader(),
      body: this.renderBody()
    }));
  }
});

},{"../../../modules/ajax/ajax_helper":4,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"../newsfeed_item_header_timestamp":164,"../nonsocial_update":165,"react":"react"}],149:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _interview_newsfeed_item_body = require("./interview_newsfeed_item_body");

var _interview_newsfeed_item_body2 = _interopRequireDefault(_interview_newsfeed_item_body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "InterviewNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.interviewNewsfeedResource()
  },

  renderCard: function renderCard() {
    return _jsx("div", {}, void 0, _jsx(_interview_newsfeed_item_body2.default, {
      resource: this.props.resource
    }));
  },
  render: function render() {
    return React.createElement(_social_update2.default, _extends({
      body: this.renderCard()
    }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../social_update":188,"./interview_newsfeed_item_body":150}],150:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "InterviewNewsfeedItemBody",

  propTypes: {
    resource: _gr_prop_types2.default.interviewNewsfeedResource()
  },

  renderImage: function renderImage(resource) {
    if (resource.imageUrl) {
      return _jsx("img", {
        src: resource.imageUrl,
        alt: resource.title
      });
    } else if (resource.authorImageUrl && resource.bookImageUrl) {
      return _jsx("div", {}, void 0, _jsx("a", {
        href: resource.resourceUrl
      }, void 0, _jsx("div", {
        className: "editorialCard__image--interview\n                            editorialCard__image--interviewAuthor",
        style: { backgroundImage: "url(" + resource.authorImageUrl + ")" }
      }, void 0, _jsx("span", {
        className: "u-visuallyHidden"
      }, void 0, resource.author)), _jsx("div", {
        className: "editorialCard__image--interview\n                            editorialCard__image--interviewBook",
        style: { backgroundImage: "url(" + resource.bookImageUrl + ")" }
      }, void 0, _jsx("span", {
        className: "u-visuallyHidden"
      }, void 0, resource.bookTitle))));
    } else {
      return null;
    }
  },
  bodyHtml: function bodyHtml() {
    return { __html: this.props.resource.body.html };
  },
  render: function render() {
    var resource = this.props.resource;

    return _jsx("div", {
      className: "editorialCard"
    }, void 0, this.renderImage(resource), _jsx("div", {
      className: "editorialCard__title"
    }, void 0, _jsx("a", {
      href: resource.resourceUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, resource.title)), _jsx("div", {
      className: "editorialCard__body",
      dangerouslySetInnerHTML: this.bodyHtml()
    }));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221}],151:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _like_button = require("../../like/like_button");

var _like_button2 = _interopRequireDefault(_like_button);

var _comments = require("../../comment/comments");

var _comments2 = _interopRequireDefault(_comments);

var _comment_form = require("../../comment/comment_form");

var _comment_form2 = _interopRequireDefault(_comment_form);

var _like_information = require("../../like/like_information");

var _like_information2 = _interopRequireDefault(_like_information);

var _newsfeed_item_footer_actions = require("./newsfeed_item_footer_actions");

var _newsfeed_item_footer_actions2 = _interopRequireDefault(_newsfeed_item_footer_actions);

var _newsfeed_item_footer_comment_button = require("./newsfeed_item_footer_comment_button");

var _newsfeed_item_footer_comment_button2 = _interopRequireDefault(_newsfeed_item_footer_comment_button);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NewsfeedItemFooter",

  propTypes: {
    user: _gr_prop_types2.default.user(),
    like: React.PropTypes.shape({
      key: React.PropTypes.string.isRequired,
      label: React.PropTypes.string.isRequired,
      canRate: React.PropTypes.bool.isRequired,
      rateable: React.PropTypes.bool.isRequired
    }).isRequired,
    comment: React.PropTypes.shape({
      canComment: React.PropTypes.bool.isRequired,
      commentable: React.PropTypes.bool.isRequired,
      subjectKey: React.PropTypes.string.isRequired,
      subject: _gr_prop_types2.default.commentSubject(),
      subjectUrl: React.PropTypes.string,
      placeholder: React.PropTypes.string
    }).isRequired,
    book: _gr_prop_types2.default.book(),
    additionalFooterLinks: React.PropTypes.arrayOf(React.PropTypes.element)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      like: {
        canRate: false,
        rateable: false
      },
      comment: {
        canComment: false,
        commentable: false
      }
    };
  },
  getCommentFormData: function getCommentFormData() {
    var data = {
      subject: this.props.comment.subject,
      subjectKey: this.props.comment.subjectKey,
      authorUser: this.props.user
    };
    if (this.props.comment.placeholder) {
      data.placeholder = this.props.comment.placeholder;
    }

    return data;
  },
  getDefaultFooterLinks: function getDefaultFooterLinks() {
    var footerLinks = [];

    if (this.props.like.rateable && this.props.like.canRate) {
      footerLinks.push(_jsx(_like_button2.default, {
        resourceKey: this.props.like.key,
        resourceLabel: this.props.like.label
      }));
    }

    if (this.props.comment.commentable && this.props.comment.canComment) {
      footerLinks.push(_jsx(_newsfeed_item_footer_comment_button2.default, {
        subjectKey: this.props.comment.subjectKey
      }));
    }

    return footerLinks;
  },
  getFooterLinks: function getFooterLinks() {
    var defaultFooterLinks = this.getDefaultFooterLinks();
    if (!(0, _lodash.isUndefined)(this.props.additionalFooterLinks)) {
      return defaultFooterLinks.concat(this.props.additionalFooterLinks);
    } else {
      return defaultFooterLinks;
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem__footer"
    }, void 0, _jsx(_newsfeed_item_footer_actions2.default, {
      elements: this.getFooterLinks()
    }), _jsx(_like_information2.default, {
      resourceKey: this.props.like.key
    }), this.props.comment.commentable ? _jsx(_comments2.default, {
      subjectKey: this.props.comment.subjectKey,
      subjectUrl: this.props.comment.subjectUrl,
      subject: this.props.comment.subject
    }) : null, this.props.comment.canComment ? React.createElement(_comment_form2.default, this.getCommentFormData()) : null);
  }
});

},{"../../comment/comment_form":96,"../../comment/comments":97,"../../gr_component_factory":108,"../../like/like_button":116,"../../like/like_information":118,"../../shared/gr_prop_types":221,"./newsfeed_item_footer_actions":152,"./newsfeed_item_footer_comment_button":153,"lodash":"lodash"}],152:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _dot_separated_elements = require("../../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _user_agent_capabilities_store = require("../../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _lodash = require("lodash");

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NewsfeedItemFooterActions",

  mixins: [_reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    elements: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element)
  },

  filteredElements: function filteredElements() {
    var _this = this;

    return (0, _lodash.select)(this.props.elements, function (element) {
      if (element.type === _preview_book2.default) {
        return (0, _preview_book.shouldDisplayPreviewBookButton)(element.props.book, _this.state.userAgentCapabilities);
      }
      return true;
    });
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem__footerActions"
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: this.filteredElements()
    }));
  }
});

},{"../../../react_stores/user_agent_capabilities_store":273,"../../dot_separated_elements":102,"../../gr_component_factory":108,"../../preview_book/preview_book":200,"lodash":"lodash","react":"react","reflux":"reflux"}],153:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _comment_actions = require("../../../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NewsfeedItemFooterCommentButton",

  propTypes: {
    subjectKey: _react.PropTypes.string.isRequired
  },

  onClick: function onClick() {
    _comment_actions2.default.textareaFocusRequested(this.props.subjectKey);
  },
  render: function render() {
    return _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.onClick
    }, void 0, "Comment");
  }
});

},{"../../../react_actions/comment_actions":31,"../../gr_component_factory":108,"react":"react"}],154:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _user_rating_and_currently_reading = require("../shared/user_rating_and_currently_reading");

var _user_rating_and_currently_reading2 = _interopRequireDefault(_user_rating_and_currently_reading);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FriendDetails",

  propTypes: {
    friendUser: _gr_prop_types2.default.user().isRequired,
    isMyFriend: _react2.default.PropTypes.bool.isRequired,
    ratingDetailsText: _react2.default.PropTypes.string,
    addFriendUrl: _react2.default.PropTypes.string,
    compareBooksUrl: _react2.default.PropTypes.string,
    currentlyReadingBook: _gr_prop_types2.default.book()
  },

  renderAddFriendButtonOrPendingText: function renderAddFriendButtonOrPendingText() {
    if (this.props.isMyFriend) {
      return _jsx("div", {}, void 0, _jsx("a", {
        href: this.props.compareBooksUrl,
        className: "gr-button u-marginTopMedium"
      }, void 0, "Compare books"));
    } else {
      return _jsx("div", {}, void 0, _jsx("a", {
        href: this.props.addFriendUrl,
        className: "gr-button u-marginTopMedium"
      }, void 0, "Add friend"));
    }
  },
  render: function render() {
    var user = this.props.friendUser;
    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, _jsx("a", {
      href: user.profileUrl,
      className: "gr-newsfeedItem__resourceNameLink"
    }, void 0, user.viewableName), _jsx(_user_rating_and_currently_reading2.default, {
      ratingDetailsText: this.props.ratingDetailsText,
      currentlyReadingBook: this.props.currentlyReadingBook
    }), this.renderAddFriendButtonOrPendingText());
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../shared/user_rating_and_currently_reading":184,"react":"react"}],155:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _friend_details = require("./friend_details");

var _friend_details2 = _interopRequireDefault(_friend_details);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FriendNewsfeedUpdate",

  propTypes: {
    resource: _gr_prop_types2.default.friendNewsfeedResource()
  },

  render: function render() {
    var icon = _jsx(_user_icon2.default, {
      user: this.props.resource.friendUser,
      size: _shape_icon_values.ICON_SIZES.LARGE
    });
    var body = _jsx(_social_update_body2.default, {
      customIcon: icon
    }, void 0, React.createElement(_friend_details2.default, this.props.resource));

    return React.createElement(_social_update2.default, _extends({
      header: _jsx("span", {}, void 0, "is now friends with:"),
      body: body
    }, this.props));
  }
});

},{"../../../modules/shape_icon_values":19,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_icon":230,"../social_update":188,"../social_update_body":189,"./friend_details":154}],156:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GeneralStatusNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      user: _gr_prop_types2.default.user().isRequired,
      userStatusText: _react2.default.PropTypes.string.isRequired
    }).isRequired
  },

  getUserStatusText: function getUserStatusText() {
    return {
      __html: this.props.resource.userStatusText
    };
  },
  render: function render() {
    var body = _jsx("div", {
      className: "gr-newsfeedItem__generalStatusText",
      dangerouslySetInnerHTML: this.getUserStatusText()
    });
    return _react2.default.createElement(_social_update2.default, _extends({ body: body }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../social_update":188,"react":"react"}],157:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_book_update = require("../social_book_update");

var _social_book_update2 = _interopRequireDefault(_social_book_update);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GiveawayNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      book: _gr_prop_types2.default.book().isRequired,
      endDate: _gr_prop_types2.default.date.isRequired,
      url: _react2.default.PropTypes.string.isRequired,
      user: _gr_prop_types2.default.user().isRequired
    }).isRequired
  },

  renderGiveawayEndDate: function renderGiveawayEndDate() {
    var endDate = (0, _moment2.default)(this.props.resource.endDate).format("MMMM D, YYYY");
    return _jsx("time", {
      dateTime: this.props.time,
      "aria-label": endDate
    }, void 0, endDate);
  },
  renderBookBody: function renderBookBody() {
    return _jsx("div", {
      className: "u-marginTopSmall"
    }, void 0, _jsx("a", {
      href: this.props.resource.url,
      className: "gr-button"
    }, void 0, "View Giveaway"), _jsx("small", {
      className: "u-displayBlock u-marginTopSmall"
    }, void 0, "Giveaway ends ", this.renderGiveawayEndDate()), _jsx(_book_description2.default, {
      className: "u-marginTopXSmall",
      bookDescription: this.props.resource.book.description
    }));
  },
  renderHeader: function renderHeader() {
    return _jsx("span", {}, void 0, "entered a ", _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: "/giveaway"
    }, void 0, "Book Giveaway"));
  },
  render: function render() {
    return _react2.default.createElement(_social_book_update2.default, _extends({}, this.props, {
      header: this.renderHeader(),
      book: this.props.resource.book,
      bookBody: this.renderBookBody(),
      updateDetails: null,
      includeWTR: false }));
  }
});

},{"../../book_description":75,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../social_book_update":187,"moment":"moment","react":"react"}],158:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _appendQuery = require("append-query");

var _appendQuery2 = _interopRequireDefault(_appendQuery);

var _nonsocial_update = require("../nonsocial_update");

var _nonsocial_update2 = _interopRequireDefault(_nonsocial_update);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _group_discussion_newsfeed_item_body = require("./group_discussion_newsfeed_item_body");

var _group_discussion_newsfeed_item_body2 = _interopRequireDefault(_group_discussion_newsfeed_item_body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URL_REF_LINK = "discussion_newsfeed_item_link";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GroupDiscussionNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      user: _gr_prop_types2.default.user().isRequired
    }),
    update: React.PropTypes.shape({
      group: _gr_prop_types2.default.group().isRequired,
      topic: _gr_prop_types2.default.topic().isRequired,
      body: React.PropTypes.shape(_gr_prop_types2.default.expandableHtml())
    })
  },

  renderHeader: function renderHeader() {
    return _jsx("div", {}, void 0, _jsx(_user_profile_link2.default, {
      user: this.props.resource.user
    }), " posted to ", _jsx("a", {
      href: (0, _appendQuery2.default)(this.props.update.group.url, "ref=" + URL_REF_LINK),
      className: "gr-hyperlink gr-hyperlink--bold",
      "aria-label": "Go to group " + this.props.update.group.name
    }, void 0, this.props.update.group.name));
  },
  renderBody: function renderBody() {
    return _jsx("div", {
      className: "u-marginBottomMedium"
    }, void 0, React.createElement(_group_discussion_newsfeed_item_body2.default, this.props.update));
  },
  render: function render() {
    return _jsx(_nonsocial_update2.default, {
      header: this.renderHeader(),
      body: this.renderBody(),
      updateIconUrl: this.props.resource.user.profileImage
    });
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_profile_link":231,"../nonsocial_update":165,"./group_discussion_newsfeed_item_body":159,"append-query":"append-query"}],159:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for rendering the body of a Group Discussion (aka Topic)
// Used in GroupDiscussionNewsfeedItem and SharingNewsfeedItem with Topic resource

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _group_icon = require("../../group/group_icon");

var _group_icon2 = _interopRequireDefault(_group_icon);

var _appendQuery = require("append-query");

var _appendQuery2 = _interopRequireDefault(_appendQuery);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _shape_icon_values = require("../../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URL_REF_BUTTON = "discussion_newsfeed_item_button";
var URL_REF_LINK = "discussion_newsfeed_item_link";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GroupDiscussionNewsfeedItemBody",

  propTypes: {
    group: _gr_prop_types2.default.group().isRequired,
    topic: _gr_prop_types2.default.topic().isRequired,
    body: _react.PropTypes.shape(_gr_prop_types2.default.expandableHtml())
  },

  renderFolderTopic: function renderFolderTopic() {
    var linkClassName = "gr-hyperlink gr-hyperlink--bold";
    var folder = this.props.topic.folder;
    return _jsx("div", {}, void 0, "Topic: ", _jsx("span", {}, void 0, folder ? _jsx("span", {}, void 0, _jsx("a", {
      className: linkClassName,
      href: folder.url,
      "aria-label": "Go to group topic " + folder.name
    }, void 0, folder.name), _jsx("span", {}, void 0, " > ")) : null, _jsx("a", {
      className: linkClassName,
      href: (0, _appendQuery2.default)(this.props.topic.url, "ref=" + URL_REF_LINK),
      "aria-label": "Go to group subtopic " + this.props.topic.title
    }, void 0, this.props.topic.title)));
  },
  render: function render() {
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media"
    }, void 0, _jsx(_group_icon2.default, {
      group: this.props.group,
      size: _shape_icon_values.ICON_SIZES.LARGE
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc gr-h4 gr-h4--noMargin"
    }, void 0, this.renderFolderTopic())), _jsx("div", {
      className: "u-defaultType"
    }, void 0, React.createElement(_expandable_html2.default, this.props.body), _jsx("a", {
      href: (0, _appendQuery2.default)(this.props.topic.url, "ref=" + URL_REF_BUTTON),
      className: "gr-button u-marginTopMedium",
      "aria-label": "Join the discussion in " + this.props.topic.title
    }, void 0, "Join the discussion")));
  }
});

},{"../../../modules/shape_icon_values":19,"../../gr_component_factory":108,"../../group/group_icon":109,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"append-query":"append-query","react":"react"}],160:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _number_formatting_utils = require("../../../modules/number_formatting_utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GroupJoinDetails",

  propTypes: {
    title: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    memberCount: _react2.default.PropTypes.number.isRequired,
    joinUrl: _react2.default.PropTypes.string.isRequired,
    isMember: _react2.default.PropTypes.bool.isRequired
  },

  renderJoinGroupButton: function renderJoinGroupButton() {
    if (!this.props.isMember) {
      return _jsx("a", {
        href: this.props.joinUrl,
        className: "gr-button u-marginTopMedium"
      }, void 0, "Join Group");
    }
  },
  getGroupTitleHTML: function getGroupTitleHTML() {
    return { __html: this.props.title };
  },
  renderMemberText: function renderMemberText() {
    return (0, _number_formatting_utils.formatNumberWithDelimiter)(this.props.memberCount) + " " + (this.props.memberCount === 1 ? "Member" : "Members");
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, _jsx("a", {
      href: this.props.url,
      className: "gr-newsfeedItem__resourceNameLink",
      dangerouslySetInnerHTML: this.getGroupTitleHTML()
    }), _jsx("div", {
      className: "gr-newsfeedItem__groupDetailsText u-defaultType"
    }, void 0, this.renderMemberText()), this.renderJoinGroupButton());
  }
});

},{"../../../modules/number_formatting_utils":16,"../../gr_component_factory":108,"react":"react"}],161:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _group_join_details = require("./group_join_details");

var _group_join_details2 = _interopRequireDefault(_group_join_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GroupJoinNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      title: _react2.default.PropTypes.string.isRequired,
      url: _react2.default.PropTypes.string.isRequired,
      memberCount: _react2.default.PropTypes.number,
      joinUrl: _react2.default.PropTypes.string,
      isMember: _react2.default.PropTypes.bool,
      imageUrl: _react2.default.PropTypes.string.isRequired,
      user: _gr_prop_types2.default.user().isRequired
    })
  },

  render: function render() {
    var imageProps = { url: this.props.resource.imageUrl,
      linkUrl: this.props.resource.url };
    var body = _jsx(_social_update_body2.default, {
      image: imageProps
    }, void 0, _react2.default.createElement(_group_join_details2.default, this.props.resource));

    return _react2.default.createElement(_social_update2.default, _extends({
      header: _jsx("span", {}, void 0, "joined a group"),
      body: body
    }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../social_update":188,"../social_update_body":189,"./group_join_details":160,"react":"react"}],162:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _newsfeed_update_store = require("../../react_stores/newsfeed_update_store");

var _newsfeed_update_store2 = _interopRequireDefault(_newsfeed_update_store);

var _newsfeed_actions = require("../../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _newsfeed_helper = require("./newsfeed_helper");

var newsfeedHelper = _interopRequireWildcard(_newsfeed_helper);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _infinite_scroll_list = require("../shared/infinite_scroll_list");

var _infinite_scroll_list2 = _interopRequireDefault(_infinite_scroll_list);

var _image_registry = require("../../modules/shared/image_registry");

var _popover = require("../shared/popover/popover");

var _popover2 = _interopRequireDefault(_popover);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFS_PANE_ID = "grNewsfeedPreferencesPane";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Newsfeed",

  mixins: [_reflux2.default.connect(_newsfeed_update_store2.default, "newsfeedUpdateStore")],

  getInitialState: function getInitialState() {
    return {
      showUpdatesFeedPreferencesForm: false
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      showGenresModal: false
    };
  },
  componentDidMount: function componentDidMount() {
    // If users have not selected favorite genres, open the genre modal to
    // encourage them to select them now so that we can target them with
    // nonsocial genre newsfeed stories.
    if (this.props.showGenresModal) {
      _modal_actions2.default.openModal("favGenres");
    }
  },
  handleUpdateItemChange: function handleUpdateItemChange(event) {
    _newsfeed_actions2.default.setUpdatesFeedPreferences({ item: event.target.value });
  },
  handleUpdateScopeChange: function handleUpdateScopeChange(event) {
    _newsfeed_actions2.default.setUpdatesFeedPreferences({ scope: event.target.value });
  },
  renderLoadMore: function renderLoadMore() {
    var storeState = this.state.newsfeedUpdateStore;
    if (storeState.noAdditionalUpdates) {
      return _jsx("span", {}, void 0, "No More Updates");
    } else {
      if (storeState.loadingInProgress) {
        return _jsx(_spinner2.default, {});
      } else {
        return _jsx("button", {
          className: "gr-button gr-button--quiet gr-button--fullWidth",
          onClick: _newsfeed_actions2.default.loadMoreUpdates
        }, void 0, "Load More Updates");
      }
    }
  },
  renderLoadingInProgressMessage: function renderLoadingInProgressMessage() {
    var storeState = this.state.newsfeedUpdateStore;
    if (storeState.loadingInProgress) {
      return _jsx("div", {
        className: "u-textAlignCenter"
      }, void 0, _jsx(_spinner2.default, {
        isSmall: true,
        className: "u-marginRightTiny"
      }), _jsx("small", {}, void 0, "Refreshing updates…"));
    }
  },
  renderUpdatesFeedPreferencesForm: function renderUpdatesFeedPreferencesForm() {
    var _this = this;

    var storeState = this.state.newsfeedUpdateStore;
    var updatePreferencesInProgress = storeState.loadingInProgress;

    return _jsx("div", {
      id: PREFS_PANE_ID
    }, void 0, this.renderLoadingInProgressMessage(), _jsx("fieldset", {
      className: "gr-radioButtonGroup"
    }, void 0, _jsx("legend", {}, void 0, "Content"), _jsx("small", {}, void 0, "What types of updates you see"), (0, _lodash.map)(_newsfeed_update_store.UpdateFeedPreferences.items, function (item) {
      return _jsx("label", {
        className: "gr-radioButtonGroup__choice gr-label gr-label--muted"
      }, item.value, _jsx("input", {
        name: "update_item",
        value: item.value,
        disabled: updatePreferencesInProgress,
        checked: storeState.updatesFeedPreferences.item === item.value,
        onChange: _this.handleUpdateItemChange,
        type: "radio",
        className: "gr-radioButtonGroup__button"
      }), item.label);
    })), _jsx("fieldset", {
      className: "gr-radioButtonGroup"
    }, void 0, _jsx("legend", {}, void 0, "People"), _jsx("small", {}, void 0, "Whose updates you see"), (0, _lodash.map)(_newsfeed_update_store.UpdateFeedPreferences.scopes, function (scope) {
      return _jsx("label", {
        className: "gr-radioButtonGroup__choice gr-label gr-label--muted"
      }, scope.value, _jsx("input", {
        name: "update_scope",
        value: scope.value,
        disabled: updatePreferencesInProgress,
        checked: storeState.updatesFeedPreferences.scope === scope.value,
        onChange: _this.handleUpdateScopeChange,
        type: "radio",
        className: "gr-radioButtonGroup__button"
      }), scope.label);
    })));
  },
  togglePreferences: function togglePreferences() {
    this.setState({
      showUpdatesFeedPreferencesForm: !this.state.showUpdatesFeedPreferencesForm
    });
  },
  closePreferences: function closePreferences() {
    this.setState({
      showUpdatesFeedPreferencesForm: false
    });
  },
  renderCustomizeFeedButton: function renderCustomizeFeedButton() {
    var popoverTarget = _jsx("button", {
      className: "gr-iconButton u-floatRight",
      "aria-label": "Customize updates feed preferences",
      "aria-haspopup": "true",
      "aria-expanded": this.state.showUpdatesFeedPreferencesForm,
      "aria-controls": PREFS_PANE_ID,
      onClick: this.togglePreferences
    }, void 0, _jsx("span", {
      className: "gr-iconButton__innerWrapper"
    }, void 0, _jsx("img", {
      className: "gr-settingsIcon",
      alt: "",
      src: (0, _image_registry.getImages)().settingsCog
    }), _jsx("span", {
      className: "gr-iconButton__textLabel"
    }, void 0, "Customize")));

    var preferencesForm = this.renderUpdatesFeedPreferencesForm();
    return _jsx(_popover2.default, {
      bemModifiers: "small",
      headingText: "Updates Feed Preferences",
      isOpen: this.state.showUpdatesFeedPreferencesForm,
      showArrow: false,
      onClose: this.closePreferences,
      body: preferencesForm,
      popoverTarget: popoverTarget
    });
  },
  render: function render() {
    var _this2 = this;

    var storeState = this.state.newsfeedUpdateStore;
    var newsfeedUpdates = (0, _lodash.map)(storeState.newsfeedUpdates, function (newsfeedUpdate) {
      return _jsx("div", {}, newsfeedUpdate.id, newsfeedHelper.renderNewsfeedItem(newsfeedUpdate, {
        allowBehavioralTargeting: _this2.props.allowBehavioralTargeting,
        urcDeprecateViewChallengeLink: _this2.props.urcDeprecateViewChallengeLink,
        readOnlyStars: _this2.props.readOnlyStars
      }));
    });

    return _jsx("div", {
      className: "gr-newsfeed u-defaultType"
    }, void 0, _jsx("h3", {
      className: "gr-newsfeed__title"
    }, void 0, "Updates"), this.renderCustomizeFeedButton(), _jsx("div", {
      className: "u-clearBoth"
    }, void 0, _jsx(_infinite_scroll_list2.default, {
      loadMoreAction: _newsfeed_actions2.default.loadMoreUpdates,
      loadingInProgress: storeState.loadingInProgress,
      noMoreItems: storeState.noAdditionalUpdates
    }, void 0, newsfeedUpdates), _jsx("div", {
      className: "gr-newsfeed__loadMore"
    }, void 0, this.renderLoadMore())));
  }
});

},{"../../modules/shared/image_registry":20,"../../react_actions/modal_actions":36,"../../react_actions/newsfeed_actions":37,"../../react_stores/newsfeed_update_store":267,"../gr_component_factory":108,"../shared/infinite_scroll_list":223,"../shared/popover/popover":224,"../spinner":226,"./newsfeed_helper":163,"lodash":"lodash","reflux":"reflux"}],163:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resourceTypeToComponentMap = undefined;
exports.getNewsfeedItemByType = getNewsfeedItemByType;
exports.isNewsfeedTypeSupported = isNewsfeedTypeSupported;
exports.renderNewsfeedItem = renderNewsfeedItem;

var _lodash = require("lodash");

var _author_qa_setting_newsfeed_item = require("./author/author_qa_setting_newsfeed_item");

var _author_qa_setting_newsfeed_item2 = _interopRequireDefault(_author_qa_setting_newsfeed_item);

var _blog_newsfeed_item = require("./editorial/blog_newsfeed_item");

var _blog_newsfeed_item2 = _interopRequireDefault(_blog_newsfeed_item);

var _interview_newsfeed_item = require("./editorial/interview_newsfeed_item");

var _interview_newsfeed_item2 = _interopRequireDefault(_interview_newsfeed_item);

var _community_question_newsfeed_item = require("./community_question/community_question_newsfeed_item");

var _community_question_newsfeed_item2 = _interopRequireDefault(_community_question_newsfeed_item);

var _community_answer_newsfeed_item = require("./community_answer/community_answer_newsfeed_item");

var _community_answer_newsfeed_item2 = _interopRequireDefault(_community_answer_newsfeed_item);

var _read_status_newsfeed_item = require("./read_status/read_status_newsfeed_item");

var _read_status_newsfeed_item2 = _interopRequireDefault(_read_status_newsfeed_item);

var _user_status_newsfeed_item = require("./user_status/user_status_newsfeed_item");

var _user_status_newsfeed_item2 = _interopRequireDefault(_user_status_newsfeed_item);

var _recommendation_newsfeed_item = require("./recommendation/recommendation_newsfeed_item");

var _recommendation_newsfeed_item2 = _interopRequireDefault(_recommendation_newsfeed_item);

var _review_newsfeed_item = require("./review/review_newsfeed_item");

var _review_newsfeed_item2 = _interopRequireDefault(_review_newsfeed_item);

var _friend_newsfeed_item = require("./friend/friend_newsfeed_item");

var _friend_newsfeed_item2 = _interopRequireDefault(_friend_newsfeed_item);

var _giveaway_request_newsfeed_item = require("./giveaway/giveaway_request_newsfeed_item");

var _giveaway_request_newsfeed_item2 = _interopRequireDefault(_giveaway_request_newsfeed_item);

var _general_status_newsfeed_item = require("./general_status/general_status_newsfeed_item");

var _general_status_newsfeed_item2 = _interopRequireDefault(_general_status_newsfeed_item);

var _group_join_newsfeed_item = require("./group_join/group_join_newsfeed_item");

var _group_join_newsfeed_item2 = _interopRequireDefault(_group_join_newsfeed_item);

var _group_discussion_newsfeed_item = require("./group_discussion/group_discussion_newsfeed_item");

var _group_discussion_newsfeed_item2 = _interopRequireDefault(_group_discussion_newsfeed_item);

var _rating_newsfeed_item = require("./rating/rating_newsfeed_item");

var _rating_newsfeed_item2 = _interopRequireDefault(_rating_newsfeed_item);

var _comment_newsfeed_item = require("./comment/comment_newsfeed_item");

var _comment_newsfeed_item2 = _interopRequireDefault(_comment_newsfeed_item);

var _author_blog_post_newsfeed_item = require("./author/author_blog_post_newsfeed_item");

var _author_blog_post_newsfeed_item2 = _interopRequireDefault(_author_blog_post_newsfeed_item);

var _author_follow_newsfeed_item = require("./author/author_follow_newsfeed_item");

var _author_follow_newsfeed_item2 = _interopRequireDefault(_author_follow_newsfeed_item);

var _challenge_newsfeed_item = require("./challenge/challenge_newsfeed_item");

var _challenge_newsfeed_item2 = _interopRequireDefault(_challenge_newsfeed_item);

var _user_quote_newsfeed_item = require("./user_quote/user_quote_newsfeed_item");

var _user_quote_newsfeed_item2 = _interopRequireDefault(_user_quote_newsfeed_item);

var _poll_vote_newsfeed_item = require("./poll/poll_vote_newsfeed_item");

var _poll_vote_newsfeed_item2 = _interopRequireDefault(_poll_vote_newsfeed_item);

var _trending_genre_newsfeed_item = require("./book_inspiration/trending_genre_newsfeed_item");

var _trending_genre_newsfeed_item2 = _interopRequireDefault(_trending_genre_newsfeed_item);

var _user_following_newsfeed_item = require("./user_following/user_following_newsfeed_item");

var _user_following_newsfeed_item2 = _interopRequireDefault(_user_following_newsfeed_item);

var _native_ad = require("../ads/native_ads/native_ad");

var _native_ad2 = _interopRequireDefault(_native_ad);

var _recommendation_request_newsfeed_item = require("./recommendation_request/recommendation_request_newsfeed_item");

var _recommendation_request_newsfeed_item2 = _interopRequireDefault(_recommendation_request_newsfeed_item);

var _reading_notes_collection_newsfeed_item = require("./reading_notes/reading_notes_collection_newsfeed_item");

var _reading_notes_collection_newsfeed_item2 = _interopRequireDefault(_reading_notes_collection_newsfeed_item);

var _reading_year_newsfeed_item = require("./reading_year/reading_year_newsfeed_item");

var _reading_year_newsfeed_item2 = _interopRequireDefault(_reading_year_newsfeed_item);

var _reading_note_newsfeed_item = require("./reading_notes/reading_note_newsfeed_item");

var _reading_note_newsfeed_item2 = _interopRequireDefault(_reading_note_newsfeed_item);

var _sharing_newsfeed_item = require("./sharing/sharing_newsfeed_item");

var _sharing_newsfeed_item2 = _interopRequireDefault(_sharing_newsfeed_item);

var _custom_newsfeed_item = require("./editorial/custom_newsfeed_item");

var _custom_newsfeed_item2 = _interopRequireDefault(_custom_newsfeed_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resourceTypeToComponentMap = exports.resourceTypeToComponentMap = {
  Blog: _blog_newsfeed_item2.default,
  Interview: _interview_newsfeed_item2.default,
  CommunityQuestion: _community_question_newsfeed_item2.default,
  CommunityAnswer: _community_answer_newsfeed_item2.default,
  ReadStatus: _read_status_newsfeed_item2.default,
  UserStatus: _user_status_newsfeed_item2.default,
  GeneralStatus: _general_status_newsfeed_item2.default,
  Recommendation: _recommendation_newsfeed_item2.default,
  Review: _review_newsfeed_item2.default,
  Friend: _friend_newsfeed_item2.default,
  GiveawayRequest: _giveaway_request_newsfeed_item2.default,
  GroupUser: _group_join_newsfeed_item2.default,
  Rating: _rating_newsfeed_item2.default,
  LikeOnExternalResourcePlaceholder: _rating_newsfeed_item2.default,
  Comment: _comment_newsfeed_item2.default,
  Topic: _group_discussion_newsfeed_item2.default,
  AuthorBlogPost: _author_blog_post_newsfeed_item2.default,
  AuthorFollowing: _author_follow_newsfeed_item2.default,
  AuthorQaSetting: _author_qa_setting_newsfeed_item2.default,
  UserChallenge: _challenge_newsfeed_item2.default,
  UserQuote: _user_quote_newsfeed_item2.default,
  PollVote: _poll_vote_newsfeed_item2.default,
  TopList: _trending_genre_newsfeed_item2.default,
  UserFollowing: _user_following_newsfeed_item2.default,
  NewsfeedAd: _native_ad2.default,
  ReadingNotesCollectionPlaceholder: _reading_notes_collection_newsfeed_item2.default,
  RecommendationRequest: _recommendation_request_newsfeed_item2.default,
  ReadingYear: _reading_year_newsfeed_item2.default,
  "Services::Models::ReadingNote": _reading_note_newsfeed_item2.default,
  Sharing: _sharing_newsfeed_item2.default,
  CustomNewsfeedStory: _custom_newsfeed_item2.default
};

function getNewsfeedItemByType(update) {
  if (update.resourceType === "Comment" && update.subjectType === "Topic") {
    return resourceTypeToComponentMap[update.subjectType];
  } else {
    return resourceTypeToComponentMap[update.resourceType];
  }
}

function isNewsfeedTypeSupported(newsfeedType) {
  return (0, _lodash.has)(resourceTypeToComponentMap, newsfeedType);
}

function renderNewsfeedItem(update) {
  var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var NewsfeedItem = this.getNewsfeedItemByType(update);
  if (NewsfeedItem) {
    return React.createElement(NewsfeedItem, _extends({}, update, props));
  } else {
    return null;
  }
}

},{"../ads/native_ads/native_ad":55,"./author/author_blog_post_newsfeed_item":128,"./author/author_follow_newsfeed_item":130,"./author/author_qa_setting_newsfeed_item":131,"./book_inspiration/trending_genre_newsfeed_item":132,"./challenge/challenge_newsfeed_item":133,"./comment/comment_newsfeed_item":138,"./community_answer/community_answer_newsfeed_item":141,"./community_question/community_question_newsfeed_item":143,"./editorial/blog_newsfeed_item":146,"./editorial/custom_newsfeed_item":148,"./editorial/interview_newsfeed_item":149,"./friend/friend_newsfeed_item":155,"./general_status/general_status_newsfeed_item":156,"./giveaway/giveaway_request_newsfeed_item":157,"./group_discussion/group_discussion_newsfeed_item":158,"./group_join/group_join_newsfeed_item":161,"./poll/poll_vote_newsfeed_item":167,"./rating/rating_newsfeed_item":168,"./read_status/read_status_newsfeed_item":170,"./reading_notes/reading_note_newsfeed_item":171,"./reading_notes/reading_notes_collection_newsfeed_item":172,"./reading_year/reading_year_newsfeed_item":173,"./recommendation/recommendation_newsfeed_item":176,"./recommendation_request/recommendation_request_newsfeed_item":178,"./review/review_newsfeed_item":182,"./sharing/sharing_newsfeed_item":185,"./user_following/user_following_newsfeed_item":191,"./user_quote/user_quote_newsfeed_item":194,"./user_status/user_status_newsfeed_item":197,"lodash":"lodash"}],164:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _relative_time = require("../../react_components/time/relative_time");

var _relative_time2 = _interopRequireDefault(_relative_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NewsfeedItemHeaderTimestamp",

  propTypes: {
    time: _gr_prop_types2.default.date.isRequired,
    resourceDisplayName: _react2.default.PropTypes.string,
    resourceUrl: _react2.default.PropTypes.string
  },

  linkExists: function linkExists() {
    return this.props.resourceDisplayName && this.props.resourceUrl;
  },
  renderTimestamp: function renderTimestamp() {
    if (this.linkExists()) {
      return _jsx("a", {
        href: this.props.resourceUrl,
        className: "gr-hyperlink gr-hyperlink--naked",
        "aria-label": "Permanent link to " + this.props.resourceDisplayName
      }, void 0, _jsx(_relative_time2.default, {
        time: this.props.time
      }));
    } else {
      return _jsx("span", {}, void 0, _jsx(_relative_time2.default, {
        time: this.props.time
      }));
    }
  },
  render: function render() {
    return _jsx("small", {
      className: "gr-newsfeedItem__headerTimestamp"
    }, void 0, this.renderTimestamp());
  }
});

},{"../../react_components/time/relative_time":228,"../gr_component_factory":108,"../shared/gr_prop_types":221,"react":"react"}],165:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NonsocialUpdate",

  propTypes: {
    header: React.PropTypes.element.isRequired,
    body: React.PropTypes.element.isRequired,
    footer: React.PropTypes.element,
    updateIconUrl: React.PropTypes.string.isRequired
  },

  renderIcon: function renderIcon() {
    return _jsx(_shape_icon2.default, {
      imageUrl: this.props.updateIconUrl,
      imageAlt: "Goodreads",
      size: _shape_icon_values.ICON_SIZES.MEDIUM
    });
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem gr-mediaBox"
    }, void 0, _jsx("div", {
      className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
    }, void 0, this.renderIcon()), _jsx("div", {
      className: "gr-mediaBox__desc gr-newsfeedItem__body"
    }, void 0, _jsx("div", {
      className: "gr-newsfeedItem__header gr-newsfeedItem__header--timestamp"
    }, void 0, this.props.header), this.props.body), _jsx("div", {
      className: "gr-newsfeedItem__footer"
    }, void 0, this.props.footer));
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":108,"../shape_icon":219}],166:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_book_update = require("../social_book_update");

var _social_book_update2 = _interopRequireDefault(_social_book_update);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ChoicePollVoteNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.choicePollVoteNewsfeedResource()
  },

  renderHeader: function renderHeader() {
    return _jsx("span", {}, void 0, "voted in the ", _jsx("a", {
      href: this.props.resource.choiceUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, "Goodreads Choice Awards ", this.props.resource.choiceYear));
  },
  getPollNameHtml: function getPollNameHtml() {
    return { __html: this.props.resource.pollName.replace("Best", "Readers' Favorite") };
  },
  renderChoiceBanner: function renderChoiceBanner() {
    return _jsx("a", {
      href: this.props.resource.choiceUrl
    }, void 0, _jsx("img", {
      className: "gr-newsfeedItem__pollLogo",
      src: this.props.resource.badgeUrl,
      alt: "Choice Awards"
    }));
  },
  renderChoiceDetails: function renderChoiceDetails() {
    return _jsx("div", {
      className: "gr-newsfeedItem__pollDetails"
    }, void 0, _jsx("div", {
      className: "gr-newsfeedItem__pollLabel u-marginBottomSmall"
    }, void 0, "Nominated for ", _jsx("a", {
      href: this.props.resource.url,
      dangerouslySetInnerHTML: this.getPollNameHtml()
    })), this.renderChoiceBanner(), _jsx("div", {}, void 0, _jsx("a", {
      href: this.props.resource.url,
      className: "gr-newsfeedItem__pollCTA gr-button gr-button--choice"
    }, void 0, "Vote Now!")));
  },
  render: function render() {
    return React.createElement(_social_book_update2.default, _extends({}, this.props, {
      header: this.renderHeader(),
      book: this.props.resource.votedBook,
      bookBody: this.renderChoiceDetails(),
      updateDetails: null,
      includeWTR: false }));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../social_book_update":187}],167:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _choice_poll_vote_newsfeed_item = require("./choice_poll_vote_newsfeed_item");

var _choice_poll_vote_newsfeed_item2 = _interopRequireDefault(_choice_poll_vote_newsfeed_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAKE_THE_POLL_LABEL = "Take the Poll";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PollVoteNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.pollVoteNewsfeedResource()
  },

  getPollNameHtml: function getPollNameHtml() {
    return { __html: this.props.resource.pollName };
  },
  renderBody: function renderBody() {
    var imageProps = {
      altText: TAKE_THE_POLL_LABEL,
      url: this.props.resource.imageUrl,
      linkUrl: this.props.resource.isGroupPoll ? this.props.resource.groupUrl : this.props.resource.url
    };
    return _jsx(_social_update_body2.default, {
      image: imageProps
    }, void 0, _jsx("div", {
      className: "gr-newsfeedItem__pollName",
      dangerouslySetInnerHTML: this.getPollNameHtml()
    }), this.renderPollVote(), this.props.resource.isGroupPoll ? this.renderGroupName() : null);
  },
  renderPollVote: function renderPollVote() {
    return _jsx("div", {
      className: "gr-newsfeedItem__pollDetails"
    }, void 0, _jsx("span", {
      className: "gr-newsfeedItem__pollLabel"
    }, void 0, "Vote:"), React.createElement(_expandable_html2.default, _extends({ className: "gr-newsfeedItem__pollAnswer"
    }, this.props.resource.answer)));
  },
  renderGroupName: function renderGroupName() {
    return _jsx("div", {
      className: "gr-newsfeedItem__pollDetails"
    }, void 0, _jsx("span", {
      className: "gr-newsfeedItem__pollLabel"
    }, void 0, "Group Poll by"), _jsx("a", {
      href: this.props.resource.groupUrl
    }, void 0, this.props.resource.groupName, " "));
  },
  renderPollLinks: function renderPollLinks() {
    return [_jsx("a", {
      href: this.props.resource.url
    }, void 0, TAKE_THE_POLL_LABEL)];
  },
  render: function render() {
    if (this.props.resource.isChoicePoll) {
      return React.createElement(_choice_poll_vote_newsfeed_item2.default, this.props);
    } else {
      return React.createElement(_social_update2.default, _extends({
        header: _jsx("span", {}, void 0, "voted on a poll"),
        body: this.renderBody(),
        additionalFooterLinks: this.renderPollLinks()
      }, this.props));
    }
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"../social_update":188,"../social_update_body":189,"./choice_poll_vote_newsfeed_item":166}],168:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _child_newsfeed_item = require("../child_newsfeed_item");

var _child_newsfeed_item2 = _interopRequireDefault(_child_newsfeed_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RatingNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.object.isRequired,
    update: _react2.default.PropTypes.object.isRequired
  },

  headerText: function headerText() {
    var resourceTypeDisplayName = this.props.update.resource.typeDisplayName;
    if (!resourceTypeDisplayName) {
      resourceTypeDisplayName = "update";
    }

    return "liked an " + resourceTypeDisplayName;
  },
  render: function render() {
    return _jsx(_child_newsfeed_item2.default, {
      update: this.props.update,
      user: this.props.resource.user,
      headerText: this.headerText(),
      readOnlyStars: this.props.readOnlyStars
    });
  }
});

},{"../../gr_component_factory":108,"../child_newsfeed_item":137,"react":"react"}],169:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadStatusHeader",

  propTypes: {
    headerText: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("span", {}, void 0, this.props.headerText);
  }
});

},{"../../gr_component_factory":108,"react":"react"}],170:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_book_update = require("../social_book_update");

var _social_book_update2 = _interopRequireDefault(_social_book_update);

var _read_status_header = require("./read_status_header");

var _read_status_header2 = _interopRequireDefault(_read_status_header);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadStatusNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      headerText: _react2.default.PropTypes.string.isRequired,
      readText: _react2.default.PropTypes.string,
      book: _gr_prop_types2.default.book().isRequired
    }).isRequired
  },

  buildAdditionalFooterLinks: function buildAdditionalFooterLinks() {
    return [_jsx(_preview_book2.default, {
      book: this.props.resource.book
    })];
  },
  renderReadText: function renderReadText() {
    return this.props.resource.readText ? _jsx("div", {
      className: "gr-newsfeedItem__readCountText"
    }, void 0, this.props.resource.readText) : null;
  },
  render: function render() {
    var resource = this.props.resource;
    return _react2.default.createElement(_social_book_update2.default, _extends({
      header: _jsx(_read_status_header2.default, {
        headerText: resource.headerText
      }),
      book: resource.book,
      updateDetails: this.renderReadText(),
      additionalFooterLinks: this.buildAdditionalFooterLinks()
    }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../preview_book/preview_book":200,"../../shared/gr_prop_types":221,"../social_book_update":187,"./read_status_header":169,"react":"react"}],171:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _user_status_header = require("../user_status/user_status_header");

var _user_status_header2 = _interopRequireDefault(_user_status_header);

var _spoiler = require("../../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingNoteNewsfeedItem",
  propTypes: {
    readingNotesLinkUrl: _react2.default.PropTypes.string.isRequired,
    resourceDisplayName: _react2.default.PropTypes.string.isRequired,
    resourceUrl: _react2.default.PropTypes.string.isRequired,
    resource: _react2.default.PropTypes.shape({
      book: _gr_prop_types2.default.book().isRequired,
      headerText: _react2.default.PropTypes.string.isRequired,
      highlightText: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml()),
      noteText: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml()),
      isSpoiler: _react2.default.PropTypes.bool.isRequired,
      user: _gr_prop_types2.default.user().isRequired
    }).isRequired,
    user: _gr_prop_types2.default.user()
  },

  renderSpoilerWarning: function renderSpoilerWarning() {
    return _jsx("span", {
      className: "newsfeedNoteHighlightTextContainer__spoilerWarning"
    }, void 0, "This " + this.props.resource.headerText + " contains spoilers…");
  },
  renderHeader: function renderHeader() {
    return _jsx(_user_status_header2.default, {
      headerText: "shared a " + this.props.resource.headerText + " from ",
      book: this.props.resource.book
    });
  },
  renderBody: function renderBody() {
    var body = _jsx("div", {
      className: "newsfeedNoteHighlightTextContainer newsfeedNoteHighlightTextContainer--withBorder"
    }, void 0, !(0, _lodash.isEmpty)(this.props.resource.highlightText) && _jsx("div", {
      className: "newsfeedNoteHighlightTextContainer__highlightText newsfeedNoteHighlightTextContainer__highlightText--withMargin"
    }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.resource.highlightText)), !(0, _lodash.isEmpty)(this.props.resource.noteText) && this.renderNoteText(), this.renderReadingNotesLink());

    if (this.props.resource.isSpoiler) {
      return _jsx(_spoiler2.default, {
        spoilerWarning: this.renderSpoilerWarning()
      }, void 0, body);
    } else {
      return body;
    }
  },
  renderNoteText: function renderNoteText() {
    return _jsx("div", {
      className: "newsfeedNoteHighlightTextContainer__noteContainer newsfeedNoteHighlightTextContainer__noteContainer--withMargin"
    }, void 0, _jsx("div", {
      className: "newsfeedNoteHighlightTextContainer__noteImage"
    }, void 0, _jsx("div", {
      className: "gr-icon gr-icon--readingNotesIcon"
    }, void 0, _jsx("span", {
      className: "u-visuallyHidden"
    }, void 0, "Note"))), _jsx("div", {
      className: "newsfeedNoteHighlightTextContainer__noteText"
    }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.resource.noteText)));
  },
  renderReadingNotesLink: function renderReadingNotesLink() {
    var linkText = "See all of " + this.props.resource.user.viewableName + "’s notes & highlights";

    return _jsx("div", {
      className: "newsfeedNoteHighlightTextContainer__noteLink"
    }, void 0, _jsx("a", {
      href: this.props.readingNotesLinkUrl
    }, void 0, linkText));
  },
  render: function render() {
    return _react2.default.createElement(_social_update2.default, _extends({}, this.props, {
      header: this.renderHeader(),
      body: this.renderBody()
    }));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"../../user_content/spoiler":234,"../social_update":188,"../user_status/user_status_header":196,"lodash":"lodash","react":"react"}],172:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _nonsocial_update = require("../nonsocial_update");

var _nonsocial_update2 = _interopRequireDefault(_nonsocial_update);

var _book = require("../../book");

var _book2 = _interopRequireDefault(_book);

var _user_status_header = require("../user_status/user_status_header");

var _user_status_header2 = _interopRequireDefault(_user_status_header);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _newsfeed_item_header_timestamp = require("../newsfeed_item_header_timestamp");

var _newsfeed_item_header_timestamp2 = _interopRequireDefault(_newsfeed_item_header_timestamp);

var _newsfeed_item_footer_actions = require("../footer/newsfeed_item_footer_actions");

var _newsfeed_item_footer_actions2 = _interopRequireDefault(_newsfeed_item_footer_actions);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

var _want_to_read_button = require("../../want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingNotesCollectionNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      book: _gr_prop_types2.default.book().isRequired,
      user: _gr_prop_types2.default.user().isRequired,
      headerText: _react2.default.PropTypes.string.isRequired,
      highlightText: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml()),
      noteText: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml())
    }).isRequired,
    readingNotesLinkUrl: _react2.default.PropTypes.string.isRequired,
    resourceDisplayName: _react2.default.PropTypes.string.isRequired,
    resourceUrl: _react2.default.PropTypes.string.isRequired,
    updateIconUrl: _react2.default.PropTypes.string.isRequired
  },

  renderReadingNotesLink: function renderReadingNotesLink() {
    var linkText = "See all of " + this.props.resource.user.viewableName + "’s notes & highlights";

    return _jsx("a", {
      href: this.props.readingNotesLinkUrl
    }, void 0, linkText);
  },
  renderBookBody: function renderBookBody() {
    return _jsx("div", {}, void 0, _jsx(_want_to_read_button2.default, {
      bookTitle: this.props.resource.book.title,
      uniqueId: (0, _lodash2.default)(1000000).toString(),
      bookId: this.props.resource.book.bookId,
      showStars: true,
      readOnlyStars: this.props.readOnlyStars
    }));
  },
  renderReadingNote: function renderReadingNote() {
    if ((0, _lodash.isEmpty)(this.props.resource.highlightText) && (0, _lodash.isEmpty)(this.props.resource.noteText)) {
      return null;
    } else {
      return _jsx("div", {
        className: "newsfeedNoteHighlightTextContainer newsfeedNoteHighlightTextContainer--withBottomBorder"
      }, void 0, !(0, _lodash.isEmpty)(this.props.resource.highlightText) && _jsx("div", {
        className: "newsfeedNoteHighlightTextContainer__highlightText"
      }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.resource.highlightText)), !(0, _lodash.isEmpty)(this.props.resource.noteText) && _jsx("div", {
        className: "newsfeedNoteHighlightTextContainer__noteContainer"
      }, void 0, _jsx("div", {
        className: "newsfeedNoteHighlightTextContainer__noteImage"
      }, void 0, _jsx("div", {
        className: "gr-icon gr-icon--readingNotesIcon"
      }, void 0, _jsx("span", {
        className: "u-visuallyHidden"
      }, void 0, "Note"))), _jsx("div", {
        className: "newsfeedNoteHighlightTextContainer"
      }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.resource.noteText))));
    }
  },
  getFooterLinks: function getFooterLinks() {
    return [_jsx(_preview_book2.default, {
      book: this.props.resource.book
    }), this.renderReadingNotesLink()];
  },
  renderHeader: function renderHeader() {
    return _jsx("div", {}, void 0, _jsx(_user_profile_link2.default, {
      user: this.props.resource.user,
      className: "u-marginRightTiny"
    }), _jsx(_user_status_header2.default, {
      book: this.props.resource.book,
      headerText: this.props.resource.headerText
    }));
  },
  renderBody: function renderBody() {
    return _jsx("div", {}, void 0, _jsx(_newsfeed_item_header_timestamp2.default, {
      time: this.props.updatedAt,
      resourceDisplayName: this.props.resourceDisplayName,
      resourceUrl: this.props.resourceUrl
    }), this.renderReadingNote(), _react2.default.createElement(
      _book2.default,
      _extends({}, this.props.resource.book, {
        className: this.props.bookClassName,
        size: _book.VALID_BOOK_SIZES.LARGE }),
      this.renderBookBody()
    ));
  },
  renderFooter: function renderFooter() {
    return _jsx(_newsfeed_item_footer_actions2.default, {
      elements: this.getFooterLinks()
    });
  },
  render: function render() {
    return _react2.default.createElement(_nonsocial_update2.default, _extends({}, this.props, {
      header: this.renderHeader(),
      body: this.renderBody(),
      footer: this.renderFooter()
    }));
  }
});

},{"../../book":73,"../../gr_component_factory":108,"../../preview_book/preview_book":200,"../../shared/gr_prop_types":221,"../../user/user_profile_link":231,"../../user_content/expandable_html":232,"../../want_to_read/want_to_read_button":238,"../footer/newsfeed_item_footer_actions":152,"../newsfeed_item_header_timestamp":164,"../nonsocial_update":165,"../user_status/user_status_header":196,"lodash":"lodash","react":"react"}],173:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _book_cover_row = require("../shared/book_cover_row");

var _book_cover_row2 = _interopRequireDefault(_book_cover_row);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingYearNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      user: _gr_prop_types2.default.user().isRequired
    }),
    imageUrl: _react2.default.PropTypes.string.isRequired,
    yearInBooksUrl: _react2.default.PropTypes.string.isRequired,
    year: _react2.default.PropTypes.number.isRequired,
    numRead: _react2.default.PropTypes.number.isRequired,
    books: _react2.default.PropTypes.arrayOf(_gr_prop_types2.default.book()).isRequired,
    updateText: _react2.default.PropTypes.string.isRequired,
    yearlyBlurb: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml())
  },

  renderHeader: function renderHeader() {
    return _jsx("span", {}, void 0, "shared their ", _jsx("a", {
      href: this.props.yearInBooksUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, "Year in Books ", this.props.year));
  },
  renderBlurb: function renderBlurb() {
    if (this.props.yearlyBlurb) {
      return _jsx("div", {
        className: "readingYearBlurb"
      }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.yearlyBlurb));
    } else {
      return null;
    }
  },
  renderBody: function renderBody() {
    var user = this.props.resource.user;
    var imageProps = {
      url: this.props.imageUrl,
      linkUrl: this.props.yearInBooksUrl,
      altText: "See " + user.viewableName + "'s year in books"
    };
    return _jsx(_social_update_body2.default, {
      image: imageProps,
      imageClass: "gr-newsfeedItem__readingYearBadge"
    }, void 0, _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, this.props.updateText), _jsx(_book_cover_row2.default, {
      numBooksRead: this.props.numRead,
      books: this.props.books,
      url: this.props.yearInBooksUrl
    }), this.renderBlurb(), _jsx("a", {
      href: this.props.yearInBooksUrl,
      className: "gr-button"
    }, void 0, "Check out ", user.viewableName, "'s Year in Books"));
  },
  render: function render() {
    return _react2.default.createElement(_social_update2.default, _extends({
      header: this.renderHeader(),
      body: this.renderBody()
    }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"../shared/book_cover_row":183,"../social_update":188,"../social_update_body":189,"react":"react"}],174:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RecommendationDetails",

  propTypes: {
    message: _react2.default.PropTypes.shape(_gr_prop_types2.default.truncatedHtml())
  },

  render: function render() {
    if (this.props.message) {
      return _react2.default.createElement(_expandable_html2.default, this.props.message);
    } else {
      return null;
    }
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"react":"react"}],175:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RecommendationHeader",

  propTypes: {
    toUser: _gr_prop_types2.default.user().isRequired,
    recommendedToYou: _react2.default.PropTypes.bool
  },

  render: function render() {
    if (this.props.recommendedToYou) {
      return _jsx("span", {}, void 0, "recommended a book to you");
    } else {
      return _jsx("span", {}, void 0, "recommended a book to ", _jsx(_user_profile_link2.default, {
        user: this.props.toUser
      }));
    }
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_profile_link":231,"react":"react"}],176:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_book_update = require("../social_book_update");

var _social_book_update2 = _interopRequireDefault(_social_book_update);

var _recommendation_header = require("./recommendation_header");

var _recommendation_header2 = _interopRequireDefault(_recommendation_header);

var _recommendation_details = require("./recommendation_details");

var _recommendation_details2 = _interopRequireDefault(_recommendation_details);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RecommendationNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      book: _gr_prop_types2.default.book().isRequired
    }).isRequired
  },

  renderRecommendationDetails: function renderRecommendationDetails() {
    return _jsx(_recommendation_details2.default, {
      message: this.props.resource.message
    });
  },
  renderBookBody: function renderBookBody() {
    return _jsx("div", {}, void 0, _jsx(_book_description2.default, {
      className: "u-marginTopXSmall",
      bookDescription: this.props.resource.book.description
    }));
  },
  render: function render() {
    var resource = this.props.resource;
    var header = _jsx(_recommendation_header2.default, {
      recommendedToYou: resource.recommendedToYou,
      toUser: resource.toUser
    });

    if (this.props.resource.message) {
      var recommendationDetails = _jsx(_recommendation_details2.default, {
        message: this.props.resource.message
      });
      return _react2.default.createElement(_social_book_update2.default, _extends({
        header: header,
        book: this.props.resource.book,
        bookBody: this.renderBookBody(),
        updateDetails: recommendationDetails,
        showBookBorder: true,
        additionalFooterLinks: [_jsx(_preview_book2.default, {
          book: this.props.resource.book
        })]
      }, this.props));
    } else {
      return _react2.default.createElement(_social_book_update2.default, _extends({
        header: header,
        book: this.props.resource.book,
        additionalFooterLinks: [_jsx(_preview_book2.default, {
          book: this.props.resource.book
        })],
        bookBody: null,
        updateDetails: null
      }, this.props));
    }
  }
});

},{"../../book_description":75,"../../gr_component_factory":108,"../../preview_book/preview_book":200,"../../shared/gr_prop_types":221,"../social_book_update":187,"./recommendation_details":174,"./recommendation_header":175,"react":"react"}],177:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RecommendationRequestDetails",

  propTypes: {
    body: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    user: _gr_prop_types2.default.user().isRequired
  },

  renderRecommendButton: function renderRecommendButton() {
    return _jsx("a", {
      href: this.props.url,
      className: "gr-button u-marginTopMedium u-marginBottomMedium",
      "aria-label": "Recommend a book for " + this.props.user.viewableName
    }, void 0, "Recommend a book");
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, _jsx("div", {
      className: "gr-newsfeed u-defaultType"
    }, void 0, this.props.body), this.renderRecommendButton());
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"react":"react"}],178:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _recommendation_request_details = require("./recommendation_request_details");

var _recommendation_request_details2 = _interopRequireDefault(_recommendation_request_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RecommendationRequestNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      body: _react2.default.PropTypes.string.isRequired,
      url: _react2.default.PropTypes.string.isRequired,
      user: _gr_prop_types2.default.user().isRequired
    })
  },

  render: function render() {
    var body = _react2.default.createElement(_recommendation_request_details2.default, this.props.resource);
    return _react2.default.createElement(_social_update2.default, _extends({
      header: _jsx("span", {}, void 0, "is looking for a book recommendation"),
      body: body
    }, this.props));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../social_update":188,"./recommendation_request_details":177,"react":"react"}],179:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _review_meta_details = require("./review_meta_details");

var _review_meta_details2 = _interopRequireDefault(_review_meta_details);

var _spoiler = require("../../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReviewDetails",

  propTypes: {
    readText: _react2.default.PropTypes.string,
    rating: _react2.default.PropTypes.number,
    user: _gr_prop_types2.default.user().isRequired,
    reviewUrl: _react2.default.PropTypes.string.isRequired,
    reviewBody: _react2.default.PropTypes.shape(_gr_prop_types2.default.truncatedHtml()),
    reviewSpoilerFlag: _react2.default.PropTypes.bool
  },

  renderReadText: function renderReadText() {
    return this.props.readText ? _jsx("div", {
      className: "gr-newsfeedItem__readCountText"
    }, void 0, this.props.readText) : null;
  },
  renderRating: function renderRating() {
    return this.props.rating > 0 ? _jsx("span", {
      className: "u-marginRightTiny"
    }, void 0, _jsx("span", {}, void 0, "Rating "), _jsx(_community_rating2.default, {
      className: "u-inlineBlock",
      rating: this.props.rating,
      size: _community_rating2.default.ICON_SIZES.MEDIUM
    })) : null;
  },
  renderReviewLink: function renderReviewLink() {
    return _jsx("a", {
      href: this.props.reviewUrl,
      className: "gr-hyperlink"
    }, void 0, "Read ", this.props.user.viewableName, "’s review");
  },
  renderSpoilerWarning: function renderSpoilerWarning() {
    return _jsx("span", {
      className: "gr-newsfeedItem__reviewText__spoilerWarning"
    }, void 0, "This review contains spoilers…");
  },
  renderReviewBody: function renderReviewBody() {
    var reviewBody = _react2.default.createElement(_expandable_html2.default, this.props.reviewBody);
    if (this.props.reviewSpoilerFlag) {
      return _jsx(_spoiler2.default, {
        spoilerWarning: this.renderSpoilerWarning()
      }, void 0, reviewBody);
    } else {
      return reviewBody;
    }
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderReadText(), _jsx("div", {
      className: "gr-metaText u-marginBottomXSmall"
    }, void 0, this.renderRating(), this.renderReviewLink()), _react2.default.createElement(_review_meta_details2.default, this.props), _jsx("div", {
      className: "gr-newsfeedItem__reviewText"
    }, void 0, this.renderReviewBody()));
  }
});

},{"../../community_rating":99,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"../../user_content/spoiler":234,"./review_meta_details":181,"react":"react"}],180:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReviewHeader",

  propTypes: {
    headerText: _react2.default.PropTypes.string.isRequired,
    rating: _react2.default.PropTypes.number,
    book: _gr_prop_types2.default.book().isRequired,
    reviewBodyPresent: _react2.default.PropTypes.bool.isRequired
  },

  renderHeaderWithoutRating: function renderHeaderWithoutRating() {
    return _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: this.props.book.bookUrl
    }, void 0, this.props.book.title);
  },
  renderHeaderWithRating: function renderHeaderWithRating() {
    return _jsx("span", {}, void 0, this.props.rating > 0 ? _jsx(_community_rating2.default, {
      className: "u-inlineBlock",
      rating: this.props.rating,
      size: _community_rating2.default.ICON_SIZES.MEDIUM
    }) : null);
  },
  render: function render() {
    return _jsx("span", {}, void 0, _jsx("span", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, this.props.headerText), this.props.reviewBodyPresent ? this.renderHeaderWithoutRating() : this.renderHeaderWithRating());
  }
});

},{"../../community_rating":99,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"react":"react"}],181:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _dot_separated_elements = require("../../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReviewMetaDetails",

  propTypes: {
    readAtText: _react2.default.PropTypes.string,
    recommendedByUser: _gr_prop_types2.default.user()
  },

  renderReaderText: function renderReaderText() {
    return this.props.readAtText ? this.props.readAtText : null;
  },
  renderRecommendedByUserInfo: function renderRecommendedByUserInfo() {
    return this.props.recommendedByUser ? _jsx("span", {}, void 0, "Recommended by ", _jsx(_user_profile_link2.default, {
      user: this.props.recommendedByUser
    })) : null;
  },
  getReviewDetailElements: function getReviewDetailElements() {
    return (0, _lodash.compact)([this.renderReaderText(), this.renderRecommendedByUserInfo()]);
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-metaText"
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: this.getReviewDetailElements()
    }));
  }
});

},{"../../dot_separated_elements":102,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_profile_link":231,"lodash":"lodash","react":"react"}],182:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_book_update = require("../social_book_update");

var _social_book_update2 = _interopRequireDefault(_social_book_update);

var _review_header = require("./review_header");

var _review_header2 = _interopRequireDefault(_review_header);

var _review_details = require("./review_details");

var _review_details2 = _interopRequireDefault(_review_details);

var _review_meta_details = require("./review_meta_details");

var _review_meta_details2 = _interopRequireDefault(_review_meta_details);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReviewNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      book: _gr_prop_types2.default.book().isRequired
    }).isRequired
  },

  // Helper method to determine if review body is present
  reviewBodyPresent: function reviewBodyPresent() {
    return !(0, _lodash.isEmpty)(this.props.resource.reviewBody);
  },

  // When review body is not present:
  // - Display meta details in book body
  renderBookBody: function renderBookBody() {
    return _jsx("div", {}, void 0, !this.reviewBodyPresent() ? _jsx(_review_meta_details2.default, {
      readAtText: this.props.resource.readAtText,
      recommendedByUser: this.props.resource.recommendedByUser
    }) : null, _jsx(_book_description2.default, {
      className: "u-marginTopXSmall",
      bookDescription: this.props.resource.book.description
    }));
  },
  renderReadText: function renderReadText(review) {
    return review.readText ? _jsx("div", {
      className: "gr-newsfeedItem__readCountText"
    }, void 0, review.readText) : null;
  },
  render: function render() {
    var review = this.props.resource;
    var header = _jsx(_review_header2.default, {
      headerText: review.headerText,
      rating: review.rating,
      book: this.props.resource.book,
      reviewBodyPresent: this.reviewBodyPresent()
    });

    var bookBody = this.renderBookBody();
    var updateDetails = null;

    if (review.reviewBody) {
      updateDetails = _jsx(_review_details2.default, {
        reviewBody: review.reviewBody,
        reviewSpoilerFlag: review.spoilerFlag,
        rating: review.rating,
        readText: review.readText,
        recommendedByUser: review.recommendedByUser,
        readAtText: review.readAtText,
        reviewUrl: this.props.resourceUrl,
        user: review.user
      });
    } else {
      updateDetails = this.renderReadText(review);
    }

    return _react2.default.createElement(_social_book_update2.default, _extends({
      header: header,
      book: this.props.resource.book,
      bookBody: bookBody,
      updateDetails: updateDetails,
      showBookBorder: !(0, _lodash.isNull)(updateDetails),
      additionalFooterLinks: [_jsx(_preview_book2.default, {
        book: this.props.resource.book
      })]
    }, this.props));
  }
});

},{"../../book_description":75,"../../gr_component_factory":108,"../../preview_book/preview_book":200,"../../shared/gr_prop_types":221,"../social_book_update":187,"./review_details":179,"./review_header":180,"./review_meta_details":181,"lodash":"lodash","react":"react"}],183:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Displays a row of books with an overlay on the last book displaying the number
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            of additional books. Only used for the UserChallenge (reading challenge) and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            ReadingYear (your year in books) updates
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_DISPLAYED_BOOKS = undefined;

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_DISPLAYED_BOOKS = exports.MAX_DISPLAYED_BOOKS = 4;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookCoverRow",
  propTypes: {
    numBooksRead: React.PropTypes.number.isRequired,
    books: React.PropTypes.arrayOf(_gr_prop_types2.default.book()),
    url: React.PropTypes.string.isRequired
  },

  isLastBook: function isLastBook(index) {
    if (this.props.books.length <= MAX_DISPLAYED_BOOKS) {
      return index === this.props.books.length - 1;
    } else {
      return index === MAX_DISPLAYED_BOOKS - 1;
    }
  },
  shouldRenderLastBookCoverOverlay: function shouldRenderLastBookCoverOverlay(index) {
    return this.isLastBook(index) && this.props.numBooksRead > MAX_DISPLAYED_BOOKS;
  },
  getBookCoverRowClasses: function getBookCoverRowClasses(index) {
    return (0, _classnames2.default)("bookCoverRow__image", { bookCoverRow__lastCompletedBookOverlay: this.shouldRenderLastBookCoverOverlay(index) });
  },
  getBookImageClasses: function getBookImageClasses(index) {
    return (0, _classnames2.default)("gr-book__image", { "gr-book__image--noRightMargin": this.isLastBook(index) });
  },
  renderLastBookCoverOverlay: function renderLastBookCoverOverlay() {
    return _jsx("div", {
      className: "bookCoverRow__leftoverBookCount"
    }, void 0, "+" + (this.props.numBooksRead - MAX_DISPLAYED_BOOKS));
  },
  render: function render() {
    var _this = this;

    return _jsx("div", {
      className: "bookCoverRow"
    }, void 0, (0, _lodash.map)((0, _lodash.take)(this.props.books, MAX_DISPLAYED_BOOKS), function (book, i) {
      var bookImageUrl = _this.shouldRenderLastBookCoverOverlay(i) ? _this.props.url : book.bookUrl;
      return _jsx("a", {
        href: bookImageUrl
      }, book.bookId, _jsx("div", {
        className: _this.getBookCoverRowClasses(i)
      }, void 0, _jsx("img", {
        alt: book.title,
        className: _this.getBookImageClasses(i),
        src: book.imageUrl
      }), _this.shouldRenderLastBookCoverOverlay(i) ? _this.renderLastBookCoverOverlay() : null));
    }));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"classnames":"classnames","lodash":"lodash"}],184:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Displays a user's average rating and currently reading book in newsfeed item
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            bodies. Currently used in Friend and UserFollowing updates.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserRatingAndCurrentlyReading",

  propTypes: {
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: _gr_prop_types2.default.book()
  },

  renderRatingDetailsText: function renderRatingDetailsText() {
    if (this.props.ratingDetailsText) {
      return _jsx("div", {
        className: "gr-newsfeedItem__ratingDetailsText u-defaultType"
      }, void 0, this.props.ratingDetailsText);
    } else {
      return null;
    }
  },
  renderCurrentlyReadingBook: function renderCurrentlyReadingBook() {
    if (this.props.currentlyReadingBook) {
      return _jsx("div", {
        className: "gr-metaText u-marginTopXSmall"
      }, void 0, "Currently Reading:", _jsx("a", {
        href: this.props.currentlyReadingBook.bookUrl,
        className: "gr-hyperlink gr-hyperlink--bold gr-newsfeedItem__currentlyReadingBookTitleLink"
      }, void 0, this.props.currentlyReadingBook.title));
    } else {
      return null;
    }
  },
  render: function render() {
    if (this.props.ratingDetailsText || this.props.currentlyReadingBook) {
      return _jsx("div", {}, void 0, this.renderRatingDetailsText(), this.renderCurrentlyReadingBook());
    } else {
      return null;
    }
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"react":"react"}],185:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_book_update = require("../social_book_update");

var _social_book_update2 = _interopRequireDefault(_social_book_update);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _sharing_nonbook_details = require("./sharing_nonbook_details");

var _sharing_nonbook_details2 = _interopRequireDefault(_sharing_nonbook_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SharingNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      sharingText: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml()),
      sharingResource: _react2.default.PropTypes.shape({
        resourceType: _react2.default.PropTypes.string.isRequired,
        resourceTypeFriendlyText: _react2.default.PropTypes.string.isRequired,
        item: _react2.default.PropTypes.object.isRequired
      }).isRequired,
      user: _gr_prop_types2.default.user().isRequired
    }).isRequired
  },

  renderHeader: function renderHeader() {
    var sharingResourceHeader = undefined;
    var sharingResource = this.props.resource.sharingResource;
    if (sharingResource.resourceType === "Book") {
      sharingResourceHeader = _jsx("a", {
        className: "gr-hyperlink gr-hyperlink--bold",
        href: sharingResource.item.bookUrl
      }, void 0, sharingResource.item.title);
    } else if (sharingResource.resourceType === "Topic") {
      var group = sharingResource.item.group;
      sharingResourceHeader = _jsx("span", {}, void 0, "this " + sharingResource.resourceTypeFriendlyText + " in ", _jsx("a", {
        "aria-label": "Go to group " + group.name,
        className: "gr-hyperlink gr-hyperlink--bold",
        href: group.url
      }, void 0, group.name));
    } else {
      sharingResourceHeader = _jsx("span", {}, void 0, "this ", sharingResource.resourceTypeFriendlyText);
    }
    return _jsx("span", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "shared ", sharingResourceHeader);
  },
  renderSharingText: function renderSharingText() {
    if (this.props.resource.sharingText) {
      return _jsx("div", {
        className: "feedItemSharingText"
      }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.resource.sharingText));
    } else {
      return null;
    }
  },
  renderNonBookBody: function renderNonBookBody() {
    return _jsx("div", {
      className: "gr-newsfeedItem__sharingNonBookBody"
    }, void 0, this.renderSharingText(), _react2.default.createElement(_sharing_nonbook_details2.default, this.props.resource.sharingResource));
  },
  render: function render() {
    var header = this.renderHeader();
    if (this.props.resource.sharingResource.resourceType == "Book") {
      return _react2.default.createElement(_social_book_update2.default, _extends({
        header: header,
        book: this.props.resource.sharingResource.item,
        updateDetails: this.renderSharingText(),
        showBookBorder: true,
        additionalFooterLinks: [_jsx(_preview_book2.default, {
          book: this.props.resource.sharingResource.item
        })]
      }, this.props));
    } else {
      return _react2.default.createElement(_social_update2.default, _extends({
        header: header,
        body: this.renderNonBookBody()
      }, this.props));
    }
  }
});

},{"../../gr_component_factory":108,"../../preview_book/preview_book":200,"../../shared/gr_prop_types":221,"../../user_content/expandable_html":232,"../social_book_update":187,"../social_update":188,"./sharing_nonbook_details":186,"react":"react"}],186:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This component handles the logic to determine sharing story content for non-book sharing resources
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Sharing details refer to content rendered in the body of the sharing story, specific to the shared resource
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This does not include the story header or sharing text
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Sharing details for certain resource types may necessitate the creation of new react components that can be rendered here
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             SharingNonBookDetails is rendered in the renderNonBookBody() method of SharingNewsfeedItem
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The content generated in renderNonBookBody() is used as the SocialUpdate body prop
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _group_discussion_newsfeed_item_body = require("../group_discussion/group_discussion_newsfeed_item_body");

var _group_discussion_newsfeed_item_body2 = _interopRequireDefault(_group_discussion_newsfeed_item_body);

var _blog_newsfeed_item_body = require("../editorial/blog_newsfeed_item_body");

var _blog_newsfeed_item_body2 = _interopRequireDefault(_blog_newsfeed_item_body);

var _interview_newsfeed_item_body = require("../editorial/interview_newsfeed_item_body");

var _interview_newsfeed_item_body2 = _interopRequireDefault(_interview_newsfeed_item_body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SharingNonBookDetails",

  propTypes: {
    resourceType: _react.PropTypes.string.isRequired,
    resourceTypeFriendlyText: _react.PropTypes.string.isRequired,
    item: _react.PropTypes.object
  },

  render: function render() {
    var classnames = "gr-newsfeedItem__details gr-newsfeedItem__details--belowContent gr-newsfeedItem__details--border";
    switch (this.props.resourceType) {
      case "Group":
        return _jsx("div", {
          className: classnames
        });
      case "Genre":
        return _jsx("div", {
          className: classnames
        });
      case "Topic":
        return _jsx("div", {
          className: classnames
        }, void 0, React.createElement(_group_discussion_newsfeed_item_body2.default, this.props.item));
      case "Blog":
        {
          var _classnames = "gr-newsfeedItem__details";
          return _jsx("div", {
            className: _classnames
          }, void 0, React.createElement(_blog_newsfeed_item_body2.default, this.props.item));
        }
      case "Interview":
        {
          var _classnames2 = "gr-newsfeedItem__details";
          return _jsx("div", {
            className: _classnames2
          }, void 0, React.createElement(_interview_newsfeed_item_body2.default, this.props.item));
        }
      default:
        break;
    }
  }
});

},{"../../gr_component_factory":108,"../editorial/blog_newsfeed_item_body":147,"../editorial/interview_newsfeed_item_body":150,"../group_discussion/group_discussion_newsfeed_item_body":159,"react":"react"}],187:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("./social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _book_with_wtr_button = require("../book_with_wtr_button");

var _book_with_wtr_button2 = _interopRequireDefault(_book_with_wtr_button);

var _book_description = require("../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _book = require("../book");

var _book2 = _interopRequireDefault(_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SocialBookUpdate",
  /*
    Prop Types:
    header: A React element that is rendered in the header portion of the newsfeed
      update.
    bookBody: A React element that is rendered underneath the WTR button in the
      Book + WTR Button portion of the newsfeed update body.
    updateDetails: A React element that is rendered above the Book + WTR Button
      portion of the newsfeed update body.
  */
  propTypes: {
    header: _react2.default.PropTypes.element.isRequired,
    book: _gr_prop_types2.default.book().isRequired,
    bookBody: _react2.default.PropTypes.element,
    bookLabel: _react2.default.PropTypes.element,
    updateDetails: _react2.default.PropTypes.element,
    additionalFooterLinks: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element),
    showBookBorder: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      includeWTR: true,
      showBookBorder: false
    };
  },
  renderBookBody: function renderBookBody() {
    if (this.props.bookBody) {
      return this.props.bookBody;
    } else {
      return _jsx(_book_description2.default, {
        className: "u-marginTopXSmall",
        bookDescription: this.props.book.description
      });
    }
  },
  renderUpdateDetails: function renderUpdateDetails() {
    if (this.props.updateDetails) {
      return _jsx("div", {
        className: "gr-newsfeedItem__socialBookUpdateDetails"
      }, void 0, this.props.updateDetails);
    } else {
      return null;
    }
  },
  renderBody: function renderBody() {
    var bookClassName = (0, _classnames2.default)({ "gr-book--border": this.props.showBookBorder });
    return _jsx("div", {}, void 0, this.renderUpdateDetails(), this.props.includeWTR ? _react2.default.createElement(_book_with_wtr_button2.default, _extends({}, this.props, { bookClassName: bookClassName, body: this.renderBookBody() })) : _react2.default.createElement(
      _book2.default,
      _extends({}, this.props.book, {
        className: this.props.bookClassName,
        label: this.props.bookLabel,
        size: _book.VALID_BOOK_SIZES.LARGE }),
      this.renderBookBody()
    ));
  },
  render: function render() {
    return _react2.default.createElement(_social_update2.default, _extends({}, this.props, {
      header: this.props.header,
      body: this.renderBody()
    }));
  }
});

},{"../book":73,"../book_description":75,"../book_with_wtr_button":76,"../gr_component_factory":108,"../shared/gr_prop_types":221,"./social_update":188,"classnames":"classnames","react":"react"}],188:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

var _newsfeed_item_header_timestamp = require("./newsfeed_item_header_timestamp");

var _newsfeed_item_header_timestamp2 = _interopRequireDefault(_newsfeed_item_header_timestamp);

var _newsfeed_item_footer = require("./footer/newsfeed_item_footer");

var _newsfeed_item_footer2 = _interopRequireDefault(_newsfeed_item_footer);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SocialUpdate",

  propTypes: {
    header: _react2.default.PropTypes.element,
    body: _react2.default.PropTypes.element.isRequired,
    resource: _react2.default.PropTypes.object.isRequired,
    additionalFooterLinks: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      header: null,
      isChildNewsfeedItem: false
    };
  },
  renderHeader: function renderHeader() {
    var resourceUser = this.props.resource.user;
    if (resourceUser) {
      return _jsx("div", {
        className: "gr-newsfeedItem__header gr-newsfeedItem__header--timestamp"
      }, void 0, _jsx(_user_profile_link2.default, {
        user: resourceUser,
        className: "u-marginRightTiny"
      }), this.props.header);
    }
  },
  renderHeaderIcon: function renderHeaderIcon() {
    var resourceUser = this.props.resource.user;
    if (resourceUser) {
      return _jsx("div", {
        className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
      }, void 0, _jsx(_user_icon2.default, {
        user: resourceUser,
        size: _shape_icon_values.ICON_SIZES.MEDIUM
      }));
    }
  },
  render: function render() {
    var newsfeedItemClasses = (0, _classnames2.default)("gr-newsfeedItem", "gr-mediaBox", { "gr-childNewsfeedItemContainer": this.props.isChildNewsfeedItem });

    return _jsx("div", {
      className: newsfeedItemClasses
    }, void 0, this.renderHeaderIcon(), _jsx("div", {
      className: "gr-mediaBox__desc gr-newsfeedItem__body"
    }, void 0, this.renderHeader(), _jsx(_newsfeed_item_header_timestamp2.default, {
      time: this.props.updatedAt,
      resourceDisplayName: this.props.resourceDisplayName,
      resourceUrl: this.props.resourceUrl
    }), this.props.body), _jsx(_newsfeed_item_footer2.default, {
      user: this.props.user,
      like: this.props.social.liking,
      comment: this.props.social.commenting,
      book: this.props.book,
      additionalFooterLinks: this.props.additionalFooterLinks
    }));
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":108,"../user/user_icon":230,"../user/user_profile_link":231,"./footer/newsfeed_item_footer":151,"./newsfeed_item_header_timestamp":164,"classnames":"classnames","react":"react"}],189:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * This component displays a resource image to the left and any of the children
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * passed to it on the right.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * ## Props
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * ### Required
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * `customIcon` or `image` : must supply either a valid rendering block or an image url.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * If supplying `customIcon`, the resource is assumed to render itself as desired.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * If supplying `image`, a url must be passed in for the image. An `altText` attribute
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * should be supplied unless the image is merely decorative [1]. An optional
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * `linkUrl` can be passed in to make the image a hyperlink, in which case
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * `altText` is mandatory; if not supplied, link will not be rendered.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *  [1] https://w.amazon.com/index.php/Goodreads/Engineering/Web/Accessibility
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * ### Optional
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * `imageClass` : an extra class to apply to the image
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SocialUpdateBody",

  propTypes: {
    customIcon: _react2.default.PropTypes.element,
    image: _react2.default.PropTypes.shape({
      altText: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string.isRequired,
      linkUrl: _react2.default.PropTypes.string
    }),
    imageClass: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { imageClass: "gr-socialUpdateBody__circleImage" };
  },
  hasAltText: function hasAltText() {
    return !_lodash2.default.isEmpty(this.props.image.altText);
  },
  imgAltText: function imgAltText() {
    if (this.hasAltText()) {
      return this.props.image.altText;
    } else {
      return "";
    }
  },
  renderImage: function renderImage() {
    if (this.props.customIcon) {
      return this.props.customIcon;
    } else {
      if (this.props.image.linkUrl && this.hasAltText()) {
        return _jsx("a", {
          href: this.props.image.linkUrl
        }, void 0, this.renderImageElement());
      } else {
        return this.renderImageElement();
      }
    }
  },
  renderImageElement: function renderImageElement() {
    return _jsx("img", {
      alt: this.imgAltText(),
      className: this.props.imageClass,
      src: this.props.image.url
    });
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-mediaBox gr-socialUpdateBody"
    }, void 0, _jsx("div", {
      className: "gr-socialUpdateBody__image gr-mediaBox__media"
    }, void 0, this.renderImage()), _jsx("div", {
      className: "gr-mediaBox__desc gr-socialUpdateBody__additionalContent"
    }, void 0, this.props.children));
  }
});

},{"../gr_component_factory":108,"lodash":"lodash","react":"react"}],190:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _user_rating_and_currently_reading = require("../shared/user_rating_and_currently_reading");

var _user_rating_and_currently_reading2 = _interopRequireDefault(_user_rating_and_currently_reading);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserFollowingDetails",

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    followingUser: _gr_prop_types2.default.user().isRequired,
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: _gr_prop_types2.default.book()
  },

  render: function render() {
    var user = this.props.followingUser;
    return _jsx("div", {
      className: "gr-newsfeedItem__details"
    }, void 0, _jsx("a", {
      href: user.profileUrl,
      className: "gr-newsfeedItem__resourceNameLink"
    }, void 0, user.viewableName), _jsx(_user_rating_and_currently_reading2.default, {
      ratingDetailsText: this.props.ratingDetailsText,
      currentlyReadingBook: this.props.currentlyReadingBook
    }), _jsx("div", {}, void 0, _jsx("a", {
      href: this.props.followingUser.profileUrl,
      className: "gr-button u-marginTopMedium"
    }, void 0, "View Profile")));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../shared/user_rating_and_currently_reading":184,"react":"react"}],191:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _user_following_details = require("./user_following_details");

var _user_following_details2 = _interopRequireDefault(_user_following_details);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserFollowingNewsfeedItem",

  propTypes: {
    resource: _gr_prop_types2.default.userFollowingNewsfeedResource()
  },

  render: function render() {
    var icon = _jsx(_user_icon2.default, {
      user: this.props.resource.followingUser,
      size: _shape_icon_values.ICON_SIZES.LARGE
    });
    var body = _jsx(_social_update_body2.default, {
      customIcon: icon
    }, void 0, React.createElement(_user_following_details2.default, this.props.resource));

    return React.createElement(_social_update2.default, _extends({
      header: _jsx("span", {}, void 0, "is now following:"),
      body: body
    }, this.props));
  }
});

},{"../../../modules/shape_icon_values":19,"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user/user_icon":230,"../social_update":188,"../social_update_body":189,"./user_following_details":190}],192:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserQuoteHeader",

  propTypes: {
    quote: _gr_prop_types2.default.quote().isRequired
  },

  getQuoteAuthor: function getQuoteAuthor(quote) {
    return (0, _lodash.merge)({}, quote.author, {
      viewableName: quote.author.name
    });
  },
  render: function render() {
    var quote = this.props.quote;
    var quoteAuthor = this.getQuoteAuthor(quote);

    return _jsx("div", {}, void 0, React.createElement(_truncated_html2.default, _extends({}, quote.body, { html: "“" + quote.body.html + "”" })), _jsx("div", {}, void 0, _jsx("a", {
      href: quoteAuthor.profileUrl,
      className: "gr-book gr-book__authorLink gr-hyperlink gr-hyperlink--bold"
    }, void 0, quoteAuthor.viewableName)));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"../../user_content/truncated_html":235,"lodash":"lodash"}],193:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserQuoteHeader",

  propTypes: {
    quoteUrl: _react2.default.PropTypes.string.isRequired,
    quoteLiked: _react2.default.PropTypes.bool.isRequired
  },

  getHeaderTextPrefix: function getHeaderTextPrefix() {
    return this.props.quoteLiked ? "liked a" : "shared a";
  },
  render: function render() {
    return _jsx("span", {}, void 0, this.getHeaderTextPrefix(), " ", _jsx("a", {
      href: this.props.quoteUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, "quote"));
  }
});

},{"../../gr_component_factory":108,"react":"react"}],194:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _social_update = require("../social_update");

var _social_update2 = _interopRequireDefault(_social_update);

var _social_update_body = require("../social_update_body");

var _social_update_body2 = _interopRequireDefault(_social_update_body);

var _user_quote_header = require("./user_quote_header");

var _user_quote_header2 = _interopRequireDefault(_user_quote_header);

var _user_quote_body = require("./user_quote_body");

var _user_quote_body2 = _interopRequireDefault(_user_quote_body);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserQuoteNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.object.isRequired
  },

  getQuoteUser: function getQuoteUser(quote) {
    return (0, _lodash.merge)({}, quote.author, {
      viewableName: quote.author.name
    });
  },
  renderBody: function renderBody() {
    var quote = this.props.resource.quote;
    var icon = _jsx(_user_icon2.default, {
      user: this.getQuoteUser(quote),
      size: _shape_icon_values.ICON_SIZES.LARGE
    });

    return _jsx(_social_update_body2.default, {
      customIcon: icon
    }, void 0, _jsx(_user_quote_body2.default, {
      quote: quote
    }));
  },
  getFooterLinks: function getFooterLinks() {
    var quote = this.props.resource.quote;
    return [_jsx("a", {
      href: quote.quotesAuthorUrl,
      className: "gr-hyperlink"
    }, void 0, "More quotes by ", quote.author.name)];
  },
  render: function render() {
    var header = _jsx(_user_quote_header2.default, {
      quoteUrl: this.props.resource.quote.url,
      quoteLiked: this.props.resource.liked
    });
    return _react2.default.createElement(_social_update2.default, _extends({ header: header,
      body: this.renderBody(),
      additionalFooterLinks: this.getFooterLinks()
    }, this.props));
  }
});

},{"../../../modules/shape_icon_values":19,"../../gr_component_factory":108,"../../user/user_icon":230,"../social_update":188,"../social_update_body":189,"./user_quote_body":192,"./user_quote_header":193,"lodash":"lodash","react":"react"}],195:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_status_helper = require("../../../modules/user_status_helper");

var _progress_bar = require("../../progress_bar");

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROGRESS_BAR_WIDTH = 124;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserStatusDetails",

  propTypes: {
    maxProgressValue: _react2.default.PropTypes.number,
    progressValue: _react2.default.PropTypes.number.isRequired,
    userStatusText: _react2.default.PropTypes.string,
    pageProgressText: _react2.default.PropTypes.string,
    readText: _react2.default.PropTypes.string
  },

  getUserStatusHtml: function getUserStatusHtml() {
    return { __html: this.props.userStatusText };
  },
  renderReadText: function renderReadText() {
    return this.props.readText ? _jsx("div", {
      className: "gr-newsfeedItem__readCountText"
    }, void 0, this.props.readText) : null;
  },
  renderProgressBar: function renderProgressBar() {
    if ((0, _user_status_helper.isDisplayableAsPercent)(this.props)) {
      return _jsx(_progress_bar2.default, {
        max: this.props.maxProgressValue,
        width: PROGRESS_BAR_WIDTH,
        value: this.props.progressValue,
        progressText: this.props.pageProgressText
      });
    } else {
      return _jsx("small", {}, void 0, this.props.pageProgressText);
    }
  },
  render: function render() {
    var detailsClassName = (0, _classnames2.default)({ "u-paddingBottomSmall u-bottomGrayBorder": !this.props.userStatusText });
    return _jsx("div", {
      className: detailsClassName
    }, void 0, this.renderReadText(), this.renderProgressBar(), this.props.userStatusText ? _jsx("div", {
      className: "gr-newsfeedItem__userStatusText",
      dangerouslySetInnerHTML: this.getUserStatusHtml()
    }) : null);
  }
});

},{"../../../modules/user_status_helper":23,"../../gr_component_factory":108,"../../progress_bar":204,"classnames":"classnames","react":"react"}],196:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserStatusHeader",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    headerText: _react2.default.PropTypes.string
  },

  render: function render() {
    return _jsx("span", {}, void 0, this.props.headerText, _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: this.props.book.bookUrl
    }, void 0, this.props.book.title));
  }
});

},{"../../gr_component_factory":108,"../../shared/gr_prop_types":221,"react":"react"}],197:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _social_book_update = require("../social_book_update");

var _social_book_update2 = _interopRequireDefault(_social_book_update);

var _user_status_header = require("./user_status_header");

var _user_status_header2 = _interopRequireDefault(_user_status_header);

var _user_status_details = require("./user_status_details");

var _user_status_details2 = _interopRequireDefault(_user_status_details);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserStatusNewsfeedItem",

  propTypes: {
    resource: _react2.default.PropTypes.shape({
      book: _gr_prop_types2.default.book().isRequired
    }).isRequired
  },

  hasStatusText: function hasStatusText() {
    return !(0, _lodash.isEmpty)(this.props.resource.userStatusText);
  },
  renderBookBody: function renderBookBody() {
    return _jsx("div", {}, void 0, _jsx(_book_description2.default, {
      className: "u-marginTopXSmall",
      bookDescription: this.props.resource.book.description
    }));
  },
  render: function render() {
    var resource = this.props.resource;
    var header = _jsx(_user_status_header2.default, {
      book: this.props.resource.book,
      headerText: resource.headerText
    });

    return _react2.default.createElement(_social_book_update2.default, _extends({
      header: header,
      book: this.props.resource.book,
      bookBody: this.renderBookBody(),
      updateDetails: _react2.default.createElement(_user_status_details2.default, resource),
      additionalFooterLinks: [_jsx(_preview_book2.default, {
        book: this.props.resource.book
      })],
      showBookBorder: this.hasStatusText()
    }, this.props));
  }
});

},{"../../book_description":75,"../../gr_component_factory":108,"../../preview_book/preview_book":200,"../../shared/gr_prop_types":221,"../social_book_update":187,"./user_status_details":195,"./user_status_header":196,"lodash":"lodash","react":"react"}],198:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Renders a set of links for pagination: previous, next, plus some direct page
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           links.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Comes in a default (links) flavor and a "buttons" flavor. The "buttons" flavor,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           activated by passing the `asButtons` prop, was created for GR-42011. The two
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           variants are somewhat arbitrary, and might need revision over time...maybe one
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           becomes a "small"/"one line" variant, and the other becomes a "large"/"multiline"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           variant. Or, ideally, we converge on a single way to display pagination.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _pagination_single_page_link = require("./pagination_single_page_link");

var _pagination_single_page_link2 = _interopRequireDefault(_pagination_single_page_link);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PaginationLinks",

  propTypes: {
    asButtons: _react2.default.PropTypes.bool,
    totalSize: _gr_prop_types2.default.naturalNumber.isRequired,
    currentPageNumber: _react2.default.PropTypes.number.isRequired,
    className: _react2.default.PropTypes.string,
    perPage: _gr_prop_types2.default.naturalNumber.isRequired,
    changePageAction: _react2.default.PropTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { asButtons: false };
  },
  maxPageNumber: function maxPageNumber() {
    return Math.ceil(this.props.totalSize / this.props.perPage);
  },
  renderLinkToPage: function renderLinkToPage(pageNumber) {
    return _jsx(_pagination_single_page_link2.default, {
      pageNumber: pageNumber,
      currentPageNumber: this.props.currentPageNumber,
      changePageAction: this.props.changePageAction
    }, pageNumber);
  },
  renderPageLinks: function renderPageLinks() {
    var _this = this;

    var numPages = this.maxPageNumber();
    if (numPages !== 1) {
      if (numPages <= 6) {
        return _jsx("span", {
          className: "gr-paginationLinks__pageLinksWrapper"
        }, void 0, _lodash2.default.times(numPages, function (n) {
          return _this.renderLinkToPage(n + 1);
        }));
      } else {
        if (this.props.currentPageNumber <= 3) {
          // Render links for the the first four pages, then ellipsis, then the last page
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, _lodash2.default.times(4, function (n) {
            return _this.renderLinkToPage(n + 1);
          }), "…", this.renderLinkToPage(this.maxPageNumber()));
        } else if (this.props.currentPageNumber >= this.maxPageNumber() - 3) {
          // First page, ellipsis, last four pages
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, this.renderLinkToPage(1), "…", this.renderLinkToPage(this.maxPageNumber() - 3), this.renderLinkToPage(this.maxPageNumber() - 2), this.renderLinkToPage(this.maxPageNumber() - 1), this.renderLinkToPage(this.maxPageNumber()));
        } else {
          // First page, ellipsis, three middle pages starting from current, ellipsis, last
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, this.renderLinkToPage(1), "…", this.renderLinkToPage(this.props.currentPageNumber), this.renderLinkToPage(this.props.currentPageNumber + 1), this.renderLinkToPage(this.props.currentPageNumber + 2), "…", this.renderLinkToPage(this.maxPageNumber()));
        }
      }
    }
  },
  renderPrevLink: function renderPrevLink() {
    if (this.maxPageNumber() === 1) {
      return null;
    } else {
      var cx = (0, _classnames2.default)({
        "gr-paginationLinks__previousLink": !this.props.asButtons,
        "gr-paginationLinks__previousButton": this.props.asButtons,
        "gr-button": this.props.asButtons,
        "gr-button--large": this.props.asButtons
      });
      return _jsx("button", {
        "aria-label": "Previous page",
        className: cx,
        onClick: this.moveToPrevPage,
        disabled: this.props.currentPageNumber === 1
      }, void 0, "← Previous");
    }
  },
  renderNextLink: function renderNextLink() {
    if (this.maxPageNumber() === 1) {
      return null;
    } else {
      var cx = (0, _classnames2.default)({
        "gr-paginationLinks__nextLink": !this.props.asButtons,
        "gr-paginationLinks__nextButton": this.props.asButtons,
        "gr-button": this.props.asButtons,
        "gr-button--large": this.props.asButtons
      });
      return _jsx("button", {
        "aria-label": "Next page",
        className: cx,
        onClick: this.moveToNextPage,
        disabled: this.props.currentPageNumber === this.maxPageNumber()
      }, void 0, "Next →");
    }
  },
  moveToNextPage: function moveToNextPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.currentPageNumber + 1);
  },
  moveToPrevPage: function moveToPrevPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.currentPageNumber - 1);
  },
  render: function render() {
    var cx = (0, _classnames2.default)("gr-paginationLinks", { "gr-paginationLinks--asButtons": this.props.asButtons }, this.props.className);
    // <div>s around next/prev links so that grid item sizing applied to wrapper
    // instead of the link/buttons themselves
    return _jsx("div", {
      className: cx
    }, void 0, _jsx("span", {
      className: "gr-paginationLinks__previousLinkWrapper"
    }, void 0, this.renderPrevLink()), this.renderPageLinks(), _jsx("span", {
      className: "gr-paginationLinks__nextLinkWrapper"
    }, void 0, this.renderNextLink()));
  }
});

},{"./gr_component_factory":108,"./pagination_single_page_link":199,"./shared/gr_prop_types":221,"classnames":"classnames","lodash":"lodash","react":"react"}],199:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PaginationSinglePageLink",

  propTypes: {
    pageNumber: _react2.default.PropTypes.number,
    currentPageNumber: _react2.default.PropTypes.number,
    changePageAction: _react2.default.PropTypes.func.isRequired
  },

  render: function render() {
    if (this.props.pageNumber === this.props.currentPageNumber) {
      return _jsx("span", {
        "aria-label": this.props.pageNumber + " current page",
        className: "gr-paginationLinks__pageNumLink\n                         gr-paginationLinks__pageNumLink--selected"
      }, void 0, this.props.pageNumber);
    } else {
      return _jsx("button", {
        className: "gr-paginationLinks__pageNumLink",
        onClick: this.jumpToPage
      }, void 0, this.props.pageNumber);
    }
  },
  jumpToPage: function jumpToPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.pageNumber);
  }
});

},{"./gr_component_factory":108,"react":"react"}],200:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayPreviewBookButton = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal_store = require("../../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _newsfeed_actions = require("../../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _report_wrong_book_button = require("./report_wrong_book_button");

var _report_wrong_book_button2 = _interopRequireDefault(_report_wrong_book_button);

var _report_wrong_book_form = require("./report_wrong_book_form");

var _report_wrong_book_form2 = _interopRequireDefault(_report_wrong_book_form);

var _wrong_book_report_acknowledgment = require("./wrong_book_report_acknowledgment");

var _wrong_book_report_acknowledgment2 = _interopRequireDefault(_wrong_book_report_acknowledgment);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldDisplayPreviewBookButton = exports.shouldDisplayPreviewBookButton = function shouldDisplayPreviewBookButton(book, userAgentCapabilities) {
  if (userAgentCapabilities && userAgentCapabilities.touch === true) {
    return false;
  }
  return !!book.kcrPreviewUrl;
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PreviewBook",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.preview_book
    };
  },
  getInitialState: function getInitialState() {
    return {
      previewViewed: false,
      uniqueId: Math.random(1000000)
    };
  },
  getReportWrongBookModalId: function getReportWrongBookModalId() {
    return "report-" + this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  getPreviewModalId: function getPreviewModalId() {
    return this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  getAcknowledgmentModalId: function getAcknowledgmentModalId() {
    return "acknowledge-" + this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  openBookPreview: function openBookPreview() {
    _newsfeed_actions2.default.previewBook();
    this.setState({ previewViewed: true });
  },
  render: function render() {
    var previewBookModalContents = null;
    var wrongBookForm = null;
    var acknowledgmentModal = null;

    var previewModalId = this.getPreviewModalId();
    var reportWrongBookModalId = this.getReportWrongBookModalId();
    var acknowledgmentModalId = this.getAcknowledgmentModalId();

    if (this.state.modalStore.currentActiveModal === previewModalId) {
      previewBookModalContents = _jsx("div", {
        className: "previewBook__container"
      }, void 0, _jsx("div", {
        className: "previewBook__topBanner"
      }, void 0, _jsx("div", {
        className: "previewBook__headerText"
      }, void 0, "Preview - ", _jsx("cite", {}, void 0, this.props.book.title)), _jsx(_report_wrong_book_button2.default, {
        book: this.props.book,
        modalId: reportWrongBookModalId
      })), _jsx("iframe", {
        className: "previewBook__kcrPreview",
        src: this.props.book.kcrPreviewUrl
      }));
    }

    if (this.state.previewViewed) {
      wrongBookForm = _jsx(_report_wrong_book_form2.default, {
        book: this.props.book,
        modalId: reportWrongBookModalId,
        acknowledgmentModalId: acknowledgmentModalId
      });
      acknowledgmentModal = _jsx(_wrong_book_report_acknowledgment2.default, {
        modalId: acknowledgmentModalId
      });
    }
    if (shouldDisplayPreviewBookButton(this.props.book, this.state.userAgentCapabilities)) {
      return _jsx("span", {
        className: "previewBook"
      }, void 0, _jsx(_modal_trigger2.default, {
        id: previewModalId
      }, void 0, _jsx("button", {
        "aria-label": "Preview " + this.props.book.title,
        className: "gr-buttonAsLink\n                             previewBook__openPreview",
        onClick: this.openBookPreview
      }, void 0, "Preview Book")), wrongBookForm, acknowledgmentModal, _jsx(_modal2.default, {
        id: previewModalId,
        bemModifiers: "preview"
      }, void 0, previewBookModalContents));
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../../react_actions/newsfeed_actions":37,"../../react_stores/modal_store":266,"../../react_stores/user_agent_capabilities_store":273,"../gr_component_factory":108,"../modal":126,"../modal_trigger":127,"../shared/gr_prop_types":221,"./report_wrong_book_button":201,"./report_wrong_book_form":202,"./wrong_book_report_acknowledgment":203,"reflux":"reflux"}],201:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the 'Report Wrong Book' button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `book`: Book JSON referring to the book this link lets you preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: ID of the corresponding modal this button opens (ReportWrongBookForm)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReportWrongBookButton",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    modalId: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "previewBook__reportWrongBookButtonContainer"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: this.props.modalId
    }, void 0, _jsx("button", {
      "aria-label": "This is not the right book.",
      className: "gr-buttonAsLink\n                               previewBook__reportWrongBookButton"
    }, void 0, "Not the book you’re looking for?")));
  }
});

},{"../gr_component_factory":108,"../modal_trigger":127,"../shared/gr_prop_types":221,"react":"react"}],202:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the 'Report Wrong Book' form.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `book`: Book JSON referring to the book this link lets you preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: This component expects to be assigned an ID (since it relies on being opened by ReportWrongBookButton)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `acknowledgmentModalId`: The ID of the acknowledgment modal to be displayed if this form is submitted.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FLAG_BOOK_REASONS = {
  wrongBook: "It’s the wrong book",
  wrongEdition: "It’s the wrong edition",
  other: "Other"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReportWrongBookForm",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    modalId: _react2.default.PropTypes.string.isRequired,
    acknowledgmentModalId: _react2.default.PropTypes.string.isRequired
  },

  getAuthorString: function getAuthorString() {
    return "by " + this.props.book.authorName;
  },
  showReportAcknowledgement: function showReportAcknowledgement() {
    _modal_actions2.default.openModal(this.props.acknowledgmentModalId);
  },
  closeModal: function closeModal(ev) {
    ev.preventDefault();
    _modal_actions2.default.closeModal();
  },
  renderWrongBookForm: function renderWrongBookForm() {
    var wrongBookOptions = [];

    _lodash2.default.forEach(FLAG_BOOK_REASONS, function (reasonText, reason) {
      wrongBookOptions.push(_jsx("option", {
        value: reason
      }, reason, reasonText));
    });

    return _jsx("form", {
      className: "previewBook__reportWrongBookForm",
      action: "/kindle_book_mapping_flags",
      "data-remote": "true",
      method: "post"
    }, void 0, "We’d love your help. Let us know what’s wrong with this preview of ", _jsx("cite", {}, void 0, this.props.book.title), this.props.book.authorName ? this.getAuthorString() : "", ".", _jsx("br", {}), _jsx("input", {
      type: "hidden",
      name: "kindle_book_mapping_flag[book_id]",
      value: this.props.book.bookId
    }), _jsx("div", {
      className: "gr-formInputContainer"
    }, void 0, _jsx("label", {
      className: "gr-label",
      htmlFor: "kindle_book_mapping_flag_reason"
    }, void 0, "Problem"), _jsx("select", {
      name: "kindle_book_mapping_flag[reason]",
      id: "kindle_book_mapping_flag_reason"
    }, void 0, wrongBookOptions)), _jsx("div", {
      className: "gr-formInputContainer"
    }, void 0, _jsx("label", {
      className: "gr-label",
      htmlFor: "kindle_book_mapping_flag_other_reason"
    }, void 0, "Details (if other)"), _jsx("input", {
      name: "kindle_book_mapping_flag[other_reason]",
      id: "kindle_book_mapping_flag_other_reason"
    })), _jsx("button", {
      className: "gr-button gr-button--modalPrimaryLeft",
      type: "submit",
      onClick: this.showReportAcknowledgement
    }, void 0, "Report Problem"), _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.closeModal,
      type: "button"
    }, void 0, "Cancel"));
  },
  render: function render() {
    return _jsx(_modal2.default, {
      id: this.props.modalId
    }, void 0, _jsx("h2", {}, void 0, "See a Problem?"), this.renderWrongBookForm());
  }
});

},{"../../react_actions/modal_actions":36,"../gr_component_factory":108,"../modal":126,"../shared/gr_prop_types":221,"lodash":"lodash","react":"react"}],203:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the acknowledgment after reporting a wrong book preview.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: This component expects to be assigned an ID (since it relies on
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        being opened by submitting a wrong book report from the book preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        modal)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WrongBookReportAcknowledgment",

  propTypes: {
    modalId: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "previewBook__wrongBookReportAcknowledgment"
    }, void 0, _jsx(_modal2.default, {
      id: this.props.modalId
    }, void 0, "Thanks for telling us about the problem.", _jsx("div", {}, void 0, _jsx("button", {
      className: "gr-button",
      onClick: _modal_actions2.default.closeModal
    }, void 0, "Close"))));
  }
});

},{"../../react_actions/modal_actions":36,"../gr_component_factory":108,"../modal":126,"react":"react"}],204:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ProgressBar",

  propTypes: {
    value: _react2.default.PropTypes.number.isRequired,
    max: _react2.default.PropTypes.number.isRequired,
    width: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]).isRequired,
    progressText: _react2.default.PropTypes.string
  },

  render: function render() {
    var progressBarContainerStyle = { width: this.props.width };
    return _jsx("div", {
      className: "gr-progressBar",
      "aria-label": this.props["aria-label"]
    }, void 0, _jsx("progress", {
      className: this.withBemModifiers("gr-progressBar__progress"),
      value: this.props.value,
      max: this.props.max,
      style: progressBarContainerStyle,
      role: "progressbar",
      "aria-valuetext": this.props.progressText,
      "aria-valuenow": this.props.value,
      "aria-valuemax": this.props.max
    }), this.props.progressText ? _jsx("span", {
      className: "gr-progressBar__text u-defaultType u-marginLeftSmall"
    }, void 0, this.props.progressText) : this.props.children);
  }
});

},{"./gr_component_factory":108,"react":"react"}],205:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _qualtrics_survey_modal = require("./qualtrics_survey_modal");

var _qualtrics_survey_modal2 = _interopRequireDefault(_qualtrics_survey_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Wrapper component of QualtricsSurveyModal. Adds a couple event listeners
// onto the book show page's nonReact WTR button that fire when a user clicks
// WTR via button or dropdown.
// Note that all it does is render the child modal, which has its own rendering
// logic.
// Also note that this is pretty hacky due to interaction between React and
// nonReact components - pls no copy

var BookShowSurveyModal = (function (_Component) {
  _inherits(BookShowSurveyModal, _Component);

  function BookShowSurveyModal(props) {
    _classCallCheck(this, BookShowSurveyModal);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BookShowSurveyModal).call(this, props));

    _this.state = { renderModal: false };

    _this.handleWTR = _this.handleWTR.bind(_this);
    return _this;
  }

  _createClass(BookShowSurveyModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var button = document.getElementById(this.props.buttonId);
      if (!button) return null;
      // there are two event listeners to add on the WTR button:
      // 1. when the user clicks WTR on the WTR button
      // 2. when the user clicks WTR on the WTR dropdown
      var nodes = button.querySelectorAll("button.wtrExclusiveShelf[value='to-read'], button.wtrToRead[type='submit']");
      [].concat(_toConsumableArray(nodes)).forEach(function (node) {
        return node.addEventListener("click", _this2.handleWTR);
      });
    }
  }, {
    key: "handleWTR",
    value: function handleWTR() {
      var _this3 = this;

      // Hack: set a timeout so you can see that WTR click did something.
      if (!this.state.renderModal) {
        setTimeout(function () {
          return _this3.setState({ renderModal: true });
        }, 2500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.renderModal ? React.createElement(_qualtrics_survey_modal2.default, this.props) : null;
    }
  }]);

  return BookShowSurveyModal;
})(_react.Component);

exports.default = BookShowSurveyModal;

BookShowSurveyModal.propTypes = {
  buttonId: _react.PropTypes.string.isRequired
};

},{"./qualtrics_survey_modal":207,"react":"react"}],206:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _book_show_survey_modal = require("./book_show_survey_modal");

var _book_show_survey_modal2 = _interopRequireDefault(_book_show_survey_modal);

var _qualtrics_survey_modal = require("./qualtrics_survey_modal");

var _qualtrics_survey_modal2 = _interopRequireDefault(_qualtrics_survey_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SURVEY_MAP = {
  signed_in_book_show: _book_show_survey_modal2.default
}; // maps which qualtrics survey goes to which page

var QualtricsSurvey = function QualtricsSurvey(props) {
  var Component = SURVEY_MAP[props.type] || _qualtrics_survey_modal2.default;
  return React.createElement(Component, props);
};

QualtricsSurvey.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(SURVEY_MAP))
};

exports.default = QualtricsSurvey;

},{"./book_show_survey_modal":205,"./qualtrics_survey_modal":207,"react":"react"}],207:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUALTRICS_COOKIE = undefined;

var _react = require("react");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _cookies = require("../shared/cookies");

var _cookies2 = _interopRequireDefault(_cookies);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               React component that renders a survey prompt in a Modal that shows by default,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               and then renders a Qualtrics survey in an iframe if user consents.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var QUALTRICS_COOKIE = exports.QUALTRICS_COOKIE = "hide_qualtrics_survey";

var QualtricsSurveyModal = (function (_Component) {
  _inherits(QualtricsSurveyModal, _Component);

  function QualtricsSurveyModal(props) {
    _classCallCheck(this, QualtricsSurveyModal);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(QualtricsSurveyModal).call(this, props));

    _this.state = { isShown: false };
    return _this;
  }

  _createClass(QualtricsSurveyModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isShown = this.shouldShow();
      if (isShown) {
        (0, _ajax_helper.httpPost)("/track/track", {
          data: { tid: "QualtricsSurveyModal:" + (this.props.type || "default") }
        });
        this.setState({ isShown: isShown });
      }
    }
  }, {
    key: "shouldShow",
    value: function shouldShow() {
      // No repeat showings before a certain time period
      if (_cookies2.default.get(QUALTRICS_COOKIE)) {
        return false;
      }
      // If user is signed out, make sure they've seen the login interstitial
      // before prompting a survey.
      if (this.props.signedOut) {
        return !!_cookies2.default.get("blocking_sign_in_interstitial");
      }
      return true;
    }
  }, {
    key: "onCloseHandler",
    value: function onCloseHandler() {
      _cookies2.default.set(QUALTRICS_COOKIE, true, 90);
    }
  }, {
    key: "renderSurvey",
    value: function renderSurvey() {
      return _jsx("div", {
        className: "qualtricsSurvey"
      }, void 0, _jsx("iframe", {
        className: "qualtricsSurvey__iframe",
        src: this.props.qualtricsUrl
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.isShown) {
        return null;
      }

      return _jsx(_modal2.default, {
        id: "QualtricsSurveyModal",
        showByDefault: true,
        onCloseHandler: this.onCloseHandler
      }, void 0, this.renderSurvey());
    }
  }]);

  return QualtricsSurveyModal;
})(_react.Component);

QualtricsSurveyModal.propTypes = {
  signedOut: _react.PropTypes.bool.isRequired,
  qualtricsUrl: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string
};

exports.default = QualtricsSurveyModal;

},{"../../modules/ajax/ajax_helper":4,"../modal":126,"../shared/cookies":220,"react":"react"}],208:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Reading Challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: reading_challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Displays a user's reading challenge. This component is used on the home page.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           REQUIRED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:title` : the name of the reading challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:url` : the url of the reading challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:year` : the year of the current reading challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:id` : the id of the current reading challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:type` : the type (yearly/group) of the current reading challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:maxGoal` : the maximum goal a the current reading challenge can be set to
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:images:book` : url to the reading challenge book image used in the badge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `challenge:images:completed` : url to the reading challenge completed sash overlay image
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * OPTIONAL
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `goalNum` : how many books the has specified he/she will read in the challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `numRead` : how many books the user has read in the challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `isFinished` : whether the challenge is completed by the user or not
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `progressText` : message of whether the user is behind/ahead/on track in their challenge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.ReadingChallenge',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      goalNum: 10,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      numRead: 5,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      isFinished: false,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      progressText: "You’re on track",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      challenge: {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        title: '2016 Reading Challenge',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        url: 'https://www.goodreads.com',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        year: 2016,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        id: 5555,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        type: 'y',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        maxGoal: 10000,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        images: {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          badge: "http://d.gr-assets.com/challenges/yearly/img_RCBook.svg"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          completed "http://d.gr-assets.com/challenges/yearly/img_RCCompleted.png"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    } %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _number_formatting_utils = require("../modules/number_formatting_utils");

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _progress_bar = require("./progress_bar");

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _reading_challenge_edit = require("./reading_challenge_edit");

var _reading_challenge_edit2 = _interopRequireDefault(_reading_challenge_edit);

var _reading_challenge_badge = require("./reading_challenge/reading_challenge_badge");

var _reading_challenge_badge2 = _interopRequireDefault(_reading_challenge_badge);

var _reading_challenge_store = require("../react_stores/reading_challenge_store");

var _reading_challenge_store2 = _interopRequireDefault(_reading_challenge_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingChallenge",
  mixins: [_reflux2.default.connect(_reading_challenge_store2.default, "readingChallengeStore")],
  propTypes: {
    challenge: _gr_prop_types2.default.readingChallenge().isRequired
  },

  renderBooksReadCount: function renderBooksReadCount() {
    var state = this.state.readingChallengeStore;
    var urc_path = "/readingchallenges/annual";
    var readingChallengeUrl = state.enableUrcUpdates ? urc_path : state.userChallengeUrl;

    if (state.userChallengeUrl) {
      return _jsx("a", {
        href: readingChallengeUrl,
        className: "gr-hyperlink gr-hyperlink--naked"
      }, void 0, this.renderBooksReadText());
    } else {
      return this.renderBooksReadText();
    }
  },
  renderBooksReadText: function renderBooksReadText() {
    var state = this.state.readingChallengeStore;

    return _jsx("div", {}, void 0, _jsx("div", {
      className: "readingChallengeStatusBox__bookCount"
    }, void 0, state.numRead), "books completed");
  },
  renderProgressMessage: function renderProgressMessage() {
    var state = this.state.readingChallengeStore;
    return _jsx("div", {}, void 0, this.renderBooksReadCount(), _jsx("div", {
      className: "readingChallengeStatusBox__message"
    }, void 0, _jsx("small", {}, void 0, state.progressText)));
  },
  renderChallengeBadge: function renderChallengeBadge() {
    var state = this.state.readingChallengeStore;
    var challenge = Object.assign({}, this.props.challenge, { isFinished: state.startedChallenge && state.isFinished });

    return _jsx(_reading_challenge_badge2.default, {
      challenge: challenge
    });
  },
  renderCongratsMessage: function renderCongratsMessage() {
    var state = this.state.readingChallengeStore;
    var urc_path = "/readingchallenges/annual";
    var readingChallengeUrl = state.enableUrcUpdates ? urc_path : state.userChallengeUrl;

    return _jsx("div", {}, void 0, _jsx("div", {
      className: "readingChallengeStatusBox__congrats"
    }, void 0, "Congrats!"), "You have read", " ", _jsx("a", {
      href: readingChallengeUrl,
      className: "gr-hyperlink"
    }, void 0, state.numRead, " books"), " ", "of your goal of ", state.goalNum, "!");
  },
  renderProgressBar: function renderProgressBar() {
    var state = this.state.readingChallengeStore;
    return _jsx(_progress_bar2.default, {
      value: state.numRead,
      max: state.goalNum,
      width: 70,
      bemModifiers: "thick"
    }, void 0, _jsx("div", {
      className: "u-defaultType u-inlineBlock u-marginLeftXSmall u-verticalAlignMiddle"
    }, void 0, (0, _number_formatting_utils.fractionWithPercentage)(state.numRead, state.goalNum)));
  },
  renderChallengeLink: function renderChallengeLink() {
    return _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, _jsx("a", {
      href: this.props.challenge.url
    }, void 0, "View Challenge"));
  },
  renderUserChallengeInfo: function renderUserChallengeInfo() {
    var state = this.state.readingChallengeStore;
    return _jsx("div", {
      className: "gr-mediaBox"
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media u-marginRightMedium"
    }, void 0, this.renderChallengeBadge()), _jsx("div", {
      className: "gr-mediaBox__desc"
    }, void 0, state.isFinished ? this.renderCongratsMessage() : this.renderProgressMessage(), this.renderProgressBar(), this.renderChallengeLink()));
  },
  render: function render() {
    var state = this.state.readingChallengeStore;
    return _jsx("div", {
      className: "readingChallenge"
    }, void 0, _jsx("h3", {}, void 0, this.props.challenge.title), state.startedChallenge ? this.renderUserChallengeInfo() : _jsx(_reading_challenge_edit2.default, {
      challenge: this.props.challenge,
      booksToRead: state.booksToRead,
      showLoadingSpinner: state.showLoadingSpinner,
      enableUrcUpdates: state.enableUrcUpdates
    }));
  }
});

},{"../modules/number_formatting_utils":16,"../react_stores/reading_challenge_store":268,"./gr_component_factory":108,"./progress_bar":204,"./reading_challenge/reading_challenge_badge":209,"./reading_challenge_edit":210,"./shared/gr_prop_types":221,"reflux":"reflux"}],209:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: ReadingChallengeBadge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: reading_challenge_badge
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           A component for displaying the yearly challenge badge/image.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           REQUIRED - challenge: a yearly challenge consisting of the challenge year,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           the paths to the images required to display the badge,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           boolean of whether the challenge is completed for the user
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingChallengeBadge",

  propTypes: {
    challenge: _gr_prop_types2.default.readingChallenge().isRequired
  },

  renderYearHeader: function renderYearHeader() {
    return _jsx("span", {
      className: "yearHeader"
    }, void 0, this.props.challenge.year);
  },
  renderBookImage: function renderBookImage() {
    return _jsx("img", {
      src: this.props.challenge.images.badge,
      alt: "",
      className: "bookImg"
    });
  },
  renderCompletedImage: function renderCompletedImage() {
    return _jsx("img", {
      src: this.props.challenge.images.completed,
      className: "completedImg"
    });
  },
  renderBadgeFooter: function renderBadgeFooter() {
    return _jsx("div", {
      className: "challengeText"
    }, void 0, _jsx("div", {
      className: "challengeText--reading"
    }, void 0, "READING"), _jsx("div", {}, void 0, "CHALLENGE"));
  },
  render: function render() {
    var challenge = this.props.challenge;
    return _jsx("div", {
      className: "readingChallengeBadge"
    }, void 0, _jsx("div", {
      className: "badgeYear",
      style: { backgroundColor: "" + challenge.primaryColor }
    }, void 0, challenge.isFinished ? this.renderCompletedImage() : null, this.renderYearHeader(), this.renderBookImage(), this.renderBadgeFooter()));
  }
});

},{"../gr_component_factory":108,"../shared/gr_prop_types":221}],210:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _spinner = require("./spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _reading_challenge_actions = require("../react_actions/reading_challenge_actions");

var _reading_challenge_actions2 = _interopRequireDefault(_reading_challenge_actions);

var _reading_challenge_badge = require("./reading_challenge/reading_challenge_badge");

var _reading_challenge_badge2 = _interopRequireDefault(_reading_challenge_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingChallengeEdit",
  propTypes: {
    challenge: _gr_prop_types2.default.readingChallenge().isRequired,
    showLoadingSpinner: React.PropTypes.bool.isRequired,
    booksToRead: React.PropTypes.number,
    enableUrcUpdates: React.PropTypes.bool
  },

  startChallenge: function startChallenge() {
    if (this.props.enableUrcUpdates) {
      window.location = "/readingchallenges/annual";
    } else if (this.props.booksToRead > this.props.challenge.maxGoal) {
      window.alert("Your goal number of books is too high! It must be less than " + this.props.challenge.maxGoal);
    } else {
      _reading_challenge_actions2.default.startChallenge();
    }
  },
  renderButtonOrSpinner: function renderButtonOrSpinner() {
    if (this.props.showLoadingSpinner) {
      return _jsx(_spinner2.default, {});
    } else {
      var disabled = this.props.enableUrcUpdates ? false : !this.props.booksToRead || this.props.booksToRead <= 0;
      return _jsx("button", {
        disabled: disabled,
        className: "gr-button",
        onClick: this.startChallenge,
        "aria-label": "Start your " + this.props.challenge.year + " reading challenge"
      }, void 0, "Start Challenge");
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "readingChallenge__edit"
    }, void 0, _jsx("div", {
      className: "u-marginBottomSmall"
    }, void 0, "Challenge yourself to read more this year!"), _jsx("div", {
      className: "gr-mediaBox"
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media u-marginRightMedium"
    }, void 0, _jsx(_reading_challenge_badge2.default, {
      challenge: this.props.challenge
    })), this.props.enableUrcUpdates ? _jsx("div", {
      className: "gr-mediaBox__desc"
    }, void 0, this.renderButtonOrSpinner()) : _jsx("div", {
      className: "gr-mediaBox__desc"
    }, void 0, _jsx("div", {
      className: "u-marginBottomXSmall"
    }, void 0, "I want to read"), _jsx("input", {
      type: "number",
      autoComplete: "off",
      disabled: this.props.showLoadingSpinner,
      placeholder: "12",
      value: this.props.booksToRead,
      className: "u-marginBottomXSmall",
      "aria-label": "Number of books you want to read in " + this.props.challenge.year,
      onChange: function onChange(ev) {
        _reading_challenge_actions2.default.bookNumChanged(ev.target.value);
      }
    }), _jsx("div", {
      className: "u-marginBottomXSmall"
    }, void 0, "books in ", this.props.challenge.year), this.renderButtonOrSpinner())), !this.props.enableUrcUpdates && _jsx("small", {
      className: "u-displayBlock u-marginTopTiny"
    }, void 0, "You can change your goal at any time"));
  }
});

},{"../react_actions/reading_challenge_actions":38,"./gr_component_factory":108,"./reading_challenge/reading_challenge_badge":209,"./shared/gr_prop_types":221,"./spinner":226}],211:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingNotesLink",

  defaultProps: {
    className: "",
    countTextClassName: "",
    hasSharedContent: false,
    readingNotesVisibilityText: ""
  },

  propTypes: {
    className: _react2.default.PropTypes.string,
    countTextClassName: _react2.default.PropTypes.string,
    hasSharedContent: _react2.default.PropTypes.bool,
    readingNotesCountText: _react2.default.PropTypes.string.isRequired,
    readingNotesUrl: _react2.default.PropTypes.string.isRequired,
    readingNotesVisibilityText: _react2.default.PropTypes.string
  },

  render: function render() {
    var className = (0, _classnames2.default)(this.props.className);
    var readingNotesIconClassname = (0, _classnames2.default)("gr-icon", "u-verticalAlignTop", "gr-icon--readingNotesIcon", { "gr-icon--readingNotesIcon--white": !this.props.hasSharedContent });
    var countTextClassName = (0, _classnames2.default)("u-inlineBlock", this.props.countTextClassName);
    var countText = this.props.readingNotesCountText;
    var visibilityText = this.props.readingNotesVisibilityText;
    var readingNoteUrl = this.props.readingNotesUrl;
    return _jsx("div", {
      className: className
    }, void 0, _jsx("div", {
      className: readingNotesIconClassname
    }, void 0, _jsx("span", {
      className: "u-visuallyHidden"
    }, void 0, "Note")), _jsx("div", {
      className: countTextClassName
    }, void 0, _jsx("a", {
      href: readingNoteUrl
    }, void 0, countText), (0, _lodash.isEmpty)(visibilityText) ? null : _jsx("span", {
      className: "u-displayBlock gr-metaText"
    }, void 0, visibilityText)));
  }
});

},{"../gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react"}],212:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _progress_bar = require("../progress_bar");

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reading_session_helper = require("../../modules/reading_session_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingProgressBar",

  propTypes: {
    positionType: React.PropTypes.oneOf((0, _lodash.values)(_reading_session_helper.PositionTypes)),
    currentPosition: _gr_prop_types2.default.naturalNumber.isRequired,
    finalPosition: _gr_prop_types2.default.naturalNumber
  },

  render: function render() {
    var labelText = (0, _reading_session_helper.currentPositionLabel)(this.props);
    if ((0, _reading_session_helper.isDisplayableAsPercent)(this.props)) {
      return _jsx(_progress_bar2.default, {
        "aria-label": "Reading progress: " + labelText,
        bemModifiers: "thick",
        value: this.props.currentPosition,
        max: this.props.finalPosition,
        width: 70
      }, void 0, _jsx("div", {
        className: "u-defaultType u-inlineBlock u-marginLeftXSmall u-verticalAlignMiddle"
      }, void 0, labelText));
    } else {
      return _jsx("small", {
        className: "u-displayBlock u-marginTopTiny"
      }, void 0, labelText);
    }
  }
});

},{"../../modules/reading_session_helper":18,"../gr_component_factory":108,"../progress_bar":204,"../shared/gr_prop_types":221,"lodash":"lodash"}],213:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRITE_A_REVIEW = undefined;

var _react = require("react");

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               title: Write a review button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This component displays the "Write a review" button and also redirects to the destinationPath
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               on button click.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               In addition, if an actionType metric is provided, the event will be fired off to Clickstream.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `destinationPath`: The destination Url on clicking on the WTR button or rating widget
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookId`: Clickstream event metadata
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `actionType`: The Clickstream metric for the WTR button click
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var WRITE_A_REVIEW = exports.WRITE_A_REVIEW = "Write a review";

var WriteAReviewButton = (function (_Component) {
  _inherits(WriteAReviewButton, _Component);

  function WriteAReviewButton(props) {
    _classCallCheck(this, WriteAReviewButton);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(WriteAReviewButton).call(this, props));
  }

  _createClass(WriteAReviewButton, [{
    key: "handleButtonClick",
    value: function handleButtonClick() {
      var _this2 = this;

      if (this.props.actionType && this.props.bookId) {
        var ratePostUrl = "/review/rateable";
        var ratePostData = {
          id: this.props.bookId
        };
        (0, _ajax_helper.httpGet)(ratePostUrl, {
          data: ratePostData
        }).done(function (promptValues, responseStatus) {
          if (responseStatus === "success") {
            (0, _ajax_helper.httpPost)("/track/track_clickstream", {
              data: {
                action_type: _this2.props.actionType,
                book_id: _this2.props.bookId
              }
            });
            window.location.assign(_this2.props.destinationPath);
          } else {
            if (xhr.status === 403 && xhr.getResponseHeader("errorType") === "frozen") {
              window.alert("This book has temporary limitations on submitting ratings and reviews. This may be because we've detected unusual behavior that doesn't follow our review guidelines.");
            } else if (xhr.status !== 403) {
              window.alert("There was an error saving your rating, please try again.");
            }
          }
        }).fail(function () {
          window.alert("There was an error saving your rating, please try again.");
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classNames = "gr-button u-marginTopBottomXSmall " + this.props.className;
      return _jsx("button", {
        className: classNames,
        onClick: this.handleButtonClick.bind(this)
      }, void 0, WRITE_A_REVIEW);
    }
  }]);

  return WriteAReviewButton;
})(_react.Component);

exports.default = WriteAReviewButton;

WriteAReviewButton.propTypes = {
  destinationPath: _react.PropTypes.string.isRequired
};

},{"../../modules/ajax/ajax_helper":4,"react":"react"}],214:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();
/* react-onclickoutside is a deprecated package that should not be used for new
   code. Instead of having an outside click close a module, there should be an
   explicit close affordances in the spec. */

// STORE

// COMPONENTS

// MIXINS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _keys = require("../../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _book_search_store_factory = require("../../react_stores/book_search_store_factory");

var _book_search_store_factory2 = _interopRequireDefault(_book_search_store_factory);

var _book_search_results = require("./book_search_results");

var _book_search_results2 = _interopRequireDefault(_book_search_results);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _factory_store_mixin = require("../../react_mixins/factory_store_mixin");

var _factory_store_mixin2 = _interopRequireDefault(_factory_store_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELAYED_SEARCH_MS = 300;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearch",

  mixins: [_reactOnclickoutside2.default, _reflux2.default.ListenerMixin, (0, _factory_store_mixin2.default)(_book_search_store_factory2.default)],

  propTypes: {
    autoFocus: _react2.default.PropTypes.bool,
    onChooseResult: _react2.default.PropTypes.func.isRequired,
    maxResults: _react2.default.PropTypes.number,
    shelfName: _react2.default.PropTypes.string,
    searchPath: _react2.default.PropTypes.string.isRequired,
    closeAfterResultChosen: _react2.default.PropTypes.bool,
    autocompleteUrl: _react2.default.PropTypes.string.isRequired,
    signedIn: _react2.default.PropTypes.bool,
    deviceType: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoFocus: false,
      maxResults: 5,
      closeAfterResultChosen: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this.delayedSearch = _lodash2.default.debounce(function (event) {
      _this.actions.search(event.target.value, _this.props.autocompleteUrl);
    }, DELAYED_SEARCH_MS);
    this.signedInStr = this.props.signedIn ? "SignedIn" : "SignedOut";
  },
  hide: function hide() {
    this.actions.setShowResultsContainer(false);
  },
  show: function show() {
    this.actions.setShowResultsContainer(true);
  },
  handleClickOutside: function handleClickOutside() {
    this.hide();
  },
  handleSearch: function handleSearch(event) {
    this.setState({ searchBoxValue: event.target.value });

    if (!_lodash2.default.isEmpty(event.target.value)) {
      event.persist();
      this.delayedSearch(event);
    } else {
      this.hide();
    }
  },
  handleClick: function handleClick(event) {
    if (!_lodash2.default.isEmpty(this.state.query)) {
      this.handleSearch(event);
    }
  },
  handleChoice: function handleChoice(book) {
    $j.post("/track/track_click", {
      feature: "NavSearch:" + this.props.deviceType + ":" + this.signedInStr + ":suggestion_click",
      pmet_value: book.rank
    });

    this.props.onChooseResult(book);
    if (this.props.closeAfterResultChosen) {
      this.hide();
    }
  },

  // Note: This method manipulates a datastore of the book objects, marking one as "active," which triggers
  //       book_search_result (which is listening) to add a special class. Only problem is that we don't know
  //       which link element is currently selected, so we can't trigger a click on the active one when a user
  //       presses Enter. Which is why the current method does a hard window.location move when an item is
  //       activated, which is all kinds of wrong. The implementation of this entire component set prevents
  //       normal browser behavior, and for that reason this should be re-engineered from the ground up. -Joey
  handleKeyPress: function handleKeyPress(event) {
    var maxResults = Math.min(this.props.maxResults, this.state.results.length);
    if (_keys2.default.isEnter(event.keyCode)) {
      if (this.state.activeResult !== null) {
        this.handleChoice(this.state.activeResult);
        event.preventDefault();
      } else if (_lodash2.default.isEmpty(event.target.value)) {
        event.preventDefault();
      }
    } else if (_keys2.default.isArrowDown(event.keyCode)) {
      this.actions.selectNextResult(maxResults);
    } else if (_keys2.default.isArrowUp(event.keyCode)) {
      this.actions.selectPreviousResult(maxResults);
    } else if (_keys2.default.isEscape(event.keyCode)) {
      this.hide();
    }
  },
  logSubmit: function logSubmit() {
    $j.post("/track/track_click", { feature: "NavSearch:" + this.props.deviceType + ":" + this.signedInStr + ":see_all_click" });
  },
  renderInputIcon: function renderInputIcon() {
    var searchSpinnerClasses = this.withBemModifiers("searchBox__icon", "loadingSpinner");
    var searchIconClasses = (0, _classnames2.default)("searchBox__icon--magnifyingGlass gr-iconButton", this.withBemModifiers("searchBox__icon"));
    if (this.state.showLoadingSpinner) {
      return _jsx("span", {
        className: searchSpinnerClasses
      }, void 0, _jsx(_spinner2.default, {}));
    } else {
      return _jsx("button", {
        type: "submit",
        className: searchIconClasses,
        "aria-label": "Search"
      });
    }
  },
  renderResultsContainer: function renderResultsContainer() {
    if (!_lodash2.default.isEmpty(this.state.query)) {
      return _react2.default.createElement(_book_search_results2.default, _extends({}, this.props, this.state, {
        onChooseResult: this.handleChoice,
        mouseoverAction: this.actions.selectSpecificResult
      }));
    }
  },
  render: function render() {
    var searchBoxClasses = (0, _classnames2.default)(this.withBemModifiers("searchBox"));
    var searchInputClasses = (0, _classnames2.default)(this.withBemModifiers("searchBox__input"));

    return _jsx("div", {
      acceptCharset: "UTF-8",
      className: searchBoxClasses,
      onKeyDown: this.handleKeyPress
    }, void 0, _jsx("form", {
      autoComplete: "off",
      action: this.props.searchPath,
      className: "searchBox__form",
      role: "search",
      "aria-label": "Search for books to add to your shelves",
      onSubmit: this.logSubmit
    }, void 0, _jsx("input", {
      className: searchInputClasses,
      autoComplete: "off",
      autoFocus: this.props.autoFocus,
      name: "q",
      type: "text",
      placeholder: "Search books",
      "aria-label": "Search books",
      onFocus: this.show,
      onClick: this.handleClick,
      onChange: this.handleSearch,
      value: this.state.searchBoxValue,
      "aria-controls": "searchResults"
    }), _jsx("input", {
      type: "hidden",
      name: "qid",
      value: this.state.results.length > 0 ? this.state.results[0].qid : ""
    }), this.renderInputIcon(), this.state.showResultsContainer ? this.renderResultsContainer() : null));
  }
});

},{"../../modules/keys":14,"../../react_mixins/factory_store_mixin":249,"../../react_stores/book_search_store_factory":257,"../gr_component_factory":108,"../spinner":226,"./book_search_results":216,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],215:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _author_badge = require("../author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearchResult",

  propTypes: {
    book: _gr_prop_types2.default.book({ qid: _react2.default.PropTypes.string, rank: _react2.default.PropTypes.number }).isRequired,
    onChooseResult: _react2.default.PropTypes.func.isRequired
  },

  render: function render() {
    var _this = this;

    var linkClasses = (0, _classnames2.default)("gr-mediaFlexbox", "gr-book--navbar", "gr-hyperlink", "gr-hyperlink--naked", "gr-hyperlink--noUnderline", "gr-bookSearchResults__result");
    // Note: We should be adding a url to the href attribute on these links elements, but we can't
    //       because there are JS handlers up and down this component chain that hijack normal link
    //       element behavior. That should not be - this whole thing should be re-engineered to make
    //       better use of default browser behavior.
    return _jsx("a", {
      className: linkClasses,
      href: "#",
      "aria-label": "Search result",
      onClick: function onClick() {
        _this.props.onChooseResult(_this.props.book);
      }
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media",
      src: this.props.book.imageUrl,
      alt: ""
    }), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-book__title gr-book__title--navbar u-defaultType"
    }, void 0, this.props.book.title), _jsx("div", {
      className: "gr-book__author gr-book__author--navbar"
    }, void 0, "by ", this.props.book.author.name, _react2.default.createElement(_author_badge2.default, this.props.book.author))));
  }
});

},{"../author/author_badge":70,"../gr_component_factory":108,"../shared/gr_prop_types":221,"classnames":"classnames","react":"react"}],216:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _drop_down_list = require("../drop_down_list");

var _drop_down_list2 = _interopRequireDefault(_drop_down_list);

var _book_search_result = require("./book_search_result");

var _book_search_result2 = _interopRequireDefault(_book_search_result);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearchResults",

  propTypes: {
    maxResults: _react2.default.PropTypes.number.isRequired,
    query: _react2.default.PropTypes.string,
    results: _react2.default.PropTypes.array.isRequired,
    shelfName: _react2.default.PropTypes.string,
    searchPath: _react2.default.PropTypes.string,
    onChooseResult: _react2.default.PropTypes.func.isRequired,
    mouseoverAction: _react2.default.PropTypes.func.isRequired,
    activeResult: _react2.default.PropTypes.shape({
      title: _react2.default.PropTypes.string.isRequired,
      bookId: _react2.default.PropTypes.string.isRequired
    }),
    signedIn: _react2.default.PropTypes.string,
    deviceType: _react2.default.PropTypes.string
  },

  componentDidMount: function componentDidMount() {
    $j.post("/track/track_click", { feature: "NavSearch:" + this.props.deviceType + ":" + (this.props.signedIn ? "SignedIn" : "SignedOut") + ":overlay_shown" });
  },
  renderLastSearchResultItem: function renderLastSearchResultItem(text) {
    var searchResultsLastItemClasses = (0, _classnames2.default)("gr-buttonAsLink", "gr-bookSearchResults__lastItem", this.withBemElement("gr-bookSearchResults", "lastItem"));

    return _jsx("button", {
      className: searchResultsLastItemClasses,
      type: "submit"
    }, void 0, text);
  },
  render: function render() {
    var _this = this;

    var searchResultsClasses = (0, _classnames2.default)(this.withBemModifiers("gr-bookSearchResults"), "gr-box", "gr-box--withShadow");

    return _jsx("div", {
      className: searchResultsClasses,
      id: "bookSearchResults" + this.props.query + this.props.results.length,
      "aria-live": "polite",
      "aria-label": "Book search results"
    }, void 0, _jsx(_drop_down_list2.default, {
      maxListItems: this.props.maxResults
    }, void 0, this.props.results.length > 0 ? _lodash2.default.map(_lodash2.default.slice(this.props.results, 0, this.props.maxResults), function (result) {
      return _jsx("div", {
        className: (0, _classnames2.default)("gr-bookSearchResults__item", { "gr-bookSearchResults__item--active": result === _this.props.activeResult }),
        onMouseOver: function onMouseOver() {
          _this.props.mouseoverAction(result.bookId);
        }
      }, result.bookId, _jsx(_book_search_result2.default, {
        book: result,
        onChooseResult: _this.props.onChooseResult
      }));
    }) : this.renderLastSearchResultItem("Search for \"" + this.props.query + "\"…"), this.props.results.length > 0 ? this.renderLastSearchResultItem("See all results for \"" + this.props.query + "\"") : null));
  }
});

},{"../drop_down_list":103,"../gr_component_factory":108,"./book_search_result":215,"classnames":"classnames","lodash":"lodash","react":"react"}],217:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SelectMenu",

  propTypes: {
    items: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
      name: _react2.default.PropTypes.string.isRequired,
      url: _react2.default.PropTypes.string
    })).isRequired,

    defaultIndex: _react2.default.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return { defaultIndex: 0 };
  },
  onOptionChange: function onOptionChange(event) {
    var index = event.target.selectedIndex;
    if (this.props.items[index] != null) {
      window.location.href = this.props.items[index].url;
    }
  },
  render: function render() {
    return _jsx("select", {
      className: "gr-dropdown gr-selectMenu u-fullWidth",
      onChange: this.onOptionChange,
      defaultValue: this.props.items[this.props.defaultIndex].name
    }, void 0, (0, _lodash.map)(this.props.items, function (option, index) {
      return _jsx("option", {
        value: option.name,
        disabled: option.url == null
      }, index, option.name);
    }));
  }
});

},{"./gr_component_factory":108,"lodash":"lodash","react":"react"}],218:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 A series of circles that indicate the position of a selection in a sequence.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var SequenceIndicators = (function (_Component) {
  _inherits(SequenceIndicators, _Component);

  function SequenceIndicators() {
    _classCallCheck(this, SequenceIndicators);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(SequenceIndicators).apply(this, arguments));
  }

  _createClass(SequenceIndicators, [{
    key: "renderIndicatorCircle",
    value: function renderIndicatorCircle(idx) {
      var indicatorCircleClasses = (0, _classnames2.default)("sequenceIndicators__circle", { "sequenceIndicators__circle--selected": idx === this.props.selectedIndex });
      return _jsx("div", {
        className: indicatorCircleClasses
      }, idx);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("div", {
        className: "sequenceIndicators"
      }, void 0, (0, _lodash.times)(this.props.count, function (idx) {
        return _this2.renderIndicatorCircle(idx);
      }));
    }
  }]);

  return SequenceIndicators;
})(_react.Component);

SequenceIndicators.propTypes = {
  count: _react.PropTypes.number.isRequired,
  selectedIndex: _react.PropTypes.number.isRequired
};

exports.default = SequenceIndicators;

},{"classnames":"classnames","lodash":"lodash","react":"react"}],219:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shape_icon_values = require("../modules/shape_icon_values");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShapeIcon",

  propTypes: {
    imageUrl: _react2.default.PropTypes.string.isRequired,
    imageAlt: _react2.default.PropTypes.string.isRequired,
    includeLink: _react2.default.PropTypes.bool,
    linkUrl: _react2.default.PropTypes.string,
    size: _react2.default.PropTypes.oneOf((0, _lodash.values)(_shape_icon_values.ICON_SIZES)),
    shape: _react2.default.PropTypes.oneOf((0, _lodash.values)(_shape_icon_values.ICON_SHAPES)),
    border: _react2.default.PropTypes.bool
  },

  getShapeClass: function getShapeClass() {
    var modifier = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    var name = this.props.shape + "Icon";
    if (modifier) {
      name += "--" + modifier;
    }
    return name;
  },
  getDefaultProps: function getDefaultProps() {
    return {
      includeLink: false,
      size: _shape_icon_values.ICON_SIZES.SMALL,
      shape: _shape_icon_values.ICON_SHAPES.CIRCLE,
      border: false
    };
  },
  render: function render() {
    var _classNames;

    var classes = (0, _classnames2.default)(this.props.className, (_classNames = {}, _defineProperty(_classNames, "" + this.getShapeClass(), true), _defineProperty(_classNames, "" + this.getShapeClass("medium"), this.props.size === _shape_icon_values.ICON_SIZES.MEDIUM), _defineProperty(_classNames, "" + this.getShapeClass("large"), this.props.size === _shape_icon_values.ICON_SIZES.LARGE), _defineProperty(_classNames, "" + this.getShapeClass("border"), this.props.border), _classNames));

    if (this.props.includeLink && this.props.linkUrl) {
      return _jsx("a", {
        href: this.props.linkUrl
      }, void 0, _jsx("img", {
        className: classes,
        src: this.props.imageUrl,
        alt: this.props.imageAlt
      }));
    } else {
      return _jsx("img", {
        className: classes,
        src: this.props.imageUrl,
        alt: this.props.imageAlt
      });
    }
  }
});

},{"../modules/shape_icon_values":19,"./gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react"}],220:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Cookie manipulation functions. Originally copied from javascripts/shared_all
// formats/cookies with the intention to replace with the react-cookies package,
// but that never happened.

exports.default = {
  get: function get(name) {
    var value = null;
    var $j = window.$j;
    if ($j) {
      $j.each(document.cookie.split("; "), function (i, cookie) {
        var cookiePair = cookie.split("=");
        if (cookiePair[0] === name) {
          value = cookiePair[1];
        }
      });
    }
    return value;
  },
  set: function set(name, value, daysToExpire) {
    daysToExpire = daysToExpire || 365;

    var date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }
};

},{}],221:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateValidator = function dateValidator(props, propName, componentName) {
  var value = props[propName];
  var coercedValue = _lodash2.default.isString(value) ? new Date(value) : value;
  if (!_lodash2.default.isDate(coercedValue) || _lodash2.default.isNaN(coercedValue.getTime())) {
    return new Error("Property '" + propName + "' must be a Date. " + componentName + " was supplied: '" + value + "'.");
  }
};

var naturalNumberValidator = function naturalNumberValidator(props, propName, componentName) {
  var value = props[propName];
  if (value <= 0) {
    return new Error("Property '" + propName + "' must be > 0. " + componentName + " was supplied: '" + value + "'.");
  }
};

// adapted from ReactPropTypes.js since it's not exported publicly
function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName) {
    /* istanbul ignore next */
    if (!componentName) {
      componentName = "<<anonymous>>";
    }
    if (_lodash2.default.isNull(props[propName]) || _lodash2.default.isUndefined(props[propName])) {
      if (isRequired) {
        return new Error("Required property `" + propName + "` was not specified in " + ("`" + componentName + "`."));
      }
      return null;
    } else {
      return validate(props, propName, componentName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

var merge = function merge(oldValue, newValue) {
  return _lodash2.default.merge({}, oldValue, newValue);
};

var user = function user() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    viewableName: _react2.default.PropTypes.string.isRequired,
    profileImage: _react2.default.PropTypes.string.isRequired,
    profileUrl: _react2.default.PropTypes.string,
    informalName: _react2.default.PropTypes.string
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var book = function book() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    bookId: _react2.default.PropTypes.string,
    workId: _react2.default.PropTypes.string,
    bookUrl: _react2.default.PropTypes.string,
    authorName: _react2.default.PropTypes.string,
    title: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    numPages: _react2.default.PropTypes.number
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var bookDescription = function bookDescription() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = truncatedHtml();

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var author = function author() {
  return _react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.number.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    profileImage: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string.isRequired
  });
};

var expandableHtml = function expandableHtml() {
  return {
    html: _react2.default.PropTypes.string.isRequired,
    truncatedHtml: _react2.default.PropTypes.string
  };
};

var truncatedHtml = function truncatedHtml() {
  return {
    html: _react2.default.PropTypes.string,
    fullContentUrl: _react2.default.PropTypes.string,
    fullContentText: _react2.default.PropTypes.string,
    truncated: _react2.default.PropTypes.bool.isRequired,
    className: _react2.default.PropTypes.string,
    bookDescriptionTargetingData: _react2.default.PropTypes.object
  };
};

var friendNewsfeedResource = function friendNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    friendUser: user().isRequired,
    isMyFriend: _react2.default.PropTypes.bool.isRequired,
    addFriendUrl: _react2.default.PropTypes.string,
    compareBooksUrl: _react2.default.PropTypes.string,
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: book()
  });
};

var userFollowingNewsfeedResource = function userFollowingNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    followingUser: user().isRequired,
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: book()
  });
};

var commentSubject = function commentSubject() {
  return _react2.default.PropTypes.shape({
    type: _react2.default.PropTypes.string,
    id: _react2.default.PropTypes.number,
    uri: _react2.default.PropTypes.string
  });
};

var comment = function comment() {
  return _react2.default.PropTypes.shape({
    canComment: _react2.default.PropTypes.bool.isRequired,
    commentable: _react2.default.PropTypes.bool.isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: commentSubject(),
    subjectUrl: _react2.default.PropTypes.string
  });
};

var like = function like() {
  return _react2.default.PropTypes.shape({
    key: _react2.default.PropTypes.string.isRequired,
    label: _react2.default.PropTypes.string.isRequired,
    isLikeable: _react2.default.PropTypes.bool.isRequired
  });
};

var authorBlogPostNewsfeedResource = function authorBlogPostNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    author: author().isRequred,
    title: _react2.default.PropTypes.string,
    url: _react2.default.PropTypes.string
  });
};

var blogNewsfeedResource = function blogNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.object.isRequired,
    url: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    typeDisplayName: _react2.default.PropTypes.string
  });
};

var interviewNewsfeedResource = function interviewNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.object,
    url: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    authorImageUrl: _react2.default.PropTypes.string,
    author: _react2.default.PropTypes.string,
    bookImageUrl: _react2.default.PropTypes.string,
    bookTitle: _react2.default.PropTypes.string,
    typeDisplayName: _react2.default.PropTypes.string
  });
};

var authorFollowNewsfeedResource = function authorFollowNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    author: author().isRequred,
    userAuthorFollowingsUrl: _react2.default.PropTypes.string
  });
};

var authorQaSettingNewsfeedResource = function authorQaSettingNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    author: author().isRequired,
    message: _react2.default.PropTypes.string,
    url: _react2.default.PropTypes.string.isRequired
  });
};

var quote = function quote() {
  return _react2.default.PropTypes.shape({
    author: author().isRequired,
    body: _react2.default.PropTypes.object.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    quotesAuthorUrl: _react2.default.PropTypes.string.isRequired
  });
};

var group = function group() {
  return _react2.default.PropTypes.shape({
    allUnreadPostsUrl: _react2.default.PropTypes.string.isRequired,
    description: _react2.default.PropTypes.string.isRequired,
    iconUrl: _react2.default.PropTypes.string.isRequired,
    id: _react2.default.PropTypes.number.isRequired,
    lastActiveAt: createChainableTypeChecker(dateValidator),
    membersCount: _react2.default.PropTypes.number,
    name: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired
  });
};

var topic = function topic() {
  return _react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.number.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    totalPosts: _react2.default.PropTypes.string.isRequired,
    newPosts: _react2.default.PropTypes.string,
    newCommentsUrl: _react2.default.PropTypes.string,
    updatedAt: createChainableTypeChecker(dateValidator),
    folder: _react2.default.PropTypes.shape({
      name: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    })
  });
};

var defaultPollVoteProps = {
  user: user().isRequired,
  pollName: _react2.default.PropTypes.string.isRequired,
  answer: _react2.default.PropTypes.object.isRequired,
  url: _react2.default.PropTypes.string.isRequired,
  imageUrl: _react2.default.PropTypes.string.isRequired,
  isGroupPoll: _react2.default.PropTypes.bool.isRequired,
  isChoicePoll: _react2.default.PropTypes.bool.isRequired,
  groupName: _react2.default.PropTypes.string,
  groupUrl: _react2.default.PropTypes.string
};

var pollVoteNewsfeedResource = function pollVoteNewsfeedResource() {
  return _react2.default.PropTypes.shape(defaultPollVoteProps);
};

var choicePollVoteNewsfeedResource = function choicePollVoteNewsfeedResource() {
  return _react2.default.PropTypes.shape(merge(defaultPollVoteProps, {
    choiceYear: _react2.default.PropTypes.number.isRequired,
    choiceUrl: _react2.default.PropTypes.string.isRequired,
    badgeUrl: _react2.default.PropTypes.string.isRequired,
    votedBook: book().isRequired
  }));
};

var communityQuestion = function communityQuestion() {
  return {
    category: _react2.default.PropTypes.number.isRequired,
    questionText: _react2.default.PropTypes.string.isRequired,
    isSpoiler: _react2.default.PropTypes.bool.isRequired,
    questionUrl: _react2.default.PropTypes.string.isRequired,
    user: user().isRequired,
    authorQuestionsUrl: _react2.default.PropTypes.string,
    book: book()
  };
};

var communityAnswer = function communityAnswer() {
  return {
    user: user().isRequired,
    answerText: _react2.default.PropTypes.shape(truncatedHtml()),
    isSpoiler: _react2.default.PropTypes.bool.isRequired,
    communityQuestion: _react2.default.PropTypes.shape(communityQuestion()).isRequired
  };
};

var creative = function creative() {
  return _react2.default.PropTypes.shape({
    book: book(),
    customText: _react2.default.PropTypes.object,
    helpLink: _react2.default.PropTypes.string,
    defaultIcon: _react2.default.PropTypes.string,
    numAdditionalFriends: _react2.default.PropTypes.number,
    friendActionText: _react2.default.PropTypes.string,
    firstFriend: user(),
    customTextReview: _react2.default.PropTypes.object,
    similarBook: book(),
    similarBookShelf: _react2.default.PropTypes.string,
    similarBookShelfUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array
  });
};

var notification = function notification() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    actor: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string,
      profileImage: _react2.default.PropTypes.string,
      profileUrl: _react2.default.PropTypes.string
    }),
    actors: _react2.default.PropTypes.array,
    createdAt: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.string,
    resource: _react2.default.PropTypes.shape({
      text: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    }),
    viewed: _react2.default.PropTypes.boolean,
    moreActors: _react2.default.PropTypes.boolean
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var searchResult = function searchResult(searchProp) {
  return _react2.default.PropTypes.shape({
    destination: _react2.default.PropTypes.string.isRequired,
    type: _react2.default.PropTypes.string.isRequired,
    object: searchProp
  });
};

var authorSearchResult = function authorSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    profileImage: _react2.default.PropTypes.string
  }));
};

var bookSearchResult = function bookSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    authorName: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    title: _react2.default.PropTypes.string.isRequired,
    imageUrl: _react2.default.PropTypes.string
  }));
};

var userSearchResult = function userSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    profileImage: _react2.default.PropTypes.string
  }));
};

var readingNotesAnnotatedBookItem = function readingNotesAnnotatedBookItem() {
  return _react2.default.PropTypes.shape({
    asin: _react2.default.PropTypes.string.isRequired,
    imageUrl: _react2.default.PropTypes.string.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    authorName: _react2.default.PropTypes.string.isRequired,
    sharedCount: _react2.default.PropTypes.number.isRequired,
    highlightCount: _react2.default.PropTypes.number,
    noteCount: _react2.default.PropTypes.number,
    readingNotesUrl: _react2.default.PropTypes.string.isRequired,
    knhCta: _react2.default.PropTypes.string.isRequired,
    noSharedAnnotations: _react2.default.PropTypes.bool.isRequired
  });
};

var readingChallenge = function readingChallenge() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    id: _react2.default.PropTypes.number.isRequired,
    year: _react2.default.PropTypes.number.isRequired,
    type: _react2.default.PropTypes.string.isRequired,
    maxGoal: _react2.default.PropTypes.number.isRequired,
    isFinished: _react2.default.PropTypes.bool,
    primaryColor: _react2.default.PropTypes.string.isRequired,
    secondaryColor: _react2.default.PropTypes.string.isRequired,
    images: _react2.default.PropTypes.shape({
      badge: _react2.default.PropTypes.string.isRequired,
      completed: _react2.default.PropTypes.string.isRequired
    })
  });
};

var shareDialog = function shareDialog() {
  return {
    signedIn: _react2.default.PropTypes.bool,
    signInUrl: _react2.default.PropTypes.string,

    social: _react2.default.PropTypes.shape({
      inModal: _react2.default.PropTypes.shape({
        facebook: _react2.default.PropTypes.bool.isRequired,
        twitter: _react2.default.PropTypes.bool.isRequired,
        pinterest: _react2.default.PropTypes.bool.isRequired,
        copyLink: _react2.default.PropTypes.bool.isRequired
      }).isRequired,

      outsideModal: _react2.default.PropTypes.shape({
        facebook: _react2.default.PropTypes.bool.isRequired,
        twitter: _react2.default.PropTypes.bool.isRequired,
        pinterest: _react2.default.PropTypes.bool.isRequired,
        copyLink: _react2.default.PropTypes.bool.isRequired
      }).isRequired,

      fbOptions: _react2.default.PropTypes.object,
      twitterOptions: _react2.default.PropTypes.object,
      pinterestOptions: _react2.default.PropTypes.object
    }).isRequired,

    sharingData: _react2.default.PropTypes.shape({
      resourceTypeFriendlyText: _react2.default.PropTypes.string.isRequired,
      resourceId: _react2.default.PropTypes.number.isRequired,
      sharerUserId: _react2.default.PropTypes.number
    }).isRequired,

    includePreview: _react2.default.PropTypes.bool,
    previewData: _react2.default.PropTypes.object
  };
};

var giveawayLogEntry = function giveawayLogEntry() {
  return _react2.default.PropTypes.shape({
    giveaway_uri: _react2.default.PropTypes.string,
    created_at: _react2.default.PropTypes.string,
    user_uri: _react2.default.PropTypes.string,
    start_at: _react2.default.PropTypes.string,
    end_at: _react2.default.PropTypes.string,
    release_at: _react2.default.PropTypes.string,
    book_uri: _react2.default.PropTypes.string,
    country_codes: _react2.default.PropTypes.string,
    book_count: _react2.default.PropTypes.string,
    adults_only_flag: _react2.default.PropTypes.string,
    description: _react2.default.PropTypes.string,
    primary_genre: _react2.default.PropTypes.string,
    secondary_genre: _react2.default.PropTypes.string,
    contact_info: _react2.default.PropTypes.string,
    nonwinner_message: _react2.default.PropTypes.string
  });
};

var reviewDraftItem = function reviewDraftItem() {
  return {
    reviewDraftUri: _react2.default.PropTypes.string.isRequired,
    book: book().isRequired,
    reviewEditPath: _react2.default.PropTypes.string.isRequired,
    reviewText: _react2.default.PropTypes.shape(expandableHtml()).isRequired
  };
};

exports.default = {
  user: user,
  author: author,
  blogNewsfeedResource: blogNewsfeedResource,
  interviewNewsfeedResource: interviewNewsfeedResource,
  book: book,
  bookDescription: bookDescription,
  quote: quote,
  commentSubject: commentSubject,
  comment: comment,
  like: like,
  group: group,
  topic: topic,
  authorBlogPostNewsfeedResource: authorBlogPostNewsfeedResource,
  authorFollowNewsfeedResource: authorFollowNewsfeedResource,
  authorQaSettingNewsfeedResource: authorQaSettingNewsfeedResource,
  communityQuestion: communityQuestion,
  communityAnswer: communityAnswer,
  friendNewsfeedResource: friendNewsfeedResource,
  userFollowingNewsfeedResource: userFollowingNewsfeedResource,
  pollVoteNewsfeedResource: pollVoteNewsfeedResource,
  expandableHtml: expandableHtml,
  truncatedHtml: truncatedHtml,
  choicePollVoteNewsfeedResource: choicePollVoteNewsfeedResource,
  date: createChainableTypeChecker(dateValidator),
  naturalNumber: createChainableTypeChecker(naturalNumberValidator),
  creative: creative,
  notification: notification,
  searchResults: {
    book: bookSearchResult,
    author: authorSearchResult,
    user: userSearchResult
  },
  readingNotesAnnotatedBookItem: readingNotesAnnotatedBookItem,
  readingChallenge: readingChallenge,
  reviewDraftItem: reviewDraftItem,
  shareDialog: shareDialog,
  giveawayLogEntry: giveawayLogEntry
};

},{"lodash":"lodash","react":"react"}],222:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _spoiler = require("../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Methods from our TextHelpers Ruby module can return text marked with <spoiler>
 * tags, possibly including inline JavaScript to show/hide their contents. This
 * library replaces that markup with the Spoiler React component.
 */
exports.default = {
  replaceSpoilerHTMLWithReactComponents: function replaceSpoilerHTMLWithReactComponents(rootDOMNode, jQuery) {
    /* istanbul ignore next */
    var $j = jQuery || window.$j;
    var spoilerLinks = $j(".jsShowSpoiler", rootDOMNode);

    _lodash2.default.each(spoilerLinks, function (spoilerLink) {
      var $spoilerLink = $j(spoilerLink);
      var spoilerContainer = $spoilerLink.next(".spoilerContainer");
      if (spoilerContainer) {
        var spoilerText = spoilerContainer.text().replace("(hide spoiler)", "");
        var spoiler = _react2.default.createElement(_spoiler2.default, { html: spoilerText });
        var placeholder = $j("<span></span>");
        $spoilerLink.replaceWith(placeholder);
        _reactDom2.default.render(spoiler, $j(placeholder)[0]);
      }
    });
  }
};

},{"../user_content/spoiler":234,"lodash":"lodash","react":"react","react-dom":"react-dom"}],223:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             A component for a list of items where scrolling through them
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             invokes an action to load more items.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The items are passed in as children and can be any React elements.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Currently, it inserts a waypoint at the top of each batch of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             items, including the initial set of items (batch 1). Assuming the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             first item is visible on the page, this has the effect of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             immediately fetching the batch 2. Once batch 2 is loaded, the waypoint will be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             moved the top of its elements. When the user scrolls to this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             moved waypoint, batch 3 will be fetched and the waypoint moved to
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             the top of batch 3's elements, and so on and so on, forever.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Warning: Using the back button to go back to a page where this list has been
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             used will have potentially confusing results.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Props
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             loadMoreAction - Required. Callback function to invoke when waypoint scrolls into view.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              It should load the next batch of items.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            loadingInProgress - Required. If true, the loadMoreAction is busy and we will not try
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                to to call it again until this is false.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             noMoreItems - optional, default=false. If true, will not create any waypoints so the list
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           will no longer call loadMoreAction.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             <InfiniteScrollList
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               loadMoreAction={Actions.loadMoreThings}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               loadingInProgress={false}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               noMoreItems={false}>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               {[<Item key={1}/>,<Item key={2}/>...]}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             </InfiniteScrollList>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reactWaypoint = require("react-waypoint");

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "InfiniteScrollList",

  propTypes: {
    loadMoreAction: _react2.default.PropTypes.func.isRequired,
    loadingInProgress: _react2.default.PropTypes.bool.isRequired,
    noMoreItems: _react2.default.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      waypointIndex: 0
    };
  },
  handleOnEnter: function handleOnEnter() {
    if (!this.props.loadingInProgress) {
      this.props.loadMoreAction();
    }
  },
  childrenWithWaypoint: function childrenWithWaypoint(children) {
    var waypoint = _jsx(_reactWaypoint2.default, {
      onEnter: this.handleOnEnter
    }, "waypoint" + children.length);
    children.splice(this.state.waypointIndex, 0, waypoint);
    return children;
  },
  renderWithWaypoint: function renderWithWaypoint() {
    var children = _react2.default.Children.toArray(this.props.children);
    if (!(0, _lodash.isEmpty)(children)) {
      if (this.props.noMoreItems === true) {
        return children;
      } else {
        return this.childrenWithWaypoint(children);
      }
    } else {
      return null;
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.children.length !== this.props.children.length) {
      this.setState({
        waypointIndex: _react2.default.Children.count(this.props.children)
      });
    }
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderWithWaypoint());
  }
});

},{"../gr_component_factory":108,"lodash":"lodash","react":"react","react-waypoint":"react-waypoint"}],224:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPOVER_ARROW_POSITIONS = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _close_button = require("../../close_button");

var _close_button2 = _interopRequireDefault(_close_button);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POPOVER_ARROW_POSITIONS = exports.POPOVER_ARROW_POSITIONS = {
  TOP_RIGHT: "topRight"
};
var POPOVER_ARROW_LENGTH_PX = 12; // See $popover-arrow-height;

var POPOVER_TARGET_REF = "popoverTarget";
var POPOVER_CLASS_NAME = "gr-popover";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Popover",

  propTypes: {
    body: _react2.default.PropTypes.element.isRequired,
    onClose: _react2.default.PropTypes.func.isRequired,
    popoverTarget: _react2.default.PropTypes.element,
    headingText: _react2.default.PropTypes.string,
    isOpen: _react2.default.PropTypes.bool,
    showCloseButton: _react2.default.PropTypes.bool,
    showArrow: _react2.default.PropTypes.bool
  },

  // Unsupported for now; accepting arrowPosition prop will require adding
  // logic to position calculation
  //arrowPosition: React.PropTypes.oneOf(values(POPOVER_ARROW_POSITIONS))
  getDefaultProps: function getDefaultProps() {
    return {
      isOpen: false,
      isCloseOnOutsideClick: true,
      showArrow: true,
      showCloseButton: true
    };
  },
  // Unsupported for now; accepting arrowPosition prop will require adding
  // logic to position calculation
  // arrowPosition: POPOVER_ARROW_POSITIONS.TOP_RIGHT
  getInitialState: function getInitialState() {
    return {
      popoverPosition: null
    };
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.props.popoverTarget) {
      var previousPosition = this.state.popoverPosition;
      var currentPosition = this.getPopoverPosition();
      if (!(0, _lodash.isEqual)(previousPosition, currentPosition)) {
        this.resetPopoverPosition();
      }
    }
  },
  componentDidMount: function componentDidMount() {
    //reset popover position relative to the `props.popoverTarget` only when present.
    if (this.props.popoverTarget) {
      this.resetPopoverPosition();
      var onResizeThrottled = (0, _lodash.throttle)(this.resetPopoverPosition, 10);
      window.addEventListener("resize", onResizeThrottled);
    }
  },
  hasTopArrow: function hasTopArrow() {
    return this.props.showArrow && (0, _lodash.includes)([POPOVER_ARROW_POSITIONS.TOP_LEFT], this.props.arrowPosition);
  },
  getPopoverTargetBoundingClientRect: function getPopoverTargetBoundingClientRect() {
    var popoverTarget = _reactDom2.default.findDOMNode(this.refs[POPOVER_TARGET_REF]);
    if (popoverTarget) {
      return popoverTarget.getBoundingClientRect();
    }
  },
  getPopoverPositionTop: function getPopoverPositionTop() {
    var popoverTargetClientRect = this.getPopoverTargetBoundingClientRect();
    if (popoverTargetClientRect) {
      if (this.hasTopArrow()) {
        return popoverTargetClientRect.height + POPOVER_ARROW_LENGTH_PX;
      } else {
        return popoverTargetClientRect.height;
      }
    } else {
      if (this.hasTopArrow()) {
        return POPOVER_ARROW_LENGTH_PX;
      } else {
        return 0;
      }
    }
  },
  getPopoverPosition: function getPopoverPosition() {
    var popoverTargetClientRect = this.getPopoverTargetBoundingClientRect();
    if (popoverTargetClientRect) {
      // Both the Popover and its target are supposed to be inside a positioned
      // wrapper (e.g., a <div> with `position:relative`) so that we can use
      // `position: absolute` to make the popover appear on top of page content
      // and slightly offset from the target. We use the target's "bounding
      // rectangle" to figure out how much space it takes up, and therefore
      // where to position the popover within the positioned wrapper.
      //
      // For now, we put the popover below the target. In the future, we could
      // complicate this function to allow it to appear in a different place,
      // e.g., above the target.
      return {
        right: 0,
        top: this.getPopoverPositionTop()
      };
    } else {
      return null;
    }
  },
  resetPopoverPosition: function resetPopoverPosition() {
    this.setState({
      popoverPosition: this.getPopoverPosition()
    });
  },
  onClose: function onClose() {
    this.props.onClose();
  },
  renderCloseAction: function renderCloseAction() {
    if (this.props.showCloseButton) {
      return _jsx("div", {
        className: "u-floatRight"
      }, void 0, _jsx(_close_button2.default, {
        action: this.onClose
      }));
    }
  },
  renderHeader: function renderHeader() {
    var headingText = this.props.headingText;
    if (headingText) {
      return _jsx("h3", {
        className: "gr-h3 gr-h3--noTopMargin"
      }, void 0, headingText);
    }
  },
  renderArrow: function renderArrow() {
    if (this.props.showArrow) {
      var arrowPositionClass = POPOVER_CLASS_NAME + "__arrow--" + POPOVER_ARROW_POSITIONS.TOP_RIGHT;
      var arrowClassNames = (0, _classnames2.default)(POPOVER_CLASS_NAME + "__arrow", arrowPositionClass);
      return _jsx("div", {
        className: arrowClassNames
      });
    }
  },
  renderPopover: function renderPopover() {
    if (this.props.isOpen) {
      var popoverStyle = {};
      if (this.state.popoverPosition) {
        popoverStyle.top = this.state.popoverPosition.top;
        popoverStyle.right = this.state.popoverPosition.right;
      }

      return _jsx("div", {
        style: popoverStyle,
        className: this.withBemModifiers(POPOVER_CLASS_NAME)
      }, void 0, this.renderArrow(), this.renderCloseAction(), this.renderHeader(), this.props.body);
    }
  },
  renderPopoverTarget: function renderPopoverTarget() {
    if (this.props.popoverTarget) {
      return _react2.default.cloneElement(this.props.popoverTarget, {
        ref: POPOVER_TARGET_REF
      });
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "u-positionRelative"
    }, void 0, this.renderPopoverTarget(), this.renderPopover());
  }
});

},{"../../close_button":94,"../../gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react","react-dom":"react-dom"}],225:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Displays a sampling of books (Book components) for a given shelf
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

// STORES

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _image_registry = require("../modules/shared/image_registry");

var _books_on_shelves_store = require("../react_stores/books_on_shelves_store");

var _books_on_shelves_store2 = _interopRequireDefault(_books_on_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShelfDisplay",

  propTypes: {
    askForRecommendationsUrl: _react2.default.PropTypes.string.isRequired,
    numToDisplay: _react2.default.PropTypes.number,
    recommendationsUrl: _react2.default.PropTypes.string.isRequired,
    shelfImageUrl: _react2.default.PropTypes.string.isRequired,
    shelfName: _react2.default.PropTypes.string.isRequired,
    shelfUrl: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      numToDisplay: 6,
      shelfUrl: null
    };
  },

  mixins: [_reflux2.default.connectFilter(_books_on_shelves_store2.default, "shelvings", function (storeData) {
    return _lodash2.default.sortByOrder(_lodash2.default.values(storeData[this.props.shelfName]), function (shelving) {
      return shelving.updatedAt;
    }, "desc").slice(0, this.props.numToDisplay);
  })],

  // Starting point for GR-32455. Won't work exactly as-is:
  // * UserShelf component deleted
  /*
  renderShelfChooser() {
    let caret = <img className="secondaryColumnSection__caret" src={this.props.caretImage} />;
    let allShelves = _.compact(this.state.userShelves.defaultShelves
      .concat(this.state.userShelves.customExclusiveShelves)
      .concat(this.state.userShelves.nonExclusiveShelves));
     return <Dropdown trigger={caret}
                     fallbackUrl="/review/list"
                     bemModifiers="shelfDisplay">
             <DropDownList maxListItems={this.props.maxShelves}
                           moreLinkURL={this.props.moreShelvesLink}
                           showMoreLink={true}>
               { _.map(_.slice(allShelves, 0, this.props.maxShelves), (shelf) => {
                   return(<MenuLink key={shelf.name}>
                            <UserShelf key={shelf.name} shelfName={shelf.name} />
                          </MenuLink>);
                 })
               }
             </DropDownList>
           </Dropdown>;
  },
  */

  renderShelfLink: function renderShelfLink() {
    if (this.props.shelfUrl && !_lodash2.default.isEmpty(this.state.shelvings)) {
      return _jsx("div", {
        className: "u-marginTopXSmall"
      }, void 0, _jsx("a", {
        href: this.props.shelfUrl,
        "aria-label": "View your " + this.props.shelfName + " shelf"
      }, void 0, "View all books"));
    } else {
      return null;
    }
  },
  renderShelvings: function renderShelvings() {
    if (!_lodash2.default.isEmpty(this.state.shelvings)) {
      return _lodash2.default.map(this.state.shelvings, function (shelving) {
        return _jsx("a", {
          className: "shelfDisplay__bookCoverLink",
          href: shelving.book.bookUrl
        }, shelving.book.bookId, _jsx("img", {
          alt: shelving.book.title,
          src: shelving.book.imageUrls.crop96x96,
          className: "gr-bookCover gr-bookCover--thumbnailSmall"
        }));
      });
    } else {
      return _jsx("div", {}, void 0, _jsx("div", {
        className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter"
      }, void 0, _jsx("img", {
        className: "gr-mediaFlexbox__media",
        alt: "",
        src: (0, _image_registry.getImages)().wtrSparseStateIcon
      }), _jsx("div", {
        className: "gr-mediaFlexbox__desc"
      }, void 0, "What do you want to read next?")), _jsx("div", {
        className: "u-marginTopMedium"
      }, void 0, _jsx("a", {
        href: this.props.recommendationsUrl
      }, void 0, "Recommendations")));
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "shelfDisplay"
    }, void 0, this.renderShelvings(), this.renderShelfLink());
  }
});

},{"../modules/shared/image_registry":20,"../react_stores/books_on_shelves_store":258,"./gr_component_factory":108,"lodash":"lodash","react":"react","reflux":"reflux"}],226:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Spinner",

  propTypes: {
    isSmall: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isSmall: false
    };
  },
  render: function render() {
    var cx = (0, _classnames2.default)("spinnerContainer", this.props.className);
    var bemModifier = this.props.isSmall ? "small" : null;
    return _jsx("div", {
      className: cx
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner", bemModifier)
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner__mask", bemModifier)
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner__maskedCircle", bemModifier)
    }))), _jsx("div", {
      className: "spinnerFallbackText"
    }, void 0, "Loading…"));
  }
});

},{"./gr_component_factory":108,"classnames":"classnames"}],227:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "StoresInitializer",

  render: function render() {
    return null;
  }
}); // This is a component used exlusively for initializing a store. Since that is
// its sole purpose, it renders nothing

},{"./gr_component_factory":108}],228:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _date_utils = require("../../modules/date_utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RelativeTime",

  propTypes: {
    time: _gr_prop_types2.default.date.isRequired,
    longFormat: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      longFormat: false
    };
  },
  getRelativeTime: function getRelativeTime() {
    if (this.props.longFormat) {
      return (0, _moment2.default)(new Date(this.props.time)).fromNow();
    } else {
      return (0, _date_utils.fromNow)(this.props.time);
    }
  },
  render: function render() {
    return _jsx("time", {
      dateTime: this.props.time,
      "aria-label": (0, _moment2.default)(new Date(this.props.time)).fromNow()
    }, void 0, this.getRelativeTime());
  }
});

},{"../../modules/date_utils":10,"../gr_component_factory":108,"../shared/gr_prop_types":221,"moment":"moment","react":"react"}],229:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reading_session_helper = require("../modules/reading_session_helper");

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reading_session_actions = require("../react_actions/reading_session_actions");

var _reading_session_actions2 = _interopRequireDefault(_reading_session_actions);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _default_shelves = require("../modules/default_shelves");

var _lodash = require("lodash");

var _gr_reflux = require("../react_mixins/gr_reflux");

var _spinner = require("./spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _keys = require("../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _react_ref_helpers = require("../modules/react_ref_helpers");

var _book_origins = require("../modules/book_origins");

var _long_text_popup_form = require("./forms/long_text_popup_form");

var _long_text_popup_form2 = _interopRequireDefault(_long_text_popup_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UpdateReadingProgress",
  propTypes: {
    existingReadingSession: _react2.default.PropTypes.shape({
      positionType: _react2.default.PropTypes.oneOf([_reading_session_helper.PositionTypes.Page, _reading_session_helper.PositionTypes.Percent]).isRequired,
      currentPosition: _react2.default.PropTypes.number.isRequired
    }).isRequired,
    book: _gr_prop_types2.default.book().isRequired,
    MAX_BODY_LENGTH: _react2.default.PropTypes.number.isRequired
  },

  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "book.bookId", { stateKey: "shelvingInProgress",
    filterValue: "isShelvingInProgress" })],

  getInitialState: function getInitialState() {
    return {
      currentPosition: this.props.existingReadingSession.currentPosition,
      positionType: this.props.existingReadingSession.positionType,
      updateText: ""
    };
  },
  updateProgress: function updateProgress(text) {
    var newSessionValues = (0, _lodash.merge)({
      body: text
    }, this.props.existingReadingSession, this.state);
    if ((0, _reading_session_helper.isValidUpdate)(newSessionValues)) {
      if ((0, _reading_session_helper.isValidProgressAmount)(newSessionValues)) {
        _reading_session_actions2.default.updateProgress(newSessionValues);
      } else {
        window.alert((0, _reading_session_helper.invalidProgressMessage)(newSessionValues));
      }
    } else {
      window.alert("Please enter a progress message or amount.");
    }
  },
  syncUpdateText: function syncUpdateText(text) {
    this.setState({ updateText: text });
  },
  showPercentage: function showPercentage() {
    return this.state.positionType === _reading_session_helper.PositionTypes.Percent;
  },
  updateProgressChanged: function updateProgressChanged(value) {
    this.setState({ currentPosition: value });
  },
  togglePositionType: function togglePositionType() {
    if (this.state.positionType === _reading_session_helper.PositionTypes.Percent) {
      this.setState({ positionType: _reading_session_helper.PositionTypes.Page });
    } else if (this.state.positionType === _reading_session_helper.PositionTypes.Page) {
      this.setState({ positionType: _reading_session_helper.PositionTypes.Percent });
    }
  },
  finishedBook: function finishedBook() {
    _shelvings_actions2.default.shelveBook(this.props.book.bookId, _default_shelves.DEFAULT_SHELVES.READ, _book_origins.BOOK_ORIGINS.UPDATE_READING_PROGRESS, // tracking from old HP
    this.state.updateText); // pass along final progress update text if it exists
  },
  submitOnEnter: function submitOnEnter(ev) {
    if (_keys2.default.isEnter(ev.keyCode)) {
      this.form.submit();
    }
  },
  renderInput: function renderInput() {
    var _this = this;

    var input = _react2.default.createElement("input", { type: "text",
      "aria-label": "Enter current " + this.state.positionType + " read in " + this.props.book.title,
      className: "gr-textInput updateReadingProgress__headerInput",
      size: "3",
      value: this.state.currentPosition,
      onChange: function onChange(ev) {
        _this.updateProgressChanged(ev.target.value);
      },
      ref: _react_ref_helpers.focusOnMount,
      onKeyDown: this.submitOnEnter,
      placeholder: this.showPercentage() ? "" + this.state.currentPosition : "p. " + this.state.currentPosition });
    if (this.showPercentage()) {
      return _jsx("span", {}, void 0, "Currently ", input, "% done");
    } else {
      return _jsx("span", {}, void 0, "Currently on ", input, this.props.book.numPages ? " of " + this.props.book.numPages : null);
    }
  },
  renderPositionTypeToggle: function renderPositionTypeToggle() {
    return _jsx("span", {
      className: "updateReadingProgress__headerToggle"
    }, void 0, _jsx("button", {
      className: "buttonToggle",
      disabled: this.showPercentage(),
      onClick: this.togglePositionType
    }, void 0, "%"), _jsx("button", {
      className: "buttonToggle",
      disabled: !this.showPercentage(),
      onClick: this.togglePositionType
    }, void 0, "#"));
  },
  renderHeader: function renderHeader() {
    return _jsx("div", {
      className: "updateReadingProgress"
    }, void 0, this.renderInput(), this.renderPositionTypeToggle(), _jsx("div", {
      className: "updateReadingProgress__finishedReading"
    }, void 0, this.state.shelvingInProgress ? _jsx(_spinner2.default, {}) : _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.finishedBook
    }, void 0, "I’m finished!")));
  },
  render: function render() {
    var _this2 = this;

    return _react2.default.createElement(_long_text_popup_form2.default, {
      ref: function ref(form) {
        _this2.form = form;
      },
      header: this.renderHeader(),
      characterLimit: this.props.MAX_BODY_LENGTH,
      text: this.state.updateText,
      onSubmit: this.updateProgress,
      onCancel: _reading_session_actions2.default.closeUpdateProgressForm,
      onTextChange: this.syncUpdateText,
      submitButtonLabel: "Update progress",
      textareaProps: {
        "aria-label": "Add update progress text"
      }
    });
  }
});

},{"../modules/book_origins":6,"../modules/default_shelves":11,"../modules/keys":14,"../modules/react_ref_helpers":17,"../modules/reading_session_helper":18,"../react_actions/reading_session_actions":39,"../react_actions/shelvings_actions":41,"../react_mixins/gr_reflux":250,"../react_stores/shelvings_store":272,"./forms/long_text_popup_form":107,"./gr_component_factory":108,"./shared/gr_prop_types":221,"./spinner":226,"lodash":"lodash","react":"react"}],230:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserIcon",

  propTypes: {
    user: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string.isRequired,
      profileImage: _react2.default.PropTypes.string.isRequired,
      profileUrl: _react2.default.PropTypes.string
    }).isRequired,
    includeLink: _react2.default.PropTypes.bool,
    size: _react2.default.PropTypes.oneOf([_shape_icon_values.ICON_SIZES.SMALL, _shape_icon_values.ICON_SIZES.MEDIUM, _shape_icon_values.ICON_SIZES.LARGE])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      includeLink: true,
      size: _shape_icon_values.ICON_SIZES.SMALL
    };
  },
  render: function render() {
    var user = this.props.user;

    return _react2.default.createElement(_shape_icon2.default, _extends({ imageUrl: user.profileImage,
      imageAlt: user.viewableName,
      linkUrl: user.profileUrl,
      border: true
    }, this.props));
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":108,"../shape_icon":219,"react":"react"}],231:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserProfileLink",

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    className: _react2.default.PropTypes.string
  },

  userName: function userName() {
    return { __html: this.props.user.viewableName };
  },
  render: function render() {
    var className = (0, _classnames2.default)("gr-hyperlink", "gr-hyperlink--bold", "gr-user__profileLink", this.props.className);
    var profileLink = _jsx("a", {
      className: className,
      href: this.props.user.profileUrl,
      dangerouslySetInnerHTML: this.userName()
    });
    if (this.props.user.profileUrl && this.props.user.viewableName) {
      return _jsx(_click_tracking_wrapper2.default, {
        children: profileLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.user_profile
      });
    } else if (this.props.user.viewableName) {
      return _jsx("b", {}, void 0, this.props.user.viewableName);
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../click_tracking_wrapper":93,"../gr_component_factory":108,"../shared/gr_prop_types":221,"classnames":"classnames","react":"react"}],232:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _gr_spoiler_handler = require("../shared/gr_spoiler_handler");

var _gr_spoiler_handler2 = _interopRequireDefault(_gr_spoiler_handler);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ExpandableHtml",

  propTypes: _gr_prop_types2.default.expandableHtml(),

  getInitialState: function getInitialState() {
    return {
      expanded: false
    };
  },
  collapse: function collapse() {
    this.setState({ expanded: false });
  },
  expand: function expand() {
    this.setState({ expanded: true });
  },
  expandable: function expandable() {
    return !_lodash2.default.isEmpty(this.props.truncatedHtml);
  },
  visibleHtml: function visibleHtml() {
    if (!this.expandable() || this.state.expanded === true) {
      return this.props.html;
    } else {
      return this.props.truncatedHtml;
    }
  },
  renderToggleButton: function renderToggleButton() {
    if (!this.expandable()) {
      return null;
    }

    var action = this.state.expanded ? this.collapse : this.expand;
    var label = this.state.expanded ? "Less" : "More";

    var cx = (0, _classnames2.default)("gr-buttonAsLink", "u-marginLeftTiny");

    return _jsx("button", {
      className: cx,
      onClick: action
    }, void 0, label);
  },
  componentDidMount: function componentDidMount() {
    if (this.refs.rootNode) {
      _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.refs.rootNode) {
      _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
    }
  },
  render: function render() {
    if (_lodash2.default.isEmpty(this.props.html)) {
      return null;
    }

    var expandableClass = (0, _classnames2.default)("expandableHtml", this.props.className);
    return React.createElement(
      "div",
      { className: expandableClass, ref: "rootNode" },
      _jsx("span", {
        dangerouslySetInnerHTML: { __html: this.visibleHtml() }
      }),
      this.renderToggleButton()
    );
  }
});

},{"../gr_component_factory":108,"../shared/gr_prop_types":221,"../shared/gr_spoiler_handler":222,"classnames":"classnames","lodash":"lodash"}],233:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "HiddenHtml",

  propTypes: {
    unhideText: React.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      unhideText: "unhide"
    };
  },
  getInitialState: function getInitialState() {
    return {
      expanded: false
    };
  },
  expand: function expand() {
    this.setState({ expanded: true });
  },
  renderUnhideButton: function renderUnhideButton() {
    return _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.expand
    }, void 0, this.props.unhideText);
  },
  renderContent: function renderContent() {
    if (this.state.expanded) {
      return this.props.children;
    } else {
      return _jsx("span", {}, void 0, this.renderUnhideButton());
    }
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderContent());
  }
});

},{"../gr_component_factory":108}],234:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Spoiler",

  propTypes: {
    html: _react2.default.PropTypes.string,
    spoilerWarning: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element])
  },

  componentWillMount: function componentWillMount() {
    if (this.props.html === null && this.props.children === null) {
      throw new Error("props.children and props.html cannot both be null");
    }
  },
  getDefaultProps: function getDefaultProps() {
    return {
      html: null,
      spoilerWarning: null
    };
  },
  getInitialState: function getInitialState() {
    return {
      showSpoiler: false
    };
  },
  onClickShowSpoiler: function onClickShowSpoiler() {
    this.setState({
      showSpoiler: true
    });
  },
  onClickHideSpoiler: function onClickHideSpoiler() {
    this.setState({
      showSpoiler: false
    });
  },
  getSpoilerHtml: function getSpoilerHtml() {
    return {
      __html: this.props.html
    };
  },
  renderSpoiler: function renderSpoiler() {
    if (this.props.html) {
      return _jsx("span", {
        className: "spoiler__text u-marginRightTiny",
        dangerouslySetInnerHTML: this.getSpoilerHtml()
      });
    } else {
      return this.props.children;
    }
  },
  render: function render() {
    return _jsx("span", {}, void 0, this.state.showSpoiler ? _jsx("span", {
      className: "spoiler__textContainer"
    }, void 0, this.renderSpoiler(), _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.onClickHideSpoiler
    }, void 0, "(hide spoiler)")) : _jsx("span", {}, void 0, this.props.spoilerWarning, _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.onClickShowSpoiler
    }, void 0, "(view spoiler)")));
  }
});

},{"../gr_component_factory":108,"react":"react"}],235:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _gr_spoiler_handler = require("../shared/gr_spoiler_handler");

var _gr_spoiler_handler2 = _interopRequireDefault(_gr_spoiler_handler);

var _click_tracking_wrapper = require("../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TruncatedHtml",

  propTypes: _gr_prop_types2.default.truncatedHtml(),

  getDefaultProps: function getDefaultProps() {
    return {
      fullContentText: "More",
      bookDescriptionTargetingData: _click_tracking_helper.TRACKED_CLASSES.full_content_link
    };
  },
  componentDidMount: function componentDidMount() {
    _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
  },
  render: function render() {
    var fullContentLink = _jsx("a", {
      className: "u-marginLeftTiny fullContentLink",
      href: this.props.fullContentUrl
    }, void 0, this.props.fullContentText);
    return React.createElement(
      "div",
      { ref: "rootNode", className: this.props.className },
      _jsx("span", {
        dangerouslySetInnerHTML: { __html: this.props.html }
      }),
      this.props.truncated ? _jsx(_click_tracking_wrapper2.default, {
        children: fullContentLink,
        trackingOptions: this.props.bookDescriptionTargetingData
      }) : null
    );
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../click_tracking_wrapper":93,"../gr_component_factory":108,"../shared/gr_prop_types":221,"../shared/gr_spoiler_handler":222}],236:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAR_SIZES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _gr_reflux = require("../react_mixins/gr_reflux");

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STAR_SIZES = exports.STAR_SIZES = {
  SMALL: "smallStars",
  MEDIUM: "mediumStars",
  LARGE: "largeStars"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserRating",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "bookId")],

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string,
    starsTrackingOptions: _react2.default.PropTypes.object,
    starSize: _react2.default.PropTypes.string,
    displayLabel: _react2.default.PropTypes.bool,
    handleClick: _react2.default.PropTypes.func,
    clickstreamRef: _react2.default.PropTypes.string,
    isPreRelease: _react2.default.PropTypes.bool,
    readOnly: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      starsTrackingOptions: _click_tracking_helper.TRACKED_CLASSES.user_rating_star,
      displayLabel: true,
      starSize: STAR_SIZES.SMALL,
      readOnly: false
    };
  },
  setHoverRating: function setHoverRating(rating) {
    this.setState({ hoverRating: rating });
  },
  removeHoverRating: function removeHoverRating() {
    this.setState({ hoverRating: null });
  },
  isShelved: function isShelved() {
    return this.state.exclusiveShelfName !== null;
  },
  updateRating: function updateRating(starNum, ev) {
    ev.preventDefault();

    // Check for pre-release book and show confirmation dialog
    if (this.props.isPreRelease) {
      var message = "This edition has not yet been published. Only readers with advanced copies of this book can rate it. Go to the book's page to verify you have an advanced copy and rate this book?";

      if (confirm(message)) {
        // User confirmed, redirect to book page with rating parameters
        var bookId = this.isShelved() ? this.state.book.bookId : this.props.bookId;
        window.location.href = "/book/show/" + bookId + "?rating=" + starNum + "&preReleaseChallengeQuestion=true";
      }
      // If user cancels, do nothing (no page refresh)
      return false;
    } else {
      // Not a pre-release book, proceed normally
      if (this.isShelved()) {
        _shelvings_actions2.default.rateBook(this.state.book.bookId, starNum, this.state.book.title, this.props.clickstreamRef || null, this.refs.ratingContainer, this.props.handleClick);
      } else {
        _shelvings_actions2.default.rateBook(this.props.bookId, starNum, this.props.bookTitle, this.props.clickstreamRef || null, this.refs.ratingContainer, this.props.handleClick);
      }
    }
  },
  starLabel: function starLabel(starNum) {
    var starLabel = undefined;
    if (this.state.exclusiveShelfName !== null && this.state.rating > 0) {
      starLabel = "Change rating from " + this.state.rating + " to " + starNum + " ";
    } else {
      starLabel = "Rate " + starNum + " ";
    }
    starLabel += starNum === 1 ? "star" : "stars";
    return starLabel;
  },
  renderStar: function renderStar(starIndex) {
    var starNum = starIndex + 1;
    var savedRating = this.state.exclusiveShelfName !== null ? this.state.rating : 0;
    var currentRating = this.state.hoverRating ? this.state.hoverRating : savedRating;
    var starClass = (0, _classnames2.default)("userRating__star", { "userRating__star--selected": starNum <= currentRating }, "userRating__star--" + this.props.starSize, { "userRating__star--readOnly": this.props.readOnly });

    // If read-only render a span instead of a button
    if (this.props.readOnly) {
      return _jsx("span", {
        className: starClass
      }, starNum);
    }

    // If not read-only render interactive button
    var starButton = _jsx("button", {
      className: starClass,
      title: this.starLabel(starNum),
      onClick: this.updateRating.bind(this, starNum),
      onMouseEnter: this.setHoverRating.bind(this, starNum)
    });
    return _jsx(_click_tracking_wrapper2.default, {
      children: starButton,
      trackingOptions: this.props.starsTrackingOptions
    }, starNum);
  },
  renderTextLabel: function renderTextLabel() {
    if (this.props.displayLabel) {
      // In read-only mode, hide the label if the user hasn't rated
      if (this.props.readOnly && (this.state.exclusiveShelfName === null || this.state.rating === 0)) {
        return null;
      }
      var labelClass = (0, _classnames2.default)("userRating__label", "gr-metaText", { "userRating__label--largeStars": this.props.starSize === STAR_SIZES.LARGE });
      return _jsx("div", {
        className: labelClass
      }, void 0, this.state.exclusiveShelfName !== null && this.state.rating > 0 ? "Your rating:" : "Rate it:");
    }
  },
  render: function render() {
    // In read-only mode, hide entirely if the user hasn't rated
    if (this.props.readOnly && (this.state.exclusiveShelfName === null || this.state.rating === 0)) {
      return null;
    }
    var containerClass = (0, _classnames2.default)("userRating", { "userRating--largeStars": this.props.starSize === STAR_SIZES.LARGE });
    return _jsx("div", {
      className: containerClass
    }, void 0, this.renderTextLabel(), _react2.default.createElement(
      "div",
      { className: "userRating__starsWrapper",
        tabIndex: "0",
        ref: "ratingContainer",
        role: "group",
        onMouseLeave: this.removeHoverRating },
      _lodash2.default.times(5, function (starIndex) {
        return this.renderStar(starIndex);
      }, this)
    ));
  }
});

},{"../modules/ads/click_tracking_helper":2,"../react_actions/shelvings_actions":41,"../react_mixins/gr_reflux":250,"../react_stores/shelvings_store":272,"./click_tracking_wrapper":93,"./gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react"}],237:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_shelves_store = require("../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserShelvesBookCounts",
  mixins: [_reflux2.default.connect(_user_shelves_store2.default, "userShelvesStore")],

  renderShelfCounts: function renderShelfCounts(shelves) {
    return (0, _lodash.map)(shelves, function (shelf) {
      return _jsx("a", {
        className: "u-displayBlock",
        href: shelf.url,
        "aria-label": shelf.displayName + " shelf. " + shelf.bookCount + " books."
      }, shelf.name, shelf.bookCount);
    });
  },
  renderShelfNames: function renderShelfNames(shelves) {
    return (0, _lodash.map)(shelves, function (shelf) {
      return _jsx("a", {
        className: "userShelvesBookCounts__nameLink",
        href: shelf.url,
        "aria-label": shelf.displayName + " shelf. " + shelf.bookCount + " books."
      }, shelf.name, shelf.displayName);
    });
  },
  render: function render() {
    var state = this.state.userShelvesStore;
    var shelves = state.defaultShelves.concat(state.customExclusiveShelves, state.nonExclusiveShelves);
    return _jsx("div", {
      className: "userShelvesBookCounts"
    }, void 0, _jsx("div", {
      className: "userShelvesBookCounts__counts"
    }, void 0, this.renderShelfCounts(shelves)), _jsx("div", {}, void 0, this.renderShelfNames(shelves)), _jsx("div", {
      className: "userShelvesBookCounts__buffer"
    }));
  }
});

},{"../react_stores/user_shelves_store":276,"./gr_component_factory":108,"lodash":"lodash","reflux":"reflux"}],238:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALWAYS_DISPLAY_STARS_PROP = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

var _default_shelves = require("../../modules/default_shelves");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shelvings_store = require("../../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _user_shelves_store = require("../../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

var _want_to_read_menu_store = require("../../react_stores/want_to_read_menu_store");

var _want_to_read_menu_store2 = _interopRequireDefault(_want_to_read_menu_store);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _modal_store = require("../../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _want_to_read_menu = require("../want_to_read/want_to_read_menu");

var _want_to_read_menu2 = _interopRequireDefault(_want_to_read_menu);

var _user_rating = require("../user_rating");

var _user_rating2 = _interopRequireDefault(_user_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SAVING_BUTTON_TEXT = "Saving…";
var BOOK_ALSO_MARKED_AS_READ_TEXT = "This book has also been marked as Read";
var ALWAYS_DISPLAY_STARS_PROP = exports.ALWAYS_DISPLAY_STARS_PROP = "ALWAYS_DISPLAY_STARS_PROP";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadButton",

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string.isRequired,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    // Defaults to `display: none` for breakpoints under $large-site-width (1220px).
    // Set `showStars` to ALWAYS_DISPLAY_STARS_PROP to always display regardless of breakpoint
    showStars: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.string]),
    showMenu: _react2.default.PropTypes.bool,
    origin: _react2.default.PropTypes.string,
    trackingOptions: _react2.default.PropTypes.object,
    starsTrackingOptions: _react2.default.PropTypes.object,
    withModalShelvingMenu: _react2.default.PropTypes.bool,
    readOnlyStars: _react2.default.PropTypes.bool
  },
  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "bookId", { stateKey: "shelvings" }), (0, _gr_reflux.connectToLazyStore)(_want_to_read_menu_store2.default, "uniqueId", { stateKey: "wantToReadMenu" }), _reflux2.default.connect(_user_shelves_store2.default, "userShelves"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities"), _reflux2.default.connect(_modal_store2.default, "modalStore")],

  getDefaultProps: function getDefaultProps() {
    return {
      showStars: false,
      showMenu: true,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.want_to_read_button,
      withModalShelvingMenu: false,
      readOnlyStars: false
    };
  },
  shelveBook: function shelveBook() {
    _shelvings_actions2.default.shelveBook(this.props.bookId, _user_shelves_store2.default.defaultShelves().WANT_TO_READ, this.props.origin);
  },
  unshelveBook: function unshelveBook() {
    if (window.confirm("Removing a book deletes your rating, review, etc. Remove this book from all your shelves?")) {
      _shelvings_actions2.default.unshelveBook(this.state.shelvings.book.bookId);
    }
  },

  /*
    A note about this.restoreFocusOnUpdate:
     This was a bit tricky because we have to a) save which specific button was
    pressed to change a shelving, and b) refocus on the same button after
    multiple instances of the component updated. We needed some way to uniquely
    identify each button even if they have the same state, which ruled out
    adding another state variable to the store. Also, setting state would in
    turn cause the component to re-render, which made problems for us.
     This feels hacky, but it's the best solution we have at the time.
  */
  focusButton: function focusButton(button) {
    if (button && this.restoreFocusOnUpdate && !this.state.isShelvingInProgress) {
      this.forgetFocus();
      button.focus();
    }
  },
  rememberFocus: function rememberFocus() {
    this.restoreFocusOnUpdate = true;
  },
  forgetFocus: function forgetFocus() {
    this.restoreFocusOnUpdate = false;
  },
  checkmarkClass: function checkmarkClass() {
    return (0, _default_shelves.checkIconClassnames)(this.state.shelvings.exclusiveShelfName);
  },
  unshelved: function unshelved() {
    return this.state.shelvings.exclusiveShelfName === null;
  },
  getBookId: function getBookId() {
    return this.unshelved() ? this.props.bookId : this.state.shelvings.book.bookId;
  },
  getBookTitle: function getBookTitle() {
    return this.unshelved() ? this.props.bookTitle : this.state.shelvings.book.title;
  },
  renderWantToReadLeftUnshelved: function renderWantToReadLeftUnshelved() {
    var buttonText = this.state.shelvings.isShelvingInProgress ? SAVING_BUTTON_TEXT : "Want to Read";
    var wantToReadLeftClasses = (0, _classnames2.default)("wantToReadButton__leftUnshelvedButton", { "wantToReadButton__leftUnshelvedButton--noOutline": this.state.shelvings.isShelvingInProgress });
    var shelvingLabel = "Add " + this.props.bookTitle + " to your want to read shelf";
    return _react2.default.createElement(
      "button",
      { "aria-label": shelvingLabel,
        ref: this.focusButton,
        className: wantToReadLeftClasses,
        onClick: this.shelveBook,
        onFocus: this.rememberFocus,
        onBlur: this.forgetFocus },
      buttonText
    );
  },
  renderWantToReadLeftShelved: function renderWantToReadLeftShelved() {
    var buttonClasses = (0, _classnames2.default)("wantToReadButton__leftShelvedButton");
    var checkmarkClasses = (0, _classnames2.default)({ wantToReadButton__checkIcon: !this.state.shelvings.isShelvingInProgress }, this.checkmarkClass());
    var shelvingLabel = "Remove " + this.state.shelvings.book.title + " from my shelves";
    var buttonText = this.state.shelvings.isShelvingInProgress ? SAVING_BUTTON_TEXT : this.state.shelvings.exclusiveShelfDisplayName;
    if (this.state.userAgentCapabilities.touch) {
      return _react2.default.createElement(
        "button",
        { "aria-label": shelvingLabel,
          onClick: this.unshelveBook,
          onFocus: this.rememberFocus,
          onBlur: this.forgetFocus,
          ref: this.focusButton,
          className: buttonClasses },
        _jsx("span", {
          className: checkmarkClasses + " u-inlineBlock"
        }),
        _jsx("div", {
          className: "wantToReadButton__shelvedButtonText"
        }, void 0, buttonText)
      );
    } else {
      return _jsx("span", {}, void 0, _react2.default.createElement("button", { "aria-label": shelvingLabel,
        ref: this.focusButton,
        onClick: this.unshelveBook,
        onFocus: this.rememberFocus,
        onBlur: this.forgetFocus,
        className: buttonClasses + " " + checkmarkClasses }), _jsx("div", {
        className: "wantToReadButton__shelvedButtonText"
      }, void 0, buttonText));
    }
  },
  renderWantToReadRight: function renderWantToReadRight() {
    var bookId = this.getBookId();
    var bookTitle = this.getBookTitle();

    var dropdownModifiers = ["wantToReadMenu"];
    if (this.props.withModalShelvingMenu) {
      dropdownModifiers.push("wtrMenuToggleDropdown");
    }

    if (this.props.showMenu && !this.isWTRModalOpen()) {
      return _jsx(_dropdown2.default, {
        trigger: this.renderWantToReadRightButtonContents(),
        triggerEventType: _dropdown2.default.TriggerEventTypes.HOVER,
        bemModifiers: dropdownModifiers
      }, void 0, _jsx(_want_to_read_menu2.default, {
        uniqueId: this.props.uniqueId,
        bookId: bookId,
        bookTitle: bookTitle,
        userShelves: this.state.userShelves,
        shelvings: this.state.shelvings
      }));
    } else {
      return null;
    }
  },
  getModalId: function getModalId() {
    return "wtrModal" + this.getBookId();
  },
  isWTRModalOpen: function isWTRModalOpen() {
    return this.state.modalStore.currentActiveModal && this.state.modalStore.currentActiveModal === this.getModalId();
  },
  hideBookAlsoMarkedAsReadMessage: function hideBookAlsoMarkedAsReadMessage() {
    if (this.state.showBookAlsoMarkedAsReadMessage) {
      this.setState({ showBookAlsoMarkedAsReadMessage: false });
    }
  },
  handleWTRMenuNonExclusiveShelvingWithoutExclusive: function handleWTRMenuNonExclusiveShelvingWithoutExclusive() {
    this.setState({ showBookAlsoMarkedAsReadMessage: true });
  },
  handleModalClose: function handleModalClose() {
    _want_to_read_menu_actions2.default.closeAddShelfTextbox(this.props.uniqueId);
    this.hideBookAlsoMarkedAsReadMessage();
  },
  handleDoneClick: function handleDoneClick() {
    _modal_actions2.default.closeModal();
    this.hideBookAlsoMarkedAsReadMessage();
  },
  renderModal: function renderModal() {
    var bookId = this.getBookId();
    var bookTitle = this.getBookTitle();
    if (this.props.showMenu && this.props.withModalShelvingMenu) {
      // Class `wtrMenuToggleModal` sets display to none when window is past
      // sm breakpoint, which can lead to the Modal being in active
      // state while not being displayed (say, if user resizes the window).
      // This is no bueno because we stop body scroll when Modal is active,
      // so instead we check and make sure the modal is closed before adding the
      // toggle class.
      var cx = (0, _classnames2.default)("wtrModalContainer", {
        wtrMenuToggleModal: !this.isWTRModalOpen()
      });
      return _jsx("div", {
        className: cx
      }, void 0, _jsx(_modal_trigger2.default, {
        id: this.getModalId()
      }, void 0, _jsx("button", {
        type: "button",
        className: "wtrModalContainer__trigger"
      }, void 0, this.renderWantToReadRightButtonContents())), _jsx(_modal2.default, {
        id: this.getModalId(),
        centered: true,
        onCloseHandler: this.handleModalClose
      }, void 0, _jsx("div", {
        className: "wtrModal"
      }, void 0, _jsx("h3", {
        className: "gr-h3 gr-h3--serif gr-h3--noMargin u-paddingBottomXSmall"
      }, void 0, "Shelve ", this.props.bookTitle), _jsx(_want_to_read_menu2.default, {
        uniqueId: this.props.uniqueId,
        bookId: bookId,
        bookTitle: bookTitle,
        userShelves: this.state.userShelves,
        shelvings: this.state.shelvings,
        useModalView: true,
        bemModifiers: "modalView",
        onNonExclusiveShelvingWithoutExclusive: this.handleWTRMenuNonExclusiveShelvingWithoutExclusive,
        onExclusiveShelvingChange: this.hideBookAlsoMarkedAsReadMessage
      })),
      /* Done button gets replaced by add/cancel buttons when AddNewShelf
         is enabled */
      !this.state.wantToReadMenu.showAddShelfTextbox && _jsx("button", {
        type: "button",
        className: "gr-button wtrModal__closeButton",
        "aria-label": "Close want to read menu",
        onClick: this.handleDoneClick
      }, void 0, "Done"), this.state.showBookAlsoMarkedAsReadMessage && _jsx("div", {
        className: "wtrModal__alsoMarkedAsReadMessage"
      }, void 0, BOOK_ALSO_MARKED_AS_READ_TEXT)));
    } else {
      return null;
    }
  },
  renderWantToReadRightButtonContents: function renderWantToReadRightButtonContents() {
    return _jsx("div", {
      className: "wantToReadButton__right"
    }, void 0, _jsx("span", {
      className: "u-visuallyHidden"
    }, void 0, "Shelving menu"));
  },
  render: function render() {
    var wantToReadLeft = "";
    var wantToReadClassLeft = (0, _classnames2.default)("wantToReadButton__left", { "wantToReadButton__left--standalone": !this.props.showMenu }, { wantToReadButton__leftUnshelved: this.unshelved() }, { wantToReadButton__leftShelved: !this.unshelved() });

    if (this.unshelved()) {
      wantToReadLeft = this.renderWantToReadLeftUnshelved();
    } else {
      wantToReadLeft = this.renderWantToReadLeftShelved();
    }
    var starsCx = (0, _classnames2.default)("wtrStarsContainer", {
      "wtrStarsContainer--alwaysDisplay": this.props.showStars === ALWAYS_DISPLAY_STARS_PROP
    });
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "wantToReadButton"
    }, void 0, _jsx("div", {
      className: wantToReadClassLeft
    }, void 0, wantToReadLeft), this.renderModal(), this.renderWantToReadRight()), this.props.showStars ? _jsx("div", {
      className: starsCx
    }, void 0, _jsx(_user_rating2.default, {
      bookId: this.props.bookId,
      starsTrackingOptions: this.props.starsTrackingOptions,
      readOnly: this.props.readOnlyStars
    })) : null);
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../../modules/default_shelves":11,"../../react_actions/modal_actions":36,"../../react_actions/shelvings_actions":41,"../../react_actions/want_to_read_menu_actions":45,"../../react_mixins/gr_reflux":250,"../../react_stores/modal_store":266,"../../react_stores/shelvings_store":272,"../../react_stores/user_agent_capabilities_store":273,"../../react_stores/user_shelves_store":276,"../../react_stores/want_to_read_menu_store":277,"../dropdown":104,"../gr_component_factory":108,"../modal":126,"../modal_trigger":127,"../user_rating":236,"../want_to_read/want_to_read_menu":239,"classnames":"classnames","react":"react","reflux":"reflux"}],239:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenu component is used only within the WantToReadButton component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            right now. It generates a list of shelves, along with a filter box and 'add
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            new shelf' button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _default_shelves = require("../../modules/default_shelves");

var _want_to_read_menu_store = require("../../react_stores/want_to_read_menu_store");

var _want_to_read_menu_store2 = _interopRequireDefault(_want_to_read_menu_store);

var _want_to_read_menu_filter = require("./want_to_read_menu_filter");

var _want_to_read_menu_filter2 = _interopRequireDefault(_want_to_read_menu_filter);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _want_to_read_menu_shelf_creator = require("./want_to_read_menu_shelf_creator");

var _want_to_read_menu_shelf_creator2 = _interopRequireDefault(_want_to_read_menu_shelf_creator);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_SHELVES_TO_SHOW_FILTER = 7;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenu",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_want_to_read_menu_store2.default, "uniqueId")],

  propTypes: {
    bookId: React.PropTypes.string.isRequired,
    bookTitle: React.PropTypes.string.isRequired,
    uniqueId: React.PropTypes.string.isRequired,
    userShelves: React.PropTypes.object.isRequired,
    shelvings: React.PropTypes.object.isRequired,
    useModalView: React.PropTypes.bool,
    onNonExclusiveShelvingWithoutExclusive: React.PropTypes.func,
    onExclusiveShelvingChange: React.PropTypes.func
  },

  defaultPropTypes: function defaultPropTypes() {
    return { useModalView: false };
  },
  shelveBook: function shelveBook(shelf) {
    _shelvings_actions2.default.shelveBook(this.props.bookId, shelf);
  },
  unshelveBook: function unshelveBook() {
    if (window.confirm("Removing a book deletes your rating, review, etc. Remove this book from all your shelves?")) {
      _shelvings_actions2.default.unshelveBook(this.props.bookId);
    }
  },
  modifyExclusiveShelving: function modifyExclusiveShelving(shelved, shelf) {
    if (this.props.onExclusiveShelvingChange && _lodash2.default.isFunction(this.props.onExclusiveShelvingChange)) {
      this.props.onExclusiveShelvingChange();
    }
    shelved ? this.unshelveBook() : this.shelveBook(shelf);
  },
  toggleNonExclusiveShelving: function toggleNonExclusiveShelving(shelf) {
    if (this.props.shelvings.exclusiveShelfName === null && this.props.onNonExclusiveShelvingWithoutExclusive && _lodash2.default.isFunction(this.props.onNonExclusiveShelvingWithoutExclusive)) {
      this.props.onNonExclusiveShelvingWithoutExclusive();
    }
    _shelvings_actions2.default.toggleNonExclusiveShelving(this.props.bookId, shelf, false, this.props.bookTitle);
  },
  renderFilter: function renderFilter() {
    var allShelves = this.props.userShelves.customExclusiveShelves.concat(this.props.userShelves.nonExclusiveShelves);
    var showFilterMenu = allShelves.length >= MIN_SHELVES_TO_SHOW_FILTER;
    if (showFilterMenu) {
      return _jsx(_want_to_read_menu_filter2.default, {
        bookId: this.props.bookId,
        uniqueId: this.props.uniqueId,
        shelvings: this.props.shelvings,
        wantToReadMenu: this.state,
        bemModifiers: this.props.bemModifiers
      });
    }
  },
  renderEmptyMessage: function renderEmptyMessage() {
    var displayableExclusiveShelves = this.state.displayableExclusiveShelves;
    var displayableNonExclusiveShelves = this.state.displayableNonExclusiveShelves;
    var displayedShelvesCount = displayableNonExclusiveShelves.concat(displayableExclusiveShelves).length;
    if (displayedShelvesCount === 0) {
      return _jsx("li", {
        className: "wantToReadMenu__genericItem"
      }, void 0, "No Matching Shelves");
    }
  },
  renderExclusiveShelves: function renderExclusiveShelves() {
    var _this = this;

    var displayableExclusiveShelves = this.state.displayableExclusiveShelves;
    return _lodash2.default.map(displayableExclusiveShelves, function (shelf) {
      var shelved = shelf.name === _this.props.shelvings.exclusiveShelfName;
      var humanShelfName = shelf.displayName;
      var shelvingLabel = shelved ? "Unshelve  " + _this.props.bookTitle : "Shelve " + _this.props.bookTitle + " as " + humanShelfName;
      var exclusiveShelfClassnames = (0, _classnames2.default)(_this.withBemModifiers("wantToReadMenu__exclusiveShelf"), { "wantToReadMenu__exclusiveShelf--shelved": shelved });
      var shelvingStatusIcon = _this.props.useModalView ? _this.renderExclusiveShelfStatusIcon(shelf) : null;
      return _jsx("li", {
        className: "wantToReadMenu__shelfItem"
      }, humanShelfName, _jsx("button", {
        className: exclusiveShelfClassnames,
        "aria-label": shelvingLabel,
        onClick: function onClick() {
          _this.modifyExclusiveShelving(shelved, shelf);
        }
      }, void 0, shelvingStatusIcon && _jsx("div", {
        className: "wantToReadMenu__shelfStatusContainer"
      }, void 0, shelvingStatusIcon), humanShelfName));
    });
  },
  renderExclusiveShelfStatusIcon: function renderExclusiveShelfStatusIcon(shelf) {
    // (1) if book is shelved and shelving not in progress, render check icon
    // if shelving in progress:
    // (2) if being unshelved (no target), render spinner on shelved exclusive shelf
    // (3) if being shelved (target == shelf.name), render spinner on target shelf
    var shelvingStatusIcon = null;
    var shelved = shelf.name === this.props.shelvings.exclusiveShelfName;
    if (shelved && !this.props.shelvings.isShelvingInProgress) {
      // (1)
      var checkIconCx = (0, _classnames2.default)("wantToReadButton__checkIcon", "wantToReadButton__checkIcon--modalView", (0, _default_shelves.checkIconClassnames)(this.props.shelvings.exclusiveShelfName));
      shelvingStatusIcon = _jsx("span", {
        className: checkIconCx
      });
    } else if (this.props.shelvings.isShelvingInProgress && (!this.props.shelvings.targetExclusiveShelfName && shelved || // (2)
    this.props.shelvings.targetExclusiveShelfName === shelf.name)) {
      // (3)
      shelvingStatusIcon = _jsx(_spinner2.default, {
        isSmall: true
      });
    }

    return shelvingStatusIcon;
  },
  renderNonExclusiveShelves: function renderNonExclusiveShelves() {
    var _this2 = this;

    var displayableNonExclusiveShelves = this.state.displayableNonExclusiveShelves;
    return _lodash2.default.map(displayableNonExclusiveShelves, function (shelf) {
      var shelfChecked = false;
      if (_this2.props.shelvings.exclusiveShelfName !== null && _lodash2.default.includes(_this2.props.shelvings.nonExclusiveShelfNames, shelf.name)) {
        shelfChecked = true;
      }
      var humanShelfName = shelf.displayName;
      var shelvingLabel = "Shelve " + _this2.props.bookTitle + " as " + humanShelfName;
      var nonExclusiveShelfClassnames = _this2.withBemModifiers("wantToReadMenu__nonExclusiveShelf");
      return _jsx("li", {
        className: "wantToReadMenu__shelfItem"
      }, humanShelfName, _jsx("label", {
        className: nonExclusiveShelfClassnames
      }, void 0, _jsx("input", {
        className: "wantToReadMenu__shelfCheckbox",
        checked: shelfChecked,
        type: "checkbox",
        name: "shelf[" + shelf.name + "]",
        "aria-label": shelvingLabel,
        onChange: function onChange() {
          _this2.toggleNonExclusiveShelving(shelf);
        }
      }), humanShelfName));
    });
  },
  renderAddNewShelfButton: function renderAddNewShelfButton() {
    var allShelves = this.props.userShelves.customExclusiveShelves.concat(this.props.userShelves.nonExclusiveShelves).concat(this.props.userShelves.defaultShelves);
    var shelfNames = _lodash2.default.map(allShelves, function (shelf) {
      return shelf.name;
    });
    var userCanAddShelf = !_lodash2.default.includes(shelfNames, this.state.shelfNameFilter);
    var newShelfClassnames = this.withBemModifiers("wantToReadMenu__newShelfButtonContainer");
    return _jsx("li", {
      className: newShelfClassnames
    }, void 0, React.createElement(_want_to_read_menu_shelf_creator2.default, _extends({
      shelfNameFilter: this.state.shelfNameFilter,
      userCanAddShelf: userCanAddShelf,
      uniqueId: this.props.uniqueId,
      bookId: this.props.bookId,
      bemModifiers: this.props.bemModifiers,
      useModalView: this.props.useModalView,
      bookTitle: this.props.bookTitle
    }, this.state)));
  },
  render: function render() {
    return _jsx("div", {
      className: "wantToReadMenu"
    }, void 0, this.props.useModalView && _jsx("div", {
      className: "wantToReadMenu__headerContainer"
    }, void 0, this.renderFilter()), _jsx("div", {
      className: "wantToReadMenu__scrollableContainer"
    }, void 0, !this.props.useModalView && this.renderFilter(), this.renderEmptyMessage(), this.renderExclusiveShelves(), this.renderNonExclusiveShelves()), this.renderAddNewShelfButton());
  }
});

},{"../../modules/default_shelves":11,"../../react_actions/shelvings_actions":41,"../../react_mixins/gr_reflux":250,"../../react_stores/want_to_read_menu_store":277,"../gr_component_factory":108,"../spinner":226,"./want_to_read_menu_filter":240,"./want_to_read_menu_shelf_creator":241,"classnames":"classnames","lodash":"lodash"}],240:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenuFilter is used to filter shelf names within the Want to Read
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenuFilter",
  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    shelvings: _react2.default.PropTypes.object.isRequired,
    wantToReadMenu: _react2.default.PropTypes.object.isRequired
  },

  handleKeyPress: function handleKeyPress(event) {
    var exclusiveShelfName = null;
    if (this.props.shelvings.exclusiveShelfName !== null) {
      exclusiveShelfName = this.props.shelvings.exclusiveShelfName;
    }
    _want_to_read_menu_actions2.default.updateShelfNameFilter(event.target.value, this.props.uniqueId, exclusiveShelfName);
  },
  render: function render() {
    var classNames = this.withBemModifiers("wantToReadMenuFilter");
    return _jsx("form", {
      className: classNames,
      onSubmit: function onSubmit(ev) {
        return ev.preventDefault();
      }
    }, void 0, _jsx("input", {
      className: "gr-textInput\n                               gr-textInput--small\n                               wantToReadMenuFilter--textInput",
      type: "text",
      placeholder: "Filter Shelves",
      "aria-label": "Filter Shelf Names",
      value: this.props.wantToReadMenu.shelfNameFilter,
      onChange: this.handleKeyPress
    }));
  }
});

},{"../../react_actions/want_to_read_menu_actions":45,"../gr_component_factory":108,"react":"react"}],241:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenuShelfCreator is a component that lets you add a new shelf to your
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            UserShelves for the current user.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenuShelfCreator",

  propTypes: {
    userCanAddShelf: _react2.default.PropTypes.bool.isRequired,
    shelfNameFilter: _react2.default.PropTypes.string,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string.isRequired,
    useModalView: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { useModalView: false };
  },
  getInitialState: function getInitialState() {
    return {
      unsavedShelfName: ""
    };
  },
  openAddShelfTextbox: function openAddShelfTextbox() {
    _want_to_read_menu_actions2.default.openAddShelfTextbox(this.props.uniqueId);
  },
  closeAddShelfTextbox: function closeAddShelfTextbox() {
    _want_to_read_menu_actions2.default.closeAddShelfTextbox(this.props.uniqueId);
  },
  checkIfCommentIsEmpty: function checkIfCommentIsEmpty(event) {
    this.setState({ unsavedShelfName: event.target.value });
  },
  shelveAsNewShelfName: function shelveAsNewShelfName(shelfName, event) {
    event.preventDefault();
    _want_to_read_menu_actions2.default.updateShelfNameFilter("", this.props.uniqueId);
    _shelvings_actions2.default.toggleNonExclusiveShelving(this.props.bookId, { name: shelfName }, true, this.props.bookTitle);
  },
  render: function render() {
    var _this = this;

    if (this.props.shelfNameFilter !== "" && this.props.userCanAddShelf) {
      var buttonClassnames = this.withBemModifiers("wantToReadShelfCreator__addNamedShelfButton");
      return _jsx("span", {
        className: "wantToReadShelfCreator"
      }, void 0, _jsx("button", {
        className: buttonClassnames,
        "aria-label": "Add new " + this.props.shelfNameFilter + " shelf",
        onClick: function onClick(event) {
          _this.shelveAsNewShelfName(_this.props.shelfNameFilter, event);
        }
      }, void 0, "Add new “", _jsx("span", {
        className: "wantToReadShelfCreator__addShelfButtonShelfName"
      }, void 0, this.props.shelfNameFilter), "” shelf"));
    } else if (this.props.showAddShelfTextbox) {
      var containerCx = (0, _classnames2.default)(this.withBemModifiers("wantToReadShelfCreator"), "wantToReadShelfCreator--wrap");

      var textInputCx = (0, _classnames2.default)("gr-textInput", this.withBemModifiers("wantToReadShelfCreator__textInput"), {
        "gr-textInput--small": !this.props.useModalView
      });

      var submitCx = (0, _classnames2.default)(this.withBemModifiers("wantToReadShelfCreator__addShelfButton"), "gr-button", { "gr-button--small": !this.props.useModalView,
        "gr-button--dark gr-button--fullWidth": this.props.useModalView });

      return _jsx("form", {
        className: containerCx,
        onSubmit: function onSubmit(event) {
          _this.shelveAsNewShelfName(_this.state.unsavedShelfName, event);
        }
      }, void 0, _jsx("input", {
        className: textInputCx,
        type: "text",
        placeholder: "New Shelf Name",
        "aria-label": "Add new shelf name",
        autoFocus: true,
        onChange: this.checkIfCommentIsEmpty
      }), _jsx("div", {
        className: "wantToReadShelfCreator__buttonContainer"
      }, void 0, _jsx("input", {
        type: "submit",
        className: submitCx,
        disabled: _lodash2.default.isEmpty(_lodash2.default.trim(this.state.unsavedShelfName)),
        value: "Add"
      }), this.props.useModalView && _jsx("button", {
        type: "button",
        className: "gr-button gr-button--fullWidth wantToReadShelfCreator__cancelButton",
        onClick: this.closeAddShelfTextbox,
        "aria-label": "Close add new shelf form"
      }, void 0, "Cancel")));
    } else if (!this.props.userCanAddShelf) {
      // User cannot create a new shelf if they have typed in the name
      return null;
    } else {
      var buttonClassnames = this.withBemModifiers("wantToReadShelfCreator__showAddShelfTextboxButton");
      return _jsx("span", {
        className: "wantToReadShelfCreator"
      }, void 0, _jsx("button", {
        className: buttonClassnames,
        "aria-label": "Add new shelf",
        onClick: this.openAddShelfTextbox
      }, void 0, "Add New Shelf"));
    }
  }
});

},{"../../react_actions/shelvings_actions":41,"../../react_actions/want_to_read_menu_actions":45,"../gr_component_factory":108,"classnames":"classnames","lodash":"lodash","react":"react"}],242:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorStores = exports.AuthorComponents = undefined;

var _banner = require("../react_components/author/ask_the_author/banner");

var _banner2 = _interopRequireDefault(_banner);

var _start_answering_button = require("../react_components/author/ask_the_author/start_answering_button");

var _start_answering_button2 = _interopRequireDefault(_start_answering_button);

var _featured_author_container = require("../react_components/author/ask_the_author/featured_author_container");

var _featured_author_container2 = _interopRequireDefault(_featured_author_container);

var _community_question_answer_container = require("../react_components/author/ask_the_author/community_question_answer_container");

var _community_question_answer_container2 = _interopRequireDefault(_community_question_answer_container);

var _followed_authors_container = require("../react_components/author/ask_the_author/followed_authors_container");

var _followed_authors_container2 = _interopRequireDefault(_followed_authors_container);

var _likes_and_comments_footer = require("../react_components/like/likes_and_comments_footer");

var _likes_and_comments_footer2 = _interopRequireDefault(_likes_and_comments_footer);

var _select_menu = require("../react_components/select_menu");

var _select_menu2 = _interopRequireDefault(_select_menu);

var _ask_the_author_followed_authors_store = require("../react_stores/ask_the_author_followed_authors_store");

var _ask_the_author_followed_authors_store2 = _interopRequireDefault(_ask_the_author_followed_authors_store);

var _comments_store = require("../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _like_store = require("../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorComponents = exports.AuthorComponents = {
  AskTheAuthorBanner: _banner2.default,
  StartAnsweringButton: _start_answering_button2.default,
  AskTheAuthorFeaturedAuthorContainer: _featured_author_container2.default,
  AskTheAuthorCommunityQuestionAnswerContainer: _community_question_answer_container2.default,
  AskTheAuthorFollowedAuthorsContainer: _followed_authors_container2.default,
  LikesAndCommentsFooter: _likes_and_comments_footer2.default,
  SelectMenu: _select_menu2.default
};

var AuthorStores = exports.AuthorStores = {
  AskTheAuthorFollowedAuthorsStore: _ask_the_author_followed_authors_store2.default,
  CommentsStore: _comments_store2.default,
  LikeStore: _like_store2.default
};

},{"../react_components/author/ask_the_author/banner":64,"../react_components/author/ask_the_author/community_question_answer_container":65,"../react_components/author/ask_the_author/featured_author_container":66,"../react_components/author/ask_the_author/followed_authors_container":67,"../react_components/author/ask_the_author/start_answering_button":69,"../react_components/like/likes_and_comments_footer":120,"../react_components/select_menu":217,"../react_stores/ask_the_author_followed_authors_store":255,"../react_stores/comments_store":262,"../react_stores/like_store":265}],243:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalComponents = exports.GlobalStores = undefined;

var _google_ads_store = require("../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _login_interstitial = require("../react_components/login/interstitial/login_interstitial");

var _login_interstitial2 = _interopRequireDefault(_login_interstitial);

var _stores_initializer = require("../react_components/stores_initializer");

var _stores_initializer2 = _interopRequireDefault(_stores_initializer);

var _get_a_copy_button = require("../react_components/buy_buttons/get_a_copy_button");

var _get_a_copy_button2 = _interopRequireDefault(_get_a_copy_button);

var _get_a_copy_interstitial = require("../react_components/buy_buttons/get_a_copy_interstitial");

var _get_a_copy_interstitial2 = _interopRequireDefault(_get_a_copy_interstitial);

var _get_a_copy_interstitial_wrapper = require("../react_components/buy_buttons/get_a_copy_interstitial_wrapper");

var _get_a_copy_interstitial_wrapper2 = _interopRequireDefault(_get_a_copy_interstitial_wrapper);

var _qualtrics_survey = require("../react_components/qualtrics/qualtrics_survey");

var _qualtrics_survey2 = _interopRequireDefault(_qualtrics_survey);

var _review_cta = require("../react_components/book/review_cta");

var _review_cta2 = _interopRequireDefault(_review_cta);

var _user_icon = require("../react_components/user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _user_not_interested_store = require("../react_stores/user_not_interested_store");

var _user_not_interested_store2 = _interopRequireDefault(_user_not_interested_store);

var _user_shelves_store = require("../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalStores = exports.GlobalStores = {
  GoogleAdsStore: _google_ads_store2.default,
  UserNotInterestedStore: _user_not_interested_store2.default,
  UserShelvesStore: _user_shelves_store2.default
}; // This holds the stores and components that should be accessible site-wide.
// This file should be included in all React bundles.

var GlobalComponents = exports.GlobalComponents = {
  LoginInterstitial: _login_interstitial2.default,
  StoresInitializer: _stores_initializer2.default,
  GetACopyButton: _get_a_copy_button2.default,
  GetACopyInterstitial: _get_a_copy_interstitial2.default,
  GetACopyInterstitialWrapper: _get_a_copy_interstitial_wrapper2.default,
  QualtricsSurvey: _qualtrics_survey2.default,
  ReviewCta: _review_cta2.default,
  UserIcon: _user_icon2.default
};

},{"../react_components/book/review_cta":74,"../react_components/buy_buttons/get_a_copy_button":77,"../react_components/buy_buttons/get_a_copy_interstitial":78,"../react_components/buy_buttons/get_a_copy_interstitial_wrapper":79,"../react_components/login/interstitial/login_interstitial":123,"../react_components/qualtrics/qualtrics_survey":206,"../react_components/stores_initializer":227,"../react_components/user/user_icon":230,"../react_stores/google_ads_store":264,"../react_stores/user_not_interested_store":274,"../react_stores/user_shelves_store":276}],244:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeStores = exports.HomeComponents = undefined;

var _currently_reading = require("../react_components/currently_reading/currently_reading");

var _currently_reading2 = _interopRequireDefault(_currently_reading);

var _newsfeed = require("../react_components/newsfeed/newsfeed");

var _newsfeed2 = _interopRequireDefault(_newsfeed);

var _shelf_display = require("../react_components/shelf_display");

var _shelf_display2 = _interopRequireDefault(_shelf_display);

var _user_shelves_book_counts = require("../react_components/user_shelves_book_counts");

var _user_shelves_book_counts2 = _interopRequireDefault(_user_shelves_book_counts);

var _reading_challenge = require("../react_components/reading_challenge");

var _reading_challenge2 = _interopRequireDefault(_reading_challenge);

var _recommendations_widget = require("../react_components/home_page/recommendations_widget");

var _recommendations_widget2 = _interopRequireDefault(_recommendations_widget);

var _improve_recommendations = require("../react_components/home_page/improve_recommendations");

var _improve_recommendations2 = _interopRequireDefault(_improve_recommendations);

var _footer = require("../react_components/home_page/footer");

var _footer2 = _interopRequireDefault(_footer);

var _google_banner_ad = require("../react_components/ads/google_banner_ad");

var _google_banner_ad2 = _interopRequireDefault(_google_banner_ad);

var _editorial_blog_thumbnail = require("../react_components/home_page/editorial_blog_thumbnail");

var _editorial_blog_thumbnail2 = _interopRequireDefault(_editorial_blog_thumbnail);

var _choice_widget = require("../react_components/home_page/choice_widget");

var _choice_widget2 = _interopRequireDefault(_choice_widget);

var _sponsored_book = require("../react_components/ads/custom_campaign/sponsored_book");

var _sponsored_book2 = _interopRequireDefault(_sponsored_book);

var _youtube_video = require("../react_components/ads/custom_campaign/youtube_video");

var _youtube_video2 = _interopRequireDefault(_youtube_video);

var _carousel = require("../react_components/carousel/carousel");

var _carousel2 = _interopRequireDefault(_carousel);

var _newsfeed_update_store = require("../react_stores/newsfeed_update_store");

var _newsfeed_update_store2 = _interopRequireDefault(_newsfeed_update_store);

var _author_follow_store = require("../react_stores/author_follow_store");

var _author_follow_store2 = _interopRequireDefault(_author_follow_store);

var _recommendations_store = require("../react_stores/recommendations_store");

var _recommendations_store2 = _interopRequireDefault(_recommendations_store);

var _comments_store = require("../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _like_store = require("../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _user_shelves_store = require("../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

var _reading_session_store = require("../react_stores/reading_session_store");

var _reading_session_store2 = _interopRequireDefault(_reading_session_store);

var _google_ads_store = require("../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _reading_challenge_store = require("../react_stores/reading_challenge_store");

var _reading_challenge_store2 = _interopRequireDefault(_reading_challenge_store);

var _user_ratings_store = require("../react_stores/user_ratings_store");

var _user_ratings_store2 = _interopRequireDefault(_user_ratings_store);

var _click_tracking_store = require("../react_stores/click_tracking_store");

var _click_tracking_store2 = _interopRequireDefault(_click_tracking_store);

var _carousel_store = require("../react_stores/carousel_store");

var _carousel_store2 = _interopRequireDefault(_carousel_store);

var _user_not_interested_store = require("../react_stores/user_not_interested_store");

var _user_not_interested_store2 = _interopRequireDefault(_user_not_interested_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Stores
// Components
var HomeComponents = exports.HomeComponents = {
  CurrentlyReading: _currently_reading2.default,
  Newsfeed: _newsfeed2.default,
  GoogleBannerAd: _google_banner_ad2.default,
  ReadingChallenge: _reading_challenge2.default,
  RecommendationsWidget: _recommendations_widget2.default,
  ImproveRecommendations: _improve_recommendations2.default,
  ShelfDisplay: _shelf_display2.default,
  UserShelvesBookCounts: _user_shelves_book_counts2.default,
  Footer: _footer2.default,
  EditorialBlogThumbnail: _editorial_blog_thumbnail2.default,
  SponsoredBook: _sponsored_book2.default,
  YoutubeVideo: _youtube_video2.default,
  Carousel: _carousel2.default,
  ChoiceWidget: _choice_widget2.default
};

var HomeStores = exports.HomeStores = {
  NewsfeedUpdateStore: _newsfeed_update_store2.default,
  AuthorFollowStore: _author_follow_store2.default,
  RecommendationsStore: _recommendations_store2.default,
  CommentsStore: _comments_store2.default,
  GoogleAdsStore: _google_ads_store2.default,
  LikeStore: _like_store2.default,
  ShelvingsStore: _shelvings_store2.default,
  UserShelvesStore: _user_shelves_store2.default,
  ReadingSessionStore: _reading_session_store2.default,
  ReadingChallengeStore: _reading_challenge_store2.default,
  UserRatingsStore: _user_ratings_store2.default,
  ClickTrackingStore: _click_tracking_store2.default,
  CarouselStore: _carousel_store2.default,
  UserNotInterestedStore: _user_not_interested_store2.default
};

},{"../react_components/ads/custom_campaign/sponsored_book":51,"../react_components/ads/custom_campaign/youtube_video":52,"../react_components/ads/google_banner_ad":53,"../react_components/carousel/carousel":82,"../react_components/currently_reading/currently_reading":101,"../react_components/home_page/choice_widget":110,"../react_components/home_page/editorial_blog_thumbnail":111,"../react_components/home_page/footer":112,"../react_components/home_page/improve_recommendations":114,"../react_components/home_page/recommendations_widget":115,"../react_components/newsfeed/newsfeed":162,"../react_components/reading_challenge":208,"../react_components/shelf_display":225,"../react_components/user_shelves_book_counts":237,"../react_stores/author_follow_store":256,"../react_stores/carousel_store":260,"../react_stores/click_tracking_store":261,"../react_stores/comments_store":262,"../react_stores/google_ads_store":264,"../react_stores/like_store":265,"../react_stores/newsfeed_update_store":267,"../react_stores/reading_challenge_store":268,"../react_stores/reading_session_store":269,"../react_stores/recommendations_store":270,"../react_stores/shelvings_store":272,"../react_stores/user_not_interested_store":274,"../react_stores/user_ratings_store":275,"../react_stores/user_shelves_store":276}],245:[function(require,module,exports){
"use strict";

var _arrayPrototype = require("array.prototype.find");

var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_arrayPrototype2.default.shim();

},{"array.prototype.find":"array.prototype.find"}],246:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  propTypes: {
    bemModifiers: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string)])
  },
  // Expects `cls` to be a string holding a CSS class name. Returns string
  // holding that class, plus that class with the BEM modifier suffix(es)
  // (supplied as `bemModifiers` prop) appended.
  withBemModifiers: function withBemModifiers(cls) {
    var modifiers = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

    if (modifiers === null) {
      modifiers = this.props.bemModifiers;
    }
    if (modifiers) {
      if (_lodash2.default.isString(modifiers)) {
        return cls + " " + cls + "--" + modifiers;
      } else if (_lodash2.default.isArray(modifiers)) {
        var retval = (0, _classnames2.default)(cls, _lodash2.default.map(modifiers, function (mod) {
          return cls + "--" + mod;
        }));
        return retval;
      }
    } else {
      return cls;
    }
  },
  withBemElement: function withBemElement(cls, elem) {
    if (this.props.bemModifiers) {
      if (_lodash2.default.isString(this.props.bemModifiers)) {
        return cls + "--" + this.props.bemModifiers + "__" + elem;
      } else if (_lodash2.default.isArray(this.props.bemModifiers)) {
        return (0, _classnames2.default)(_lodash2.default.map(this.props.bemModifiers, function (mod) {
          return cls + "--" + mod + "__" + elem;
        }));
      }
    } else {
      return cls + "__" + elem;
    }
  }
}; /*
     Bem modifiers allows class modifiers to be passed in from parent components
     to child components to change styling based on the parent component.
   */

},{"classnames":"classnames","lodash":"lodash","react":"react"}],247:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel_helper = require("../../modules/carousel/carousel_helper");

var CarouselEventHandlers = {

  // Event handler for previous and next buttons

  changeSlide: function changeSlide(options) {
    var slideOffset = undefined,
        targetSlide = undefined;

    if (this.props.carouselWrapAround) {
      slideOffset = this.props.carouselSlidesToScroll;
    } else {
      if (options.message === _carousel_helper.nextTransitionMessage) {
        if (this.getState().currentSlide + this.props.carouselSlidesToShow + this.props.carouselSlidesToScroll <= this.getState().slideCount) {
          slideOffset = this.props.carouselSlidesToScroll;
        } else {
          slideOffset = this.getState().slideCount - this.getState().currentSlide - this.props.carouselSlidesToShow;
        }
      } else if (options.message === _carousel_helper.prevTransitionMessage) {
        if (this.getState().currentSlide - this.props.carouselSlidesToScroll >= 0) {
          slideOffset = this.props.carouselSlidesToScroll;
        } else {
          slideOffset = this.getState().currentSlide;
        }
      }
    }
    if (options.message === _carousel_helper.prevTransitionMessage) {
      targetSlide = this.getState().currentSlide - slideOffset;
    } else if (options.message === _carousel_helper.nextTransitionMessage) {
      targetSlide = this.getState().currentSlide + slideOffset;
    }
    this.slideHandler(targetSlide);
  },
  swipeStart: function swipeStart(e) {
    var posX = undefined,
        posY = undefined;
    posX = e.touches !== undefined ? e.touches[0].clientX : e.clientX;
    posY = e.touches !== undefined ? e.touches[0].clientY : e.clientY;
    var changedState = {
      swiping: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      }
    };
    this.setState({
      carouselStore: Object.assign({}, this.getState(), changedState)
    });
  },
  swipeEnd: function swipeEnd(e) {
    if (!this.getState().swiping) {
      return;
    }
    var touchObject = this.getState().touchObject;
    var posX = undefined,
        posY = undefined;
    posX = e.changedTouches !== undefined ? e.changedTouches[0].clientX : e.clientX;
    posY = e.changedTouches !== undefined ? e.changedTouches[0].clientY : e.clientY;
    touchObject.curX = posX;
    touchObject.curY = posY;
    var swipeDirection = this.swipeDirection(touchObject);
    var minSwipe = this.getState().carouselSlidesToShow > 2 ? this.getState().listWidth / this.getState().carouselSlidesToShow : this.getState().listWidth / 4;
    var swipeXLength = Math.abs(touchObject.curX - touchObject.startX);
    // reset the state of touch related state variables.
    var changedState = {
      swiping: false,
      touchObject: {}
    };
    this.setState({
      carouselStore: Object.assign({}, this.getState(), changedState)
    });
    if (!swipeXLength) {
      return;
    }
    if (swipeXLength > minSwipe) {
      e.preventDefault();
      if (swipeDirection === "left") {
        this.changeSlide({ message: _carousel_helper.nextTransitionMessage });
      } else if (swipeDirection === "right") {
        this.changeSlide({ message: _carousel_helper.prevTransitionMessage });
      } else {
        return;
      }
    }
  },
  swipeDirection: function swipeDirection(touchObject) {
    var xDist = undefined,
        yDist = undefined,
        r = undefined,
        swipeAngle = undefined;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
      return "left";
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return "right";
    }
    return "vertical";
  }
};

exports.default = CarouselEventHandlers;

},{"../../modules/carousel/carousel_helper":7}],248:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Interface to check state of frontend Deploy Services.
*/
exports.default = {
  propTypes: {
    deployServices: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string)
  },

  isFeatureEnabled: function isFeatureEnabled(featureCode) {
    return _lodash2.default.indexOf(this.deployServices(), featureCode) >= 0;
  },
  deployServices: function deployServices() {
    if (this.props.deployServices === undefined) {
      throw "trying to access Deploy Services from component, but component does not contain deployServices prop (" + this.constructor.displayName + ")";
    }
    return this.props.deployServices;
  }
};

},{"lodash":"lodash","react":"react"}],249:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (storeFactory) {
  return {
    getInitialState: function getInitialState() {
      this.store = storeFactory();
      return this.store.getInitialState();
    },
    componentWillMount: function componentWillMount() {
      this.actions = this.store.actions;
      this.unsubscribe = this.store.listen(this.onStoreChange);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.unsubscribe();
    },
    onStoreChange: function onStoreChange(state) {
      this.setState(state);
    }
  };
};

},{}],250:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectToLazyStore = connectToLazyStore;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
                                                                                                                                                                                                                  A lazy store manages data partitioned by keys, where each key has a
                                                                                                                                                                                                                  sensible starting value that does not need an external source to initialize
                                                                                                                                                                                                                  it prior to use, e.g. a form would have default values before any user input.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  Another important use case is for the absence of values. For example, instead
                                                                                                                                                                                                                  of requiring external code to initialize the starting value for all keys, a lazy
                                                                                                                                                                                                                  store only requires external code to initialize the non-absent values. For
                                                                                                                                                                                                                  example, if storing data about Likes or Comments, the external code would only
                                                                                                                                                                                                                  need to initialize the store with data for keys that have at least one Like
                                                                                                                                                                                                                  or Comment, leaving the rest to be lazily created in their empty state when needed.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If a store's data is not partitioned by keys, then it can just create its
                                                                                                                                                                                                                  state to the sensible starting value at creation time, and consumers do not
                                                                                                                                                                                                                  need to care about whether or not the store initialized itself or an external
                                                                                                                                                                                                                  call did. The fact that the keys are dynamic and unknown at initialization time
                                                                                                                                                                                                                  is why this extra layer is needed.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If the data for a particular key needs external information to initialize it,
                                                                                                                                                                                                                  then such initialization should be done eagerly before any components try to
                                                                                                                                                                                                                  connect to the store, removing the need for the store to be lazy.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  Usage in a component:
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  ...
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  propTypes: {
                                                                                                                                                                                                                    keyToUse: React.PropTypes.string.isRequired,
                                                                                                                                                                                                                  },
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore, "keyToUse")]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  ...
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  The lazy store should handle calls to getInitialState that include a single
                                                                                                                                                                                                                  param representing the key. If the key is not present in its data, it should
                                                                                                                                                                                                                  be set and returned. This set should not cause a trigger to any existing
                                                                                                                                                                                                                  listeners.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  You can also namespace the state from the store under a different key so that
                                                                                                                                                                                                                  store state can more easily coexist in the same component.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore, "uniqueId", {stateKey: "stateKey"})]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If you want to only listen to a specific value of the state, add a filterValue
                                                                                                                                                                                                                  param that will act as a filter for the substate you want to listen to.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore,
                                                                                                                                                                                                                                              "uniqueId",
                                                                                                                                                                                                                                              {stateKey: "stateKey", filterValue: "specificStateValue"})]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  */

function connectToLazyStore(store, keyPropName) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var _ref$stateKey = _ref.stateKey;
  var stateKey = _ref$stateKey === undefined ? null : _ref$stateKey;
  var _ref$filterValue = _ref.filterValue;
  var filterValue = _ref$filterValue === undefined ? null : _ref$filterValue;

  return {
    getInitialState: function getInitialState() {
      var value = store.getInitialState(_lodash2.default.get(this.props, keyPropName));
      if (filterValue) {
        value = value[filterValue];
      }
      if (!_lodash2.default.isNull(stateKey)) {
        value = _defineProperty({}, stateKey, value);
      }
      return value;
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      // This provides this.listenTo, which we need to use so
      // Reflux.ListenerMixin will cleanup on unmount
      _reflux2.default.utils.extend(this, _reflux2.default.ListenerMethods);

      this.listenTo(store, function (newState) {
        var incomingValue = newState[_lodash2.default.get(_this.props, keyPropName)];
        if (filterValue) {
          incomingValue = incomingValue[filterValue];
        }
        if (!_lodash2.default.isNull(stateKey)) {
          incomingValue = _defineProperty({}, stateKey, incomingValue);
        }
        _this.setState(incomingValue);
      });
    },

    componentWillUnmount: _reflux2.default.ListenerMixin.componentWillUnmount
  };
}

},{"lodash":"lodash","reflux":"reflux"}],251:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultHoverDelay = 250; /*
                             * Delayed hover behavior
                             * This is the react mixin version of the HoverIntent within shared_all_formats/
                             * hover_intent.js
                             */

exports.default = {
  onEnterIntent: function onEnterIntent(fn, delay) {
    if (!delay) {
      delay = defaultHoverDelay;
    }

    // Cancel any pending mouseleave action
    try {
      clearTimeout(this.leaveTimeout);
    } catch (e) {} /* Do nothing */

    // Set up a delayed call to the mouseenter callback
    this.hoverTimeout = _lodash2.default.delay(fn, delay);
  },
  onLeaveIntent: function onLeaveIntent(fn, delay) {
    if (!delay) {
      delay = defaultHoverDelay;
    }

    // Cancel any pending mouseenter action
    try {
      clearTimeout(this.hoverTimeout);
    } catch (e) {} /* Do nothing */

    // Set up a delayed call to the mouseleave callback
    this.leaveTimeout = _lodash2.default.delay(fn, delay);
  }
};

},{"lodash":"lodash"}],252:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require("lodash");

var _data_tracking_helper = require("../modules/data_tracking/data_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function is called on every component when it mounts and attaches 
 * click tracking data attributes that are provided by the trackingOptions props. 
 * The event listener is added to the top most element, that has enabledTracking = true
 */

exports.default = {
  componentDidMount: function componentDidMount() {
    var _this = this;

    var trackingOptions = this.props.trackingOptions;
    if (trackingOptions) {
      (function () {
        var node = _reactDom2.default.findDOMNode(_this);
        if (node) {
          // Store specified tracking values as data attributes on the component's DOM node
          (0, _lodash.each)((0, _lodash.keys)(trackingOptions), function (key) {
            var value = trackingOptions[key];
            if (!(0, _lodash.isUndefined)(value)) {
              node.setAttribute("data-tracking-" + key, JSON.stringify(value));
            }
          });

          if (trackingOptions.enableTracking === true) {
            // register click tracking for requested components
            node.addEventListener("click", _data_tracking_helper.handleDataTracking);
          }
        }
      })();
    }
  }
};

},{"../modules/data_tracking/data_tracking_helper":9,"lodash":"lodash","react-dom":"react-dom"}],253:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

var reducer = function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case _get_a_copy_actions.GET_A_COPY_ACTIONS.LOADED_SUCCESS:
      return Object.assign({}, state, {
        activeGetACopyInterstitial: action.data
      });
    case _get_a_copy_actions.GET_A_COPY_ACTIONS.INTERSTITIAL_CLOSED:
      return Object.assign({}, state, {
        activeGetACopyInterstitial: null
      });
    default:
      return state;
  }
};

exports.default = reducer;

},{"../../react_actions/buy_buttons/get_a_copy_actions":28}],254:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _ask_the_author_banner_actions = require("../react_actions/ask_the_author_banner_actions");

var _ask_the_author_banner_actions2 = _interopRequireDefault(_ask_the_author_banner_actions);

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialStateData = { isBannerShown: true };
var state = undefined;
exports.default = _reflux2.default.createStore({
  listenables: _ask_the_author_banner_actions2.default,

  getState: function getState() {
    return state.get();
  },
  getInitialState: function getInitialState() {
    state = new _freezerJs2.default(initialStateData);
    return this.getState();
  },
  reset: function reset() {
    this.getState().reset(initialStateData);
  },
  updateState: function updateState(newStateData) {
    this.getState().set(newStateData);
    this.trigger(this.getState());
  },
  showBanner: function showBanner() {
    var newStateData = { isBannerShown: true };
    this.updateState(newStateData);
  },
  hideBanner: function hideBanner() {
    var newStateData = { isBannerShown: false };
    this.updateState(newStateData);
  },
  onHideBanner: function onHideBanner() {
    this.hideBanner();
  },
  onOptAuthorIntoQA: function onOptAuthorIntoQA(authorID) {
    var _this = this;

    var url = "/ask_the_author/" + authorID + "/opt_in";
    $j.post(url).done(function (resp) {
      _this.hideBanner();
      _env_utils2.default.setLocationUrl(resp.return_url);
    }).fail(function () {
      //if there was an error opting author into qa, make sure the banner does not go away so user can retry
      _this.showBanner();
      window.alert("Please try again.");
    });
  }
});

},{"../modules/env_utils":12,"../react_actions/ask_the_author_banner_actions":25,"freezer-js":"freezer-js","reflux":"reflux"}],255:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _followed_authors_actions = require("../react_actions/ask_the_author/followed_authors_actions");

var _followed_authors_actions2 = _interopRequireDefault(_followed_authors_actions);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*doc

 Contains the list of authors a user follows.
 Store is populated with list of authors plus
 relevant data. Data is rendered in
 AskTheAuthorCommunityQuestionAnswerContainer

 */

var state = new _freezerJs2.default({
  authors: [],
  total: 0
});

var fullFollowedAuthorsList = [];

var DESKTOP_DEFAULT_INITIAL_LIST_SIZE = 3;
var DESKTOP_LOAD_MORE_SIZE = 3;

var MOBILE_DEFAULT_INITIAL_LIST_SIZE = 3;
var MOBILE_LOAD_MORE_SIZE = 3;

var defaultListSize = undefined;
var loadMoreSize = undefined;

exports.default = _reflux2.default.createStore({
  listenables: [_followed_authors_actions2.default],

  fullFollowedAuthorsList: fullFollowedAuthorsList,

  DESKTOP_DEFAULT_INITIAL_LIST_SIZE: DESKTOP_DEFAULT_INITIAL_LIST_SIZE,
  DESKTOP_LOAD_MORE_SIZE: DESKTOP_LOAD_MORE_SIZE,

  MOBILE_DEFAULT_INITIAL_LIST_SIZE: MOBILE_DEFAULT_INITIAL_LIST_SIZE,
  MOBILE_LOAD_MORE_SIZE: MOBILE_LOAD_MORE_SIZE,

  defaultListSize: defaultListSize,
  loadMoreSize: loadMoreSize,

  init: function init() {
    this.getState().set({ authors: [], total: 0 });
    fullFollowedAuthorsList = [];
    defaultListSize = DESKTOP_DEFAULT_INITIAL_LIST_SIZE;
    loadMoreSize = DESKTOP_LOAD_MORE_SIZE;
  },
  getState: function getState() {
    return state.get();
  },
  getInitialState: function getInitialState() {
    return this.getState();
  },
  reset: function reset() {
    this.getState().reset({});
    fullFollowedAuthorsList = [];
  },
  setMobileDefaults: function setMobileDefaults() {
    defaultListSize = MOBILE_DEFAULT_INITIAL_LIST_SIZE;
    loadMoreSize = MOBILE_LOAD_MORE_SIZE;
  },
  populateList: function populateList(data) {
    var numFollowedAuthors = data.length;
    (0, _lodash.each)(data, function (singleAuthorData) {
      fullFollowedAuthorsList.push({ name: singleAuthorData.author.name,
        id: singleAuthorData.author.id,
        profileUrl: singleAuthorData.author.profileUrl,
        profileImage: singleAuthorData.author.profileImage,
        authorTagline: singleAuthorData.authorTagline,
        questionURL: singleAuthorData.questionURL,
        answerURL: singleAuthorData.answerURL,
        answersCount: singleAuthorData.answersCount,
        ATAenabled: singleAuthorData.ATAenabled,
        recentQuestionText: singleAuthorData.answerData.recentQuestion.text,
        recentAnswerTruncatedHtml: singleAuthorData.answerData.recentAnswer.text,
        recentQuestionSpoiler: singleAuthorData.answerData.recentQuestion.spoiler,
        recentAnswerSpoiler: singleAuthorData.answerData.recentAnswer.spoiler,
        flagForAbuseUrl: singleAuthorData.answerData.flagForAbuseUrl,
        social: singleAuthorData.answerData.social });
    });
    if (numFollowedAuthors) {
      var authors_list = fullFollowedAuthorsList;
      if (numFollowedAuthors > defaultListSize) {
        authors_list = authors_list.slice(0, defaultListSize);
      }
      this.getState().set({ authors: authors_list, total: numFollowedAuthors });
    }
  },

  /*
  loads the next three authors from fullFollowedAuthorsList
  that were not previously loaded into the state authors variable
   */
  onLoadMoreFollowedAuthors: function onLoadMoreFollowedAuthors() {
    var state = this.getState();
    var authorList = state.authors;
    var authorListLength = authorList.length;
    var totalAuthors = state.total;
    var toAdd = Math.min(loadMoreSize, totalAuthors - authorListLength);
    for (var i = authorListLength; i < authorListLength + toAdd; i++) {
      var anotherAuthor = fullFollowedAuthorsList[i];
      authorList = authorList.push(anotherAuthor);
    }
    this.getState().set({ authors: authorList });
    this.trigger(this.getState());
  }
});

},{"../react_actions/ask_the_author/followed_authors_actions":24,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],256:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _author_follow_actions = require("../react_actions/author_follow_actions");

var _author_follow_actions2 = _interopRequireDefault(_author_follow_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var setResourceValue = function setResourceValue(resource, value) {
  return getState()[resource].set(value);
};

var getResourceValue = function getResourceValue(resource, key) {
  return getState()[resource][key];
};

var toggleAuthorFollowStoreData = function toggleAuthorFollowStoreData(resource) {
  var followingCount = getResourceValue(resource, "followingCount");
  var isFollowing = getResourceValue(resource, "isFollowing");
  var newValue = {
    isFollowing: !isFollowing,
    followingCount: isFollowing ? followingCount - 1 : followingCount + 1
  };
  setResourceValue(resource, newValue);
};

var toggleButtonEnabled = function toggleButtonEnabled(resource) {
  var oldValue = getResourceValue(resource, "buttonEnabled");
  setResourceValue(resource, { buttonEnabled: !oldValue });
};

var store = _reflux2.default.createStore({
  listenables: _author_follow_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.AUTHOR_FOLLOWS)],
  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(rawData) {
    var newValue = _lodash2.default.transform(rawData, function (scrubbedData, authorFollow, authorId) {
      scrubbedData[authorId] = {
        isFollowing: authorFollow.isFollowing || false,
        followingCount: authorFollow.followingCount || 0,
        authorFollowingId: authorFollow.authorFollowingId || null,
        source: authorFollow.source || false,
        buttonEnabled: true
      };
    });
    getState().set(newValue);
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  reset: function reset() {
    getState().reset({});
  },
  onFollow: function onFollow(resource) {
    var _this = this;

    // If we came from a knh page, include that in post for metrics counting in rails
    var source = getResourceValue(resource, "source");
    var fromAnnotatedBookPage = source === "AnnotatedBooksPage";
    var fromReadingNotesListPage = source === "ReadingNotesListPage";

    // Disable follow button
    toggleButtonEnabled(resource);
    this.trigger(this.getState());
    $j.post("/author_followings", {
      format: "json",
      id: resource,
      from_annotated_books_page: fromAnnotatedBookPage,
      from_reading_notes_list_page: fromReadingNotesListPage
    }).done(function (resp) {
      // POST /author_followings returns the url of the created author
      // following object
      var newValue = {
        authorFollowingId: parseInt(_lodash2.default.words(resp.url, /[0-9]+/)[0], 10)
      };
      setResourceValue(resource, newValue);
      toggleAuthorFollowStoreData(resource);
      toggleButtonEnabled(resource);
      _this.trigger(_this.getState());
    }).fail(function (error) {
      // Redirect to sign_in if authentication fails
      if (error && error.status === 403 && error.responseJSON) {
        location.href = error.responseJSON.redirect;
      }
    });
  },
  onUnFollow: function onUnFollow(resource) {
    var _this2 = this;

    // Disable unfollow button
    toggleButtonEnabled(resource);
    this.trigger(this.getState());
    $j.ajax({
      type: "DELETE",
      url: "/author_followings/" + getResourceValue(resource, "authorFollowingId"),
      data: {
        format: "json"
      }
    }).done(function () {
      var newValue = {
        authorFollowingId: null
      };
      setResourceValue(resource, newValue);
      toggleAuthorFollowStoreData(resource);
      toggleButtonEnabled(resource);
      _this2.trigger(_this2.getState());
    });
  }
});

exports.default = store;

},{"../react_actions/author_follow_actions":26,"./shared/newsfeed_updates_mixin":271,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],257:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _book_search_actions_factory = require("../react_actions/book_search_actions_factory");

var _book_search_actions_factory2 = _interopRequireDefault(_book_search_actions_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factory = function factory() {
  var state = new _freezerJs2.default({ showLoadingSpinner: false,
    showResultsContainer: false,
    results: [],
    query: "",
    activeResult: null
  });
  var actions = (0, _book_search_actions_factory2.default)();

  var updateState = function updateState(results) {
    var values = state.get();
    values.results.reset(results);
  };

  var store = _reflux2.default.createStore({
    listenables: actions,
    getInitialState: state.get,
    getState: state.get,
    actions: actions,

    initializeWith: function initializeWith(data) {
      state.get().set("showLoadingSpinner", data.showLoadingSpinner).set("showResultsContainer", data.showResultsContainer).set("query", data.query).set("activeResult", data.activeResult).results.reset(data.results);
    },
    reset: function reset() {
      state.get().reset({});
    },
    setValue: function setValue(key, value) {
      var stateValues = state.get();
      stateValues.set(key, value);
    },
    onSelectSpecificResult: function onSelectSpecificResult(bookId) {
      var newActiveResult = _lodash2.default.find(this.getState().results, function (result) {
        return result.bookId === bookId;
      });
      this.setValue("activeResult", newActiveResult);
      this.trigger(this.getState());
    },
    onSetShowResultsContainer: function onSetShowResultsContainer(value) {
      this.setValue("showResultsContainer", value);
      this.setValue("activeResult", null);
      this.trigger(this.getState());
    },
    onSelectNextResult: function onSelectNextResult(maxResults) {
      var results = this.getState().results;
      var currentIndex = _lodash2.default.indexOf(results, this.getState().activeResult);
      this.setValue("activeResult", results[(currentIndex + 1) % maxResults]);
      this.trigger(this.getState());
    },
    onSelectPreviousResult: function onSelectPreviousResult(maxResults) {
      var results = this.getState().results;
      var activeResult = this.getState().activeResult;
      var currentIndex = _lodash2.default.indexOf(results, activeResult);
      if (currentIndex === 0 || activeResult === null) {
        this.setValue("activeResult", results[maxResults - 1]);
      } else {
        this.setValue("activeResult", results[(currentIndex - 1) % maxResults]);
      }
      this.trigger(this.getState());
    },
    onSearchResultsFound: function onSearchResultsFound(query, results) {
      updateState(results);
      this.setValue("query", query);
      this.setValue("showLoadingSpinner", false);
      this.setValue("activeResult", null);
      this.setValue("showResultsContainer", true);
      this.trigger(this.getState());
    },
    onSearch: function onSearch(searchValue, searchUrl) {
      this.setValue("showLoadingSpinner", true);
      this.trigger(this.getState());
      $j.ajax({
        url: searchUrl,
        data: { format: "json",
          q: searchValue },
        success: function success(resp) {
          actions.searchResultsFound(searchValue, resp);
        }
      });
    }
  });

  return store;
};
// ACTIONS

exports.default = factory;

},{"../react_actions/book_search_actions_factory":27,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],258:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_store = require("./shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Maps shelf names to objects that in turn map book IDs to shelvings,
  indicating that the current user has shelved those books on the named shelf.
  i.e.:

  {'to-read': {[bookId]: {…}, [bookId2]: {…}},
   'currently-reading': {…},
   …
  }

  LIMITATION: only maps exclusive shelves

  This store gets its data by listening to ShelvingsStore. It serves as another
  "view" of the ShelvingsStore data.
*/

var state = new _freezerJs2.default({});

exports.default = _reflux2.default.createStore({
  getState: state.get,
  getInitialState: state.get,

  init: function init() {
    this.listenTo(_shelvings_store2.default, this.onShelvingsStoreChange);
  },
  reset: function reset() {
    this.getState().reset({});
  },
  onShelvingsStoreChange: function onShelvingsStoreChange(shelvingsStoreData) {
    var _this = this;

    if (_lodash2.default.isUndefined(shelvingsStoreData)) {
      this.getState().set({});
    } else {
      (function () {
        // Book IDs shelved here in BooksOnShelvesStore
        var bossShelvedBookIds = {};

        _lodash2.default.forOwn(shelvingsStoreData, function (shelving) {
          // If shelving data includes book data...
          if (_lodash2.default.has(shelving, "book.bookId")) {
            // ...and we haven't already recorded this book...
            if (!_lodash2.default.has(bossShelvedBookIds, shelving.book.bookId)) {
              bossShelvedBookIds[shelving.book.bookId] = true;

              // ...and the shelving data includes an exclusive shelf name...
              if (shelving.exclusiveShelfName !== null) {
                // If this is a shelf name we haven’t recorded before, add that
                // shelf name key to our state object
                if (!_lodash2.default.has(_this.getState(), shelving.exclusiveShelfName)) {
                  _this.getState().set(shelving.exclusiveShelfName, {});
                }

                _this.getState()[shelving.exclusiveShelfName].set(shelving.book.bookId, _lodash2.default.cloneDeep(shelving));
              }
            }
          }
        });
      })();
    }

    // Remove shelvings that no longer appear in ShelvingsStore
    // Grabbing data from shelvingsStore by using bookId as a key is not a bug --
    // if there are other books in the work that have been shelved, we're still
    // allowed to remove that book from booksOnShelvesStore, since only that
    // book was shelved, not the work.
    _lodash2.default.forOwn(this.getState(), function (shelfMap, shelfName) {
      _lodash2.default.each(_lodash2.default.keys(shelfMap), function (bookId) {
        // EV-1770: Sometimes remove isn't a function so don't call it
        if ((_lodash2.default.isUndefined(shelvingsStoreData[bookId]) || shelvingsStoreData[bookId].exclusiveShelfName === null) && _lodash2.default.isFunction(_this.getState()[shelfName].remove)) {
          _this.getState()[shelfName].remove(bookId);
        }
      });

      // If no shelvings for this shelf name, remove it entirely
      // EV-1770: Sometimes remove isn't a function so don't call it
      if (_lodash2.default.isEmpty(_this.getState()[shelfName]) && _lodash2.default.isFunction(_this.getState().remove)) {
        _this.getState().remove(shelfName);
      }
    });

    this.trigger(this.getState());
  }
});

},{"./shelvings_store":272,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],259:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require("redux");

var _reduxLogger = require("redux-logger");

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _get_a_copy_reducer = require("../../react_reducers/buy_buttons/get_a_copy_reducer");

var _get_a_copy_reducer2 = _interopRequireDefault(_get_a_copy_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middlewares = [_reduxThunk2.default]; /*
                                           This should be merged into a page-wide store.
                                           */

if (_env_utils2.default.isDevelopment() && _env_utils2.default.hasDom()) {
  middlewares.push((0, _reduxLogger2.default)());
}

var store = (0, _redux.createStore)(_get_a_copy_reducer2.default, {}, _redux.applyMiddleware.apply(undefined, middlewares));

exports.default = store;

},{"../../modules/env_utils":12,"../../react_reducers/buy_buttons/get_a_copy_reducer":253,"redux":"redux","redux-logger":"redux-logger","redux-thunk":"redux-thunk"}],260:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _carousel_actions = require("../react_actions/carousel_actions");

var _carousel_actions2 = _interopRequireDefault(_carousel_actions);

var _carousel_helper = require("../modules/carousel/carousel_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { carousels: {} };
var state = new _freezerJs2.default(defaultState);

var resetTo = function resetTo() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var getState = function getState() {
  return state.get();
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState().carousels, key)) {
    throw new ReferenceError("No such carousel existing for key " + key);
  }
  return getState().carousels[key];
};

var setDataForKey = function setDataForKey(key, data) {
  getStateForKey(key).set(data);
};

exports.default = _reflux2.default.createStore({

  listenables: [_carousel_actions2.default],

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  updateWith: function updateWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onSetSlides: function onSetSlides(carouselId) {
    var reactObjects = (0, _carousel_helper.getStoreObjects)(getStateForKey(carouselId));
    var newStateHash = {
      slideCount: getStateForKey(carouselId).slides.length,
      slides: reactObjects.slides
    };
    if (reactObjects.tooltips) {
      newStateHash.tooltips = reactObjects.tooltips;
    }
    var newState = _lodash2.default.merge(newStateHash, getStateForKey(carouselId));
    if (!reactObjects.tooltips && newState.hasOwnProperty("tooltips")) {
      newState.tooltips = undefined;
    }
    setDataForKey(carouselId, newState);
    this.notifyListeners();
  },
  onSetWidths: function onSetWidths(carouselId, data) {
    var newState = _lodash2.default.merge({}, getStateForKey(carouselId), data);
    setDataForKey(carouselId, newState);
    this.notifyListeners();
  },
  onSlidingCompletion: function onSlidingCompletion(carouselId, targetSlide) {
    setDataForKey(carouselId, _lodash2.default.merge({}, getStateForKey(carouselId), { currentSlide: targetSlide }));
    this.notifyListeners();
  },
  onShowTooltip: function onShowTooltip(carouselId, tooltipId) {
    setDataForKey(carouselId, _lodash2.default.merge({}, getStateForKey(carouselId), { displayTooltipAtIndex: tooltipId }));
    this.notifyListeners();
  },
  onHideTooltip: function onHideTooltip(carouselId) {
    setDataForKey(carouselId, _lodash2.default.merge({}, getStateForKey(carouselId), { displayTooltipAtIndex: -1 }));
    this.notifyListeners();
  },
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  getState: getState,

  reset: resetTo,

  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  }
});

},{"../modules/carousel/carousel_helper":7,"../react_actions/carousel_actions":29,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],261:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _data_tracking_actions = require("../react_actions/data_tracking/data_tracking_actions");

var _data_tracking_actions2 = _interopRequireDefault(_data_tracking_actions);

var _click_tracking_actions = require("../react_actions/click_tracking_actions");

var _click_tracking_actions2 = _interopRequireDefault(_click_tracking_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { pmetClickTrackUrl: "https://www.goodreads.com/track" };
var state = new _freezerJs2.default(defaultState);

var resetTo = function resetTo() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var getState = function getState() {
  return state.get();
};

exports.default = _reflux2.default.createStore({

  listenables: [_click_tracking_actions2.default, { trackClickEvent: _data_tracking_actions2.default.trackClickEvent }],

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  updateWith: function updateWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onTrackClickEvent: function onTrackClickEvent(event, source) {
    var target = event.target;
    var pmet = undefined,
        pmetData = undefined;

    //crawl up the source tree until you find the dfp and pmet tracking data
    while (target !== source) {
      if (target.getAttribute("data-tracking-pmet") && !pmet) {
        pmet = target.getAttribute("data-tracking-pmet");
        pmetData = JSON.parse(pmet);
        this.trackPmetClick(pmetData);
      }
      target = target.parentNode;
    }
  },
  mergeWith: function mergeWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  trackPmetClick: function trackPmetClick(additionalParams) {
    $j.ajax({
      type: "GET",
      url: getState().pmetClickTrackUrl,
      data: additionalParams
    });
  },
  getInitialState: function getInitialState() {
    return getState();
  },

  getState: getState,

  reset: resetTo,

  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  }
});

},{"../react_actions/click_tracking_actions":30,"../react_actions/data_tracking/data_tracking_actions":32,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],262:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _gr_error_reporting = require("../modules/gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

var _comment_actions = require("../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = {};
var state = new _freezerJs2.default(defaultState);
var MAX_TEXTAREA_ROWS = 2;
var MAX_COMMENTS_PER_PAGE = 10;

var getState = function getState() {
  return state.get();
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    getState().set(key, {
      numComments: 0,
      unsavedComment: "",
      comments: [],
      saveInProgress: false,
      showCommentButton: false,
      textareaRows: 1,
      showPagination: false,
      currentPage: 1,
      showSeeMoreLoadingSpinner: false
    });
  }
  return getState()[key];
};

var setDataForKey = function setDataForKey(key, data) {
  getStateForKey(key).set(data);
};

exports.default = _reflux2.default.createStore({
  listenables: _comment_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.COMMENTS)],

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  updateWith: function updateWith(data) {
    var transformedData = _lodash2.default.transform(data, function (result, commentData, key) {
      result[key] = {
        numComments: commentData.numComments || 0,
        unsavedComment: commentData.unsavedComment || "",
        comments: commentData.comments || [],
        showCommentButton: false,
        saveInProgress: false,
        textareaRows: 1,
        deletableByCurrentUser: commentData.deletableByCurrentUser,
        blockedByCurrentUser: commentData.blockedByCurrentUser || false
      };
    });
    getState().set(transformedData);
  },
  onTextareaFocusRequested: function onTextareaFocusRequested(subjectKey) {
    setDataForKey(subjectKey, {
      textareaFocusRequested: true
    });
    this.notifyListeners();
  },
  onTextareaFocused: function onTextareaFocused(subjectKey) {
    setDataForKey(subjectKey, { textareaRows: MAX_TEXTAREA_ROWS,
      textareaFocusRequested: false,
      showCommentButton: true });
    this.notifyListeners();
  },
  onTextareaUnfocused: function onTextareaUnfocused(subjectKey) {
    var comment = getStateForKey(subjectKey).unsavedComment;
    if (_lodash2.default.isEmpty(_lodash2.default.trim(comment))) {
      setDataForKey(subjectKey, { textareaRows: 1 });
    }
    this.notifyListeners();
  },
  onShowSeeMoreLoadingSpinner: function onShowSeeMoreLoadingSpinner(subjectKey) {
    setDataForKey(subjectKey, { showSeeMoreLoadingSpinner: true });
    this.notifyListeners();
  },
  onDeleteComment: function onDeleteComment(subjectKey, commentUri, commentData) {
    var _this = this;

    var subjectData = getStateForKey(subjectKey);
    var updatedNum = subjectData.numComments - 1;
    var commentIndex = _lodash2.default.findIndex(subjectData.comments, function (comment) {
      return comment.uri === commentUri;
    });
    if (commentIndex >= 0) {
      subjectData.set("numComments", updatedNum);
      subjectData.comments.splice(commentIndex, 1);
      if (!subjectData.showPagination) {
        this.notifyListeners();
      }
      $j.post("/comment/destroy?comment_uri=" + commentUri).done(function () {
        if (subjectData.showPagination) {
          if (getStateForKey(subjectKey).comments.length === 0 && subjectData.currentPage > 1) {
            commentData.page = subjectData.currentPage - 1;
            _comment_actions2.default.showCommentsForPage(commentData);
          } else if (subjectData.currentPage < Math.ceil(updatedNum / MAX_COMMENTS_PER_PAGE)) {
            commentData.page = subjectData.currentPage;
            _comment_actions2.default.showCommentsForPage(commentData);
          } else {
            _this.notifyListeners();
          }
        }
      });
    }
  },
  onAddNewComment: function onAddNewComment(commentData) {
    var _this2 = this;

    var comment = {
      body: getStateForKey(commentData.subjectKey).unsavedComment,
      authorUser: commentData.authorUser,
      updatedAtMessage: "Just now"
    };
    setDataForKey(commentData.subjectKey, { saveInProgress: true });

    this.notifyListeners();
    $j.post("/comment.json", {
      type: commentData.subject.type,
      id: commentData.subject.id,
      resource_uri: commentData.subject.uri,
      comment: {
        body_usertext: comment.body
      },
      digest_default: true,
      respect_update_feed_preference: true,
      react_framework: true
    }).done(function (resp) {
      var subjectData = getStateForKey(commentData.subjectKey);
      var updatedNum = subjectData.numComments + 1;
      subjectData.set({
        unsavedComment: "",
        saveInProgress: false,
        numComments: updatedNum,
        showCommentButton: false
      });
      if (subjectData.comments.length < MAX_COMMENTS_PER_PAGE) {
        var _comment = resp;
        subjectData.comments.push({
          createdAt: new Date(),
          body: _comment.body,
          deletableByCurrentUser: _comment.deletableByCurrentUser,
          blockedByCurrentUser: _comment.blockedByCurrentUser,
          authorUser: commentData.authorUser,
          updatedAtMessage: "Just now",
          uri: _comment.uri,
          flagForAbuseUrl: _comment.flagForAbuseUrl
        });
      } else {
        commentData.page = Math.ceil(updatedNum / MAX_COMMENTS_PER_PAGE);
        _comment_actions2.default.showCommentsForPage(commentData);
      }
      _this2.onTextareaUnfocused(commentData.subjectKey);
    }).fail(function (resp) {
      var errorMessage = null;
      if (resp.status === 404) {
        errorMessage = "Sorry, this post has been deleted.";
      } else {
        errorMessage = "Sorry, your comment cannot be posted. ";
        if (resp.responseJSON && resp.responseJSON.errors) {
          errorMessage += resp.responseJSON.errors.join(", ");
        }
      }

      if (resp.responseJSON && resp.responseJSON.errors && resp.responseJSON.errors.length === 1 && resp.responseJSON.errors.includes("There was a problem saving your comment.")) {
        // for blocked content, silently fail and fake adding the message to throw off spammers
        errorMessage = null;
        var subjectData = getStateForKey(commentData.subjectKey);
        subjectData.comments.push({
          createdAt: new Date(),
          body: {
            html: comment.body
          },
          deletableByCurrentUser: true,
          blockedByCurrentUser: false,
          authorUser: commentData.authorUser,
          updatedAtMessage: "Just now",
          uri: "",
          flagForAbuseUrl: "#"
        });

        setDataForKey(commentData.subjectKey, {
          unsavedComment: "",
          numComments: subjectData.numComments + 1
        });
      }

      if (errorMessage) {
        _gr_error_reporting2.default.notifyUser(errorMessage);
      }

      setDataForKey(commentData.subjectKey, { saveInProgress: false, showCommentButton: false });
      _comment_actions2.default.textareaUnfocused(commentData.subjectKey);
    });
  },
  onShowCommentsForPage: function onShowCommentsForPage(commentData) {
    var _this3 = this;

    var page = commentData.page > 0 ? commentData.page : 1;
    $j.get("/comment/index.json", {
      type: commentData.subject.type,
      id: commentData.subject.id,
      resource_uri: commentData.subject.uri,
      page: page,
      per_page: MAX_COMMENTS_PER_PAGE,
      reverse: true,
      react_framework: true
    }).done(function (resp) {
      setDataForKey(commentData.subjectKey, {
        comments: resp.comments,
        showPagination: true,
        currentPage: page,
        showSeeMoreLoadingSpinner: false
      });
      _this3.notifyListeners();
    });
  },
  onCommentEntered: function onCommentEntered(key, comment) {
    setDataForKey(key, { unsavedComment: comment });
    this.notifyListeners();
  },

  getState: getState,
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  reset: function reset() {
    resetTo({});
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  }
});

},{"../modules/gr_error_reporting":13,"../react_actions/comment_actions":31,"./shared/newsfeed_updates_mixin":271,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],263:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _general_status_update_actions = require("../react_actions/general_status_update_actions");

var _general_status_update_actions2 = _interopRequireDefault(_general_status_update_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  creationInProgress: false,
  saveInProgress: false
};

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

exports.default = _reflux2.default.createStore({

  listenables: _general_status_update_actions2.default,

  getInitialState: getState,
  getState: getState,

  setCreationInProgress: function setCreationInProgress(value) {
    this.setState({ creationInProgress: value });
  },
  setState: function setState(state) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var newState = this.getState().set(state);
    if (options.trigger !== false) {
      this.trigger(newState);
    }
  },
  onSave: function onSave(updateText) {
    var _this = this;

    var data = {
      user_status: {
        body: updateText
      }
    };
    $j.post("/user_status.json", data).done(function () {
      _this.onCloseCreationDialog();
    }).fail(function () {
      window.alert("An error has occurred. Please try again");
    }).always(function () {
      _this.setState({ saveInProgress: false });
    });
    this.setState({ saveInProgress: true });
  },
  onOpenCreationDialog: function onOpenCreationDialog() {
    this.setCreationInProgress(true);
  },
  onCloseCreationDialog: function onCloseCreationDialog() {
    this.setCreationInProgress(false);
  },
  reset: function reset() {
    getState().reset(initialState);
  }
});

},{"../react_actions/general_status_update_actions":33,"freezer-js":"freezer-js","reflux":"reflux"}],264:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSA_ELEMENT_TYPE = exports.ImpressionCode = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _data_tracking_actions = require("../react_actions/data_tracking/data_tracking_actions");

var _data_tracking_actions2 = _interopRequireDefault(_data_tracking_actions);

var _google_ads_actions = require("../react_actions/google_ads_actions");

var _google_ads_actions2 = _interopRequireDefault(_google_ads_actions);

var _newsfeed_actions = require("../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _google_ad_helper = require("../modules/ads/google_ad_helper");

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
  targeting: {},
  ads: {},
  nativeAds: {},
  device_type: null
}; // eslint-disable-line camelcase
var state = new _freezerJs2.default(defaultState);

var ImpressionCode = exports.ImpressionCode = {
  success: "0",
  dfpError: "1",
  monolithError: "2",
  empty: "3"
};

/** When adding, updating or removing attribute(s), please notify the Data Engineering team 
so that they can update the CSA query on their end. **/
var CSAElementAttributes = {
  adUnit: "ad",
  lineItemId: "l_id",
  campaignId: "c_id",
  type: "type",
  requestId: "r_id",
  sessionId: "s_id",
  slotId: "slot-id"
};

var CSA_ELEMENT_TYPE = exports.CSA_ELEMENT_TYPE = "DFP";

var getState = function getState() {
  return state.get();
};

var _resetTo = function _resetTo() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState().ads, key)) {
    //throw error
    if (!_lodash2.default.has(getState().nativeAds, key)) {
      throw new ReferenceError("No such product existing for key " + key);
    }
    return getState().nativeAds[key];
  }
  return getState().ads[key];
};

var setDataForKey = function setDataForKey(key, data) {
  getStateForKey(key).set(data);
};

var adUnit = function adUnit(currentSlotIdState) {
  return currentSlotIdState.path.split("/", 3)[2];
};

/* eslint-disable camelcase */
var dfpTrackingInfo = function dfpTrackingInfo(currentSlotIdState) {
  return {
    ad_unit: adUnit(currentSlotIdState),
    line_item_id: currentSlotIdState.lineItemId,
    campaign_id: currentSlotIdState.campaignId,
    ad_device_type: currentSlotIdState.adDeviceType
  };
};
/* eslint-enable camelcase */

var ajaxTrackingCall = function ajaxTrackingCall(url, currentSlotIdState, additionalParams) {
  var data = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), additionalParams);

  $j.ajax({
    url: url,
    type: "GET",
    data: data
  });
};

var setImpressionLogged = function setImpressionLogged(slotId) {
  setDataForKey(slotId, { impressionLogged: true });
};

/**
 * Tracks an element in DFP, Clickstream and CSA
 * @param {string} slotId Ad id.
 * @param {object} impressionCode Impression code to log in DFP.
 * @param {DOMNode} impressionElement The element to track in CSA.
 */
var trackImpression = function trackImpression(_ref) {
  var slotId = _ref.slotId;
  var impressionCode = _ref.impressionCode;
  var impressionElement = _ref.impressionElement;

  if (!slotId) {
    return;
  }

  var currentSlotIdState = getStateForKey(slotId);

  if (currentSlotIdState && !currentSlotIdState.impressionLogged) {
    ajaxTrackingCall(currentSlotIdState.pmetImpressionTrackUrl, currentSlotIdState, { impression_output: impressionCode } // eslint-disable-line camelcase
    );

    // CSA Impression
    trackImpressionInCSA({ currentSlotIdState: currentSlotIdState, impressionElement: impressionElement });

    setImpressionLogged(slotId);
  }
};

/**
 * Returns metadata object, which is used to set metadata attributes on
 * an element
 *
 * @param {object} currentSlotIdState The object which contains metadata.
 */
var getCSATrackingInfo = function getCSATrackingInfo(currentSlotIdState) {
  var _ref3;

  var _ref2 = window && window.ue || {};

  var id = _ref2.id;
  var sid = _ref2.sid;

  return _ref3 = {}, _defineProperty(_ref3, CSAElementAttributes.adUnit, adUnit(currentSlotIdState)), _defineProperty(_ref3, CSAElementAttributes.lineItemId, currentSlotIdState.lineItemId), _defineProperty(_ref3, CSAElementAttributes.campaignId, currentSlotIdState.campaignId), _defineProperty(_ref3, CSAElementAttributes.type, CSA_ELEMENT_TYPE), _defineProperty(_ref3, CSAElementAttributes.requestId, id), _defineProperty(_ref3, CSAElementAttributes.sessionId, sid), _defineProperty(_ref3, CSAElementAttributes.slotId, CSA_ELEMENT_TYPE), _ref3;
};

/**
 * Sets metadata attribute on the impression element and tracks it in CSA
 *
 * @param {object} currentSlotIdState The object which contains metadata.
 * @param {DOMNode} impressionElement The element to track in CSA.
 */
var trackImpressionInCSA = function trackImpressionInCSA(_ref4) {
  var currentSlotIdState = _ref4.currentSlotIdState;
  var impressionElement = _ref4.impressionElement;

  if (!impressionElement || !currentSlotIdState) {
    return;
  }

  if (window.csa) {
    (function () {

      var csaTrackingInfo = getCSATrackingInfo(currentSlotIdState);

      // setting impression attributes on the element
      Object.values(CSAElementAttributes).forEach(function (attribute) {
        if (csaTrackingInfo[attribute]) {
          impressionElement.setAttribute("data-csa-c-" + attribute, csaTrackingInfo[attribute]);
        }
      });

      // registering the element using CSA's programmatic API
      // For more details: https://info.analytics.a2z.com/#/docs/data_collection/csa/content_whitelisting
      window.csa("Content", { element: impressionElement });
    })();
  }
};

var handleClickTracker = function handleClickTracker(currentSlotIdState) {
  ajaxTrackingCall(currentSlotIdState.pmetClickTrackUrl, currentSlotIdState, {
    click_type: "click"
  }); // eslint-disable-line camelcase
};

var nativeAdGetUrl = function nativeAdGetUrl(resourceType) {
  switch (resourceType) {
    case "NewsfeedAd":
      return "/dfp/ajax_native_ad";
    case "PageSkin":
      return "/dfp/ajax_premium_campaign_page_skin";
    case "FeaturedContent":
      return "/dfp/ajax_premium_campaign_featured_content";
  }
};

exports.default = _reflux2.default.createStore({
  listenables: [_google_ads_actions2.default, { trackClickEvent: _data_tracking_actions2.default.trackClickEvent }],

  initializeWith: function initializeWith(data) {
    var _this = this;

    (0, _google_ad_helper.lazyLoadInit)();
    data = _lodash2.default.merge({}, { callbacksAttached: [] }, data);
    _resetTo(data);
    var gptSlots = [];
    var apsSlots = [];
    var a9Sizes = undefined;
    if (_env_utils2.default.hasDom() && !(0, _google_ad_helper.adSlotsDefined)()) {
      var ads = _lodash2.default.merge({}, this.getState().ads, this.getState().nativeAds);
      _lodash2.default.map(ads, function (ad, adId) {
        if (!ad.isLazyLoaded) {
          var isNativeAd = _lodash2.default.has(_this.getState().nativeAds, adId);
          (0, _google_ad_helper.defineSlot)(adId, ad.path, ad.dimensions, ad.adSizeMapping, isNativeAd);
          gptSlots.push((0, _google_ad_helper.slotToHash)(ad, adId));
          a9Sizes = (0, _google_ad_helper.getA9Sizes)(ad.dimensions);
          if (!_lodash2.default.isEmpty(a9Sizes)) {
            apsSlots.push((0, _google_ad_helper.slotToHash)(ad, adId, a9Sizes));
          }
        }
      });
      (0, _google_ad_helper.enableServices)();
      (0, _google_ad_helper.fetchApstagBids)(gptSlots, _lodash2.default.compact(apsSlots));
    }
  },
  resetTo: function resetTo(data) {
    _resetTo(data);
  },
  updateWith: function updateWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onTrackClickEvent: function onTrackClickEvent(event, source) {
    var target = event.target;
    var dfp = undefined,
        pmet = undefined,
        dfpData = undefined,
        pmetData = undefined;
    var regex = /news/;
    var adId = JSON.parse(source.getAttribute("data-tracking-adId"));
    adId = adId ? adId : _lodash2.default.findKey(getState().nativeAds, function (ad) {
      return ad.path.match(regex);
    });

    //crawl up the source tree until you find the dfp and pmet tracking data
    if (adId) {
      while (target !== source) {
        if (target.getAttribute("data-tracking-dfp") && !dfp) {
          dfp = target.getAttribute("data-tracking-dfp");
          dfpData = JSON.parse(dfp);
          if (dfpData) {
            this.trackDfpClick(adId);
          }
        }
        if (target.getAttribute("data-tracking-pmet") && !pmet) {
          pmet = target.getAttribute("data-tracking-pmet");
          pmetData = JSON.parse(pmet);
          this.trackPmetClick(adId, pmetData);
        }
        target = target.parentNode;
      }
    }
  },
  mergeWith: function mergeWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onHasAttachedDfpCallbackForSlot: function onHasAttachedDfpCallbackForSlot(adId) {
    this.getState().set("callbacksAttached", [].concat(_toConsumableArray(this.getState().callbacksAttached), [adId]));
  },
  onCheckCallbacksAttached: function onCheckCallbacksAttached(resolve, reject, slotsToCheck) {
    var result = _lodash2.default.reduce(["ads", "nativeAds"], function (result, adType) {
      var perAdType = _lodash2.default.reduce(_lodash2.default.keys(getState()[adType]), function (result, adId) {
        var intermediate = undefined;
        if (_lodash2.default.includes(slotsToCheck, adId)) {
          intermediate = getStateForKey(adId).isLazyLoaded || _lodash2.default.includes(getState().callbacksAttached, adId);
        } else {
          intermediate = true;
        }
        return result && intermediate;
      }, true);
      return result && perAdType;
    }, true);
    result ? resolve(true) : setTimeout(function () {
      return resolve(false);
    }, 500);
  },
  onRequestCreativeForSlot: function onRequestCreativeForSlot(slotId, paramsForCreative) {
    if (window.googletag && window.googletag.cmd) {
      window.googletag.cmd.push(function () {
        (0, _google_ad_helper.requestCreative)(slotId, paramsForCreative);
      });
    }
  },
  onRemoveAdSlot: function onRemoveAdSlot(slotId) {
    setDataForKey(slotId, {
      empty: true
    });
    this.notifyListeners();
  },
  onTrackImpression: function onTrackImpression(_ref5) {
    var slotId = _ref5.slotId;
    var impressionCode = _ref5.impressionCode;
    var impressionElement = _ref5.impressionElement;

    trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
  },
  onAttachServedBannerAdAttributesAndTracking: function onAttachServedBannerAdAttributesAndTracking(_ref6) {
    var slotId = _ref6.slotId;
    var campaignId = _ref6.campaignId;
    var lineItemId = _ref6.lineItemId;
    var creative = _ref6.creative;
    var impressionCode = _ref6.impressionCode;
    var delayImpressionTracking = _ref6.delayImpressionTracking;
    var impressionElement = _ref6.impressionElement;

    setDataForKey(slotId, {
      campaignId: campaignId,
      lineItemId: lineItemId,
      creative: creative,
      impressionCode: impressionCode
    });
    this.notifyListeners();
    var currentSlotIdState = getStateForKey(slotId);
    if (!creative) {
      trackImpression({ slotId: slotId, impressionCode: ImpressionCode.dfpError });
      return;
    }

    if (!delayImpressionTracking) {
      //Track impression on pmet
      trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
    }

    //ad click tracker to creative DOM object
    currentSlotIdState.creative.on("click", "a", function () {
      currentSlotIdState.creative.context.click();
      handleClickTracker(currentSlotIdState);
    });
  },
  onAttachServedNativeAdAttributesAndTracking: function onAttachServedNativeAdAttributesAndTracking(_ref7) {
    var slotId = _ref7.slotId;
    var campaignId = _ref7.campaignId;
    var lineItemId = _ref7.lineItemId;
    var creative = _ref7.creative;
    var sponsoredId = _ref7.sponsoredId;
    var impressionCode = _ref7.impressionCode;
    var dfpUrl = _ref7.dfpUrl;
    var adUnit = _ref7.adUnit;
    var impressionElement = _ref7.impressionElement;

    setDataForKey(slotId, { campaignId: campaignId, lineItemId: lineItemId, url: dfpUrl });
    var currentSlotIdState = getStateForKey(slotId);
    var resourceType = currentSlotIdState.resourceType;
    var url = nativeAdGetUrl(resourceType);
    if (!creative) {
      trackImpression({ slotId: slotId, impressionCode: ImpressionCode.dfpError });
      return;
    }

    if (currentSlotIdState.resourceType === "NewsfeedAd") {
      this.ajaxNewsfeedAd(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement);
    } else {
      this.ajaxPremiumCampaign(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement);
    }
  },
  ajaxNewsfeedAd: function ajaxNewsfeedAd(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement) {
    var _this2 = this;

    $j.ajax({
      type: "GET",
      url: url,
      /* eslint-disable camelcase */
      data: {
        format: "json",
        id: sponsoredId,
        line_item_id: lineItemId,
        ad_unit: adUnit,
        ad_device_type: "desktop",
        react: true
      }
    }). /* eslint-enable camelcase */
    done(function (json) {
      if (json.ok) {
        setDataForKey(slotId, json);
        _newsfeed_actions2.default.updateNativeAdSlot(getStateForKey(slotId).id, getStateForKey(slotId));
        _this2.notifyListeners();
        trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
      } else {
        trackImpression({
          slotId: slotId,
          impressionCode: ImpressionCode.monolithError
        });
      }
    });
  },
  ajaxPremiumCampaign: function ajaxPremiumCampaign(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement) {
    var _this3 = this;

    $j.ajax({
      type: "GET",
      url: url,
      /* eslint-disable camelcase */
      data: {
        format: "json",
        id: sponsoredId,
        line_item_id: lineItemId,
        ad_unit: adUnit,
        ad_device_type: "desktop"
      }
    }). /* eslint-enable camelcase */
    done(function (json) {
      if (json.ok) {
        setDataForKey(slotId, json);
        _this3.notifyListeners(getState());

        //Track impression on pmet
        trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
      } else {
        trackImpression({
          slotId: slotId,
          impressionCode: ImpressionCode.monolithError
        });
      }
    });
  },
  trackDfpClick: function trackDfpClick(slotId) {
    var currentSlotIdState = getStateForKey(slotId);
    var dfpClickUrl = currentSlotIdState.url;
    var queryParams = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), {
      click_type: "click"
    }); // eslint-disable-line camelcase
    var encodedQueryParams = encodeURIComponent("?" + $j.param(queryParams));

    $j.ajax({
      type: "GET",
      url: dfpClickUrl + currentSlotIdState.pmetClickTrackUrl + encodedQueryParams
    });
  },
  trackPmetClick: function trackPmetClick(slotId, additionalParams) {
    var currentSlotIdState = getStateForKey(slotId);
    var queryParams = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), additionalParams);

    $j.ajax({
      type: "GET",
      url: currentSlotIdState.pmetClickTrackUrl,
      data: queryParams
    });
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  getState: getState,

  reset: _resetTo
});

},{"../modules/ads/google_ad_helper":3,"../modules/env_utils":12,"../react_actions/data_tracking/data_tracking_actions":32,"../react_actions/google_ads_actions":34,"../react_actions/newsfeed_actions":37,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],265:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _like_actions = require("../react_actions/like_actions");

var _like_actions2 = _interopRequireDefault(_like_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

var _gr_error_reporting = require("../modules/gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

var _ajax_helper = require("../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    getState().set(key, {
      likeCount: 0,
      isLiked: false,
      showLoadingSpinner: false
    });
  }
  return getState()[key];
};

var setResourceValue = function setResourceValue(resource, key, value) {
  getState()[resource].set(key, value);
};

var getResourceValue = function getResourceValue(resource, key) {
  return getState()[resource][key];
};

var toggleLikeStoreData = function toggleLikeStoreData(resource) {
  var likeCount = getResourceValue(resource, "likeCount");
  var isLiked = getResourceValue(resource, "isLiked");
  setResourceValue(resource, "isLiked", !isLiked);
  setResourceValue(resource, "likeCount", getResourceValue(resource, "isLiked") ? likeCount + 1 : likeCount - 1);
};

var store = _reflux2.default.createStore({
  listenables: _like_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.LIKES)],
  getState: getState,

  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  reset: function reset() {
    state.get().reset({});
  },
  initializeWith: function initializeWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      var scrubbedData = data[key];
      scrubbedData.likedBy = scrubbedData.likedBy || false;
      scrubbedData.likeCount = scrubbedData.likeCount || 0;
      scrubbedData.showLoadingSpinner = false;
      getState().set(key, scrubbedData);
    });
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  triggerLoadingSpinner: function triggerLoadingSpinner(resource) {
    var oldValue = getResourceValue(resource, "showLoadingSpinner");
    setResourceValue(resource, "showLoadingSpinner", !oldValue);
  },
  onLike: function onLike(resource) {
    var _this = this;

    this.triggerLoadingSpinner(resource);
    this.trigger(this.getState());
    (0, _ajax_helper.httpPost)("/rating", {
      format: "json",
      data: {
        rating: {
          resource_type: getResourceValue(resource, "resourceType"),
          resource_id: getResourceValue(resource, "resourceId"),
          resource_uri: getResourceValue(resource, "resourceUri"),
          rating: 1
        }
      }
    }).done(function (resp) {
      toggleLikeStoreData(resource);
      setResourceValue(resource, "ratingId", resp.rating_id);
      _this.trigger(getState());
    }).fail(function (resp) {
      var message = resp.responseText;
      if (message) {
        _gr_error_reporting2.default.notifyUser(message);
      }
    }).always(function () {
      _this.triggerLoadingSpinner(resource);
      _this.trigger(getState());
    });
  },
  onUnLike: function onUnLike(resource) {
    var _this2 = this;

    this.triggerLoadingSpinner(resource);
    this.trigger(this.getState());
    var ratingId = getResourceValue(resource, "ratingId");
    var url = "";
    var data = {};
    if (ratingId) {
      url = "/rating/" + ratingId;
      data = {
        format: "json"
      };
    } else {
      url = "/rating/";
      data = {
        format: "json",
        resource_uri: getResourceValue(resource, "resourceUri")
      };
    }

    (0, _ajax_helper.httpDelete)(url, { data: data }).done(function () {
      toggleLikeStoreData(resource);
      _this2.trigger(getState());
    }).fail(function (resp) {
      var errorMessage = "Unable to unlike.";
      if (resp.status == 404) {
        errorMessage += " You may have already unliked.";
      } else if (resp.responseText) {
        errorMessage += resp.responseText;
      }
      errorMessage += " Please refresh the page and try again.";
      _gr_error_reporting2.default.notifyUser(errorMessage);
    }).always(function () {
      _this2.triggerLoadingSpinner(resource);
      _this2.trigger(getState());
    });
  }
});

exports.default = store;

},{"../modules/ajax/ajax_helper":4,"../modules/gr_error_reporting":13,"../react_actions/like_actions":35,"./shared/newsfeed_updates_mixin":271,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],266:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _modal_actions2.default,

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  onOpenModal: function onOpenModal(modalId) {
    state.get().set("currentActiveModal", modalId);
    this.notifyListeners();
  },
  onCloseModal: function onCloseModal() {
    state.get().set("currentActiveModal", null);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    state.get().reset({});
  }
});

exports.default = store;

},{"../react_actions/modal_actions":36,"freezer-js":"freezer-js","reflux":"reflux"}],267:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateFeedPreferences = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _newsfeed_actions = require("../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _newsfeed_api_client = require("../modules/newsfeed_api_client");

var _newsfeed_api_client2 = _interopRequireDefault(_newsfeed_api_client);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateFeedPreferences = exports.UpdateFeedPreferences = {
  scopes: {
    everyone: {
      value: "everyone",
      label: "Goodreads community"
    },
    friends: {
      value: "friends",
      label: "All friends and people I follow"
    },
    top_friends_following: {
      value: "top_friends_following",
      label: "Top friends and people I follow"
    },
    top_friends: {
      value: "top_friends",
      label: "Top friends only"
    }
  },
  items: {
    books: {
      value: "books",
      label: "Book updates only"
    },
    reviews: {
      value: "reviews",
      label: "Reviews only"
    },
    all: {
      value: "all",
      label: "Everything"
    }
  }
};

var defaultState = {
  newsfeedUpdates: [],
  currentPage: 1,
  minUpdatedAt: null,
  updatesFeedPreferences: {
    item: "all",
    scope: "friends"
  },
  loadingInProgress: false,
  noAdditionalUpdates: false
};
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var resetTo = function resetTo(data) {
  _newsfeed_api_client2.default.reset();
  getState().reset((0, _lodash.merge)({}, defaultState, data));
};

var setPageAndPositionForEachUpdate = function setPageAndPositionForEachUpdate(updates) {
  var page = getState().currentPage;
  (0, _lodash.map)(updates, function (update, i) {
    update.page = page;
    update.position = i + 1;
  });
  return updates;
};

var setNoAdditionalUpdates = function setNoAdditionalUpdates(minUpdatedAt) {
  getState().set("noAdditionalUpdates", minUpdatedAt === 0);
};

exports.default = _reflux2.default.createStore({
  listenables: [_newsfeed_actions2.default],
  getInitialState: getState,
  getState: getState,
  reset: resetTo,

  initializeWith: function initializeWith(data) {
    data.updates.newsfeedUpdates = setPageAndPositionForEachUpdate(data.updates.newsfeedUpdates);
    resetTo(data.updates);
    setNoAdditionalUpdates(data.updates.minUpdatedAt);
    if (data.updates.newsfeedUpdates.length > 0) {
      _newsfeed_actions2.default.newsfeedItemsLoaded(data.dependentStoreUpdates);
    }
  },
  loadMoreNewsfeedUpdates: function loadMoreNewsfeedUpdates(requestParams) {
    var _this = this;

    getState().set("loadingInProgress", true);
    this.trigger(getState());
    var promise = _newsfeed_api_client2.default.loadNewsfeedUpdatesOlderThan(getState().minUpdatedAt, { requestParams: requestParams, updatesAlreadyLoaded: getState().newsfeedUpdates });
    return promise.done(function (resp) {
      var data = resp.updates;
      if (data.newsfeedUpdates.length > 0) {
        _newsfeed_actions2.default.newsfeedItemsLoaded(resp.dependentStoreUpdates);
        var currentState = getState();
        currentState.set({
          minUpdatedAt: data.minUpdatedAt,
          currentPage: currentState.currentPage + 1
        }).newsfeedUpdates.append(setPageAndPositionForEachUpdate(data.newsfeedUpdates));
      }
      setNoAdditionalUpdates(data.minUpdatedAt);
    }).fail(function () {
      setNoAdditionalUpdates(0);
    }).always(function () {
      getState().set("loadingInProgress", false);
      _this.trigger(getState());
    });
  },
  onLoadMoreUpdates: function onLoadMoreUpdates() {
    this.loadMoreNewsfeedUpdates();
  },
  onSetUpdatesFeedPreferences: function onSetUpdatesFeedPreferences(newPrefs) {
    var existingState = getState();
    var currentPrefs = existingState.updatesFeedPreferences;
    var newValues = (0, _lodash.merge)({}, currentPrefs, newPrefs);
    existingState.set("updatesFeedPreferences", newValues);

    var stateWithUpdatedPrefs = getState();
    this.trigger(stateWithUpdatedPrefs);

    var updatedPreferences = stateWithUpdatedPrefs.updatesFeedPreferences;
    var loadMoreParams = {
      update_scope: updatedPreferences.scope,
      update_item: updatedPreferences.item
    };

    // Keep updatesFeedPreferences data, but throw everything else out.
    // We'll get the rest from the response.
    resetTo({
      updatesFeedPreferences: stateWithUpdatedPrefs.updatesFeedPreferences
    });

    this.loadMoreNewsfeedUpdates(loadMoreParams).fail(function () {
      window.alert("There was an error during this action, please try again.");
    });
  },
  onUpdateNativeAdSlot: function onUpdateNativeAdSlot(id, data) {
    var update = (0, _lodash.find)(getState().newsfeedUpdates, function (update) {
      return update.id === id;
    });
    if (update) {
      update.reset(data);
    }
  },
  onHideStory: function onHideStory(id) {
    var updateIndex = (0, _lodash.findIndex)(getState().newsfeedUpdates, function (update) {
      return update.id === id;
    });
    var newsfeedUpdates = getState().newsfeedUpdates;
    var newNewsfeedUpdates = newsfeedUpdates.splice(updateIndex, 1);
    getState().set("newsfeedUpdates", newNewsfeedUpdates);
    this.trigger(getState());
  },
  onPreviewBook: function onPreviewBook() {
    var pathParts = window.location.pathname.split("/");
    var trackerName = "";

    // Name of tracker is the URL path minus the last part (no ID)
    (0, _lodash.forEach)(pathParts, function (pathPart) {
      trackerName += pathPart;
    });

    $j.post("/track/track", {
      tid: "preview_button--" + trackerName + "--click"
    });
  }
});

},{"../modules/newsfeed_api_client":15,"../react_actions/newsfeed_actions":37,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],268:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _lodash = require("lodash");

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _reading_challenge_actions = require("../react_actions/reading_challenge_actions");

var _reading_challenge_actions2 = _interopRequireDefault(_reading_challenge_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATE = { showLoadingSpinner: false };
var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

exports.default = _reflux2.default.createStore({
  listenables: _reading_challenge_actions2.default,
  getInitialState: getState,
  getState: getState,

  initializeWith: function initializeWith(data) {
    getState().reset((0, _lodash.merge)({}, DEFAULT_STATE, data));
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  onStartChallenge: function onStartChallenge() {
    var _this = this;

    this.trigger(getState().set("showLoadingSpinner", true));

    var currentState = getState();
    var data = {
      user_challenge: {
        challenge_id: currentState.readingChallengeId,
        goal: currentState.booksToRead
      },
      format: "json"
    };

    $j.ajax({
      url: "/user_challenges/create_or_update",
      method: "PUT",
      data: data
    }).done(function (resp) {
      _this.trigger(getState().reset(resp));
    }).fail(function () {
      window.alert("There was an error starting your reading challenge, please try again.");
    }).always(function () {
      _this.trigger(getState().set("showLoadingSpinner", false));
    });
  },
  onBookNumChanged: function onBookNumChanged(value) {
    if (!isNaN(value)) {
      this.trigger(getState().set("booksToRead", parseInt(value)));
    }
  },
  reset: function reset() {
    getState().reset(DEFAULT_STATE);
  }
});

},{"../react_actions/reading_challenge_actions":38,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],269:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _reading_session_actions = require("../react_actions/reading_session_actions");

var _reading_session_actions2 = _interopRequireDefault(_reading_session_actions);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _default_shelves = require("../modules/default_shelves");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  readingSessions: [],
  sessionBeingUpdatedId: null,
  loadMoreInProgress: false
};

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var resetTo = function resetTo(data) {
  getState().reset((0, _lodash.merge)({}, INITIAL_STATE, data));
};

var store = _reflux2.default.createStore({
  listenables: [_reading_session_actions2.default, { bookShelved: _shelvings_actions2.default.bookShelved }],
  getInitialState: state.get,
  getState: getState,

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  reset: function reset() {
    resetTo({});
  },
  onBookShelved: function onBookShelved(resp) {
    if (resp && resp.shelfName === _default_shelves.DEFAULT_SHELVES.READ.name && resp.reviewEditUrl) {
      _env_utils2.default.setLocationUrl(resp.reviewEditUrl);
    }
  },
  onUpdateProgress: function onUpdateProgress(session) {
    var _this = this;

    var data = {
      user_status: {
        book_id: session.book.bookId,
        body: session.body
      }
    };
    data.user_status[session.positionType] = session.currentPosition;

    $j.post("/user_status.json", data).done(function (resp) {
      (0, _lodash.find)(getState().readingSessions, { sessionId: session.sessionId }).set(resp);
      _this.trigger(getState().set("sessionBeingUpdatedId", null));
    }).fail(function () {
      window.alert("An error has occurred. Please try again");
    });
  },
  getReadingSessionLoadOptions: function getReadingSessionLoadOptions() {
    var options = {};
    if (this.getState().readingSessions.length !== this.getState().allReadingSessionsCount) {
      options = {
        limit: 3
      };
    }
    return options;
  },
  onRefreshReadingSessions: function onRefreshReadingSessions() {
    this.loadReadingSessions(this.getReadingSessionLoadOptions());
  },
  onLoadAllReadingSessions: function onLoadAllReadingSessions() {
    this.trigger(getState().set("loadMoreInProgress", true));
    this.loadReadingSessions();
  },
  loadReadingSessions: function loadReadingSessions() {
    var _this2 = this;

    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    $j.get("/home/load_reading_sessions", options).done(function (data) {
      getState().set({
        readingSessions: data.readingSessions,
        allReadingSessionsCount: data.allReadingSessionsCount
      });
      _this2.trigger(_this2.getState());
    }).always(function () {
      _this2.trigger(getState().set("loadMoreInProgress", false));
    });
  },
  onOpenUpdateProgressForm: function onOpenUpdateProgressForm(sessionId) {
    this.trigger(getState().set("sessionBeingUpdatedId", sessionId));
  },
  onCloseUpdateProgressForm: function onCloseUpdateProgressForm() {
    this.trigger(getState().set("sessionBeingUpdatedId", null));
  },
  onShelveBookSuccess: function onShelveBookSuccess() {
    this.trigger(getState().set("showSearchForm", false));
  }
});

exports.default = store;

},{"../modules/default_shelves":11,"../modules/env_utils":12,"../react_actions/reading_session_actions":39,"../react_actions/shelvings_actions":41,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],270:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _recommendations_actions = require("../react_actions/recommendations_actions");

var _recommendations_actions2 = _interopRequireDefault(_recommendations_actions);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: [_recommendations_actions2.default, { bookShelved: _shelvings_actions2.default.bookShelved }],

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(data) {
    this.setRecommendations(data);
  },
  updateWith: function updateWith(data) {
    this.setRecommendations(data);
  },
  setRecommendations: function setRecommendations(data) {
    if (data.recommendations.length) {
      getState().reset(data).set("activeRecommendationId", 0);
      this.notifyListeners();
    }
  },
  getActiveRecommendation: function getActiveRecommendation() {
    return getState().recommendations[getState().activeRecommendationId];
  },
  onBookShelved: function onBookShelved(resp) {
    if (resp && resp.book && resp.book.bookId === this.getActiveRecommendation().book.bookId) {
      this.onRequestNextRec();
    }
  },
  onRequestNextRec: function onRequestNextRec() {
    var recommendations = getState().recommendations;
    var currentIndex = getState().activeRecommendationId;
    state.get().set("activeRecommendationId", (currentIndex + 1) % recommendations.length);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    getState().reset({});
  }
});

exports.default = store;

},{"../react_actions/recommendations_actions":40,"../react_actions/shelvings_actions":41,"freezer-js":"freezer-js","reflux":"reflux"}],271:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEWSFEED_DEPENDENT_STORE_KEYS = undefined;

var _newsfeed_actions = require("../../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
This mixin provides a reusable hook for stores to update when the newsfeed has
loaded additional updates. Example usage can be seen in any of the stores in
NEWSFEED_DEPENDENT_STORE_KEYS.

To add a new store, add the appropriate key/value in NEWSFEED_DEPENDENT_STORE_KEYS,
make sure the corresponding data is returned in newsfeed/all_stores_update_data
with the same value as the one defined in NEWSFEED_DEPENDENT_STORE_KEYS, and make
sure your store has an updateWith() method.
*/

var factory = function factory(dependentStoreKey) {
  var mixin = {
    init: function init() {
      if ((0, _lodash.includes)((0, _lodash.values)(NEWSFEED_DEPENDENT_STORE_KEYS), dependentStoreKey)) {
        this.listenTo(_newsfeed_actions2.default.newsfeedItemsLoaded, this.onNewsfeedItemsLoaded);
      }
    },
    onNewsfeedItemsLoaded: function onNewsfeedItemsLoaded(dependentStoreData) {
      if (dependentStoreKey && dependentStoreData[dependentStoreKey]) {
        this.updateWith(dependentStoreData[dependentStoreKey]);
        this.trigger(this.getState());
      }
    }
  };
  return mixin;
};

exports.default = factory;
var NEWSFEED_DEPENDENT_STORE_KEYS = exports.NEWSFEED_DEPENDENT_STORE_KEYS = {
  COMMENTS: "comments",
  LIKES: "likes",
  SHELVINGS: "shelvings",
  AUTHOR_FOLLOWS: "authorFollows"
};

},{"../../react_actions/newsfeed_actions":37,"lodash":"lodash"}],272:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _reading_session_actions = require("../react_actions/reading_session_actions");

var _reading_session_actions2 = _interopRequireDefault(_reading_session_actions);

var _user_shelves_actions = require("../react_actions/user_shelves_actions");

var _user_shelves_actions2 = _interopRequireDefault(_user_shelves_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

var _default_shelves = require("../modules/default_shelves");

var _book_origins = require("../modules/book_origins");

var _ajax_helper = require("../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  This store maps book IDs to the current user's shelving data for that book.

  The same shelving could appear in ShelvingsStore multiple times. For example,
  if a user has shelved book ID 1, and book ID 2 is another edition of the same
  Work as book ID 1, ShelvingsStore might contain keys for 1, 2, or both:

  {1: {…,
       book: {
         bookId: 1,
         …
       }},
   2: {…,
       book: {
         bookId: 1,
         …
       }},
  }
*/

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    getState().set(key, {
      exclusiveShelfName: null,
      nonExclusiveShelfNames: null,
      exclusiveShelfDisplayName: null,
      isShelvingInProgress: false,
      targetExclusiveShelfName: null
    });
  }
  return getState()[key];
};

// Update all states with a given book id included in them
var setStateForBookId = function setStateForBookId(bookId, data) {
  // merges with existing data
  getStateForKey(bookId).set(data);

  _lodash2.default.each(getState(), function (shelvingState, key) {
    if (shelvingState.book && shelvingState.book.bookId === bookId) {
      getStateForKey(key).set(data);
    }
  });
};

var addToExclusiveShelf = function addToExclusiveShelf(bookId, shelf, responseData) {
  setStateForBookId(bookId, { exclusiveShelfName: shelf.name,
    exclusiveShelfDisplayName: shelf.displayName });
  if (typeof responseData !== "undefined") {
    setStateForBookId(bookId, { book: responseData.book,
      updatedAt: Date.parse(responseData.updatedAt) });
  }
  _reading_session_actions2.default.refreshReadingSessions();
};

var deleteShelving = function deleteShelving(bookId, shelf, newShelf) {
  setStateForBookId(bookId, { exclusiveShelfName: null,
    exclusiveShelfDisplayName: null,
    rating: 0,
    nonExclusiveShelfNames: null });
  if (newShelf) {
    _user_shelves_actions2.default.removeNonExclusiveShelf(shelf.name);
  }
};

var unsetRating = function unsetRating(bookId) {
  setStateForBookId(bookId, { rating: 0 });
};

var setRating = function setRating(bookId, value) {
  var bookData = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  addToReadShelfIfUnshelved(bookId, bookData);
  setStateForBookId(bookId, { rating: value });
};

var addToNonExclusiveShelf = function addToNonExclusiveShelf(bookId, shelf) {
  var bookData = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var state = getStateForKey(bookId);
  var shelfNames = _lodash2.default.clone(state.nonExclusiveShelfNames) || [];
  shelfNames.push(shelf.name);
  setStateForBookId(bookId, { nonExclusiveShelfNames: shelfNames });
  addToReadShelfIfUnshelved(bookId, bookData);
  _user_shelves_actions2.default.addNonExclusiveShelf(shelf.name);
};

var removeFromNonExclusiveShelf = function removeFromNonExclusiveShelf(bookId, shelf, newShelf) {
  var state = getStateForKey(bookId);
  var shelfNames = _lodash2.default.clone(state.nonExclusiveShelfNames);
  shelfNames = _lodash2.default.without(shelfNames, shelf.name);
  if (newShelf) {
    _user_shelves_actions2.default.removeNonExclusiveShelf(shelf.name);
  }
  setStateForBookId(bookId, { nonExclusiveShelfNames: shelfNames });
};

var addToReadShelfIfUnshelved = function addToReadShelfIfUnshelved(bookId) {
  var bookData = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

  var state = getStateForKey(bookId);
  if (state.exclusiveShelfName === null) {
    addToExclusiveShelf(bookId, _default_shelves.DEFAULT_SHELVES.READ, bookData);
  }
};

var addToShelfRequest = function addToShelfRequest(data) {
  var origin = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
  var progress_update_text = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var args = data;
  if (origin) {
    args = _lodash2.default.merge({}, data, {
      book_origin: origin
    });
  }
  if (progress_update_text) {
    args = _lodash2.default.merge({}, args, {
      progress_update_text: progress_update_text
    });
  }
  args = _lodash2.default.merge({}, args, { v: 2 });
  return (0, _ajax_helper.httpPost)("/shelf/add_to_shelf.json", { data: args });
};

exports.default = _reflux2.default.createStore({
  listenables: _shelvings_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.SHELVINGS)],

  getState: getState,

  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },
  initializeWith: function initializeWith(data) {
    state.get().reset(data);
    this.notifyListeners();
  },
  reset: function reset() {
    state.get().reset({});
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  updateWith: function updateWith(shelvings) {
    var shelvingData = _lodash2.default.transform(shelvings, function (result, shelving, key) {
      result[key].isShelvingInProgress = false;
      result[key].updatedAt = Date.parse(shelving.updatedAt);
      return result;
    }, shelvings);

    this.getState().set(shelvingData);
    this.notifyListeners();
  },
  onShelveBook: function onShelveBook(bookId, shelf) {
    var _this = this;

    var origin = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
    var progress_update_text = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

    var currentCustomExclusiveShelf = getStateForKey(bookId).exclusiveShelfName;
    setStateForBookId(bookId, { isShelvingInProgress: true, targetExclusiveShelfName: shelf.name });
    var data = { book_id: bookId, name: shelf.name };
    this.notifyListeners();
    addToShelfRequest(data, origin, progress_update_text).done(function (responseData) {
      addToExclusiveShelf(bookId, shelf, responseData);
      responseData = responseData || {};
      responseData.shelves = {};
      responseData.shelves[(0, _default_shelves.getExclusiveShelfType)(shelf.name)] = [shelf.name];
      _shelvings_actions2.default.bookShelved(responseData);

      // if moving book to another exclusive shelf, remove it from the previous one
      if (currentCustomExclusiveShelf) {
        var shelves = {};
        shelves[(0, _default_shelves.getExclusiveShelfType)(currentCustomExclusiveShelf)] = [currentCustomExclusiveShelf];
        _shelvings_actions2.default.bookUnshelved({ shelves: shelves });
      }

      if (origin === _book_origins.BOOK_ORIGINS.CURRENTLY_READING_WIDGET) {
        _reading_session_actions2.default.shelveBookSuccess();
      }
    }).fail(function () {
      window.alert("There was an error adding the book to your shelf, please try again.");
    }).always(function () {
      setStateForBookId(bookId, { isShelvingInProgress: false, targetExclusiveShelfName: null });
      _this.notifyListeners();
    });
  },
  onUnshelveBook: function onUnshelveBook(bookId) {
    var _this2 = this;

    setStateForBookId(bookId, { isShelvingInProgress: true });
    this.notifyListeners();
    (0, _ajax_helper.httpPost)("/review/destroy", {
      data: {
        id: bookId
      }
    }).done(function () {
      var shelves = {};
      shelves[(0, _default_shelves.getExclusiveShelfType)(getStateForKey(bookId).exclusiveShelfName)] = [getStateForKey(bookId).exclusiveShelfName];
      shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = getStateForKey(bookId).nonExclusiveShelfNames || [];
      _shelvings_actions2.default.bookUnshelved({ shelves: shelves });

      deleteShelving(bookId);
    }).fail(function (response) {
      if (response.status === 403 && response.getResponseHeader("errorType") === "frozen") {
        window.alert("Something went wrong with your request. Please try again later.");
      } else {
        window.alert("There was an error removing the book from your shelves, please try again.");
      }
    }).always(function () {
      setStateForBookId(bookId, { isShelvingInProgress: false });
      _this2.notifyListeners();
    });
  },
  onToggleNonExclusiveShelving: function onToggleNonExclusiveShelving(bookId, shelf, newShelf, title) {
    var _this3 = this;

    var exclusiveShelfName = getStateForKey(bookId).exclusiveShelfName;
    var nonExclusiveShelfNames = getStateForKey(bookId).nonExclusiveShelfNames;
    var isAddingToShelf = !_lodash2.default.includes(nonExclusiveShelfNames, shelf.name);
    var isBookShelved = getState()[bookId] && getStateForKey(bookId).exclusiveShelfName !== null;
    var bookData = { book: { bookId: bookId, title: title } };

    if (isAddingToShelf) {
      addToReadShelfIfUnshelved(bookId, bookData);
      addToNonExclusiveShelf(bookId, shelf, bookData);
    } else {
      removeFromNonExclusiveShelf(bookId, shelf, false);
    }
    this.notifyListeners();

    var data = {
      book_id: bookId,
      name: shelf.name,
      a: isAddingToShelf ? "" : "remove"
    };

    addToShelfRequest(data).done(function () {
      var shelves = {};
      if (isAddingToShelf) {
        // if book is not on an exclusive shelf already, also add it to the READ shelf
        shelves[_default_shelves.SHELF_TYPES.DEFAULT] = !exclusiveShelfName ? [_default_shelves.DEFAULT_SHELVES.READ.name] : [];
        shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = [shelf.name];
        _shelvings_actions2.default.bookShelved({ shelves: shelves });
      } else {
        shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = [shelf.name];
        _shelvings_actions2.default.bookUnshelved({ shelves: shelves });
      }
    }).fail(function () {
      window.alert("There was an error adding the book to your shelf, please try again.");
      if (!isBookShelved) {
        deleteShelving(bookId, shelf, newShelf);
      } else if (isAddingToShelf) {
        removeFromNonExclusiveShelf(bookId, shelf, newShelf);
      } else {
        addToNonExclusiveShelf(bookId, shelf, bookData);
      }
      _this3.notifyListeners();
    });
  },
  onRateBook: function onRateBook(bookId, rating, title) {
    var clickstreamRef = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

    var _this4 = this;

    var ratingContainer = arguments[4];
    var handleClick = arguments[5];

    var prevRating = 0;
    var isBookShelved = false;
    var bookData = { book: { bookId: bookId, title: title } };
    if (getState()[bookId]) {
      prevRating = getStateForKey(bookId).rating;
      isBookShelved = getStateForKey(bookId).exclusiveShelfName !== null;
      if (prevRating === 0) {
        _shelvings_actions2.default.rateBook.newBook();
      }
    }
    setRating(bookId, rating, bookData);
    this.notifyListeners();

    var ratePostUrl = "/review/rate";
    var ratePostData = {
      format: "json",
      id: bookId,
      rating: rating,
      stars_click: true
    };
    if (clickstreamRef) {
      var clickstreamRefNumRating = clickstreamRef.replace("str", "st" + rating);
      ratePostUrl += "?ref=" + clickstreamRefNumRating;
    }
    var store = this;
    (0, _ajax_helper.httpPost)(ratePostUrl, {
      data: ratePostData,
      error: function error(xhr, aja_xOptions, thrownError) {
        if (xhr.status === 403 && xhr.getResponseHeader("errorType") === "frozen") {
          window.alert("This book has temporary limitations on submitting ratings and reviews. This may be because we've detected unusual behavior that doesn't follow our review guidelines.");
        } else if (xhr.status !== 403) {
          window.alert("There was an error saving your rating, please try again.");
        }
        if (prevRating > 0) {
          setRating(bookId, prevRating, bookData);
        } else if (isBookShelved) {
          unsetRating(bookId);
          _shelvings_actions2.default.rateBook.failed();
        } else {
          deleteShelving(bookId, null, false);
          _shelvings_actions2.default.rateBook.failed();
        }
        store.notifyListeners();
      },
      success: function success(response) {
        ratingContainer.focus();
        if (handleClick) {
          handleClick();
        }
        store.notifyListeners();
      }
    }).fail(function () {
      window.alert("There was an error saving your rating, please try again.");
      if (prevRating > 0) {
        setRating(bookId, prevRating, bookData);
      } else if (isBookShelved) {
        unsetRating(bookId);
        _shelvings_actions2.default.rateBook.failed();
      } else {
        deleteShelving(bookId, null, false);
        _shelvings_actions2.default.rateBook.failed();
      }
      _this4.notifyListeners();
    });
  },
  onAddShelvings: function onAddShelvings(shelvings) {
    this.updateWith(shelvings);
    this.notifyListeners();
  }
});

},{"../modules/ajax/ajax_helper":4,"../modules/book_origins":6,"../modules/default_shelves":11,"../react_actions/reading_session_actions":39,"../react_actions/shelvings_actions":41,"../react_actions/user_shelves_actions":44,"./shared/newsfeed_updates_mixin":271,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],273:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _user_agent_capabilities_actions = require("../react_actions/user_agent_capabilities_actions");

var _user_agent_capabilities_actions2 = _interopRequireDefault(_user_agent_capabilities_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { touch: false };
var state = new _freezerJs2.default(defaultState);

exports.default = _reflux2.default.createStore({
  listenables: [_user_agent_capabilities_actions2.default],

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  reset: function reset() {
    state.get().reset(defaultState);
  },
  getInitialState: function getInitialState() {
    return state.get();
  },
  onUserAgentGainsTouch: function onUserAgentGainsTouch() {
    state.get().set("touch", true);
    this.trigger(state.get());
  },
  onUserAgentLosesTouch: function onUserAgentLosesTouch() {
    state.get().set("touch", false);
    this.trigger(state.get());
  }
});

},{"../react_actions/user_agent_capabilities_actions":42,"freezer-js":"freezer-js","reflux":"reflux"}],274:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _ajax_helper = require("../modules/ajax/ajax_helper");

var _user_not_interested_actions = require("../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  A book with ID 0 is used to set default state. This book is never modified, it
  is only used to created other books with individual states as creatives appear
  from dfp.
*/
var DEFAULT_STATE = { default: { isFlashMessage: false, isClosed: false } }; /*
                                                                               This store allows users to make books as not interested. Not interested
                                                                               books will not show up in native ad slots
                                                                             */

var state = new _freezerJs2.default(DEFAULT_STATE);

var getState = function getState() {
  return state.get();
};

var _reset = function _reset(data) {
  getState().reset((0, _lodash.merge)({}, DEFAULT_STATE, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_user_not_interested_actions2.default],

  getState: getState,
  getInitialState: getState,

  reset: function reset() {
    _reset({});
  },
  setDataForKey: function setDataForKey(bookId, data) {
    var newState = {};
    newState[bookId] = data;
    getState().set((0, _lodash.merge)({}, getState(), newState));
  },
  onAddBookIDToState: function onAddBookIDToState(bookId) {
    this.setDataForKey(bookId, getState().default);
    this.trigger(getState());
  },
  onIsFlashMessageForBook: function onIsFlashMessageForBook(bookId) {
    getState()[bookId].isFlashMessage;
  },
  onCloseFlashMessage: function onCloseFlashMessage(bookId) {
    this.setDataForKey(bookId, { isClosed: true });
    this.trigger(getState());
  },
  userNotInterestedHttpPost: function userNotInterestedHttpPost(bookId) {
    return (0, _ajax_helper.httpPost)("/user_not_interested_works", {
      data: {
        user_not_interested_work: {
          book_id: bookId,
          source: "react"
        }
      }
    });
  },
  onUserNotInterested: function onUserNotInterested(bookId) {
    var _this = this;

    this.userNotInterestedHttpPost(bookId).done(function () {
      _this.setDataForKey(bookId, { isFlashMessage: true });
      _this.trigger(getState());
    }).fail(function () {
      window.alert("There was an error marking this book as not interested, please try again.");
    });
  },
  undoUserNotInterestedHttpDelete: function undoUserNotInterestedHttpDelete(bookId) {
    return (0, _ajax_helper.httpDelete)("/user_not_interested_works/undo", {
      data: {
        user_not_interested_work: { book_id: bookId }
      }
    });
  },
  onUndoUserNotInterested: function onUndoUserNotInterested(bookId) {
    var _this2 = this;

    this.undoUserNotInterestedHttpDelete(bookId).done(function () {
      _this2.setDataForKey(bookId, { isFlashMessage: false });
      _this2.trigger(getState());
    }).fail(function () {
      window.alert("There was an error undoing this action, please try again.");
    });
  }
});

},{"../modules/ajax/ajax_helper":4,"../react_actions/user_not_interested_actions":43,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],275:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  This store currently only stores a user's total ratings count under the key
  ratingsCount. Ideally, in the future it could hold more, for example a map of
  bookIDs to rating.

  As of right now, rating information for a specific book on the page is stored
  in ShelvingsStore. Eventually, we may move all rating information into this
  store.
*/

var defaultState = { ratingsCount: {} };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [{ ratedNewBook: _shelvings_actions2.default.rateBook.newBook }, { rateBookFailed: _shelvings_actions2.default.rateBook.failed }],
  getState: getState,
  getInitialState: getState,

  initializeWith: function initializeWith(data) {
    resetTo({
      ratingsCount: data.ratingsCount
    });
  },
  onRatedNewBook: function onRatedNewBook() {
    var oldRatingsCount = getState().ratingsCount;
    this.trigger(getState().set("ratingsCount", oldRatingsCount + 1));
  },
  onRateBookFailed: function onRateBookFailed() {
    var oldRatingsCount = getState().ratingsCount;
    this.trigger(getState().set("ratingsCount", oldRatingsCount - 1));
  },
  reset: function reset() {
    resetTo({});
  }
});

},{"../react_actions/shelvings_actions":41,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],276:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _user_shelves_actions = require("../react_actions/user_shelves_actions");

var _user_shelves_actions2 = _interopRequireDefault(_user_shelves_actions);

var _want_to_read_menu_actions = require("../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _default_shelves = require("../modules/default_shelves");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { defaultShelves: [],
  customExclusiveShelves: [],
  nonExclusiveShelves: [] };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var updateCount = function updateCount(shelfName, shelfType, countDelta) {
  var shelf = _lodash2.default.find(getState()[shelfType], { name: shelfName });
  if (shelf) {
    shelf.set("bookCount", shelf.bookCount + countDelta);
  }
};

exports.default = _reflux2.default.createStore({
  listenables: [_user_shelves_actions2.default, { bookShelved: _shelvings_actions2.default.bookShelved,
    bookUnshelved: _shelvings_actions2.default.bookUnshelved }],

  getInitialState: state.get,
  getState: getState,

  defaultShelves: function defaultShelves() {
    var shelves = getState().defaultShelves;
    if (shelves.length === 0) {
      return _default_shelves.DEFAULT_SHELVES;
    } else {
      return { READ: _lodash2.default.find(shelves, "name", "read"),
        CURRENTLY_READING: _lodash2.default.find(shelves, "name", "currently-reading"),
        WANT_TO_READ: _lodash2.default.find(shelves, "name", "to-read") };
    }
  },
  initializeWith: function initializeWith(shelves) {
    state.get().reset(shelves);
  },
  reset: function reset() {
    state.get().reset(defaultState);
  },
  updateWith: function updateWith(shelves) {
    state.get().reset(shelves);
  },
  onAddNonExclusiveShelf: function onAddNonExclusiveShelf(newShelfName) {
    var currentNonExclusiveShelves = _lodash2.default.clone(state.get().nonExclusiveShelves) || [];
    var shelfNames = _lodash2.default.map(currentNonExclusiveShelves, function (shelf) {
      return shelf.name;
    });
    if (!_lodash2.default.includes(shelfNames, newShelfName)) {
      currentNonExclusiveShelves.unshift({ name: newShelfName,
        url: "",
        displayName: newShelfName,
        bookCount: 0 });
      state.get().set("nonExclusiveShelves", currentNonExclusiveShelves);
      _want_to_read_menu_actions2.default.updateShelves();
      this.trigger(getState());
    }
  },
  onRemoveNonExclusiveShelf: function onRemoveNonExclusiveShelf(shelfNameToRemove) {
    var currentNonExclusiveShelves = _lodash2.default.clone(state.get().nonExclusiveShelves) || [];
    var shelfNames = _lodash2.default.map(currentNonExclusiveShelves, function (shelf) {
      return shelf.name;
    });
    if (_lodash2.default.includes(shelfNames, shelfNameToRemove)) {
      _lodash2.default.remove(currentNonExclusiveShelves, function (shelf) {
        return shelf.name === shelfNameToRemove;
      });
      state.get().set("nonExclusiveShelves", currentNonExclusiveShelves);
      _want_to_read_menu_actions2.default.updateShelves();
      this.trigger(getState());
    }
  },
  onBookShelved: function onBookShelved(options) {
    var shelves = options.shelves || {};
    _lodash2.default.each(shelves, function (shelfNames, shelfType) {
      _lodash2.default.each(shelfNames, function (shelfName) {
        updateCount(shelfName, shelfType, 1);
      });
    });
    this.trigger(getState());
  },
  onBookUnshelved: function onBookUnshelved(options) {
    var shelves = options.shelves || {};
    _lodash2.default.each(shelves, function (shelfNames, shelfType) {
      _lodash2.default.each(shelfNames, function (shelfName) {
        updateCount(shelfName, shelfType, -1);
      });
    });
    this.trigger(getState());
  }
});

},{"../modules/default_shelves":11,"../react_actions/shelvings_actions":41,"../react_actions/user_shelves_actions":44,"../react_actions/want_to_read_menu_actions":45,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],277:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _want_to_read_menu_actions = require("../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _user_shelves_store = require("./user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_ADD_SHELF_TEXTBOX_KEY = "showAddShelfTextbox";

var defaultState = {};
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var getDisplayableExclusiveShelves = function getDisplayableExclusiveShelves(shelfNameFilter, userShelvesStoreState) {
  var displayableExclusiveShelves = [];
  var unselectedExclusiveShelves = userShelvesStoreState.defaultShelves.concat(userShelvesStoreState.customExclusiveShelves || []);

  if (!_lodash2.default.isEmpty(shelfNameFilter)) {
    displayableExclusiveShelves = _lodash2.default.filter(unselectedExclusiveShelves, function (shelf) {
      return shelf.name.match(new RegExp(shelfNameFilter, "i"));
    });
  } else {
    displayableExclusiveShelves = unselectedExclusiveShelves;
  }
  return displayableExclusiveShelves;
};

var getDisplayableNonExclusiveShelves = function getDisplayableNonExclusiveShelves(shelfNameFilter, userShelvesStoreState) {
  var displayableNonExclusiveShelves = [];
  if (!_lodash2.default.isEmpty(shelfNameFilter)) {
    displayableNonExclusiveShelves = _lodash2.default.filter(userShelvesStoreState.nonExclusiveShelves, function (shelf) {
      return shelf.name.match(new RegExp(shelfNameFilter, "i"));
    });
  } else {
    displayableNonExclusiveShelves = userShelvesStoreState.nonExclusiveShelves;
  }
  return displayableNonExclusiveShelves;
};

var getFilteredShelves = function getFilteredShelves(shelfNameFilter) {
  var userShelvesStoreState = _user_shelves_store2.default.getState();
  var displayableExclusiveShelves = getDisplayableExclusiveShelves(shelfNameFilter, userShelvesStoreState);
  var displayableNonExclusiveShelves = getDisplayableNonExclusiveShelves(shelfNameFilter, userShelvesStoreState);

  return {
    displayableExclusiveShelves: displayableExclusiveShelves,
    displayableNonExclusiveShelves: displayableNonExclusiveShelves,
    shelfNameFilter: shelfNameFilter
  };
};

var updateStateWithFilter = function updateStateWithFilter(shelfNameFilter, uniqueWTRButtonId) {
  getState().set(uniqueWTRButtonId, getFilteredShelves(shelfNameFilter));
};

var updateShelvesWithoutFilterChange = function updateShelvesWithoutFilterChange(uniqueWTRButtonId) {
  var shelfNameFilter = getState()[uniqueWTRButtonId].shelfNameFilter;
  getState().set(uniqueWTRButtonId, getFilteredShelves(shelfNameFilter));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    updateStateWithFilter("", key);
  }
  return getState()[key];
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_want_to_read_menu_actions2.default],
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getState: getState,

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  reset: function reset() {
    resetTo(defaultState);
  },
  updateWith: function updateWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      getState().set(key, data[key]);
    });
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  onUpdateShelfNameFilter: function onUpdateShelfNameFilter(shelfNameFilter, uniqueWTRButtonId) {
    updateStateWithFilter(shelfNameFilter, uniqueWTRButtonId);
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, false);
    this.notifyListeners();
  },
  onOpenAddShelfTextbox: function onOpenAddShelfTextbox(uniqueWTRButtonId) {
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, true);
    this.notifyListeners();
  },
  onCloseAddShelfTextbox: function onCloseAddShelfTextbox(uniqueWTRButtonId) {
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, false);
    this.notifyListeners();
  },
  onUpdateShelves: function onUpdateShelves() {
    _lodash2.default.each(_lodash2.default.keys(getState()), function (uniqueWTRButtonId) {
      updateShelvesWithoutFilterChange(uniqueWTRButtonId);
    });
    this.notifyListeners();
  }
});

},{"../react_actions/want_to_read_menu_actions":45,"./user_shelves_store":276,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],278:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * <TextareaAutosize />
                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _calculateNodeHeight = require('./calculateNodeHeight');

var _calculateNodeHeight2 = _interopRequireDefault(_calculateNodeHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyFunction = function emptyFunction() {};

var TextareaAutosize = (_temp = _class = function (_React$Component) {
  _inherits(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    _classCallCheck(this, TextareaAutosize);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TextareaAutosize).call(this, props));

    _this.state = {
      height: null,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._onNextFrameActionId = null;
    _this._rootDOMNode = null;
    _this._onChange = _this._onChange.bind(_this);
    _this._resizeComponent = _this._resizeComponent.bind(_this);
    _this._onRootDOMNode = _this._onRootDOMNode.bind(_this);
    return _this;
  }

  _createClass(TextareaAutosize, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var valueLink = _props.valueLink;

      var props = _objectWithoutProperties(_props, ['valueLink']);

      props = _extends({}, props);
      if ((typeof valueLink === 'undefined' ? 'undefined' : _typeof(valueLink)) === 'object') {
        props.value = this.props.valueLink.value;
      }
      props.style = _extends({}, props.style, {
        height: this.state.height
      });
      var maxHeight = Math.max(props.style.maxHeight ? props.style.maxHeight : Infinity, this.state.maxHeight);
      if (maxHeight < this.state.height) {
        props.style.overflow = 'hidden';
      }
      return _react2.default.createElement('textarea', _extends({}, props, {
        onChange: this._onChange,
        ref: this._onRootDOMNode
      }));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._resizeComponent();
      window.addEventListener('resize', this._resizeComponent);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      // Re-render with the new content then recalculate the height as required.
      this._clearNextFrame();
      this._onNextFrameActionId = onNextFrame(this._resizeComponent);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // Invoke callback when old height does not equal to new one.
      if (this.state.height !== prevState.height) {
        this.props.onHeightChange(this.state.height);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove any scheduled events to prevent manipulating the node after it's
      // been unmounted.
      this._clearNextFrame();
      window.removeEventListener('resize', this._resizeComponent);
    }
  }, {
    key: '_clearNextFrame',
    value: function _clearNextFrame() {
      if (this._onNextFrameActionId) {
        clearNextFrameAction(this._onNextFrameActionId);
      }
    }
  }, {
    key: '_onRootDOMNode',
    value: function _onRootDOMNode(node) {
      this._rootDOMNode = node;
    }
  }, {
    key: '_onChange',
    value: function _onChange(e) {
      this._resizeComponent();
      var _props2 = this.props;
      var valueLink = _props2.valueLink;
      var onChange = _props2.onChange;

      if (valueLink) {
        valueLink.requestChange(e.target.value);
      } else {
        onChange(e);
      }
    }
  }, {
    key: '_resizeComponent',
    value: function _resizeComponent() {
      var useCacheForDOMMeasurements = this.props.useCacheForDOMMeasurements;

      this.setState((0, _calculateNodeHeight2.default)(this._rootDOMNode, useCacheForDOMMeasurements, this.props.rows || this.props.minRows, this.props.maxRows));
    }

    /**
     * Read the current value of <textarea /> from DOM.
     */

  }, {
    key: 'focus',


    /**
     * Put focus on a <textarea /> DOM element.
     */
    value: function focus() {
      this._rootDOMNode.focus();
    }

    /**
     * Shifts focus away from a <textarea /> DOM element.
     */

  }, {
    key: 'blur',
    value: function blur() {
      this._rootDOMNode.blur();
    }
  }, {
    key: 'value',
    get: function get() {
      return this._rootDOMNode.value;
    }

    /**
     * Set the current value of <textarea /> DOM node.
     */
    ,
    set: function set(val) {
      this._rootDOMNode.value = val;
    }

    /**
     * Read the current selectionStart of <textarea /> from DOM.
     */

  }, {
    key: 'selectionStart',
    get: function get() {
      return this._rootDOMNode.selectionStart;
    }

    /**
     * Set the current selectionStart of <textarea /> DOM node.
     */
    ,
    set: function set(selectionStart) {
      this._rootDOMNode.selectionStart = selectionStart;
    }

    /**
     * Read the current selectionEnd of <textarea /> from DOM.
     */

  }, {
    key: 'selectionEnd',
    get: function get() {
      return this._rootDOMNode.selectionEnd;
    }

    /**
     * Set the current selectionEnd of <textarea /> DOM node.
     */
    ,
    set: function set(selectionEnd) {
      this._rootDOMNode.selectionEnd = selectionEnd;
    }
  }]);

  return TextareaAutosize;
}(_react2.default.Component), _class.propTypes = {
  /**
   * Current textarea value.
   */
  value: _react2.default.PropTypes.string,

  /**
   * Callback on value change.
   */
  onChange: _react2.default.PropTypes.func,

  /**
   * Callback on height changes.
   */
  onHeightChange: _react2.default.PropTypes.func,

  /**
   * Try to cache DOM measurements performed by component so that we don't
   * touch DOM when it's not needed.
   *
   * This optimization doesn't work if we dynamically style <textarea />
   * component.
   */
  useCacheForDOMMeasurements: _react2.default.PropTypes.bool,

  /**
   * Minimal numbder of rows to show.
   */
  rows: _react2.default.PropTypes.number,

  /**
   * Alias for `rows`.
   */
  minRows: _react2.default.PropTypes.number,

  /**
   * Maximum number of rows to show.
   */
  maxRows: _react2.default.PropTypes.number
}, _class.defaultProps = {
  onChange: emptyFunction,
  onHeightChange: emptyFunction,
  useCacheForDOMMeasurements: false
}, _temp);
exports.default = TextareaAutosize;


function onNextFrame(cb) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(cb);
  }
  return window.setTimeout(cb, 1);
}

function clearNextFrameAction(nextFrameId) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(nextFrameId);
  } else {
    window.clearTimeout(nextFrameId);
  }
}

},{"./calculateNodeHeight":279,"react":"react"}],279:[function(require,module,exports){
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = calculateNodeHeight;
var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

var computedStyleCache = {};
var hiddenTextarea = undefined;

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  var minRows = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
  var maxRows = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  // Copy all CSS properties that have an impact on the height of the content in
  // the textbox

  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache);

  var paddingSize = _calculateNodeStyling.paddingSize;
  var borderSize = _calculateNodeStyling.borderSize;
  var boxSizing = _calculateNodeStyling.boxSizing;
  var sizingStyle = _calculateNodeStyling.sizingStyle;

  // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content
  hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';

  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = '';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      height = Math.min(maxHeight, height);
    }
  }
  return { height: height, minHeight: minHeight, maxHeight: maxHeight };
}

function calculateNodeStyling(node) {
  var useCache = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);

  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var sizingStyle = SIZING_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}
module.exports = exports['default'];

},{}],280:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactTransitionEvents
 */

'use strict';

var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');

/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'mozTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd'
  },

  animationend: {
    'animation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'mozAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'msAnimation': 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (ExecutionEnvironment.canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

module.exports = ReactTransitionEvents;
},{"fbjs/lib/ExecutionEnvironment":281}],281:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

'use strict';

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;
},{}]},{},[50])

